// FTLPanel.js — Admin panel FTL sekmesi (Faz 1)
// Görev-öncelikli atama sihirbazı · pilot görev geçmişi (denetçi raporu) · ruleset ayarları
// Tek kaynak: crew_duties + ftl_rulesets + ftl_pilot_baselines (RLS müşteri sınırı)
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { supabase } from '../supabaseClient';
import {
  toMin, fmtMin, spanMin, effectiveRules, overrideDirection, skpkStatement, limitAdi, ekipBilgisi, sonTarihDurumu,
  endedAtBase, projectPlannedRest, restForDuty, rotasyondaUzunMenzil, dhDinlenmesi, uzunMenzilOlcumu, arsivSaatDuzeltmeleri,
  fitness, dutyWindow, bildirimSureleri, gorevUcusSonrasiDk, tzOffsetMin, daysOffSummary, bosGunOlcumsuzNedeni, bosGunTabanMetni, gecTeblig, gecTebligMetni, gecTebligUyarisi, offToDuty, simYamasi, omlKontrol,
  medKisitlamaKontrol,
  crzRecency, pfRecency,
  standbyBefore, standbyEffect, standbyLimits, standbyRef,
  skpkLimits, skpkRef, previousDuty, acclimatisation, bandReportHHMM, dinlenmeDurumu, sektorSaatleri,
  dinlenmePenceresi, gunDinlenmesi,
  offDayRelease, offPeriodStatuses, backdateRows, offGirisEngeli, offGirisEngeliMetni, bosGunDilimi,
  sektorZamanlari, gorevSonGunu, raporSaatiTuret, azamiUgsYeniden, ucusSektorSayisi, gorevAcikMesai, ucusZamanlariEksigi, saatGecerli, bacakSirasiHatasi, skpkRaporSonTarihi, rotaKopukluklari,
  simEtiketi, simKontrolleriYaz, SIM_KONTROL_KUTULARI, yerGoreviDinlenmesi, duzenlemeOnizlemesi, turetilmisleriAyikla,
  NE_YAPMALI, maxFdpKunyesi, planliAsimMetni, shiftDate, ekranDurumu, durumNeYapmali, skpkKapsamindaMi,
  egitimUcusAsimMetni, EGITIM_TURU_SECILMEDI, EGITIM_ENGEL_TURLERI, ucusEgitimTurleri, skpkUgsUzatirMi, SKPK_EGITIM_NOTU, baglantiNotu, simSonraNotu,
  blokToplamlari, OPERATION_TYPES, sirketEsasiyla, esasSecili, hesapTuru, bacakTipi,
} from './FTLEngine';
import { normTime } from './inputFormat';
import { withReason } from '../editReason';
import { esc } from './htmlKacis';   // baskı pencerelerinin HTML kaçışı tek kaynak (W7)
import DutySheet, { gorevCizelgesi, oncekiAy, cizelgeHtml, CizelgeKagidi, cizelgeYazdir, buAy, ayKaydir, rosterCizelgesi, rosterHtml } from './DutySheet';
import { duzenleyenKodu } from './duzenleyen';
import { offlariRestYap } from './offRestCevirici';
// 🔑 Gece/gündüz SUNUCUYLA AYNI motordan (7 Eyl 2026) — iki ayrı gece tanımı
//    olsaydı aynı uçuş, arşivden mi elle mi girildiğine göre farklı çıkardı.
import { geceMiMeydan } from './SolarTimes';
import FTLLimitsBar from './FTLLimitsBar';
import FCLLimitsBar from './FCLLimitsBar';
import LocationPicker from './LocationPicker';
import { useDutyLocations } from './useDutyLocations';
import { ayniGunPlani, elleDuzeltmeKaynagi } from './ucusPlani';
import { izOnceYaz, raporuYenile } from './arsivIzi';   // arşiv düzeltmesi: iz önce + rapor yenileme sonucu (21 Eki 2026)   // görevin planı: yalnız aynı gün (21 Eki 2026, Serkan A)
import { locationKurali, locationEksigi, offYeriEksigi, offYeriHataMetni } from './DutyLocationRules';
import TrainingPanel from './TrainingPanel';
import AtplMedPanel, { yas as plmYas, fcl065 as plmFcl065 } from './AtplMedPanel';
import Katlanir from './Katlanir';
import InfoDot from './InfoDot';
import { shtBloklari, kaynakKunyesi, sirketKurallari } from './FTLRuleCatalog';
import { maddeMetni } from '../data/shtArticles';

import HarfliGiris from './HarfliGiris';
import MeydanGirisi, { dakikaFark } from './MeydanGirisi';
import { useSirketDilimi } from './sirketDilimi';
import { INIS_TIPLERI } from './inisTipiSayim';
import {
  rolAta, bacakHatasi, haritalariKur, crzVar, crzUyeleri, AZAMI_CRZ, dortPilotVar,
  uyeCikar, uyeEkle, bacakPilotlari, rolOzeti, rolleriUygula,
} from './EkipRolleri';
import { bildirimleriTazele } from './bildirimOlayi';
import { dbHata } from './dbHata';
import { kunyeMetni } from './kunyeMetni';
import { ucusEkibindenMi, tipYetkiHaritasi, tipYetkisiEngelleri } from '../roller';
import { vh, vw } from '../yaziBoyutu';
import { utcGun, utcGunAy, utcGunAySaat, utcSaat } from '../utcTarih';
// zAlan: zorunlu alan rengi — `zorunlu` ve `dolu` çağıranın KAYDETME KAPISININ koşulundan gelir (renk ile kapı ayrışmasın).
import { dugmeStili, sekmeStili, SEKME_CUBUGU, KUTU_SINIFI, zAlan } from './tasarim';
import { kagitEvrakDenetle, kagitEvraklari, kagitEvrakEkle, kagitEvrakKaldir, mbYaz, evrakliKagitAnahtarlari } from './kagitEvrak';
import { canliKagitAnahtarlari, kagitCanliBacaklari, kagitIptalEtkisi, kagitKaydiGecersizKil, kagitOzeti,
         KAGIT_GECERSIZ_IZ } from './kagitUcusSil';
import { kagitAnahtari, kagitBacagiMi, kagitGorevDurumu, PAPER_OFP_IPUCU, NO_DOCS_IPUCU } from './kagitUcus';
import { satirGrubuAnahtari, satirGrubu, rosterGruplari } from './rosterGrup';
import { useRaaqKayitlari, raaqKodlari, raaqEksigi } from './raaqKaydi';   // RAAQ erken uyarısı (21 Eki 2026)
import IsaretKutusu from './IsaretKutusu';
import { SecimKutusu } from './GosterGizle';
import { GerekcePenceresi, GerekceIpucu, gerekceTamam, gerekceIpucuMetni } from './gerekce';   // tek gerekçe penceresi + kural (21 Eki 2026, K7)   // seçim kutusu tasarım S1 (5 Eki 2026) — tek bileşen
import { hesabiBekle, hesapUyarisi } from './ftlHesapBekle';
import { SAYILI, hepsiniOku, okumaDenetimi, sayfaHataMetni } from './kesikOkuma';   // 24 ay şartı — kesik okuma sessiz geçmez (6 Eki 2026)
import Sayfalama, { SAYFA_BOYU, sayfaSayisi } from './Sayfalama';   // 3. adım — sayfalı liste, tek tip (6 Eki 2026)
import OkumaHatasi from './OkumaHatasi';
import { usePencereKapat, KapatX } from './pencereKapat';   // pencere kapatma tek tip — ESC + ✕ (12 Eki 2026)
const C = {
  bg:'var(--bg)', bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)', border2:'var(--border2)',
  accent:'var(--accent)', accentDim:'var(--accent-soft)',
  green:'var(--green)', red:'var(--red)', blue:'var(--accent)',
  // 21 Eki 2026 (kod taraması W2): `amber` sözlükte YOKTU ama 24 yerde kullanılıyordu — 20 uyarı amber renksiz çiziliyordu.
  amber:'var(--amber)',
  t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
};
const S = {
  label:{ fontSize:10, color:C.t2, fontWeight:700, letterSpacing:1.5, textTransform:'uppercase', fontFamily:'var(--mono)', display:'block', marginBottom:6 },
  input:{ background:'var(--input-bg)', border:`1px solid ${C.border}`, borderRadius:6, color:'var(--t1)', padding:'9px 11px', fontSize:13, fontFamily:'var(--mono)', width:'100%', boxSizing:'border-box', outline:'none' },
  table:{ width:'100%', borderCollapse:'collapse' },
  th:{ padding:'9px 12px', textAlign:'left', fontSize:10, color:'var(--t1)', fontWeight:700, letterSpacing:1, textTransform:'uppercase', borderBottom:`1px solid ${C.border}`, background:C.bg3, whiteSpace:'nowrap', fontFamily:'var(--mono)' },
  td:{ padding:'9px 12px', borderBottom:`1px solid ${C.border}`, color:'var(--t1)', fontSize:12.5, fontWeight:600, verticalAlign:'middle', whiteSpace:'nowrap', fontFamily:'var(--mono)', fontVariantNumeric:'tabular-nums' },
  // 1 Eki 2026 — düğmeler ORTAK tasarımdan (tasarim.js, Serkan: "her modülün içinde butonlarda border, aynı tasarım"); eskiden bu dosyada ayrı tanımlıydı.
  btnP:dugmeStili('birincil'),
  btnS:dugmeStili('notr'),
  btnSil:dugmeStili('silme'),   // silme / geri dönüşsüz (eskiden btnS ya da btnP kırmızıya boyanıyordu)
  panel:{ background:C.bg2, border:`1px solid ${C.border}`, borderRadius:10, overflow:'hidden', marginBottom:22 },
  panelH:{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'11px 16px', borderBottom:`1px solid ${C.border}`, background:C.bg3 },
  panelT:{ fontSize:11, fontWeight:700, letterSpacing:2, color:C.accent, textTransform:'uppercase', fontFamily:'var(--mono)' },
  note:{ fontSize:10, color:C.t3, letterSpacing:.5, lineHeight:1.7, padding:'9px 12px', background:C.bg3, borderLeft:`2px solid ${C.border2}`, fontFamily:'var(--mono)' },
};
const badge = (kind) => {
  const map = {
    green:{ c:C.green, bg:'var(--green-soft)', bd:'var(--green-soft)' }, red:{ c:C.red, bg:'var(--red-soft)', bd:'var(--red-soft)' },
    blue:{ c:C.blue, bg:'var(--accent-soft)', bd:'var(--accent-soft)' }, amber:{ c:C.accent, bg:'var(--amber-soft)', bd:C.accentDim },
    dim:{ c:C.t3, bg:'var(--bg3)', bd:C.border2 },
    // 19 Eyl 2026 — Serkan: *"renk kodu zaten orange veya amber olur."*
    // AMBER = mevzuatın tanıdığı istisna (SKPK kaydı var, raporu var).
    // ORANGE = AÇIKLAMASI OLMAYAN eksik. İkisi ayrı renk olmalı ki denetçi
    // "nerede bunun raporu" diye soracağı satırı bir bakışta ayırsın.
    orange:{ c:'var(--orange)', bg:'var(--orange-soft)', bd:'var(--orange)' },
  }[kind] || {};
  return { display:'inline-block', padding:'2px 8px', fontSize:9, letterSpacing:1, fontWeight:700, border:`1px solid ${map.bd}`, color:map.c, background:map.bg, fontFamily:'var(--mono)' };
};

// ── TÜM SAATLER UTC (6 Ağu 2026, Serkan ilkesi) ─────────────────────
// "Bizim prensibe göre bütün zamanlar UTC olmalı; lokal time işleri için
//  kendi hesaplamasını yapabilir."
// Girilen ve gösterilen HER saat UTC'dir — EFB'nin geri kalanıyla (iOS, uçuş
// raporu, arşiv) aynı. YEREL saat yalnız REGÜLASYONUN İSTEDİĞİ yerde, İÇERİDE
// türetilir: Tablo 1 bandı (Md.22/2) ekibin İNTİBAK ETTİĞİ meydanın yerel
// saatiyle okunur, boş gün pencereleri (Md.4/ü) ana üssün yerel gecesiyle.
// İkisi de meydan tz'sinden hesaplanır, kullanıcıdan istenmez.
//
// Bu, eski "girilen saat kalkış meydanının yerelidir" kurgusunu bitirir ve
// onunla birlikte iki hata kaynağını da: dispatcher'ın TARAYICI dilimi ve
// "meydan tz yok → admin dilimi kullanıldı" yaması. Artık tz eksikse saat
// kaymaz; yalnız BANT çözülemez ve pilot NOT LEGAL olur (sessiz tahmin yok).
const utcISO = (dateStr, hhmm) => {
  if (!dateStr || !hhmm) return null;
  const d = new Date(`${dateStr}T${String(hhmm).padStart(5, '0')}:00Z`);
  return isNaN(d) ? null : d.toISOString();
};
const addMin = (iso, min) => iso ? new Date(new Date(iso).getTime() + min * 60000).toISOString() : null;
// YER GÖREVİNİN KAYITTAKİ BİTİŞİ — ASSIGN kapısı ve kaydı AYNI anı kullanır (5 Eki 2026). SIM: girilen "Sim ends" + Md.10(c)
// sonrası süre (aşağıdaki kayıt bloğunun gerekçesi). 🔴 Önce kapı "Sim ends"i, kayıt +60 dk'yı kullanıyordu: kapıda dinlenme,
// çakışma, toplamlar ve simülatör oturumu (Md.27(1)(a)) kaydedilecek görevden 60 dk kısa ölçülüyordu.
const yerGoreviBitisISO = (gnd, date, rules, company) => {
  if (!gnd?.end || !gnd?.start) return null;
  const girilen = utcISO(toMin(gnd.end) < toMin(gnd.start) ? nextDay(date) : date, gnd.end);
  const sonra = simSonrasiDk(gnd.kind, { rules, company });
  return sonra && girilen ? addMin(girilen, sonra) : girilen;
};
// SİMÜLATÖR SONRASI SÜRE (Md.10(c)) — TEK KURAL, ÜÇ EKRAN (ASSIGN · PLN ? · EDIT yer görevi), 5 Eki 2026. 🔑 Serkan: *"saatleri elle
// giriyoruz zaten — off block ve on block gibi düşün — üstüne 60 dk eklenecek, neden 2 kere 60 ekliyor?"* Kutu SIM ENDS'tir; kayıtta
// görev bitişi = SIM ENDS + bu süre, BİR kez; ekran kayıttaki bitişten GERİ çıkarıp gösterir. Görevin KENDİ kural seti kopyasından.
// 🔴 Önce: PLN ? kutuyu kayıttaki bitişle (60 dk dahil) doldurup bir daha 60 ekliyordu (her "oldu" onayı 60 dk uzatıyordu); EDIT kutuyu
// görev bitişi sayıp hiç eklemiyordu (ASSIGN'dan farklı anlam).
function simSonrasiDk(kind, kural) {
  if (kind !== 'sim' || !kural?.rules) return 0;
  return bildirimSureleri(kural.rules, kural.company, { egitim: true })?.postFlightMin ?? 0;
}
const satirKurali = (row, yedek = null) => (row?.ruleset_snapshot?.regulation ? effectiveRules(row.ruleset_snapshot)
  : (yedek ? effectiveRules(yedek) : null));
/** Kayıttaki görev bitişinden ekranın SIM ENDS kutusu (HH:MM UTC) — SIM değilse bitişin kendisi. */
const kutuBitisi = (row, kind, kural) => {
  if (!row?.duty_end) return '';
  const iso = addMin(row.duty_end, -simSonrasiDk(kind, kural));
  return new Date(iso).toISOString().slice(11, 16);
};
// DH BACAKLARI → MUTLAK ANLAR (4 Eki 2026, Md.16 ⑦): ASSIGN kapısı ve kayıt AYNI anları kullanır. Gün devri: geriye
// giden her saat ertesi gündür (uçuş yolundaki kural). Eksik bacak varsa `null`.
/** DH bacağının kapı ölçüsü — kapı (`dhDamgala`) ve zorunlu alan rengi AYNI (5 Eki 2026): boş satır sayılmaz, yazılmış
 *  satırın DEP, DEST ve iki saati zorunlu; hiç satır yazılmamışsa ilk satır zorunlu. */
export const dhSatirDolu = (l) => !!(l && (l.dep || l.dest || l.start || l.end || l.flt));
export const dhSaatGecerli = (t) => /^\d{2}:\d{2}$/.test(t || '');
export const dhSatirZorunlu = (legs, i) => dhSatirDolu((legs || [])[i]) || (i === 0 && !(legs || []).some(dhSatirDolu));
/** DH bacaklarının eksikleri ADIYLA — `dhDamgala` ile AYNI ölçü (boş: hiç başlanmamışsa ilk satır eksiktir). DH görevi ve
 *  uçuş öncesi konumlandırma kapısı bu mesajı kullanır (5 Eki 2026, Serkan A: yarım konumlandırma sessizce atılmaz). */
export const dhBacakEksikleri = (legs) => {
  const l = legs || [];
  const ad = { dep: 'DEP', dest: 'DEST', start: 'DEP UTC', end: 'ARR UTC' };
  return l.flatMap((x, i) => {
    if (!dhSatirZorunlu(l, i)) return [];
    const eksik = Object.keys(ad).filter(k => (k === 'start' || k === 'end') ? !dhSaatGecerli(x?.[k]) : !String(x?.[k] || '').trim());
    if (!eksik.length) return [];
    return [`sector ${i + 1}${x?.dep || x?.dest ? ` ${x?.dep || '?'}→${x?.dest || '?'}` : ''}: ${eksik.map(k => ad[k]).join(', ')} missing`];
  });
};
export const dhDamgala = (legs, date) => {
  const sat = (legs || []).filter(dhSatirDolu);
  const saat = dhSaatGecerli;
  if (!date || !sat.length || sat.some(l => !l.dep || !l.dest || !saat(l.start) || !saat(l.end))) return null;
  let gun = date, onceki = null;
  return sat.map(l => {
    const out = {};
    for (const k of ['start', 'end']) {
      const m = toMin(l[k]);
      if (onceki != null && m < onceki) gun = nextDay(gun);
      onceki = m;
      out[k] = utcISO(gun, l[k]);
    }
    return { ...l, ...out };
  });
};
// ── UZUN MENZİL: ÖLÇÜNÜN ANLARI + ORTAK METİNLER (30 Eyl 2026 · FTL nöbetçisi B2-3) ──
// Ölçü motorda (`uzunMenzilOlcumu`); ekran tarafı yalnız anları ve metinleri verir.
// Anlar görev penceresinden: rapor → görev sonu. Pencere uzun menzilden BAĞIMSIZ
// kurulur (uzun menzil yalnız FDP tavanını değiştirir, saatleri değil) — döngü olmaz.
function gorevAnlari(legs, konaklama, ruleset, opts, date) {
  const saat = (t) => /^\d{1,2}:\d{2}$/.test(t || '');
  if (!date || !legs?.length || !legs.every(l => saat(l.etd) && saat(l.eta))) return {};
  const w = dutyWindow(legs, konaklama, ruleset, { ...opts, longRange: false });
  if (!w?.report) return {};
  const raporISO = utcISO(date, w.report);
  return { raporISO, bitisISO: raporISO && w.dutyMin ? addMin(raporISO, w.dutyMin) : null };
}
// Tek metin, iki kapı (ASSIGN · EDIT) — eskiden EDIT'teki uyarı başka bir mevzuata (EASA) atıf yapıyordu.
const uzunMenzilUyarisi = (saat) => `TZ CROSSING ${saat}H — long-range rules per SHT-FTL/HG Md.22(3)/16(3): `
  + 'arrival rest max(duty,14:00), 48h/2 local nights on return; FDP: the table value under the '
  + 'Md.22(3) long-range limit of the ruleset (a split extension is added on top).';
// YER GÖREVİNİN DİNLENMESİ — kayıt ve uygunluk AYNI formül (30 Eyl 2026 · B3).
// HAVAALANI HARİCİ NÖBETTE sürenin yalnız %25'i görev sayılır (Md.17/2/g) ve görev
// verilmezse özel hüküm asgari 8 saat der (Md.17/2/b); öteki yer görevlerinde genel
// kural: dinlenme ≥ görev süresi, asgari ana üs tabanı.
// Yer görevi dinlenmesi motora taşındı (3 Eki 2026, `yerGoreviDinlenmesi` — tek hesap fonksiyonu da kullanır).
const dilimOkunamadiMetni = (eksik, kuralEksik = null) => (kuralEksik
  // Md.22 ② (5 Eki 2026): eşik kural setinde yoksa sebep o — "dilim okunamadı" denmez.
  ? `NOT SAVED — RULE SET: ${kuralEksik} missing, so long range (SHT-FTL/HG Md.4(ee)) cannot be measured and neither the FDP `
    + 'limit nor the rest can be computed. Nothing was written; tell GO2.'
  : `NOT SAVED — the time zone of ${[...new Set(eksik)].join(', ') || 'the aerodromes'} `
    + 'could not be read, so long range (SHT-FTL/HG Md.4(ee)) cannot be measured and neither the FDP limit '
    + 'nor the rest can be computed. Nothing was written; try again.');

// ── MEYDAN DİLİMİ NEDEN HÂLÂ LAZIM (saatler UTC olmasına rağmen) ────
// Tarihçe: 4 Ağu'da saatler ADMIN MAKİNESİNİN diliminde mutlaklaştırılıyordu;
// dönüş meydanı farklı dilimdeyse duty_end ve earliest_next_report mutlak
// zamanda kayıyor, dinlenme penceresi yanlış çıkıyordu. Buna karşı saatler
// meydan dilimleriyle mutlaklaştırıldı (`zonedISO`).
// 6 Ağu'da Serkan ilkeyi netleştirdi: **bütün zamanlar UTC**. Böylece
// mutlaklaştırma DÜZ hale geldi ve `zonedISO` ile "tz yoksa admin dilimi"
// yaması tamamen gereksizleşti — kayma kaynağı kökten kalktı.
// Meydan dilimi yine de gerekli, ama artık YALNIZ regülasyonun yerel saat
// istediği yerlerde: Tablo 1 bandı (Md.22/2, intibak edilen meydanın yereli),
// boş gün pencereleri (Md.4/ü, ana üssün yerel gecesi) ve uzun menzil
// tespiti (Md.4/ee). Bunlar hesaplanır, kullanıcıdan istenmez.
// 🔴 21 Eki 2026 (kod taraması W4b): okuma hatası okunmuyordu — düşen okuma BOŞ harita dönüyordu, yani "bu meydanların
//    dilimi kayıtlı değil": ASSIGN var olan meydanlar için "TIME ZONE UNKNOWN — add the aerodrome to AIRPORTS" diyor,
//    pilot ana üsleri şirketin üssüne düşüyordu. Artık okunamazsa `null` döner (okunamadı ≠ yok); çağıran ne yapacağını
//    söyler. Kayıt yolları zaten durur ("NOT SAVED — … could not be read … try again").
const fetchTzMap = async (icaos) => {
  const clean = [...new Set(icaos.filter(Boolean).map(x => x.toUpperCase()))];
  if (!clean.length) return {};
  let sonuc;
  try { sonuc = await supabase.from('airports').select('icao,tz').in('icao', clean); }
  catch (e) { return null; }
  if (sonuc?.error) return null;
  const m = {};
  (sonuc?.data || []).forEach(r => { if (r.tz) m[r.icao] = r.tz; });
  return m;
};
const DILIM_OKUNAMADI = 'AERODROME TIME ZONES (airports)';
// crypto.randomUUID Safari 15.4 oncesinde yok — yedegi RFC4122 v4 uretir.
const newUuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const b = new Uint8Array(16);
  window.crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map(x => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0,8)}-${h.slice(8,12)}-${h.slice(12,16)}-${h.slice(16,20)}-${h.slice(20)}`;
};
// Gösterim de UTC — tarayıcının dilimi kayda da ekrana da karışmaz.
// Ay adı sabit listeden (Eylül "SEPT" değil "SEP") — tek kaynak ../utcTarih.js.
const fmtDT = (iso) => utcGunAySaat(iso);
const fmtD = (d) => utcGunAy(d);
// GECE YARISINI GEÇEN GÖREV — SATIRDA (4 Eki 2026, Serkan A: *"satır gösteriminde 4-5 Ekim olarak tek satırda görünsün"*):
// satırın tarihi görevin başladığı günden BİTTİĞİ güne (UTC); ertesi güne düşen saat ⁺¹. Roster, DUTY HISTORY ve baskısı aynı.
const gunOf = (iso) => (iso ? new Date(iso).toISOString().slice(0, 10) : null);
export const gorevTarihi = (d) => (gorevSonGunu(d) === d.duty_date ? fmtD(d.duty_date) : `${fmtD(d.duty_date)} — ${fmtD(gorevSonGunu(d))}`);
const artiBir = (iso, gun) => (iso && gunOf(iso) > gun ? '⁺¹' : '');
// Bacakların kalkış / iniş anları — motorun tek kuralı (`sektorZamanlari`); i. bacağın [kalkış ⁺¹, iniş ⁺¹] işaretleri.
const bacakArtiBir = (d) => {
  const z = sektorZamanlari(d.duty_date, (d.sectors || []).flatMap(l => [l.off_block || l.etd, l.on_block || l.eta]));
  return (i) => [artiBir(z[i * 2], d.duty_date), artiBir(z[i * 2 + 1], d.duty_date)];
};

// ── OFF → REST (1 Eki 2026) — gerçekleşmiş görev KAYDEDİLDİKTEN SONRA, web'in dört yazan yolu buradan çağırır ──
// (uçuş EDIT'i · yer görevi "it took place" · geriye dönük atama / PAPER OFP · yer görevi EDIT'i; beşincisi
// archive-flight). Kural motorda, yazma offRestCevirici'de. Uygulamada bildirim tek ve iki türlü (2,5 sn'de kapanan
// yeşil · kalıcı kart) — gözden kaçmasın diye KALICI kart, EN SON gösterilir.
async function offRestUygula({ duties, gorevler, ruleset, offTypes, pilotDilim, myProfile, toast }) {
  try {
    const r = await offlariRestYap(supabase, {
      duties, gorevler, offTypes, editedBy: myProfile?.id ?? null, kaynak: 'web',
      kurallar: (g) => effectiveRules(g.ruleset_snapshot || ruleset).rules,
      tzOf: (pid) => (pilotDilim || {})[pid]?.tz || null,
    });
    if (r.hata) toast(r.hata, 'error');
    // 4 Eki 2026: cümle OFF → DUTY ya da OFF → REST der (`offRestMetni`); başlık ikisini de kapsar.
    else if (r.cevrilen.length) toast(`DAY OFF CANCELLED (Md.4/ü) — ${r.cevrilen.join(' · ')}`, 'error');
  } catch (e) { toast(`OFF → REST check failed: ${String(e.message || e)}`, 'error'); }
}

// ── KURAL İHLALİ KARTI (29 Eyl 2026 · adım b) ────────────────────────────
// 🔑 Serkan: *"rule set'e aykırı bir davranışta atama yapılamadığı zaman neden
//    popup ekranla mı veriyor, nasıl veriyoruz hata mesajını?"* → B: her gerekçe
//    ayrı satır, yanında ⓘ; ⓘ'de MADDENİN KENDİ METNİ (künyeden — `kunyeMetni`,
//    uydurulmaz) ve ne yapılabileceği. ÖNCESİ (ölçüldü): üç ayrı biçim — ayrı bir
//    pencere (BlockedModal), `·` ile yan yana dizilmiş genel hata kartı, dar
//    sütun; hiçbirinde madde metni yoktu.
// satirlar: [{ kim?, metin, ref?, neYapmali }] — ref gerekçeyi ÜRETEN yerden
// gelir (`kunyeli`); null ise madde gösterilmez (ör. çakışma: kayıt olgusu).
export const IHLAL_BASLIK = 'THIS DUTY CANNOT BE PLANNED';
// `NE_YAPMALI` motorda (3 Eki 2026, adım 4a): görev durumu kartı da aynı cümleleri yazar — tek kaynak.
export { NE_YAPMALI, maxFdpKunyesi };
// Uçulmuş görevde reddedilen değişiklik bir PLANLAMA değildir (SKPK tavanı).
export const KAYIT_BASLIK = 'THIS CHANGE CANNOT BE SAVED';
export function ihlalDetayi(satirlar, { baslik = IHLAL_BASLIK } = {}) {
  return {
    baslik,
    satirlar: (satirlar || []).map(x => ({
      kim: x.kim || null,
      metin: x.metin,
      aciklama: { kunye: x.ref || null, madde: x.ref ? kunyeMetni(x.ref) : null,
                  neYapmali: x.ref ? x.neYapmali : (x.neYapmaliKayit || NE_YAPMALI.kayit) },
    })),
  };
}
// Ekrandaki kutularda AYNI açıklama (30 Eyl 2026 · adım ①): kartın satırıyla tek
// kaynak (`ihlalDetayi`) — künye varsa maddenin kendi metni, yoksa "kayıt olgusu".
function IhlalNoktasi({ k, testid, neYapmali, neYapmaliKayit }) {
  const a = ihlalDetayi([{ metin: k.metin, ref: k.ref, neYapmali, neYapmaliKayit }]).satirlar[0].aciklama;
  return (
    <InfoDot testid={testid} title={a.kunye || 'RECORDS'} note={k.metin}
             madde={a.madde?.metin || null} maddeRef={a.kunye} maddeKaynak={a.madde?.kaynak || 'SHT'}
             rule={a.madde ? null : a.kunye ? `${a.kunye} — article text not found; read the regulation directly.`
                                           : 'Not a rule of the regulation — a fact about the records.'}
             action={a.neYapmali} />
  );
}
// `kunyeli` yoksa (eski çağıran) düz gerekçe künyesiz satır olur — madde uydurulmaz.
const kunyeliYaDuz = (x) => x?.kunyeli || (x?.reasons || []).map(m => ({ metin: m, ref: null }));
// TEK GEREKÇE LİSTESİ (30 Eyl 2026 · adım ③).
// 🔑 Serkan: *"bir tasarım ve bir özellik farklı farklı yerlerde kullanılıyorsa tek
//    tip olması gerekir, tek kaynaktan çekilmeli — verimi arttırır, yanlışlıkları
//    minimuma indirir."* Ekranda KIRMIZI (engelleyen) gerekçe gösteren her yer —
//    EDIT FTL/ekip kutuları, EDIT nöbet ve SKPK önizlemeleri, ASSIGN REASON sütunu,
//    yer görevi ve ekip kutuları — bunu çağırır: her gerekçe ayrı satır, yanında ⓘ.
//    ÖNCESİ: dört yer gerekçeyi ' · ' / '; ' ile tek satıra diziyordu, ⓘ iki yerde
//    elle kurulmuştu. Amber uyarılar bu listeye girmez (künyeleri yok).
// testid: satır `${testid}-satir-${i}`, ⓘ `${testid}-i-${i}`.
// neYapmaliSec (3 Eki 2026): satır başına cümle — (k) => metin; verilirse neYapmali / neYapmaliKayit yerine o.
function GerekceListesi({ kunyeli, neYapmali, neYapmaliKayit, neYapmaliSec = null, onEk = '', testid }) {
  if (!kunyeli?.length) return null;
  return (
    <>
      {kunyeli.map((k, i) => (
        <div key={i} style={{ color:C.red, fontSize:11 }} data-testid={`${testid}-satir-${i}`}>
          {onEk}{k.metin}
          <IhlalNoktasi k={k} testid={`${testid}-i-${i}`}
                        neYapmali={neYapmaliSec ? neYapmaliSec(k) : neYapmali}
                        neYapmaliKayit={neYapmaliSec ? neYapmaliSec(k) : neYapmaliKayit} />
        </div>
      ))}
    </>
  );
}
// UÇULMUŞ GÖREVİN EDIT KUTUSU (3 Eki 2026): azami UGS ve Md.16 dinlenme satırları SKPK + rapor cümlesini alır (durum
// kartıyla aynı — Serkan: *"skpk raporu yazılıp save edilince legale döner"*); öteki sebepler kayıt cümlesini.
const uculduNeYapmali = (k) => (skpkKapsamindaMi(k?.ref) ? NE_YAPMALI.skpkRapor : NE_YAPMALI.uculdu);
// EDIT'in eskiden kendi yazdığı TÜRETİLMİŞ değer iz satırları (3 Eki 2026, tek motor 1c): artık yazılmaz — o değişiklik
// sunucunun SYSTEM RECALC satırında görünür. Girdi satırları (sectors/times, route, actual times, crew, skpk …) kalır.
export const EDIT_TURETILMIS_IZ = new Set(['max_fdp', 'max_fdp (crew)', 'max_fdp (split duty)', 'standby/max_fdp',
                                           'report_time']);

// PLANLI GÖREVDE AZAMİ UGS AŞIMI — KURAL İHLALİ (3 Eki 2026, Serkan "A")
// 🔑 Planlı görev azami UGS'yi aşamaz: SKPK (Md.12) görev başladıktan sonraki öngörülemeyen olayın kaydıdır, planlama
//    aracı değildir. Eskiden ASSIGN kırmızı not gösterip kaydediyordu, EDIT yalnız "EXCEEDED" yazıyordu; nöbetten gelen
//    aşım ise engelleniyordu (tutarsız). Uçulmuş görev bir KAYITtır — orada aşım görünür ama engellemez (4 Eyl kuralı).
// Künye (`maxFdpKunyesi`) ve metin (`planliAsimMetni`) motorda — görev durumu da aynısını yazar (adım 4a).

// PİLOT BAŞINA İHLAL BİLDİRİMİ — TEK KAYNAK (30 Eyl 2026 · adım ②).
// 🔑 Serkan: *"tek kaynak prensibimiz burada da devam edecek … uyarı gösterilme
//    metodu, renk kodlaması, uniform bir tasarım ve uniform bir mimari."*
// ASSIGN kaydı · ASSIGN'da NOT LEGAL satıra tıklama · ASSIGN nöbet kapısı · EDIT
// kaydı aynı cümleyi ve aynı kartı BURADAN kurar (önce üç yerde ayrı yazılıydı).
// engelliler: [{ kim, kaynak }] — kaynak `kunyeli`/`reasons` taşıyan motor sonucu.
export function pilotIhlalBildirimi(engelliler, { basMetin = null } = {}) {
  const kimler = engelliler.map(e => e.kim).join(', ');
  return {
    mesaj: basMetin ? `${basMetin} — ${kimler}: the reasons are listed below.`
                    : `${kimler} cannot fly this duty — the reasons are listed below.`,
    detay: ihlalDetayi(engelliler.flatMap(e => kunyeliYaDuz(e.kaynak)
      .map(k => ({ kim: e.kim, metin: k.metin, ref: k.ref, neYapmali: NE_YAPMALI.pilot })))),
  };
}

// ── YAZMA SONUCU KARTI: BAŞLIK + ⓘ (29 Eyl 2026) ─────────────────────────
// 🔑 Serkan: *"hata mesajı verdiğinde … i remarka tıklayınca çıkacak mı? nasıl
//    anlayacak kullanıcı?"* → B: kartta kısa cümle, ⓘ'de NEDEN · NE YAPMALI ·
//    TEKNİK. Reddedilen yazmanın iki nedeni var, kullanıcı için iki AYRI cümle:
//    sunucu HATA döndürdü (sebebini söyler) · hata yok ama satır da yok (RLS'in
//    sessiz reddi — İlke 2). Kısmi başarıda başlık "PARTLY SAVED"dir; eski sabit
//    başlık ("nothing was written") orada yalan söylüyordu.
// Tek kaynak: FTL'nin bütün kayıt-sonucu kartları buradan kurulur.
const IZ_CUMLESI = 'Nothing is hidden: the EDIT REPORT has a "NOT WRITTEN" or "REFUSED" line '
                 + 'for every record that was not changed.';
export function yazmaDetayi({ kismen = false, hata = null, izCumlesi = IZ_CUMLESI, neYapmali = null } = {}) {
  const sunucu = hata?.message ? String(hata.message) : null;
  const ek = izCumlesi ? ` ${izCumlesi}` : '';
  // Yola özel yönlendirme (varsa) varsayılanın ÖNÜNE eklenir, yerine geçmez.
  const once = neYapmali ? `${neYapmali} ` : '';
  return {
    baslik: kismen ? 'PARTLY SAVED — some records were written, some were not' : 'NOT SAVED',
    aciklama: sunucu ? {
      neden: `The server refused the change and gave this reason: ${dbHata(sunucu).metin}`,
      neYapmali: once + 'Correct what the reason points to and try again. If the reason is not '
                 + 'clear, send the technical text below to the EFB admin.' + ek,
      teknik: sunucu,
    } : {
      neden: 'The database received the change but did not apply it, and returned no error. That is how '
           + 'a permission rule refuses a write: your role may not be allowed to change this record, the '
           + 'record may belong to another company, or your session may have expired.',
      neYapmali: once + 'Log out, log in again and repeat the change. If it is refused again, '
                 + 'tell the EFB admin.' + ek,
      teknik: 'The write returned no row (0 rows affected) and no error.',
    },
  };
}

// ── İZLİ TEK SATIR YAZMA — TEK KAYNAK (29 Eyl RULE SET'te doğdu · 30 Eyl ortak) ──
// 🔑 Serkan (30 Eyl): *"bir tasarım ve bir özellik farklı yerlerde kullanılıyorsa
//    tek tip olmalı, tek kaynaktan çekilmeli."* Aynı desen (iz ÖNCE → yazma dönen
//    satırla → satır dönmezse iz yanına DÜZELTME SATIRI → kart NOT SAVED + ⓘ)
//    RULE SET sekmesinde yazılıydı, match review kapatmada eksikti.
// İz düşerse hiçbir şey değişmez; yazma reddedilirse iz kendini düzeltir, silinmez
// (İlke 2 · 3). Hata varsa { metin, detay } döner, yoksa null.
export async function izliYaz({ izTablosu, tablo, id, patch, izler, duzeltme, logAdi, izCumlesi }) {
  const { error: izErr } = await supabase.from(izTablosu).insert(izler);
  // İz düşerse hiçbir şey değişmedi: "nothing was changed" DOĞRU, detay yok.
  if (izErr) return { metin: `Audit write failed — nothing was changed: ${izErr.message}`, detay: null };
  const { data: donen, error } = await supabase.from(tablo).update(patch).eq('id', id).select('id');
  if (!error && donen?.length === 1) return null;
  const { error: dErr } = await supabase.from(izTablosu).insert(izler.map(z => ({ ...z, ...duzeltme })));
  // Kartta kısa cümle; neden/ne yapmalı/teknik ⓘ'de (yazmaDetayi).
  return {
    metin: 'NOT SAVED — the change was refused.'
      + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
              : ` ${logAdi} records that it was not written.`),
    detay: yazmaDetayi({ hata: error, izCumlesi }),
  };
}

// scopeCustomerId: super admin BASKA bir sirketi izliyorsa dolu gelir. Panelin
// tamami tek bir customerId uzerinden calistigi icin bu tek nokta yetiyor.
// `focusDutyId` — ust bardaki candan gelir (26 Agu 2026). Can yalnizca
// GOSTERIR ve buraya GETIRIR; SKPK kaydini yazan tek yer roster'in EDIT
// akisidir. Ikinci bir yazma yolu acmiyoruz (Ilke 3): 1 saat esigi ve 28
// gunluk SHGM tarihi orada motordan hesaplaniyor.
export default function FTLPanel({ toast, myProfile, customerId: scopeCustomerId = null, readOnly = false,
                                   focusDutyId = null, onFocusHandled = null }) {
  // readOnly: super admin BASKA sirketi izliyor. Yazan gorunumler (gorev atama,
  // SKPK, ruleset) hic acilmaz — acilsalardi RLS yazmayi reddederdi ve kullanici
  // ham veritabani hatasi gorurdu. Salt okunurken denetim icin gereken zaten
  // GOREV GECMISI ve DUZELTME RAPORU'dur, ikisi de yazmaz.
  const [view, setView] = useState(readOnly ? 'history' : 'assign');
  const [whatIfAcik, setWhatIfAcik] = useState(false);
  // ROSTER'ın gösterilen ayı ve görünümü PANELDE (21 Eki 2026): kayıttan sonra panel LOADING'e dönüp roster'ı kaldırır;
  // durum roster'ın içinde olsaydı her kayıtta bugünkü aya / kâğıda geri dönerdi.
  const [rosterAyi, setRosterAyi] = useState(() => buAy());
  const [rosterGorunumu, setRosterGorunumu] = useState('sheet');   // WHAT IF penceresi (12 Eki 2026)
  // Canadan bir goreve gelindiyse roster sekmesine gec (EDIT orada aciliyor).
  useEffect(() => { if (focusDutyId && !readOnly) setView('assign'); }, [focusDutyId, readOnly]);
  const [pilots, setPilots] = useState([]);
  const [duties, setDuties] = useState([]);
  // ── UÇUŞ SAATLERİNİN SAHİBİ (19 Eyl 2026) ─────────────────────────
  // 🔑 Serkan: *"Aynı data farklı farklı yerlerde olamaz."* Uçulmuş sektörün
  //    saatlerinin sahibi `archived_flights`tir; görev yalnız bağı (`plan_id`)
  //    taşır. Panel bugüne kadar bu tabloyu HİÇ okumuyordu, o yüzden sektöre
  //    yazılmış EKSİK kopyayı gösteriyordu (T/O ve LND hep boş).
  //    Anahtar: plan_id → uçuş satırı.
  const [ucuslar, setUcuslar] = useState({});
  const [baselines, setBaselines] = useState([]); // en güncel satır / pilot
  const [ruleset, setRuleset] = useState(null);
  const [offTypes, setOffTypes] = useState([]);
  const [homeBases, setHomeBases] = useState({});
  const [lisansMed, setLisansMed] = useState({});      // pilot_id → ATPL & MED satiri
  const [tipVasiflari, setTipVasiflari] = useState({}); // pilot_id → [ac_type]
  const [loading, setLoading] = useState(true);
  // Açılış okumalarından DÜŞENLER: [{ ad, metin }] — null ise hepsi okundu.
  const [yuklemeHatasi, setYuklemeHatasi] = useState(null);

  const customerId = scopeCustomerId || myProfile?.customer_id;
  // Yer gorevi / egitim LOCATION listesi (1 Eyl 2026) — okuma+ekleme ORTAK
  // kancada, egitim formuyla ayni kod (Ilke 3).
  const { locations: dutyLocations, okumaHatasi: konumHatasi, addLocation, reloadLocations } = useDutyLocations(customerId);
  // ASGARI UCUS EKIBI (Serkan, 3 Eyl 2026) — ucak kaydindan okunur, koda
  // gomulmez (Ilke 6). Bos ise KONTROL YAPILMAZ; bos "1 yeter" DEMEZ.
  // 🔴 21 Eki 2026 (W4b): okuma hatası okunmuyordu — düşünce liste boş kalıyor, asgari ekip kapısı "tanımlı değil" sayıp
  //    SESSİZCE hiç denetlemiyordu. Artık düşen ya da kesik okuma panelin okuma kutusuna katılır (yarım veriyle açılmaz).
  const [aircraft, setAircraft] = useState([]);
  const [ucakHatasi, setUcakHatasi] = useState(null);
  const [ucakDeneme, setUcakDeneme] = useState(0);
  useEffect(() => {
    if (!customerId) return;
    let dead = false;
    (async () => {
      const { dustu, oku } = okumaDenetimi();
      const data = oku('AIRCRAFT (aircraft)', await supabase.from('aircraft')
        .select('registration,ac_type,min_flight_crew,active', SAYILI).eq('customer_id', customerId));
      if (dead) return;
      setUcakHatasi(dustu.length ? dustu : null);
      setAircraft(dustu.length ? [] : (data || []));
    })();
    return () => { dead = true; };
  }, [customerId, ucakDeneme]);

  // ── PILOT DILIMI — TEK KAYNAK (21 Eyl 2026) ────────────────────────
  //
  // 🔑 Serkan: *"home base bos kalamaz"* · *"home base sirketin tanimlamasi
  //    gereken bir durum dinlenme sureleri icin"* · *"yurt disinda yasayan
  //    pilot sirket kurallari geregi mumkun degil; ucakla ayni basede olsun
  //    ister sirketler"* → ana us bos kalirsa SIRKETIN base'i dogru vekildir,
  //    cunku pilot fiilen orada.
  //
  // 🔴 ONCESI: dilim IKI AYRI YERDE cozuluyordu (`AssignDuty.hbTz` ve
  //    `DutyHistory.hbIcaoTz`), UCUNCU ve DORDUNCU yer (EDIT modali, FTL LIMITS
  //    cubugu) hic cozmuyordu. Cozmeyen ikisi `zonedISO`'nun eski yedek
  //    kuraliyla MAKINENIN dilimine dusuyordu: ayni gorev ASSIGN'da LTAC'a,
  //    EDIT'te tarayiciya gore olculuyordu. Turkiye'den bakilinca ikisi
  //    tesadufen ortusuyor (+03:00), yurt disindan bakilinca ayriliyor.
  //    Artik tek yerde cozulur ve asagi verilir (Ilke 3).
  // ⚠️ KAPSAMLI cagri: super admin baska bir sirketi izliyorsa (`customerId`)
  //    vekil dilim O SIRKETIN ussunden gelir, girisi yapanin sirketinden degil.
  const sirketDilimi = useSirketDilimi(customerId || null);
  const [usDilimleri, setUsDilimleri] = useState({});   // ICAO -> IANA
  // 🔴 21 Eki 2026 (W4b): okunamayan ana üs dilimi "kendi üssü yok" sayılıp ŞİRKETİN üssüne düşüyordu (yurt dışı üslü
  //    pilotun yerel geceleri yanlış dilimle ölçülürdü). Artık panelin okuma kutusuna katılır.
  const [usDilimHatasi, setUsDilimHatasi] = useState(null);
  const [usDilimDeneme, setUsDilimDeneme] = useState(0);
  useEffect(() => {
    const icaos = [...new Set(Object.values(homeBases || {}).filter(Boolean))];
    if (!icaos.length) { setUsDilimleri({}); setUsDilimHatasi(null); return; }
    let dead = false;
    (async () => {
      const m = await fetchTzMap(icaos);
      if (dead) return;
      setUsDilimHatasi(m ? null : [{ ad: `${DILIM_OKUNAMADI} — home bases`, metin: 'could not be read' }]);
      setUsDilimleri(m || {});
    })();
    return () => { dead = true; };
  }, [homeBases, usDilimDeneme]);

  /** pilot_id -> { tz, icao, kaynak: 'own' | 'company' | null }
   *  `kaynak` EKRANDA GORUNUR: sirketin base'ine dusuldugu durum dogru bir
   *  olcumdur ama EKSIK BIR KAYITTIR — soylenmezse kimse doldurmaz (Ilke 1). */
  const pilotDilim = useMemo(() => {
    const out = {};
    (pilots || []).forEach(p => {
      const icao = (homeBases || {})[p.id];
      const own = icao ? usDilimleri[String(icao).toUpperCase()] : null;
      if (own) { out[p.id] = { tz: own, icao: String(icao).toUpperCase(), kaynak: 'own' }; return; }
      if (sirketDilimi.durum === 'hazir' && sirketDilimi.tz) {
        out[p.id] = { tz: sirketDilimi.tz, icao: sirketDilimi.icao, kaynak: 'company' };
        return;
      }
      out[p.id] = { tz: null, icao: null, kaynak: null };
    });
    return out;
  }, [pilots, homeBases, usDilimleri, sirketDilimi]);

  const load = useCallback(async () => {
    setLoading(true);
    setYuklemeHatasi(null);
    // ── OKUMA DÜŞERSE EKRAN YARIM VERİYLE AÇILMAZ (29 Eyl 2026) ──────────
    // 🔴 ÖNCESİ: dokuz okumanın hiçbirinin `error`ü okunmuyordu. Supabase
    //    hatayı fırlatmaz, `{ error }` döndürür (İlke 2) — düşen okuma BOŞ
    //    LİSTE gibi görünüyordu: görevler düşerse ekran "görev yok" diyor,
    //    kümülatifler 0 çıkıyor, pilot yasal görünüyordu. Kural seti düşerse
    //    "NO FTL RULESET LINKED" diyordu — bağlı olan kural seti için yanlış cümle.
    // 🔑 Şimdi: biri bile düşerse panel ÇİZİLMEZ; düşen okuma ADIYLA ve
    //    sunucunun KENDİ cümlesiyle söylenir (FTL nöbetçisi, ölçüm 1 · A1).
    //    `dbHata` kullanılmadı: o YAZMA hataları içindir, RLS'i "bu değişikliği
    //    yapmaya yetkin yok" diye çevirir — okumada yanlış cümle olurdu.
    // 🔴 KESİK OKUMA DA DÜŞMÜŞ SAYILIR (6 Eki 2026 · 24 ay şartı): sunucu tek istekte belli sayıda satır
    //    döndürür, fazlasını HATA VERMEDEN keser. Aşağıdaki her liste okuması `SAYILI` istenir; gelen satır
    //    toplamdan azsa panel AÇILMAZ, okuma adıyla ve "1000 of 1250" sayılarıyla söylenir (kesikOkuma.js).
    //    Kural tek kaynaktan (`okumaDenetimi`, kesikOkuma.js) — AIRCRAFTS da aynısını kullanır.
    const { dustu, oku } = okumaDenetimi();
    // ŞİRKET FİLTRESİ AÇIKÇA YAZILIYOR (10 Ağu 2026).
    // Eskiden tenant ayrımını tamamen RLS yapıyordu ve bu, süper admin için
    // sessizce bozuluyordu: süper adminin okuma politikaları çok kiracılıdır,
    // filtresiz sorgu BÜTÜN şirketlerin görevlerini getirir. Serkan hem süper
    // admin hem REC admini olduğu için bu, kendi panelinde başka şirketin
    // verisini görmesi demekti. Filtre artık koda yazılı.
    const okumalar = [
      ['PILOT LIST (profiles)',
        supabase.from('profiles').select('id,code,full_name,role', SAYILI).eq('customer_id', customerId).order('full_name')],
      // 🔑 BÜYÜYEN TABLO (görevler) PARÇA PARÇA okunur (6 Eki 2026 · `hepsiniOku`): sunucu sınırı ne olursa olsun TAM
      //    gelir — FTL hesabı görevin bütün geçmişini ister; öteki listeler ana veridir (filo/ekip büyüklüğüyle sınırlı),
      //    toplamı isteyip kesiği söyler. EDIT REPORT izleri artık kendi sekmesinde, aralık + sayfa ile okunur (3. adım).
      ['DUTIES (crew_duties)',
        hepsiniOku(() => supabase.from('crew_duties').select('*', SAYILI).eq('customer_id', customerId).order('report_time', { ascending: true }))],
      ['FTL BASELINES (ftl_pilot_baselines)',
        supabase.from('ftl_pilot_baselines').select('*', SAYILI).eq('customer_id', customerId).order('created_at', { ascending: false })],
      ['COMPANY RECORD (customers)',
        supabase.from('customers').select('id,ftl_ruleset_id,ftl_hesap_esasi').eq('id', customerId).single()],
      ['OFF-DUTY TYPES (ftl_off_types)',
        supabase.from('ftl_off_types').select('*', SAYILI).eq('customer_id', customerId).eq('active', true).order('code')],
      ['HOME BASES (home_bases)',
        supabase.from('home_bases').select('pilot_id,icao', SAYILI)],
      // EDIT REPORT burada OKUNMAZ (6 Eki 2026, 3. adım): iz kayıtları yalnız o sekmede, seçilen aralığın sayfası okunur.
      // 🔑 ATPL & MED — kisi/lisans/saglik olgulari. Serkan (5 Eyl 2026):
      //    *"MED talimatindaki korelatif kurallari assign modulde
      //     calistirabilmemiz lazim."*  Veri tek yerde girilir, buraya OKUNUR.
      ['ATPL & MED (pilot_licence_med)',
        supabase.from('pilot_licence_med').select('*', SAYILI).eq('customer_id', customerId)
          .order('created_at', { ascending: false })],
      ['TYPE QUALIFICATIONS (crew_qualifications)',
        supabase.from('crew_qualifications').select('pilot_id,ac_type', SAYILI)],
    ];
    const sonuclar = await Promise.all(okumalar.map(([, sorgu]) => sorgu));
    const [p, d, b, cust, ot, hb, plm, cq] = sonuclar.map((s, i) => oku(okumalar[i][0], s));
    if (dustu.length) { setYuklemeHatasi(dustu); setLoading(false); return; }
    const bazlar = Object.fromEntries((hb || []).map(h => [h.pilot_id, h.icao]));
    // Pilot basina EN YENI lisans/saglik satiri (Ilke 4 — duzeltme yeni satir).
    const lisansMed = {};
    (plm || []).forEach(r => { if (!lisansMed[r.pilot_id]) lisansMed[r.pilot_id] = r; });
    setLisansMed(lisansMed);
    setTipVasiflari(tipYetkiHaritasi(cq));
    setPilots(p || []); setOffTypes(ot || []);
    setHomeBases(bazlar);
    // ── TEK GECIS NOKTASI (27 Agu 2026) ─────────────────────────────────
    // PLN satirlarinin dinlenmesi burada O ANKI plandan TURETILIR; ACT
    // satirlarina DOKUNULMAZ (islenen saatler nihai olandir).
    // Asagidaki her sey — roster, gorev gecmisi, FTL LIMITS cubugu, atama
    // uygunlugu, can — AYNI listeyi okur, dolayisiyla iki ekran ayni gorev
    // icin farkli sayi gosteremez (Serkan: "plan ile act arasinda celiski
    // dogmamasi gerekir").

    // ── SAATLERİN SAHİBİNİ ÇEK ─────────────────────────────────────────
    // `archived_flights`ta `customer_id` YOK (bağ plan üzerinden). Tenant
    // güvenliği şuradan gelir: plan id'leri ZATEN müşteriye süzülmüş
    // görevlerin sektörlerinden toplanıyor.
    // ⚠️ `.in()` parça parça: tek istekte yüzlerce id URL sınırına dayanır ve
    //    sessizce kırpılırdı. 200'lük dilimler — İlke 9, her koşulda çalışsın.
    const planIdleri = [...new Set((d || []).flatMap(x => (x.sectors || [])
      .map(sk => sk.plan_id).filter(Boolean).map(String)))];
    const ucusMap = {};
    for (let i = 0; i < planIdleri.length; i += 200) {
      // Dilim düşerse sektörler saklı eksik kopyada kalırdı (T/O–LND boş) —
      // o da yarım veridir, panel açılmaz.
      const af = oku('FLIGHT TIMES (archived_flights)', await supabase.from('archived_flights')
        .select('id,plan_id,off_blocks,takeoff_time,landing_time,on_blocks,block_minutes,airborne_minutes', SAYILI)
        .in('plan_id', planIdleri.slice(i, i + 200))
        .is('deleted_at', null));
      if (dustu.length) { setYuklemeHatasi(dustu); setLoading(false); return; }
      (af || []).forEach(r => { ucusMap[String(r.plan_id)] = r; });
    }
    setUcuslar(ucusMap);

    // ── PLANLI UÇUŞLARIN MEYDAN DİLİMLERİ (30 Eyl 2026 · FTL nöbetçisi B2-2) ──
    // Projeksiyon dinlenmede uzun menzili (Md.16(3)) ölçer; dilimler BURADA bir
    // kez okunur (200'lük dilimler, yukarıdaki gibi). Okuma düşerse panel
    // açılmaz (A1) — eksik dilimle "uzun menzil değil" denmez.
    const planliIcao = [...new Set((d || [])
      .filter(x => x.status === 'planned' && x.duty_type === 'flight')
      .flatMap(x => (x.sectors || []).flatMap(sk => [sk.dep, sk.actual_dest ?? sk.dest]))
      .filter(Boolean).map(x => String(x).toUpperCase()))];
    const tzHaritasi = {};
    for (let i = 0; i < planliIcao.length; i += 200) {
      const ap = oku('AERODROME TIME ZONES (airports)', await supabase.from('airports')
        .select('icao,tz', SAYILI).in('icao', planliIcao.slice(i, i + 200)));
      if (dustu.length) { setYuklemeHatasi(dustu); setLoading(false); return; }
      (ap || []).forEach(r => { if (r.tz) tzHaritasi[String(r.icao).toUpperCase()] = r.tz; });
    }

    // ── ÇÖZÜMLEME TEK YERDE (19 Eyl 2026) ──────────────────────────────
    //
    // 🔑 SAKLAMA tek kaynaktır; OKUMA çözümlenmiş olmalıdır. Sektörün saatleri
    //    sahibinden (uçuş kaydı) burada BİR KEZ çözümlenir ve aşağıdaki her şey
    //    — roster · görev geçmişi · FTL motoru · limit çubuğu · rapor — çözülmüş
    //    hâli okur. Böylece 36 okuma noktasının her birine ayrı ayrı "sahibi
    //    kim" sorusu gömülmez (İlke 3: tek sahip, tek çözümleyici).
    //
    // ⚠️ Bu bir KOPYA DEĞİLDİR: bellekte, okuma anında türetilir, hiçbir yere
    //    yazılmaz. Kalıcı kopya adım 2b'de `crew_duties.sectors`tan kalkacak.
    //
    // 🔑 Kazancı yalnız T/O–LND değil: uçuş kaydının saatleri TAM ANdır
    //    (tarih dahil), sektörünki tarihsiz "HH:MM". 15 Eyl'deki gün devri
    //    kusuru tarihsizlikten doğmuştu.
    const cozumle = (liste) => (liste || []).map(x => {
      if (!(x.sectors || []).length) return x;
      let degisti = false;
      const sek = x.sectors.map(sk => {
        const t = sektorSaatleri(sk, sk.plan_id ? ucusMap[String(sk.plan_id)] : null);
        if (t.kaynak !== 'flight') return sk;
        degisti = true;
        return { ...sk, off_block: t.off_block, on_block: t.on_block,
                 takeoff_time: t.takeoff_time, landing_time: t.landing_time,
                 off_block_iso: t.offISO, on_block_iso: t.onISO,
                 takeoff_iso: t.toISO, landing_iso: t.lndISO };
      });
      return degisti ? { ...x, sectors: sek } : x;
    });
    setDuties(projectPlannedRest(cozumle(d || []), bazlar, tzHaritasi));
    // pilot başına en güncel baseline
    const seen = {};
    (b || []).forEach(r => { if (!seen[r.pilot_id]) seen[r.pilot_id] = r; });
    setBaselines(seen);
    // "NO FTL RULESET LINKED" yalnız GERÇEKTEN bağ yoksa söylenir; bağlı kural
    // seti okunamadıysa bu, okuma hatasıdır ve adıyla söylenir.
    if (cust?.ftl_ruleset_id) {
      const rs = oku('FTL RULESET (ftl_rulesets)',
        await supabase.from('ftl_rulesets').select('*').eq('id', cust.ftl_ruleset_id).single());
      if (dustu.length) { setYuklemeHatasi(dustu); setLoading(false); return; }
      // 🔑 FTL HESAP ESASI (31 Eki 2026): şirketin seçimi (süper admin) kural setinin şirket katmanına konur — ASSIGN/EDIT
      //    pencereleri ve görev kopyası (`ruleset_snapshot`) bu birleşik setten. Kural setine YAZILMAZ (RULESET SETTINGS ayıklar).
      setRuleset(rs ? sirketEsasiyla(rs, cust.ftl_hesap_esasi) : null);
    } else {
      setRuleset(null);
    }
    setLoading(false);
  }, [customerId]);
  useEffect(() => { if (customerId) load(); }, [load, customerId]);
  // ── KAYIT SONRASI ZİL DE TAZELENİR (29 Eyl 2026) ─────────────────────
  // Zil görevleri de okuyor (SKPK uyarıları, FCL.060 yakınlığı — PF bacak
  // sayısı). Bir atama/düzenleme kaydedilince panel yeniden okunur; zil 5 dk
  // beklemesin diye aynı anda haber alır. İlk açılışta ATILMAZ — zil kendi
  // açılışında zaten okuyor.
  // 🔑 TEK MOTOR TEK YOL (3 Eki 2026, Serkan): türetilmiş FTL değerlerini yalnız sunucudaki motor yazar; kayıttan
  // sonra veritabanı tetikleyicisi onu çağırır. Önce HEMEN okunur (kaydedilen girdiler görünsün), bekleyen hesap varsa
  // "RECALCULATING" gösterilir, hesap bitince YENİDEN okunur. Hata / zaman aşımı GİZLENMEZ (ftlHesapBekle).
  const [hesapDurumu, setHesapDurumu] = useState(null);
  const tazele = useCallback(async () => {
    load(); bildirimleriTazele();
    setHesapDurumu('bekliyor');
    const s = await hesabiBekle(supabase, customerId);
    setHesapDurumu(s.durum === 'yok' || s.durum === 'tamam' ? null : s);
    if (s.durum !== 'yok') load();
  }, [load, customerId]);
  const hesapNotu = hesapUyarisi(hesapDurumu);

  // Sekmeler FLT OPS ile AYNI kutu tasarımı — tek kaynak tasarim.js (1 Eki 2026, Serkan: "bu modüldeki butonlar değişmemiş").
  const sekme = (t, ad, ek = null) => (
    <button key={t} type="button" data-testid={`ftl-sekme-${t}`} className={KUTU_SINIFI}
            style={sekmeStili(view === t)} onClick={() => setView(t)}>{ad}{ek}</button>
  );

  // SKPK'nin 28 gunluk SHGM suresi (Md.12/1/c/2) SESSIZCE gecmemeli: gecikmis
  // sayi SEKMENIN USTUNDE durur, ilgili sekme acilmasa bile gorunur.
  const skpkOverdue = useMemo(() => {
    const now = Date.now();
    const seen = new Set();
    return (duties || []).filter(d => {
      if (d.status === 'cancelled' || !d.skpk_authority_due || d.skpk_authority_reported_at) return false;
      const k = d.assignment_id || d.id;
      if (seen.has(k)) return false;                       // olay basina 1 kez
      seen.add(k);
      return sonTarihDurumu(d.skpk_authority_due, now).gecti;   // tek hesap (21 Eki 2026, K9)
    }).length;
  }, [duties]);

  if (!customerId) return <div style={{ padding:32, color:C.t3, fontSize:11, fontFamily:'var(--mono)' }}>NO CUSTOMER CONTEXT — select a company first.</div>;
  if (loading) return <div style={{ padding:32, textAlign:'center', color:C.t3, fontSize:11, fontFamily:'var(--mono)' }}>LOADING FTL DATA...</div>;
  // Kutu tek tip (OkumaHatasi.js) — AIRCRAFTS da aynısını çizer. Görev yerleri ayrı kancadan okunur, düşerse aynı kutuya
  // katılır (21 Eki 2026, W4 — boş şehir listesi "yok" sanılmasın).
  // 21 Eki 2026 (W4b): uçak listesi (asgari ekip) ve pilot ana üs dilimleri de ayrı okunur — düşerse aynı kutuya.
  if (yuklemeHatasi || konumHatasi || ucakHatasi || usDilimHatasi) return (
    <OkumaHatasi testid="ftl-yukleme-hatasi" style={{ padding:32 }}
      satirlar={[...(yuklemeHatasi || []), ...(konumHatasi || []), ...(ucakHatasi || []), ...(usDilimHatasi || [])]}
      onRetry={() => { if (yuklemeHatasi) load(); if (konumHatasi) reloadLocations();
                       if (ucakHatasi) setUcakDeneme(n => n + 1); if (usDilimHatasi) setUsDilimDeneme(n => n + 1); }}
      baslik="FTL DATA COULD NOT BE LOADED — the screen is not shown with partial data." />
  );
  if (!ruleset) return <div style={{ padding:32, color:C.red, fontSize:11, fontFamily:'var(--mono)' }}>NO FTL RULESET LINKED TO THIS CUSTOMER — run Faz 0 SQL / link customers.ftl_ruleset_id.</div>;

  return (
    <div style={{ flex:1, overflowY:'auto', minWidth:0 }}>
      <div style={SEKME_CUBUGU}>
        {!readOnly && sekme('assign', 'Assign Duty')}
        {sekme('history', 'Duty History')}
        {sekme('training', 'Training')}
        {/* 🔑 Serkan (5 Eyl 2026): *"Bu gereklilikleri yeni bir modüle koyacağız —
            'ATPL and MED', FTL modülün altına yeni modül."* */}
        {sekme('atplmed', 'ATPL & MED')}
        {!readOnly && sekme('skpk', 'SKPK', skpkOverdue > 0 && <span style={badge('red')}>{skpkOverdue}</span>)}
        {sekme('edits', 'Edit Report')}
        {!readOnly && sekme('ruleset', 'Ruleset')}
        <div style={{ marginLeft:'auto', fontSize:9, color:C.t3, letterSpacing:1, fontFamily:'var(--mono)' }}>
          {readOnly && <span style={{ color:C.red, marginRight:10 }}>READ ONLY</span>}
          {ruleset.name} · ALL TIMES UTC
        </div>
      </div>
      <div style={{ padding:18 }}>
        {hesapNotu && (
          <div data-testid="ftl-hesap-uyarisi" data-renk={hesapNotu.renk}
               style={{ marginBottom:12, padding:'8px 12px', borderRadius:6, fontSize:10, letterSpacing:0.5,
                        fontFamily:'var(--mono)', display:'flex', alignItems:'center', gap:10,
                        color: hesapNotu.renk === 'kirmizi' ? C.red : C.accent,
                        border:`1px solid ${hesapNotu.renk === 'kirmizi' ? C.red : C.accent}` }}>
            <span style={{ flex:1 }}>{hesapNotu.metin}</span>
            {hesapNotu.renk === 'kirmizi' && (
              <button type="button" style={S.btnS} onClick={() => { setHesapDurumu(null); load(); }}>RELOAD</button>
            )}
          </div>
        )}
        {!readOnly && view === 'assign' && <>
          {/* ASSIGN PENCEREDE (21 Eki 2026, Serkan B): sayfanın altındaki hep açık form kalktı — ASSIGN ve WHAT IF ? roster'ın
              üst satırında; gün kutusunun boş yerine tıklamak ASSIGN'ı o tarihle açar. Gösterilen ay ve görünüm BURADA
              tutulur: kayıttan sonra panel yeniden yüklenince roster sıfırlanmaz, görev kendi ayının kâğıdında görünür. */}
          <DutyRoster {...{ toast, myProfile, pilots, duties, ucuslar, baselines, ruleset, homeBases, pilotDilim, offTypes, reload: tazele, lisansMed,
                            dutyLocations, addLocation, focusDutyId, onFocusHandled, aircraft, tipVasiflari }}
                      gosterilenAy={rosterAyi} setGosterilenAy={setRosterAyi} gorunum={rosterGorunumu} setGorunum={setRosterGorunumu}
                      onWhatIf={() => setWhatIfAcik(true)} />
          {whatIfAcik && (
            <WhatIfPenceresi onClose={() => setWhatIfAcik(false)}
                             {...{ toast, myProfile, pilots, duties, baselines, ruleset, offTypes, homeBases, pilotDilim, dutyLocations, aircraft, lisansMed, tipVasiflari }} />
          )}
        </>}
        {view === 'history' && <DutyHistory {...{ pilots, duties, ucuslar, baselines, offTypes, ruleset, homeBases, pilotDilim, dutyLocations, addLocation,
                                                 toast, myProfile, reload: tazele, readOnly, lisansMed, aircraft, tipVasiflari }} />}
        {view === 'training' && <TrainingPanel {...{ toast, myProfile, pilots, customerId, readOnly }} />}
        {view === 'atplmed' && <AtplMedPanel {...{ toast, myProfile, pilots, readOnly }} />}
        {!readOnly && view === 'skpk' && <SkpkTracker {...{ toast, myProfile, pilots, duties, reload: tazele }} />}
        {view === 'edits' && <EditReport {...{ pilots, duties, customerId }} />}
        {!readOnly && view === 'ruleset' && <RulesetSettings {...{ toast, myProfile, ruleset, offTypes, reload: tazele }} />}
      </div>
      {/* Limit gostergesi TUM sekmelerde en altta sabit durur (Serkan, 17 Agu).
          Ustteki FROM/TO araligina BAKMAZ — kayan pencereler "su an"a goredir. */}
      {/* FCL, FTL'in ALTINDA ve AYRI: iki ayri mevzuat (SHT-FTL/HG vs SHT-FCL).
          Serkan (4 Eyl): *"Artik FTL limits gibi FCL limits yazsin barlarin
          basligi ve ref versin tabii ki."* */}
      <FCLLimitsBar {...{ pilots, duties }} />
      <FTLLimitsBar {...{ pilots, duties, baselines, ruleset, offTypes, pilotDilim }} />
    </div>
  );
}

// ═══ 0z) SKPK TAKIPCISI — SHT-FTL/HG Md.12(1)(c) ═════════════════
// Md.12(1)(c)(1): her SKPK'da isleticiye rapor sunulur (istisnasiz).
// Md.12(1)(c)(2): gerceklesen uzatma/kisaltma 1 SAATI ASARSA, kaptan raporunun
//   kopyasi ISLETICININ KENDI YORUMLARIYLA BIRLIKTE, olaydan itibaren en gec
//   28 GUN icinde Genel Mudurluge gonderilir.
//
// Bu ekranin varlik sebebi: 28 gunluk sure sessizce gecer. Kolona yazilmis ama
// kimsenin bakmadigi bir tarih, denetimde "takip edilmiyor" demektir — kayit
// tutmak yetmez, SURENIN DOLDUGUNU SOYLEYEN bir yer olmali. (Ilke 1'in uyum
// hali: sessiz gecme yok.)
function SkpkTracker({ toast, myProfile, pilots, duties, reload }) {
  const [pending, setPending] = useState(null);   // {rows, label}
  const nameOf = (pid) => { const x = pilots.find(p => p.id === pid); return x ? (x.code || x.full_name) : '—'; };

  // Bir SKPK = bir UCUS = bir komutan karari. Satirlar pilot bazli oldugu icin
  // atama kimligine gore gruplanir; Genel Mudurluge giden de TEK pakettir.
  const groups = useMemo(() => {
    const rows = (duties || []).filter(d =>
      d.status !== 'cancelled' &&
      ((d.skpk_fdp_extension_min || 0) > 0 || (d.skpk_rest_reduction_min || 0) > 0));
    const map = new Map();
    rows.forEach(d => {
      const key = d.assignment_id || d.id;
      if (!map.has(key)) map.set(key, { key, head: d, rows: [] });
      map.get(key).rows.push(d);
    });
    return [...map.values()].sort((a, b) =>
      String(b.head.duty_date).localeCompare(String(a.head.duty_date)));
  }, [duties]);

  const today = new Date();
  const statusOf = (d) => {
    if (!d.skpk_authority_due) return { kind:'operator', label:'OPERATOR ONLY (≤01:00)', tone:'dim' };
    if (d.skpk_authority_reported_at) return { kind:'sent', label:`SENT ${fmtD(d.skpk_authority_reported_at)}`, tone:'green' };
    // Tek hesap (`sonTarihDurumu`, 21 Eki 2026 K9) — zille aynı sayı ve yazı; eskiden burada aşağı yuvarlanıyordu.
    const sd = sonTarihDurumu(d.skpk_authority_due, today.getTime());
    if (sd.gecti) return { kind:'overdue', label: sd.metin, tone:'red', days: sd.kalan };
    return { kind:'due', label: sd.metin, tone: sd.gun <= 7 ? 'amber' : 'dim', days: sd.gun };
  };

  const overdue = groups.filter(g => statusOf(g.head).kind === 'overdue').length;
  const soon = groups.filter(g => { const s = statusOf(g.head); return s.kind === 'due' && s.days <= 7; }).length;

  const markSent = async (reason) => {
    const rows = pending.rows;
    const stamp = new Date().toISOString();
    // IZ ONCE (silme/iptal/edit ile ayni ilke)
    const { error: eErr } = await supabase.from('ftl_duty_edits').insert(rows.map(r => ({
      duty_id: r.id, customer_id: r.customer_id, pilot_id: r.pilot_id,
      assignment_id: r.assignment_id || null, edit_type: 'EDIT', field_name: 'skpk_authority_report',
      old_value: r.skpk_authority_reported_at ? `sent ${r.skpk_authority_reported_at}` : 'not sent',
      new_value: `sent to DGCA ${stamp} (due ${r.skpk_authority_due})`,
      reason: reason.trim(), edited_by: myProfile?.id ?? null })));
    if (eErr) { toast(`Audit write failed: ${eErr.message}`, 'error'); return; }
    // Her yazma DÖNEN SATIRLA doğrulanır (29 Eyl 2026 · FTL nöbetçisi A2). RLS
    // reddi hata değil 0 satır döner (İlke 2): eskiden ekran "reported" diyor, iz
    // "sent to DGCA" diyor, görev ise BİLDİRİLMEMİŞ kalıyordu — Md.12(1)(c)(2)'nin
    // 28 günlük süresi sessizce kaçabilirdi. İlk düşende durulur; işaretlenmeyen
    // ve hiç denenmeyen ekip ADIYLA söylenir, izin yanına DÜZELTME SATIRI düşer.
    const yazilan = [];
    for (const r of rows) {
      const { data: donen, error } = await supabase.from('crew_duties')
        .update({ skpk_authority_reported_at: stamp, skpk_operator_comment: reason.trim() })
        .eq('id', r.id).select('id');
      if (!error && donen?.length === 1) { yazilan.push(r); continue; }
      const sebep = error?.message || 'no row returned (permission?)';
      const olmayan = rows.slice(rows.indexOf(r));
      const { error: dErr } = await supabase.from('ftl_duty_edits').insert(olmayan.map((o, k) => ({
        duty_id: o.id, customer_id: o.customer_id, pilot_id: o.pilot_id,
        assignment_id: o.assignment_id || null, edit_type: 'EDIT', field_name: 'skpk_authority_report',
        old_value: '(report logged)', new_value: '(NOT WRITTEN — still not marked as sent)',
        reason: k === 0 ? `Update refused: ${sebep}` : `Not attempted — an earlier write was refused: ${sebep}`,
        edited_by: myProfile?.id ?? null })));
      // Kartta kısa cümle; neden/ne yapmalı/teknik ⓘ'de (yazmaDetayi).
      toast(`NOT MARKED as reported for ${olmayan.map(o => nameOf(o.pilot_id)).join(', ')} — refused.`
            + (yazilan.length ? ` Marked for ${yazilan.map(o => nameOf(o.pilot_id)).join(', ')}.` : '')
            + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
                    : ' The edit log records that it was not written.'),
            'error', yazmaDetayi({ kismen: yazilan.length > 0, hata: error }));
      if (yazilan.length) { setPending(null); reload(); }   // bir kısmı oldu: ekran gerçeği göstersin
      return;
    }
    toast('Marked as reported to the DGCA (logged).', 'success');
    setPending(null); reload();
  };

  // SHGM PAKETI: Md.12(1)(c)(2) "kaptan raporunun bir kopyasi ISLETICININ KENDI
  // YORUMLARI ILE BIRLIKTE" — ikisi tek belgede basilir, gonderilecek olan bu.
  const printPacket = (g) => {
    const d = g.head;
    const sectors = (d.sectors || []).map(s =>
      `${esc(s.dep)}–${esc(s.dest)} ${esc(s.off_block || s.etd)}–${esc(s.on_block || s.eta)}`).join(' · ') || '—';
    const w = window.open('', '_blank', 'width=900,height=700');
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>SKPK — ${esc(fmtD(d.duty_date))}</title><style>
      body{font-family:-apple-system,'Helvetica Neue',sans-serif;color:#0f172a;margin:28px;font-size:12px}
      h1{font-size:15px;letter-spacing:2px;margin:0 0 2px}
      .sub{font-size:10px;color:#64748b;margin-bottom:16px}
      .box{border:1px solid #cbd5e1;border-radius:6px;padding:12px 14px;margin-bottom:12px}
      .box h2{font-size:10px;letter-spacing:1.5px;margin:0 0 8px;color:#475569}
      .kv{display:flex;gap:28px;flex-wrap:wrap}.kv div{font-size:11px}
      .kv b{display:block;font-size:9px;color:#64748b;letter-spacing:1px;margin-bottom:2px}
      pre{white-space:pre-wrap;font-family:ui-monospace,Menlo,monospace;font-size:11px;margin:0}
      .warn{color:#b91c1c;font-weight:700}
      @media print{body{margin:10mm}}
    </style></head><body>
      <h1>COMMANDER'S DISCRETION REPORT — SKPK</h1>
      <div class="sub">SHT-FTL/HG Md.12(1)(c)(2) — commander's report with the operator's comments, to the DGCA within 28 days of the event</div>
      <div class="box"><h2>FLIGHT</h2><div class="kv">
        <div><b>DATE</b>${esc(fmtD(d.duty_date))}</div>
        <div><b>SECTORS</b>${sectors}</div>
        <div><b>CREW</b>${g.rows.map(r => esc(nameOf(r.pilot_id))).join(', ')}</div>
        <div><b>DUTY</b>${esc(fmtDT(d.report_time))} → ${esc(fmtDT(d.duty_end))}</div>
      </div></div>
      <div class="box"><h2>DISCRETION APPLIED</h2><div class="kv">
        <div><b>FDP EXTENSION</b>${fmtMin(d.skpk_fdp_extension_min || 0)}</div>
        <div><b>REST REDUCTION</b>${fmtMin(d.skpk_rest_reduction_min || 0)}</div>
        <div><b>MAX FDP AFTER</b>${fmtMin(d.max_fdp_minutes)}</div>
        <div><b>NEXT REST (incl. 2× compensation)</b>${fmtMin(d.min_rest_minutes)}</div>
        <div><b>REPORTED TO OPERATOR</b>${esc(fmtDT(d.skpk_reported_at))}</div>
        <div><b>DGCA DUE</b>${esc(fmtD(d.skpk_authority_due))}</div>
      </div></div>
      <!-- MATBU METIN KAYITTAN KURULUR (26 Agu 2026, Serkan onayladi):
           saklanan tek sey pilotun yazdigi BOSLUKTUR (skpk_reason). Tarih,
           meydan, off-block ve sure her basimda kayittan gelir — arsiv gercek
           saatleri yazinca rapor da kendiliginden duzelir. Cumlenin tamami
           saklansaydi metin ile kayit sessizce ayrisirdi (Ilke 3). -->
      <div class="box"><h2>COMMANDER'S REPORT</h2><pre>${esc(skpkStatement(d, d.skpk_reason).text)}</pre></div>
      <div class="box"><h2>OPERATOR'S COMMENTS</h2><pre>${d.skpk_operator_comment ? esc(d.skpk_operator_comment) : '<span class="warn">NOT RECORDED YET — required by Md.12(1)(c)(2)</span>'}</pre></div>
    </body></html>`);
    w.document.close();
  };

  return (
    <div style={S.panel}>
      <div style={S.panelH}>
        <span style={S.panelT}>SKPK — COMMANDER'S DISCRETION (Md.12)</span>
        <span style={{ fontSize:10, fontFamily:'var(--mono)', color:C.t3 }}>
          {groups.length} EVENT(S){overdue ? ` · ${overdue} OVERDUE` : ''}{soon ? ` · ${soon} DUE ≤7D` : ''}
        </span>
      </div>
      {(overdue > 0 || soon > 0) && (
        <div style={{ ...S.note, borderLeftColor: overdue ? C.red : C.accent,
                      color: overdue ? C.red : C.t2, margin:0, borderRadius:0 }}>
          {overdue > 0 && <>{overdue} SKPK EVENT(S) PAST THE 28-DAY DGCA DEADLINE (Md.12/1/c/2). </>}
          {soon > 0 && <>{soon} DUE WITHIN 7 DAYS. </>}
          The commander's report plus the operator's comments must reach the DGCA — print the packet, send it, then mark it here.
        </div>
      )}
      <div style={{ overflowX:'auto' }}>
        <table style={S.table}>
          <thead><tr>{['DATE', 'SECTORS', 'CREW', 'FDP EXT', 'REST RED', 'OPERATOR REPORT', 'DGCA STATUS', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {groups.map(g => {
              const d = g.head; const st = statusOf(d);
              return (
                <tr key={g.key}>
                  <td style={S.td}>{fmtD(d.duty_date)}</td>
                  <td style={{ ...S.td, whiteSpace:'normal' }}>{routeOf(d)}</td>
                  <td style={S.td}>{g.rows.map(r => nameOf(r.pilot_id)).join(', ')}</td>
                  <td style={{ ...S.td, color: d.skpk_fdp_extension_min ? C.accent : C.t3, fontWeight:700 }}>
                    {d.skpk_fdp_extension_min ? `+${fmtMin(d.skpk_fdp_extension_min)}` : '—'}</td>
                  <td style={{ ...S.td, color: d.skpk_rest_reduction_min ? C.accent : C.t3, fontWeight:700 }}>
                    {d.skpk_rest_reduction_min ? `−${fmtMin(d.skpk_rest_reduction_min)}` : '—'}</td>
                  <td style={{ ...S.td, color:C.t3 }} title={d.skpk_reason || ''}>{fmtDT(d.skpk_reported_at)}</td>
                  <td style={S.td}><span style={badge(st.tone)}>{st.label}</span></td>
                  <td style={{ ...S.td, textAlign:'right' }}>
                    <button style={{ ...S.btnS, padding:'5px 10px', marginRight:6 }} onClick={() => printPacket(g)}>PACKET</button>
                    {d.skpk_authority_due && !d.skpk_authority_reported_at && (
                      <button style={{ ...S.btnS, padding:'5px 10px' }}
                              onClick={() => setPending({ rows: g.rows, label: `${fmtD(d.duty_date)} ${routeOf(d)}` })}>
                        MARK SENT
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
            {!groups.length && (
              <tr><td style={{ ...S.td, color:C.t3 }} colSpan={8}>No commander's discretion recorded. SKPK is entered on a flown duty via ROSTER → EDIT.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      {pending && (
        <ReasonModal aciklamaTur="degisiklik" etiket="Reason / report *"
          title={`MARK REPORTED TO DGCA — ${pending.label}`}
          warn={'This records that the commander\'s report AND the operator\'s comments were sent to the DGCA (Md.12/1/c/2). What you type here is stored as the OPERATOR\'S COMMENTS and printed on the packet — write the operator\'s assessment, not just "sent".'}
          confirmLabel="MARK SENT"
          onCancel={() => setPending(null)}
          onConfirm={markSent} />
      )}
    </div>
  );
}

// ── FDP / MAX FDP HUCRESI (26 Agu 2026, Serkan) ──────────────────────────
//
// 🔑 *"Bir gorev planlandi diyelim ki flight duty time bu goreve 10:30 ve duty
//    time 12:00 saat. Plan asamasinda tabloda max da mesela 13:00 gorunsun —
//    planlananin yaninda MAX gorelim."*
//
// Deger UYDURULMAZ ve YENIDEN HESAPLANMAZ: `max_fdp_minutes` atama sirasinda
// ruleset'ten hesaplanip KAYDA yazilir (rapor saati bandi + sektor sayisi +
// faaliyet tipi) ve ucus arsivlenince gercek saatlerle KENDILIGINDEN tazelenir
// (21 Agu zinciri: report_time -> max_fdp -> fdp -> min_rest -> next_report).
// Yani "ucus bitince gerceklesenle limitin farkini gorelim" istegi ek bir is
// gerektirmiyor; ayni hucre kendiliginden guncel kalir.
//
// 🔑 KUMULATIF TAVANLAR (7/14/28 gun) BU KOLONA GIRMEZ — Serkan: *"eger bu ucus
// plan asamasinda 7 gunluk duty'ye takilacaksa uyariyi zaten verecek assign
// ederken, onu tabloya koymaya gerek yok."* Ayrica `60:00` bir GOREVIN degil
// YEDI GUNUN tavanidir; satir basina yazilsa "bu gorev 60 saate kadar
// uzayabilir" diye okunurdu (Ilke 1). Ayni uyariyi iki yerde tasimiyoruz.
//
// Yer gorevi / OFF: FDP URETMEZ (22 Agu karari — `fdp_minutes: null`) -> "—".
// Eski kayitta tavan yoksa yine "—": olmayan bir tavani varmis gibi gostermeyiz.
function FdpMaxCell({ d }) {
  // Renk `var(--red)` gibi degiskenlerle verildigi icin TESTTEN OKUNAMAZ;
  // asim durumu ayrica isaretlenir (canin `data-durum` deseninin ayni sebebi).
  const bos = <span data-testid="fdp-max" data-asildi="NA" style={{ color:C.t3 }}>—</span>;
  if (d.duty_type !== 'flight') return bos;
  const fdp = d.fdp_minutes, max = d.max_fdp_minutes;
  if (fdp == null && max == null) return bos;
  const asildi = fdp != null && max != null && fdp > max;
  return (
    <span data-testid="fdp-max" data-asildi={asildi ? 'YES' : 'NO'}
          style={{ fontFamily:'var(--mono)', whiteSpace:'nowrap' }}>
      <b style={{ color: asildi ? C.red : 'var(--t1)' }}>{fdp != null ? fmtMin(fdp) : '—'}</b>
      <span style={{ color:C.t3 }}> / </span>
      <span style={{ color: asildi ? C.red : C.t2 }}>{max != null ? fmtMin(max) : '—'}</span>
    </span>
  );
}

// ═══ 0) DUTY ROSTER — TARIH ARALIGI + IPTAL / SILME ═══════════════
// Saha talebi (3 Agu, Serkan): "Assign duty tarafinda ekleme var cikarma yok,
// tarih araligi secilmiyor. Iki tarih penceresi olmali, araligi gormeliyiz, ayni
// anda hem gorev ekleyip hem silebilmeliyiz."
//
// IKI SILME YOLU, IKISI DE GEREKCE ZORUNLU:
//   CANCEL  → status='cancelled'. Gorev listeden duser, KAYITTAN DUSMEZ.
//             Gerceklesmis gorevlerde tek yol budur.
//   DELETE  → satir gercekten silinir. YALNIZ gerceklesmemis gorevde mumkun
//             (planned + duty_finished degil + hic plan bagi yok). Bu sart
//             veritabaninda da dayatiliyor (crew_duties_del politikasi) —
//             arayuz sadece imkansiz olani teklif etmesin diye ayni kontrolu
//             yapiyor. Silmeden ONCE ftl_duty_edits'e mezar tasi yazilir.
const canHardDelete = (d) =>
  d.status === 'planned' && !d.duty_finished &&
  (!d.plan_ids || d.plan_ids.length === 0);

const routeOf = (d) => {
  // SIM etiketi tek kaynaktan (2 Eki 2026): SIM · SIM/OPC · SIM/LPC · SIM/LPC&OPC.
  if (d.ground_kind === 'sim') return simEtiketi(d);
  if (d.duty_type !== 'flight') return (d.ground_kind || d.off_subtype || d.duty_type || '').toUpperCase();
  const s = d.sectors || [];
  if (!s.length) return '—';
  // DIVERT gorunur (4 Agu): arsiv sektore actual_dest yazar — planlanan
  // varistan farkliysa "DEP-DEST>ACT DVT" olarak basilir.
  return s.map(x => {
    const act = x.actual_dest && x.actual_dest !== x.dest ? `>${x.actual_dest} DVT` : '';
    return `${x.dep || '?'}-${x.dest || '?'}${act}`;
  }).join(' · ');
};

// UYARI ACIKLAMA NOKTASI ⓘ (Serkan, 3 Eyl 2026).
//
// *"Tamam sorsun ama text yazsin… anlasin neyin match etmedigini. Her uyarida
//  aciklama olsun demistik, burda da olsun."* ve *"popup bir ekran ciksin,
//  yanina i koyalim gorelim — ayrica bir yere yazamiyorsak."*
//
// 🔴 Bugunku hal: ciplak bir `REVIEW` rozeti. Yoneticiye "bir seye bak" deyip
// NEYE bakacagini soylemiyordu — 30 Agu'da kapattigimiz hata metni kusurunun
// aynisi (mesaj var, yonlendirme yok).
//
// Tooltip YETMEZ: uzerine gelmeyi gerektirir ve tablo dar oldugu icin metin
// satira sigmiyor. Bu yuzden GORUNUR bir ⓘ ve acilan pencere. Kendi durumunu
// tasir, HER uyarinin yaninda ayni sekilde kullanilir (Ilke 3).
//
// 🔑 Serkan: *"Hatta bu i butun uyarilari icin kullanilabilir — basit ve
//  anlasilir."* Bu yuzden bilesen tipe bagli DEGIL: metni cagiran verir.
//  Yeni bir uyari rozeti eklenirse yanina ⓘ konur, kural tek yerde kalir.
//
// 🔑 IKI PARCA, YAPIYA GOMULU (Serkan, 3 Eyl): *"Hatta icinde duzeltici eylemi
//  de soyleyebiliriz — mesela sunu yap veya bunu yap, sunu duzelt, bu sekilde
//  yaparsan limit asimi olur."* 30 Agu'daki hata metni kuralinin aynisi:
//  NE OLDU + NE YAPMALI. Metnin insafina birakilmaz, ayri iki alan olur —
//  `action` bos birakilirsa pencere yalniz olguyu gosterir ve eksiklik GORUNUR.
//
// 🔑 UC PARCA (Serkan, 3 Eyl): *"Koddaki kuralin aciklamasi text formunda yani."*
//  ① NE OLDU  — olculen olgu, sayilariyla
//  ② KURAL    — kodun uyguladigi mantik, DUZ METIN + mevzuat kunyesi
//  ③ NE YAPMALI
//  Ikinci parca kritik: kural yalniz kodda dururken kimse dogrulayamaz. Ekranda
//  yazili olunca pilot da denetci de neyin uygulandigini gorur — ve bu metinler
//  onay dosyasindaki EGITIM PROGRAMI icin de hazir malzeme olur (0c/17).
// 🔴 4 Eyl 2026: InfoDot BURADAN CIKTI (`./InfoDot`). Sebebi FCL Limits
// barindaki ⓘ'lerin tiklanamamasiydi — bilesen bu dosyaya gomulu oldugu icin
// baska ekrandan kullanilamiyordu. Ikinci bir kopya yazmak iki ⓘ'nin zamanla
// ayrismasi demekti.
export const __InfoDot = InfoDot;   // yalniz test icin disari acilir

// `extra` — uyarinin ALTINA, gerekcenin USTUNE giren istege bagli alan.
// 19 Eyl 2026'da eklendi: gecmis tarihli atama onayinda KAGIT OFP kutusu
// buradan cikiyor. Ayri bir modal yazmak yerine yuva acildi — iki onay
// ekrani olsaydi biri duzelirken oteki geride kalirdi (Ilke 3).
// GEREKÇE PENCERESİ — TEK PENCERE `gerekce.js`ten (21 Eki 2026, K7, Serkan tasarım A): FTL'in dört çağrısı için ince kabuk.
// 🔴 Önce kendi penceresiydi: kural yalnız "boş olmasın" ("Ab" kaydediliyordu), altında Türkçe not vardı.
function ReasonModal({ title, warn, extra = null, confirmLabel, onCancel, onConfirm, aciklamaTur = 'uyari', onayTur = 'birincil',
                       etiket = 'Reason *' }) {
  return (
    <GerekcePenceresi baslik={title} aciklama={warn} aciklamaTur={aciklamaTur} ek={extra} etiket={etiket}
                      onayMetni={confirmLabel} onayTur={onayTur} testid="ftl-gerekce" metinTestid="gerekce-penceresi"
                      onClose={onCancel} onOnay={onConfirm} />
  );
}

// ── ENGEL PENCERESI (26 Agu 2026, Serkan) ────────────────────────────────
//
// 🔑 *"ASSIGN DUTY butonuna bastigimda eger bir limit asimi soz konusu ise
//    popup ekran ciksin ve limite takilan sey neyse orda gorunsun."*
//
// 🔴 BUGUNE KADAR ENGEL SESSIZDI. Sebepler ZATEN uretiliyordu (`fitList`in
// `reasons` dizisi: REST UNTIL … · OVERLAPS DUTY … · FDP > MAX AFTER STANDBY
// REDUCTION (Md.17(1)) · ACCLIMATISATION NOT DETERMINED (Md.22/1) · DAY OFF
// (Md.5) · CANNOT VERIFY REST) ama yalnizca 280 piksellik dar bir kolonda
// duruyordu ve NOT LEGAL satira tiklayinca HICBIR SEY olmuyordu. Tiklayan
// kisi "tiklamam mi islemedi, yoksa yasak mi?" diye kaliyordu.
// Ustelik tutarsizdi: NOBET limiti icin kaybolan bir `toast` cikiyor, diger
// sebepler icin hicbir sey cikmiyordu.
//
// 🔒 EMNIYET KAPISI GEVSEMEZ (Ilke 7 · Serkan onayladi): NOT LEGAL satir yine
// secilemez, "gerekce yazip yine de ata" yolu YOK. Degisen tek sey: sistem
// artik NEYIN yasal olmadigini SOYLUYOR.
//
// Pencere kapatilmadan gecilmez — kaybolan uyari, bakilmayan uyaridir.
// 🔑 29 Eyl 2026 (adım b): ayrı pencere (`BlockedModal`) KALKTI — aynı iş artık
//    ORTAK kural ihlali kartında (`ihlalDetayi` → Bildirim): başlık aynı ("THIS
//    DUTY CANNOT BE PLANNED"), gerekçeler yine kısaltılmadan ve pilot pilot, ama
//    her satırın yanında ⓘ: maddenin KENDİ metni + ne yapılabileceği. Kart da
//    DISMISS'e basılana kadar durur. Ekip kapıları, nöbet limiti ve asgari ekip
//    de aynı karta düşer — dört ayrı biçim tek biçime indi.

// GOREV TIPI ETIKETI — TEK KAYNAK (Serkan, 3 Eyl 2026).
//
// *"DH de type GND degil DH olmali; assign'de FLT GND OFF ve DH olmali yani."*
// ve *"mantiksal orguye uygun olmasi gerekiyor, simdi biraz sacma."*
//
// 🔑 DH ARTIK KENDI TIPI: `duty_type === 'dh'`. Sebep: DH'nin SEKTORU var
// (ucula bacak), SAATLERI var ve Md.14 ona AYRI hukum veriyor — GND'nin bir
// "cesidi" gibi durmasi orguyu bozuyordu.
//
// ⚠️ FTL DAVRANISI DEGISMEZ: DH ucus suresi ve sektor olarak SAYILMAZ; onu
// `deadhead` bayragi yapar (FTLEngine:1236 · :1466), `duty_type` degil.
// Tarama (3 Eyl): 38 dallanmanin 12'si 'flight', 14'u 'off' karsilastirmasi —
// 'dh' ikisi de olmadigi icin KENDILIGINDEN dogru kaldi. Nobet arama (:849)
// ve other_standby (:1270) DH'yi zaten kapsamiyor. Tek gercek is `gndDays`
// sayaciydi; o da ayrildi.
const dutyTypeLabel = (d) => d?.duty_type === 'flight' ? 'FLT'
  : d?.duty_type === 'off' ? 'OFF'
  : d?.duty_type === 'dh' ? 'DH' : 'GND';

// ── FAALİYET TİPİNİN ADLARI — TEK TABLO (27 Eki 2026, ölü kod parça 4b) ──────────────────────────────────────────
// Tipler ve sıraları motordan (`OPERATION_TYPES`); burada yalnız ekrandaki adlar durur. `kisa`: rozet ve başlık
// (`opLabel`) · `uzun` + `md`: bacak satırındaki seçici. Önce seçicinin seçenekleri ve `opLabel` ayrı ayrı elle yazılıydı.
export const OP_ADLARI = {
  air_taxi:         { kisa: 'AIR TAXI',    uzun: 'AIR TAXI',         md: 'Md.22' },
  aerial_work:      { kisa: 'AERIAL WORK', uzun: 'AERIAL WORK',      md: 'Md.26' },
  general_aviation: { kisa: 'GENERAL AV',  uzun: 'GENERAL AVIATION', md: 'Md.25' },
  training:         { kisa: 'TRAINING',    uzun: 'TRAINING',         md: 'Md.27' },
  // FERRY: SHT'de kategorisi YOK — madde yazılmaz. Serkan (2 Eyl): "Ferry ucus bir ticari ucus veya genel havacilik
  // ucusunun arkasindan olabilir; bu sebeple planlama yaparken EN DAR KAPSAMLI olan limiti secelim." Limit ruleset'ten:
  // most_restrictive_of [air_taxi, general_aviation]; karisik gorevde `governingOperation` en dar tipi secer.
  ferry:            { kisa: 'FERRY',       uzun: 'FERRY',            md: null },
};
const opLabel = (t) => OP_ADLARI[t]?.kisa || String(t).toUpperCase();
const opSecenekMetni = (t) => {
  const a = OP_ADLARI[t];
  if (!a) return String(t).toUpperCase();
  return a.md ? `${a.uzun} — ${a.md}` : a.uzun;
};

// ── FAALİYET TİPİ — ASSIGN VE EDIT TEK TİP (25 Eki 2026) ─────────────────────────────────────────────────────
// 🔑 Serkan (22 Ağu): *"çok bacaklı bir planlamada uçuşun tipini seçerken her bacak için ayrı ayrı seçelim."* ·
//    (25 Eki, tasarım A): *"A seçeneği hem edit ekranında hem assign ekranında olacak."* Tip bacak satırının SONUNDA
//    seçilir; görevin başında yalnız YÖNETİCİ tip görünür (en dar limitli olan, 2 Eyl). Üç parça da buradan — ASSIGN'ın
//    kendi kopyaları kalktı (Ilke 3).
/** Bacak satırındaki tip seçicisi — ASSIGN ve EDIT AYNI kutuyu çağırır; stil, değer ve olay çağırandan. */
function OperasyonSecici(props) {
  return (
    <select {...props}>
      <option value="">— OPERATION —</option>
      {OPERATION_TYPES.map(t => <option key={t} value={t}>{opSecenekMetni(t)}</option>)}
    </select>
  );
}

/** Görevin başı: tip burada SEÇİLMEZ (iki ayrı gerçek kaynak olurdu — Ilke 2), yönetici tip gösterilir. `bilgi`: ek gri
 *  satır (EDIT'te uçulmuş görev); `notlar`: bacakların plan notları (amber — okunamadı / belirsiz / uyuşmuyor). */
function OperasyonBasligi({ tip, bilgi = null, notlar = [], testid, notTestid }) {
  return (
    <div><span style={S.label}>Operation (SHT-FTL/HG Md.9)</span>
      <div data-testid={testid} style={{ ...S.input, width:210, display:'flex', alignItems:'center',
                                          background:C.bg3, cursor:'default' }}>
        {tip ? opLabel(tip) : '—'}
      </div>
      <div style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)', marginTop:3, maxWidth:230, lineHeight:1.5 }}>
        PER SECTOR — SET IT ON EACH LEG BELOW
      </div>
      {bilgi && (
        <div style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)', marginTop:3, maxWidth:420, lineHeight:1.5 }}>{bilgi}</div>
      )}
      {notlar.map(n => (
        <div key={n} data-testid={notTestid} style={{ fontSize:9, color:C.amber, fontFamily:'var(--mono)',
                                                      marginTop:3, maxWidth:420, lineHeight:1.5 }}>{n}</div>))}
    </div>
  );
}

/** Karışık görev notu (Md.9): birden fazla tip varsa limiti EN DAR olan belirler. `maxFdpMin` bilinmiyorsa yazılmaz. */
function KarisikGorevNotu({ tipler, yoneten, maxFdpMin = null }) {
  return (
    <div data-testid="mixed-op-warning"
         style={{ ...S.note, borderLeftColor:C.accent, color:C.t1, marginBottom:12 }}>
      <b style={{ color:C.accent }}>MIXED OPERATION DUTY</b> — this duty has more
      than one operation type ({tipler.map(opLabel).join(' + ')}).
      The limit is set by the MOST RESTRICTIVE one: <b>{opLabel(yoneten)}</b>
      {maxFdpMin != null && <> — MAX FDP {fmtMin(maxFdpMin)}</>}. (SHT-FTL/HG Md.9)
    </div>
  );
}

// ── KÂĞIT OFP — TEK YAZICI, TEK KUTU (19 Eyl 2026) ────────────────────
//
// 🔑 Serkan (sahadan): *"Paper OFP nereden seçiyorum ki ben?"* · *"Editten
//    uçuşu açınca da sorması lazım; edit kısmında paper OFP tıklayınca bunu
//    istatistiğe PAPER OFP olarak yazmalı."*
//
// 🔴 ÖLÇÜLEN KUSUR (19 Eyl): bir görevi "uçuldu" yapmanın ÜÇ yolu var ama
//    uçuş kaydını YALNIZ BİRİ oluşturuyordu —
//      · `PLN` rozeti → "gerçekleşti mi?"  → upsert ✅ (kutu YALNIZ burada)
//      · EDIT DUTY → gerçek saatler        → `.update()` 🔴 satır yoksa HİÇBİR ŞEY
//      · ASSIGN → geçmiş tarihli görev     → 🔴 hiç
//    Sonucu sahada: 14 · 17 · 18 Eylül uçuşları roster'da ACTUAL, saatleri FTL
//    kümülatiflerine giriyor, ama STATISTICS'te, uçak saatinde ve iniş
//    sayısında YOKLAR. Aynı uçuş bir ekranda var, öbüründe yok.
//
// 🔴 Ve EDIT yolundaki daha sinsiydi: `.update()` satır yoksa HATA DÖNDÜRMEZ,
//    0 satır etkiler. Kod `if (mErr)` diye bakıyordu — hata yok, demek ki oldu
//    sanıyordu. CLAUDE.md İlke 2'nin kelimesi kelimesine tarif ettiği tuzak.
//
// 🔑 ÇÖZÜM: kutu da yazıcı da TEK. İki yerde iki kopya olsaydı er ya da geç
//    ayrışırdı (İlke 3) — 18 Eyl'de gün devri kuralını web'de düzeltip Edge'de
//    unutmuştuk, aynı aile.

/** Kâğıt OFP satırını kurar ve yazar. Tek yazıcı — iki ekran da bunu çağırır. */
/** Kâğıt OFP satırlarını kurar ve yazar. Tek yazıcı — üç ekran da bunu çağırır.
 *
 *  🔑 SEKTÖR BAŞINA BİR SATIR (20 Eyl 2026, Serkan'ın tasarımı):
 *     *"Her uçuşun veri kolonları dep, dest, block saatler ve uçan pilotlar
 *     olarak saklanır."* · *"Her manuel plana numara verelim."*
 *     Eskiden bir ATAMA = bir satırdı ve sektörler `sectors` jsonb'sinde
 *     duruyordu; o hâliyle elle girilen sektörün SAHİBİ yoktu. Artık arşivden
 *     gelen uçuş `archived_flights`ta, elle girilen `manual_flights`ta —
 *     ikisi de BACAK başına. *"Uçuldu mu?"* tek soruya indi: sahibi var mı.
 *
 *  🔑 SAATLER TAM ZAMAN DAMGASI. Gün devri `sektorZamanlari` ile ve BÜTÜN
 *     zincir üzerinden kurulur (yalnız sektörün kendi içinde değil): 3. sektörün
 *     off-block'u 2. sektörün on-block'undan geri gidiyorsa gün ilerler.
 *     Kural `FTLEngine`de TEK yerde — Edge de aynı fonksiyonu çağırıyor.
 *
 *  🔑 GECE/GÜNDÜZ HER BACAK İÇİN AYRI ölçülür — arşiv yolundaki kuralın
 *     aynısı, çünkü artık satırlar da bacak. Eskiden atama başına tek ölçüm
 *     vardı (ilk kalkış + son iniş) ve aradaki bacaklar hiç ölçülmüyordu.
 *     Koordinat ya da saat yoksa `null` kalır — "gündüz" DEMEYİZ (İlke 1). */
export async function paperOfpYaz({ duty, sectors, reg, reason, editedBy, ekip = null }) {
  // ── DH BACAĞI UÇUŞ DEĞİLDİR (29 Eyl 2026) ────────────────────────────────
  // 🔴 EDIT ve "gerçekleşti mi?" görevin BÜTÜN sektörlerini gönderiyordu;
  //    konumlandırma (DH) bacağı kâğıt OFP uçuşu gibi yazılıyor, iniş bilgisi
  //    isteniyor, istatistiğe blok saati giriyordu. DH yolcu olarak uçulur —
  //    sektör sayılmaz (Md.14/1/b), uçuş kaydı da değildir. ASSIGN zaten
  //    ayıklıyordu; artık yazıcı kendisi ayıklar (kural tek yerde).
  sectors = (sectors || []).filter(x => !x?.deadhead);
  // ── EKSİK ALAN VARSA SATIR YAZILMAZ (2 Eki 2026) — kural `kagitOfpEksigi`de TEK yerde ──
  // EDIT ekranı aynı fonksiyonu kaydetmeden ÖNCE çağırır; bu kapı yedektir: başka bir çağıran eksik
  // bilgiyle gelirse de satır açılmaz (hiçbir şey okunmadan, yazılmadan döner).
  const eksikler = kagitOfpEksigi({ duty, sectors, reg, ekip });
  if (eksikler.length) return { error: { message: eksikler.join(' | ') } };
  // BÜTÜN saatler tek zincirde: 4 saat × N sektör, sırayla.
  const zincir = sektorZamanlari(duty.duty_date, sectors.flatMap(x =>
    [x.off_block, x.takeoff_time, x.landing_time, x.on_block]));
  const dkArasi = (a, b) => (a && b)
    ? Math.round((new Date(b).getTime() - new Date(a).getTime()) / 60000) : null;

  // Meydan koordinatları — TEK sorgu, bütün sektörlerin iki ucu.
  const icaolar = [...new Set(sectors.flatMap(x => [x.dep, x.dest, x.actual_dest]).filter(Boolean))];
  const { data: meydanlar } = icaolar.length
    ? await supabase.from('airports').select('icao,lat,lon').in('icao', icaolar)
    : { data: [] };
  // 🔑 TEK GIRIS NOKTASI (21 Eyl 2026): koordinat varsa hesaplanir, yoksa
  //    gorevin KENDI beyanina bakilir. Desen uc yerde ayri ayri yaziliydi;
  //    tanimsiz meydan dali gelince ucune birden ikinci bir sart eklemek
  //    yerine soru `geceMiMeydan`a tasindi (Ilke 3).
  const geoHaritasi = Object.fromEntries(
    (meydanlar || []).map(m => [String(m.icao).toUpperCase(), { lat: m.lat, lon: m.lon }]));
  // Beyan GOREVIN kendi satirindadir — kuresel bir tanimsiz-meydan tablosu YOK
  // (Serkan: *"bu meydan database'e girmez, bir kereye mahsus"*).
  const gece = (icao, an) =>
    geceMiMeydan(icao, an, { geo: geoHaritasi, beyan: duty?.ad_hoc_airports });

  // ── PİLOTLAR EKİBİN TAMAMINDAN (29 Eyl 2026) ─────────────────────────
  // 🔑 Serkan: *"Hem PF hem PM hem de varsa CRZ pilot görevleri kayıt altına
  //    alınacak ki SHT-FTL hesabı yapılabilsin."*
  // 🔴 7 Eyl'den beri yazıcı ekibin YALNIZ BİR satırını alıyordu: o pilot PF
  //    ise `pf_pilot`, PM ise `pm_pilot` doluyor, öteki sütun BOŞ kalıyordu.
  //    Tasarım her pilotun kendi görevini ayrı kapatacağını varsaymıştı
  //    ("ikinci pilot kapatınca upsert satırı tamamlar"); ama üç ekran da
  //    ekibi TEK SEFERDE kapatıyor — ikinci kapanış hiç olmadı. Test de
  //    boş sütunu doğru diye kilitlemişti.
  // Artık her bacağın PF/PM/CRZ'si ekipteki HER pilotun kendi sektöründen
  // okunur ve ÜÇ sütun da her seferinde yazılır (rol değişince eskisi kalmasın).
  // `ekip` verilmezse eski çağrı biçimi: tek pilot, rolü sektörde.
  const uyeler = ekip || [{ pilot_id: duty.pilot_id, sectors }];
  const kimler = sectors.map((x, i) => bacakPilotlari(uyeler, x, i));

  const satirlar = sectors.map((x, i) => {
    const [off, to, lnd, on] = zincir.slice(i * 4, i * 4 + 4);
    const kim = kimler[i];
    return {
      customer_id: duty.customer_id,
      // Aynı uçuşun İKİNCİ pilotu kapatıldığında yeni satır AÇILMAZ —
      // (assignment_id, seq) benzersiz, upsert aynı satırı tamamlar.
      assignment_id: kagitAnahtari(duty),
      seq: i + 1,
      duty_date: duty.duty_date,
      reg: reg || null,
      // DIVERT (5 Eki 2026): `dest` = İNİLEN meydan (uçak saati, gece inişi, istatistik onu kullanır), `planned_dest` =
      // planlanan varış (yalnız divert'te; sütun 20261005d). Rozet ikisinden türetilir (`kagitUcus.divertMi`).
      dep: x.dep || null, dest: (x.actual_dest || x.dest) || null,
      planned_dest: x.actual_dest && x.actual_dest !== x.dest ? x.dest : null,
      off_block: off, takeoff_time: to, landing_time: lnd, on_block: on,
      block_minutes: dkArasi(off, on),
      airborne_minutes: dkArasi(to, lnd),
      // İNİŞ SAYISI VE TİPİ ELLE GİRİLİR (22 Eyl 2026, Serkan: *"manuel flt
      // girişi yapılırken de soracak: iniş nereden nasıl yapıldı, kaç cycle
      // iniş diye elle gireceğiz"* · *"belki touch and go çalışıldı 6 cycle"*).
      // Eskiden `1` SABİTTİ: altı touch-and-go uçulsa da kayda bir iniş
      // giriyordu. Sektörde yoksa eski davranış korunur (1) — alan zaten
      // ekranda zorunlu, bu yol yalnız eski çağrılar için durur.
      landing_count: Number(x.landings) || 1,
      lnd_type: (typeof x.lnd_type === 'string' && x.lnd_type.trim()) ? x.lnd_type.trim() : null,
      // İkinci CRZ (4 pilotlu ekip, Md.11(4), 5 Eki 2026) — sütun `20261005b_ikinci_crz.sql`.
      pf_pilot: kim.pf, pm_pilot: kim.pm, crz_pilot: kim.crz, crz2_pilot: kim.crz2,
      is_night_takeoff: gece(x.dep, to),
      is_night_landing: gece(x.actual_dest || x.dest, lnd),
      note: (reason || '').trim() || null,
      created_by: editedBy ?? null,
      // İşaret geri konunca kayıt GERİ GELİR (5 Eki 2026, A): iptal / işaret kaldırma satırı silmez, DELETED yapar;
      // aynı (atama, sıra) yeniden yazılınca geçersizlik kalkar — yoksa upsert satırı tazeler ama sayılmaz bırakırdı.
      deleted_at: null, deleted_by: null, delete_reason: null,
    };
  });

  return supabase.from('manual_flights')
    .upsert(satirlar, { onConflict: 'assignment_id,seq' });
}

/** Kâğıt OFP kaydının EKSİKLERİ, gruplu ve ADIYLA — yazıcı da EDIT ekranı da bunu çağırır (2 Eki 2026).
 *  🔑 Serkan: *"tescil, saatler, PM PF rolleri, inişin türü bunlar zorunlu olmalı, aksi halde tasnif edilemez"* ·
 *     PF/PM için A: *"rollerin girilmesi lazım"* — her UÇULMUŞ bacakta bir PF ve bir PM; ekipte tek pilot varsa
 *     kayıt reddedilir. (Planda tek pilot hâlâ kaydedilir — ikinci pilot sonradan atanabilir; kural yalnız
 *     uçulmuş kâğıt kayıtta.)
 *  🔴 ÖNCESİ: tescil boşsa satır `reg: null` yazılıyordu — 1 Eki LTBA→LTAC hiçbir uçağın saatine girmedi. PF ya
 *     da PM yoksa sütun boş yazılıyordu. İniş/saat eksiği yazıcıda yakalanıyordu ama görev ÇOKTAN kaydedilmişti
 *     ("Duty saved, but the PAPER OFP record failed") — görev uçuldu, istatistikte yok.
 *  Girdi yazıcınınkiyle AYNI (DH bacakları burada da ayıklanır). @returns {string[]} boşsa eksik yok. */
export function kagitOfpEksigi({ duty, sectors, reg, ekip = null }) {
  const ucan = (sectors || []).filter(x => !x?.deadhead);
  const gruplar = [];
  if (!String(reg ?? '').trim()) gruplar.push('AIRCRAFT REGISTRATION missing — choose the aircraft in the PAPER OFP box');
  const uyeler = ekip || [{ pilot_id: duty?.pilot_id, sectors: ucan }];
  const iki = [], rolEksik = [];
  ucan.forEach((x, i) => {
    const k = bacakPilotlari(uyeler, x, i);
    const ad = `${x?.dep || '?'}-${x?.dest || '?'}`;
    // Sessizce birini seçmek öbürünü kaybetmek olurdu (İlke 2) — adıyla söyle.
    if (k.hata) iki.push(k.hata);
    if (!k.pf) rolEksik.push(`${ad}: PF missing`);
    if (!k.pm) rolEksik.push(`${ad}: PM missing`);
  });
  if (iki.length) gruplar.push(`CREW ROLES INVALID — ${iki.join(' · ')} (fix the roles in EDIT)`);
  if (rolEksik.length) {
    gruplar.push(`CREW ROLES missing — ${rolEksik.join(' · ')} (every flown sector needs a PF and a PM — add the second pilot to the crew)`);
  }
  // İniş bilgisi (22 Eyl 2026): sessizce `1` yazmak kayıt uydurmaktı (İlke 1).
  const inis = kagitInisEksik(ucan, ucan);
  if (inis.length) gruplar.push(`LANDINGS / TYPE OF LNDG missing — ${inis.join(' · ')}`);
  // Dört zaman yoksa havada süre yoktur: kayıt uçak/motor saatine sessizce GİRMEZDİ (2 Eki 2026).
  const zaman = ucusZamanlariEksigi(ucan);
  if (zaman.length) gruplar.push(`FLIGHT TIMES missing — ${zaman.join(' · ')}`);
  return gruplar;
}

/** SIM görevinin OPC / LPC kutuları — ASSIGN ve EDIT AYNISINI çizer (2 Eki 2026, Serkan: kaldırılan T/O · LDG hücrelerinin
 *  yerinde "OPC LPC diye iki kutu"; roster'da SIM/OPC · SIM/LPC · SIM/LPC&OPC). Yalnız roster etiketidir (A): kontrolün
 *  sonucu TRAINING'de girilir. Yakınlık: FFS Level D oturumu programın asgarisi sayılır (FTLEngine `simSectors`). */
function SimKontrolKutulari({ secili = [], degistir, testid = 'sim-kontrol' }) {
  return (
    <div>
      <span style={S.label}>Checks</span>
      <div style={{ display:'flex', gap:8 }}>
        {SIM_KONTROL_KUTULARI.map(k => {
          const on = (secili || []).includes(k);
          return (
            <SecimKutusu key={k} isaretli={on} testid={`${testid}-${k}`}
                         onClick={() => degistir(on ? secili.filter(x => x !== k) : [...(secili || []), k])}>{k}</SecimKutusu>
          );
        })}
      </div>
    </div>
  );
}
/** PAKET SIM SATIRI (14 Eki 2026, Serkan: *"pilot seçilsin"*) — ASSIGN'da uçuşla AYNI kayıtta, görevin başında ya da sonunda.
 *  Alanlar GND formunun SIM'iyle aynı (cihaz, OPC / LPC, yer); pilotlar uçuş ekibinden tek tek seçilir — SIM yalnız
 *  seçilenlere yazılır. Motor aynı paketteki SIM'i uçuşun periyoduna bağlar (Md.23(1)). */
export const bosPaketSim = () => ({ start:'', end:'', device:'', checks:[], loc:{ location:'', location_tz:null }, pilotlar:[] });
/** Paket SIM'in eksikleri — kapı ve zorunlu alan rengi AYNI ölçü. */
export function paketSimEksikleri(sim, ekipIdleri = []) {
  if (!sim) return [];
  const e = [];
  if (!saatGecerli(sim.start)) e.push('START UTC');
  if (!saatGecerli(sim.end)) e.push('SIM ENDS UTC');
  const yer = locationEksigi('sim', { location: sim.loc?.location, locationTz: sim.loc?.location_tz, icao: sim.loc?.location });
  if (yer) e.push(yer);
  if (!(sim.pilotlar || []).some(pid => ekipIdleri.includes(pid))) e.push('PILOT');
  return e;
}
function PaketSimSatiri({ yer, sim, degistir, ekip = [], onSil, locations, onAddLocation }) {
  const t = `paket-sim-${yer}`;
  const secili = sim.pilotlar || [];
  return (
    <div data-testid={t} style={{ border:`1px dashed ${C.accent}`, borderRadius:6, padding:'10px 12px', margin:'0 0 12px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
        <span style={{ ...S.label, margin:0, color:C.accent }}>
          {yer === 'once' ? 'Simulator before this flight' : 'Simulator after this flight'} — same duty period (SHT-FTL/HG Md.23(1))
        </span>
        <button type="button" data-testid={`${t}-sil`} style={{ ...S.btnS, padding:'4px 10px' }} onClick={onSil}>✕</button>
      </div>
      <div style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end' }}>
        <div style={{ width:110 }}><span style={S.label}>Start (UTC)</span>
          <input {...zAlan(S.input, true, saatGecerli(sim.start))} data-testid={`${t}-start`} value={sim.start}
                 onChange={e => degistir('start', normTime(e.target.value))} /></div>
        <div style={{ width:110 }}><span style={S.label}>Sim ends (UTC)</span>
          <input {...zAlan(S.input, true, saatGecerli(sim.end))} data-testid={`${t}-end`} value={sim.end}
                 onChange={e => degistir('end', normTime(e.target.value))} /></div>
        <div><span style={S.label}>Device</span>
          <select style={{ ...S.input, width:150 }} data-testid={`${t}-device`} value={sim.device || ''}
                  onChange={e => degistir('device', e.target.value)}>
            <option value="">— SELECT —</option>
            <option value="FFS_D">FFS LEVEL D</option>
            <option value="FNPT">FNPT</option>
          </select></div>
        <div style={{ width:280 }}><span style={S.label}>Location</span>
          <LocationPicker kural={locationKurali('sim')} value={sim.loc} zorunlu locations={locations}
                          onChange={v => degistir('loc', v)} onAdd={onAddLocation} /></div>
        <SimKontrolKutulari secili={sim.checks || []} testid={`${t}-kontrol`} degistir={v => degistir('checks', v)} />
      </div>
      <div style={{ marginTop:8 }}>
        <span style={S.label}>Pilots on the simulator</span>
        {ekip.length ? (
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }} data-zorunlu={secili.some(id => ekip.some(p => p.id === id)) ? 'dolu' : 'eksik'}
               data-testid={`${t}-pilotlar`}>
            {ekip.map(p => {
              const on = secili.includes(p.id);
              return <SecimKutusu key={p.id} isaretli={on} testid={`${t}-pilot-${p.code}`}
                                  onClick={() => degistir('pilotlar', on ? secili.filter(x => x !== p.id) : [...secili, p.id])}>{p.code}</SecimKutusu>;
            })}
          </div>
        ) : <div style={{ fontSize:10, color:C.t3 }}>Select the crew below first — the simulator is written only for the pilots ticked here.</div>}
      </div>
      <div style={{ ...S.note, marginTop:8 }}>
        {yer === 'once'
          ? 'The FDP starts at the start of the simulator; the Md.16 rest is asked before the simulator. '
          : 'The FDP runs to the end of the simulator, the wait included; the rest after it follows the whole duty period. '}
        The duty of the simulator ends 60 min after it (Md.10(1)(c)); it is not a sector.
      </div>
    </div>
  );
}
const SIM_NOTU = 'An FFS Level D session counts as the approved programme\'s minimum — 3 take-offs and 3 landings '
  + '(FCL.060(a)(1)); they are not entered. Night is not asked (IR held, FCL.060(a)(2)(ii)). OPC / LPC is shown on the '
  + 'roster — record the check itself in TRAINING.';

/** Kâğıt OFP kutusu — İKİ SEÇENEĞİN DE SONUCU EKRANDA YAZAR.
 *  🔴 Seçmeyenin ne kaybettiğini söylemek şart: işaretlemeyi unutan saatleri
 *     sessizce kaybediyordu ve bunu aylar sonra fark ediyorduk. */
/** Kâğıt OFP satırlarında eksik iniş bilgisi — ADIYLA (22 Eyl 2026).
 *  Kutu işaretliyse her sektör kendi iniş sayısını ve tipini taşımalı:
 *  arşivden gelen uçuşta bu ikisi END FLT'in kapısında zorunlu, elle girilende
 *  de boş geçilemez (aksi halde aynı boşluk sessizce geri gelirdi). */
/** İniş alanlarının kapı ölçüsü — kapı (`kagitInisEksik`) ve zorunlu alan rengi AYNI ölçüyü okur (5 Eki 2026). */
export const inisSayisiGecerli = (v) => { const n = Number(v); return v !== '' && v != null && Number.isInteger(n) && n >= 1; };
export const inisTipiGecerli = (v) => !!String(v || '').trim();
export function kagitInisEksik(sektorler, inisler) {
  return (sektorler || []).flatMap((sk, i) => {
    const ad = `${sk?.dep || '?'}-${sk?.dest || '?'}`;
    const g = (inisler || [])[i] || {};
    const eksik = [];
    if (!inisSayisiGecerli(g.landings)) eksik.push(`${ad}: LANDINGS missing`);
    if (!inisTipiGecerli(g.lnd_type)) eksik.push(`${ad}: TYPE OF LNDG missing`);
    return eksik;
  });
}

function PaperOfpKutusu({ isaretli, setIsaretli, reg, setReg, ucaklar, testid = 'paper-ofp',
                          sektorler = [], inisler = [], setInis = () => {}, ucakHata = null, evrak = null,
                          kayitVar = false, zorunlu = false }) {
  // `zorunlu`: işaretin kendisi kapıda (EDIT — uçulmuş göreve eklenen bacak kâğıt OFP'dir, 5 Eki 2026) → iPad renk kuralı.
  const kutu = { marginTop:14, padding:'12px 14px', background:C.bg3, border:`1px solid ${isaretli ? C.accent : C.border2}` };
  return (
    <div {...zAlan(kutu, zorunlu, isaretli)} data-testid={`${testid}-kutu`}>
      {/* Seçim kutusu tasarım S1 (5 Eki 2026) — tek bileşen `SecimKutusu`. */}
      <SecimKutusu isaretli={isaretli} onClick={() => setIsaretli(v => !v)} testid={`${testid}-toggle`}
                   style={{ textTransform:'none' }}>
        <span><b>PAPER OFP</b> — flown on a paper OFP, no EFB report exists</span>
      </SecimKutusu>
      {isaretli && (
        <div style={{ marginTop:10 }}>
          <span style={S.label}>Aircraft *</span>
          {/* Kapı: `kagitOfpEksigi` — tescil boşsa kayıt yok. */}
          <select {...zAlan(S.input, true, !!String(reg ?? '').trim())} data-testid={`${testid}-reg`}
                  value={reg} onChange={e => setReg(e.target.value)}>
            <option value="">— SELECT —</option>
            {ucaklar.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          {/* Liste okunamadıysa BOŞ liste "uçak yok" demez — sebebi yazar. */}
          {ucakHata && (
            <div data-testid={`${testid}-reg-hata`}
                 style={{ fontSize:11, color:C.red, marginTop:4, fontFamily:'var(--mono)' }}>
              {ucakHata}
            </div>
          )}
          <div style={{ fontSize:10, color:C.t3, marginTop:4 }}>
            Aircraft hours are totalled per registration — without it these hours
            never reach the aircraft.
          </div>

          {/* ── İNİŞ SAYISI + TİPİ, SEKTÖR SEKTÖR (22 Eyl 2026) ──────────
              🔑 Serkan: *"Manuel flt girişi yapılırken de soracak: iniş nereden
                 nasıl yapıldı, kaç cycle iniş diye elle gireceğiz onu da."*
                 · *"Belki touch and go çalışıldı, 6 cycle mesela."*
              Her bacak kendi sayısını taşır: iki bacaklı görevde ikisine birden
              6 yazmak kaydı bozardı. Tek bacakta tek satır görünür.
              Tipler iPad'in END FLT menüsüyle AYNI metinlerdir. */}
          <div style={{ marginTop:12 }}>
            <span style={S.label}>Landings * — cycles and type, per sector</span>
            {/* DH bacağı uçuş değildir — iniş sorulmaz (29 Eyl 2026). Sıra
                (`i`) korunur: çağıranın dizisiyle hizalı kalsın. */}
            {(sektorler.length ? sektorler : [{}]).map((sk, i) => sk?.deadhead || sk?._arsiv ? null : (
              <div key={i} style={{ display:'grid', gridTemplateColumns:'110px 70px 1fr',
                                    gap:8, alignItems:'center', marginTop:6 }}>
                <span style={{ fontSize:11, color:C.t2, fontFamily:'var(--mono)' }}>
                  {`${sk?.dep || '?'}-${sk?.dest || '?'}`}
                </span>
                {/* Kapı: `kagitInisEksik` — aynı ölçü (`inisSayisiGecerli` / `inisTipiGecerli`). Boş alan "1" gösterse de
                    doldurulmamıştır: amber kalır. */}
                <input {...zAlan({ ...S.input, textAlign:'center' }, true, inisSayisiGecerli(inisler[i]?.landings))}
                       type="number" min="1" max="99" placeholder="1"
                       data-testid={`${testid}-ldg-${i}`}
                       value={inisler[i]?.landings ?? ''}
                       onChange={e => setInis(i, 'landings', e.target.value.replace(/\D/g, ''))} />
                <select {...zAlan(S.input, true, inisTipiGecerli(inisler[i]?.lnd_type))} data-testid={`${testid}-tip-${i}`}
                        value={inisler[i]?.lnd_type || ''}
                        onChange={e => setInis(i, 'lnd_type', e.target.value)}>
                  <option value="">— TYPE OF LNDG —</option>
                  {INIS_TIPLERI.map(x => <option key={x} value={x}>{x}</option>)}
                  {/* Listede artik olmayan eski tip (31 Eki 2026: OTS → SA) — kayit oldugu gibi gorunur, sessizce bos gostermez. */}
                  {inisler[i]?.lnd_type && !INIS_TIPLERI.includes(inisler[i].lnd_type)
                    && <option value={inisler[i].lnd_type}>{inisler[i].lnd_type}</option>}
                </select>
              </div>
            ))}
            <div style={{ fontSize:10, color:C.t3, marginTop:4 }}>
              Cycles is the number of landings on that sector — six touch-and-go
              circuits are six. Both are required: the EFB asks for them at the end
              of every flight, so a hand-entered flight cannot leave them empty.
            </div>
          </div>

          {/* ── EVRAK (2 Eki 2026) — Serkan: ofis uçaktan gelen evrakı tarar, burada yükler, SAVE eder; arşivde
              VIEW + DOWNLOAD. Yalnız PDF, en fazla 20 MB, birden çok, zorunlu değil; kaldırılan TAMAMEN silinir.
              Değişiklikler SAVE'de uygulanır (iz önce, sonra dosya). Kurallar `kagitEvrak.js`te. */}
          {evrak && (
            <div data-testid={`${testid}-evrak`} style={{ marginTop:12 }}>
              <span style={S.label}>Documents — PDF, max 20 MB each (optional)</span>
              {evrak.okumaHata && (
                <div data-testid={`${testid}-evrak-hata`}
                     style={{ fontSize:11, color:C.red, marginTop:4, fontFamily:'var(--mono)' }}>{evrak.okumaHata}</div>
              )}
              {(evrak.liste || []).map(d => {
                const gidecek = evrak.kaldirilacak.has(d.id);
                return (
                  <div key={d.id} data-testid={`${testid}-evrak-satir`}
                       style={{ display:'flex', gap:8, alignItems:'center', marginTop:6, fontFamily:'var(--mono)', fontSize:11,
                                color: gidecek ? C.red : C.t1, textDecoration: gidecek ? 'line-through' : 'none' }}>
                    <span style={{ flex:1, overflow:'hidden', textOverflow:'ellipsis' }}>📄 {d.file_name}</span>
                    <span style={{ color:C.t3 }}>{mbYaz(d.file_size)}</span>
                    <button type="button" data-testid={`${testid}-evrak-kaldir`} className={KUTU_SINIFI}
                            style={{ ...dugmeStili(gidecek ? 'notr' : 'silme'), padding:'3px 10px', fontSize:10 }}
                            onClick={() => evrak.kaldir(d.id)}>{gidecek ? 'UNDO' : 'REMOVE'}</button>
                  </div>
                );
              })}
              {evrak.yeni.map((f, i) => (
                <div key={`y${i}`} data-testid={`${testid}-evrak-yeni`}
                     style={{ display:'flex', gap:8, alignItems:'center', marginTop:6, fontFamily:'var(--mono)', fontSize:11, color:C.accent }}>
                  <span style={{ flex:1, overflow:'hidden', textOverflow:'ellipsis' }}>📄 {f.name}</span>
                  <span style={{ color:C.t3 }}>{mbYaz(f.size)} · uploaded on SAVE</span>
                  <button type="button" data-testid={`${testid}-evrak-yeni-cikar`} className={KUTU_SINIFI}
                          style={{ ...dugmeStili('notr'), padding:'3px 10px', fontSize:10 }}
                          onClick={() => evrak.yeniCikar(i)}>✕</button>
                </div>
              ))}
              {evrak.ret.map((m, i) => (
                <div key={`r${i}`} data-testid={`${testid}-evrak-ret`}
                     style={{ fontSize:11, color:C.red, marginTop:4, fontFamily:'var(--mono)' }}>{m}</div>
              ))}
              <label className={KUTU_SINIFI} style={{ ...dugmeStili('notr'), display:'inline-block', marginTop:8, cursor:'pointer' }}>
                + ADD PDF
                <input type="file" accept="application/pdf,.pdf" multiple hidden data-testid={`${testid}-evrak-sec`}
                       onChange={e => { evrak.ekle([...(e.target.files || [])]); e.target.value = ''; }} />
              </label>
              <div style={{ fontSize:10, color:C.t3, marginTop:4 }}>
                The scanned documents of this flight. They are uploaded when you SAVE and shown in ARCHIVED FLTS → DOCUMENTS.
                A removed document is deleted for good; its name, size and your reason stay in the edit log.
              </div>
            </div>
          )}
        </div>
      )}
      <div data-testid={`${testid}-sonuc`}
           style={{ marginTop:10, fontSize:11, lineHeight:1.6,
                    color: isaretli ? C.green : C.amber }}>
        {isaretli
          ? 'Counted in STATISTICS and aircraft hours, shown with a PAPER OFP badge. '
            + 'No flight report — there is none to show.'
          : kayitVar
            // Kayıtlı kâğıt kayıt varken işaret kaldırıldı (5 Eki 2026, A) — SAVE'de ne olacağı önceden söylenir.
            ? 'On SAVE the paper record of this flight is marked DELETED: it stays in ARCHIVED FLTS with your reason, '
              + 'but is no longer counted in statistics or aircraft hours. Its documents are kept. '
              + 'Tick the box again to bring the record back.'
            : 'These hours will NOT appear in statistics or aircraft hours. '
              + 'Tick the box above if the flight was flown without the EFB.'}
      </div>
    </div>
  );
}

// ── TEK "+ ADD" (14 Eki 2026) ────────────────────────────────────────────
// 🔑 Serkan: *"add sector here butonunu değiştirip oraya add duty desek (tek buton), buna tıklayınca SECTOR / DH / SIM neyse
//    duty'nin türünü seçip devam etsek"* · *"her yerin buton olması tasarıma aykırı"*. Her ekleme noktasında tek düğme;
//    yalnız O NOKTADA İZİNLİ türler gösterilir (DH uçuş bacaklarının önüne / arkasına — iki uçuşun arasına konmaz). Tek tür
//    izinliyse doğrudan ekler, birden çoksa türler açılır. ASSIGN (uçuş + DH) ve EDIT aynı düğme.
// 5 Eki 2026'dan (Serkan: *"her bacağın altında add sector here bütün problemleri çözer"*): yeni satır düğmenin olduğu yere
//    girer (gece yarısında da); yanlış yere konursa sıra kontrolü (`bacakSirasiHatasi`) bacağı adıyla söyler ve kayıt durur.
// 🔴 Önce: "+ ADD SECTOR HERE", "+ ADD DUTY AFTER: DH" ve DH ekranında "+ ADD FLT DUTY" — üç ayrı düğme.
/** @param secenekler { tur: 'sector' | 'dh', etiket, onSec }[] — bu noktada izinli türler, sırayla */
function EkleSecici({ secenekler, testid }) {
  const [acik, setAcik] = useState(false);
  if (!secenekler.length) return null;
  const kucuk = { ...S.btnS, borderStyle:'dashed', color:C.t3, padding:'3px 10px', fontSize:10 };
  if (!acik) {
    return (
      <button type="button" data-testid={testid} style={{ ...kucuk, margin:'0 0 8px 40px' }}
              onClick={() => (secenekler.length === 1 ? secenekler[0].onSec() : setAcik(true))}>
        + ADD
      </button>
    );
  }
  return (
    <div data-testid={`${testid}-secenekler`} style={{ display:'flex', gap:6, alignItems:'center', margin:'0 0 8px 40px' }}>
      {secenekler.map(x => (
        <button key={x.tur} type="button" data-testid={`${testid}-${x.tur}`} style={{ ...kucuk, borderStyle:'solid', color:C.accent }}
                onClick={() => { setAcik(false); x.onSec(); }}>
          + {x.etiket}
        </button>
      ))}
      <button type="button" data-testid={`${testid}-iptal`} style={kucuk} onClick={() => setAcik(false)}>CANCEL</button>
    </div>
  );
}
/** Diziye `i`'nin ARKASINA eleman koyar (i = -1 → başa). */
const arayaKoy = (dizi, i, yeni) => [...dizi.slice(0, i + 1), yeni, ...dizi.slice(i + 1)];

// ── BACAK BAŞINA EKİP ROLLERİ (29 Eyl 2026) ──────────────────────────
//
// 🔑 Serkan: *"4 bacak uçuş girilse dahi her bacak için ayrı ayrı edit
//    edilebilmeli."* ASSIGN ve EDIT AYNI bileşeni kullanır (İlke 3) — kural
//    `EkipRolleri.js`te, burada yalnız seçim var.
// Seçim TAKASTIR: bir bacakta PF'i değiştirince eski PF, yeni seçilenin eski
// rolünü alır. İki pilotta öteki kendiliğinden PM olur; üç pilotta kalan CRZ.
// Eski kayıttan gelen geçersiz bacak (ör. iki PF) sessizce düzeltilmez —
// satırında ADIYLA yazar, kayıt düzeltilmeden geçmez.
// 5 Eki 2026 (4 pilotlu ekip, Md.11(4)): iki CRZ varsa iki CRZ sütunu — her sütunun SAHİBİ o bacaktaki n'inci CRZ'dir,
// takas o sahiple yapılır (`rolAta` sahibiKey).
function BacakRolleri({ sektorler, uyeler, haritalar, onDegis, testid = 'leg-roles' }) {
  const crzSutun = Math.max(0, Math.min(uyeler.length - 2, AZAMI_CRZ));
  const sutunlar = uyeler.length >= 2 ? ['PF', 'PM', ...Array.from({ length: crzSutun }, (_, j) => `CRZ CPT${crzSutun > 1 ? ` ${j + 1}` : ''}`)]
                 : ['PF'];
  const rolu = (sutun) => (sutun.startsWith('CRZ CPT') ? 'CRZ CPT' : sutun);
  const crzSirasi = (sutun) => (sutun.startsWith('CRZ CPT ') ? Number(sutun.slice(8)) - 1 : 0);
  return (
    <div data-testid={testid} style={{ marginTop:12 }}>
      <span style={S.label}>Crew roles — per sector</span>
      <div style={{ overflowX:'auto' }}>
        <table style={S.table}>
          <thead><tr>{['SECTOR', ...sutunlar].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {(sektorler || []).map((s, i) => {
              const h = (haritalar || [])[i];
              if (s?.deadhead || !h) return null;
              const hata = bacakHatasi(h);
              return (
                <tr key={i} data-testid={`${testid}-${i}`}>
                  <td style={S.td}>
                    {`${s?.dep || '?'}-${s?.dest || '?'}`}
                    {hata && <div data-testid={`${testid}-${i}-hata`}
                                  style={{ color:C.red, fontSize:10, whiteSpace:'normal' }}>{hata}</div>}
                  </td>
                  {sutunlar.map(sutun => {
                    const rol = rolu(sutun);
                    const sahibi = Object.keys(h).filter(k => h[k] === rol)[rol === 'CRZ CPT' ? crzSirasi(sutun) : 0] || '';
                    const kimlik = rol !== 'CRZ CPT' ? rol : (crzSirasi(sutun) ? `CRZ${crzSirasi(sutun) + 1}` : 'CRZ');
                    return (
                      <td key={sutun} style={S.td}>
                        <select style={{ ...S.input, fontSize:11, padding:'6px 8px' }} value={sahibi}
                                data-testid={`${testid}-${i}-${kimlik}`}
                                onChange={e => e.target.value && onDegis(i, rolAta(h, e.target.value, rol, sahibi || null))}>
                          {!sahibi && <option value="">— SELECT —</option>}
                          {uyeler.map(u => <option key={u.key} value={u.key}>{u.ad}</option>)}
                        </select>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ ...S.note, marginTop:6 }}>
        Pick the PF{uyeler.length >= 2 ? ' and PM' : ''} for each sector — the pilot you replace takes
        the other role{uyeler.length >= 4 ? '; the remaining pilots are CRZ CPT on that sector'
          : uyeler.length === 3 ? '; the remaining pilot is CRZ CPT on that sector' : ''}.
        Roles are saved per sector: FCL.060 recency counts PF sectors, and statistics and the
        PAPER OFP record read the crew of every sector.
      </div>
    </div>
  );
}

// ── 3. KİŞİ KUTUSU — CRZ CPT / CHECK RIDE (4 Ağu · 29 Eyl 2026) ─────────
//
// 🔑 Serkan (29 Eyl): *"3 kişilik ekiplerde de bir box olsun, tıklayınca aynı
//    app'te olduğu gibi sorsun: CRZ pilot mu yoksa öğretmenli mi; CRZ ise
//    tanımlı diğer pilot otomatik çıkar, değil check uçuşu ise elle ismi
//    girilir."*
// 🔴 Kutu yalnız ASSIGN'daydı; EDIT sonradan üçüncü kişi ekleyemiyordu.
//    Artık iki ekran da BU bileşeni çizer (İlke 3). CRZ pilotunun nasıl
//    seçildiği ekrana özgüdür (ASSIGN: listeden 3. tıklama · EDIT: şirket
//    pilotları listesi) — o parça `crzSecici` olarak gelir.
// CHECK RIDE denetçisi şirket pilotu değildir: FTL'i tutulmaz, standart
// 2 pilot UGS'si geçerlidir (4 Ağu kararı).
// ── AÇIK MESAİ (SPLIT DUTY) KUTUSU — ASSIGN ve EDIT ORTAK (29 Eyl 2026) ──────
// 🔑 Serkan: *"1'den fazla bacak girildiğinde ve aralarda kurala göre bir boşluk
//    olduğunda split duty seçelim ve hotel mi uçak mı diye sormalısın; gerekli
//    box'ı check edip ilerlememiz lazım."* · *"Kural kesinlikle titizlikle
//    uygulanmalı."* Kural motorda (`splitDuty`, Md.15); burada yalnız cevap var.
// Cevap VARSAYILMAZ: seçilmeden kayıt olmaz (çağıran kapıda durdurur).
function AcikMesaiKutusu({ split, konaklama, setKonaklama, testid = 'split' }) {
  if (!split) return null;
  if (split.olculemedi) {
    return <div data-testid={`${testid}-olculemedi`} style={{ ...S.note, marginTop:12, borderLeftColor:C.red, color:C.red }}>{split.olculemedi}</div>;
  }
  if (!split.isSplit) return null;
  const b = split.bekleme || {};
  const digerleri = (split.adaylar || []).filter(x => x !== b && split.yolMin != null && split.esikMin != null
    && x.min - split.yolMin >= split.esikMin);
  // 🔴 12 Eki 2026 (saha, DUTY HISTORY → EDIT): ortak düğme stili satır KIRMAZ (`dugmeStili`: nowrap + yan yana dizilim) —
  //    uzun alt yazı ("FDP +02:54 (50% of the break …") düğmeyi pencereden geniş yaptı, pencerenin içeriği yana kaydı:
  //    sağda taştı, solda PF/PM ve Md.15 notu kesildi. 🔑 Serkan: *"bütün textler açılan ekran içine sığmalı, gerekirse
  //    alt satıra geçmeli"*. Bu seçim kartları yazıyı alt satıra geçirir, dar pencerede alt alta dizilir; kısa düğmeler
  //    (SAVE, CANCEL…) ortak stilde kalır.
  const secim = (deger, etiket, alt) => (
    <button type="button" data-testid={`${testid}-${deger}`} onClick={() => setKonaklama(deger)}
      style={{ ...S.btnS, flex:'1 1 240px', minWidth:0, maxWidth:'100%', whiteSpace:'normal', overflowWrap:'anywhere',
               flexDirection:'column', alignItems:'flex-start', justifyContent:'flex-start', textAlign:'left',
               borderColor: konaklama === deger ? C.accent : C.border2,
               color: konaklama === deger ? C.accent : C.t2 }}>
      <b>{konaklama === deger ? '◉' : '○'} {etiket}</b>
      <div style={{ fontSize:10, marginTop:4, color:C.t3 }}>{alt}</div>
    </button>
  );
  return (
    <div data-testid={testid} {...zAlan({ marginTop:12, padding:'12px 14px' }, true, !split.cevapGerekli)}>
      <span style={S.label}>Split duty — SHT-FTL/HG Md.15</span>
      <div style={{ ...S.note, marginBottom:10 }}>
        Wait{b.meydan ? ` at ${b.meydan}` : ''}: {b.start}–{b.end} = <b>{fmtMin(split.beklemeMin)}</b>
        {' '}· pre/post-flight duties and travel {fmtMin(split.yolMin)} (Md.15(1)(e))
        {' '}· break at the accommodation <b>{fmtMin(split.molaMin)}</b> — at least {fmtMin(split.esikMin)} consecutive (Md.15(1)(a)).
        {' '}The whole break counts as FDP (Md.15(1)(c)).
      </div>
      {split.birlesmez ? (
        <div data-testid={`${testid}-birlesmez`} style={{ ...S.note, borderLeftColor:C.accent }}>
          A CRZ CPT is on board: split duty cannot be combined with in-flight rest (Md.15(1)(d)) —
          no split extension, nothing to answer.
        </div>
      ) : (<>
        <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
          {secim('hotel', 'HOTEL — suitable accommodation',
                 `Separate quiet room with a bed (Md.4(dd)) · FDP +${fmtMin(split.otelUzatmaMin)} (50% of the break, max 4:00 — Md.15(1)(b))`)}
          {secim('aircraft', 'ON AIRCRAFT / NO SUITABLE ACCOMMODATION',
                 'Md.15 needs suitable accommodation — no extension')}
        </div>
        {split.cevapGerekli && (
          <div data-testid={`${testid}-cevap-gerekli`} style={{ fontSize:11, color:'var(--amber)', marginTop:8, fontFamily:'var(--mono)' }}>
            ANSWER REQUIRED — where was the break? The duty cannot be saved until this is chosen.
          </div>
        )}
      </>)}
      {digerleri.length > 0 && (
        <div style={{ fontSize:10, color:C.t3, marginTop:8, fontFamily:'var(--mono)' }}>
          Other waits long enough for a split: {digerleri.map(x => `${x.meydan || '?'} ${fmtMin(x.min)}`).join(' · ')}.
          Md.15 extends the FDP by one break — the longest is used.
        </div>
      )}
    </div>
  );
}

/** Artırılmış ekip notu (Md.11) — ASSIGN ve EDIT aynı metni gösterir.
 *  4 Eki 2026 (Md.11(2), Serkan B): 3 sektörün üstünde uzatma yok — o zaman YALNIZ bunu söyler ("ACTIVE +2:00" çelişkisi yok).
 *  5 Eki 2026 (4 pilotlu ekip): ekip sayısı ve uzatma pencereden (`augmentedCrewSize`, `augmentedExtensionMin` — kural seti);
 *  🔴 önce "+2:00" ve "all three crew" SABİTTİ — iki ilave pilotta (+3:00) yanlış söylerdi. */
const EKIP_SAYISI_YAZI = { 3: 'three', 4: 'four' };
function AugmentedNot({ win }) {
  const ekip = EKIP_SAYISI_YAZI[win?.augmentedCrewSize] || 'three';
  const ek = win?.augmentedExtensionMin != null ? `+${fmtMin(win.augmentedExtensionMin)}` : 'the extension';
  const ilave = win?.augmentedCrewSize === 4 ? 'two additional pilots' : 'one additional pilot';
  const tumEkip = <> Duty &amp; rest limits apply to all {ekip} crew.</>;
  if (win?.augmentedRestNotSelected) {
    return (
      <div style={{ ...S.note, borderLeftColor:C.accent, color:C.accent }} data-testid="augmented-olanak">
        IN-FLIGHT REST FACILITY NOT SELECTED — choose IN USE or NOT IN USE above. Until then MAX FDP
        {' '}{fmtMin(win.maxFdpMin)} is the standard Table 1 value: the extension depends on in-flight rest
        (SHT-FTL/HG Md.11(1)(4)).{tumEkip}
      </div>
    );
  }
  if (win?.augmentedNoRestFacility) {
    return (
      <div style={{ ...S.note, borderLeftColor:C.accent, color:C.accent }} data-testid="augmented-olanak">
        NO AUGMENTED EXTENSION — MAX FDP {win ? fmtMin(win.maxFdpMin) : '—'} is the standard Table 1 value: the extension
        depends on in-flight rest (SHT-FTL/HG Md.11(1)(4)) and the rest facility is NOT IN USE.{tumEkip}
      </div>
    );
  }
  if (win?.augmentedSectorLimitExceeded) {
    return (
      <div style={{ ...S.note, borderLeftColor:C.red, color:C.red }} data-testid="augmented-sinir">
        AUGMENTED CREW EXTENSION NOT APPLIED — MAX FDP {fmtMin(win.maxFdpMin)} is the standard Table 1 value. The extended
        FDP is limited to 3 sectors (SHT-FTL/HG Md.11(2)); with more sectors the {ilave} give{win?.augmentedCrewSize === 4 ? '' : 's'} no
        extension. Reduce to 3 sectors to use the {ek}.{tumEkip}
      </div>
    );
  }
  return (
    <div style={{ ...S.note, borderLeftColor:C.accent }}>
      AUGMENTED CREW ACTIVE — MAX FDP {win ? fmtMin(win.maxFdpMin) : '—'} (SHT-FTL/HG Md.11:
      table value {ek} with {ilave}; in-flight rest 90 min each / 2h for landing crew,
      reclining seat required; FDP limited to 3 sectors; split-duty NOT combinable — Md.15(d)).{tumEkip}
    </div>
  );
}

// UÇUŞ İÇİ DİNLENME OLANAĞI (Md.11(1)(4), 4 Eki 2026 — Serkan A): CRZ CPT seçilince ZORUNLU; ASSIGN ve EDIT aynı kutu.
const DINLENME_SECENEKLERI = [['in_use', 'IN USE'], ['not_in_use', 'NOT IN USE']];
// 🔑 4 PİLOTLU EKİP (5 Eki 2026, Serkan): *"ADD CREW dedik CRZ seçtik, ADD CREW der bir daha CRZ seçeriz"* · *"ikinci kez
//    açıldığında göstereceği liste unselected crews olmalı, daha önce ataması yapılmış görünmesin"* — CRZ'ler LİSTE
//    (`crzler`: [{ key, ad, onKaldir }]); `onCrzEkle` verilirse CRZ kutusunda yine "+ ADD COCKPIT CREW" çıkar (en çok
//    `AZAMI_CRZ`, Md.11(4)); seçici (`crzSecici`) ekrana özgüdür ve yalnız ekipte OLMAYAN pilotları listeler.
//    `onKutuKapat`: CRZ seçilmeden kutuyu kapatan REMOVE. 🔴 Önce kutu tek CRZ adı taşıyordu, REMOVE hepsini silerdi.
function UcuncuKisiKutusu({ mod, setMod, crzler = [], crzSecici = null, onCrzEkle = null, onKutuKapat = null,
                            augmentedNot = null, examiner, setExaminer, onCheckKaldir,
                            dinlenme = '', setDinlenme = null, testid = 'third-crew' }) {
  return (
    <div data-testid={testid} style={{ marginTop:12, padding:'12px 14px', border:`1px dashed ${C.border2}` }}>
      {!mod && (
        <button type="button" data-testid={`${testid}-add`} style={S.btnS}
                onClick={() => setMod('pick')}>+ ADD COCKPIT CREW</button>
      )}
      {mod === 'pick' && (
        <div style={{ display:'flex', gap:10, alignItems:'center' }}>
          <button type="button" data-testid={`${testid}-crz`} style={S.btnS}
                  onClick={() => setMod('crz')}>CRZ CPT</button>
          <button type="button" data-testid={`${testid}-checkride`} style={S.btnS}
                  onClick={() => setMod('checkride')}>CHECK RIDE</button>
          <button type="button" style={{ ...S.btnS, color:C.t3 }} onClick={() => setMod(null)}>✕</button>
        </div>
      )}
      {mod === 'crz' && (
        <div>
          <div style={{ display:'flex', gap:10, alignItems:'center', marginBottom:6, flexWrap:'wrap' }}>
            <span style={{ ...badge('blue') }} data-testid={`${testid}-rozet`}>
              {crzler.length >= 2 ? `${crzler.length + 2}-PILOT OPS — ${crzler.length} × CRZ CPT` : '3-PILOT OPS — CRZ CPT'}
            </span>
            {onKutuKapat && (
              <button type="button" data-testid={`${testid}-remove`}
                      style={{ ...S.btnS, color:C.t3, marginLeft:'auto' }}
                      onClick={onKutuKapat}>REMOVE</button>
            )}
          </div>
          {crzler.map((c, i) => (
            <div key={c.key || i} data-testid={`${testid}-crz-${i + 1}`}
                 style={{ display:'flex', gap:10, alignItems:'center', marginBottom:6, flexWrap:'wrap' }}>
              <span style={{ fontSize:10, color:C.t3, fontFamily:'var(--mono)' }}>CRZ CPT{crzler.length > 1 ? ` ${i + 1}` : ''}</span>
              <b style={{ fontSize:12, fontFamily:'var(--mono)' }}>{c.ad}</b>
              {c.onKaldir && (
                <button type="button" data-testid={`${testid}-remove-${i + 1}`}
                        style={{ ...S.btnS, color:C.t3, marginLeft:'auto' }} onClick={c.onKaldir}>REMOVE</button>
              )}
            </div>
          ))}
          {crzSecici && <div style={{ marginBottom:6 }}>{crzSecici}</div>}
          {onCrzEkle && (
            <div style={{ display:'flex', gap:10, alignItems:'center', marginBottom:6, flexWrap:'wrap' }}>
              <button type="button" data-testid={`${testid}-add-crz`} style={S.btnS} onClick={onCrzEkle}>+ ADD COCKPIT CREW</button>
              <span style={{ fontSize:10, color:C.t3 }}>
                A second CRZ CPT makes a 4-pilot crew — two additional pilots, SHT-FTL/HG Md.11(4).
              </span>
            </div>
          )}
          {setDinlenme && (
            <div data-testid={`${testid}-dinlenme`}
                 {...zAlan({ margin:'4px 0 8px', padding:'8px 10px', borderRadius:6 }, true, !!dinlenme)}>
              <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                <span style={{ ...S.label, margin:0 }}>IN-FLIGHT REST FACILITY (Md.11(1)) *</span>
                {DINLENME_SECENEKLERI.map(([v, l]) => (
                  <button key={v} type="button" data-testid={`${testid}-dinlenme-${v}`} className={KUTU_SINIFI}
                          style={sekmeStili(dinlenme === v)} onClick={() => setDinlenme(v)}>{l}</button>
                ))}
              </div>
              <div style={{ fontSize:10, color:C.t3, marginTop:4, lineHeight:1.5 }}>
                IN USE — a reclining seat or a bed is free for crew rest on this duty (no passengers in it): each pilot gets
                at least 90 min consecutive rest, the landing crew at least 2 h (Md.11(3)); the FDP gets the augmented-crew
                extension of Md.11(4) up to 3 sectors (shown below). NOT IN USE — the seats are taken by passengers: no
                extension, the standard Table 1 value applies.
                Your choice is the declaration; in-flight rest itself is not recorded.
              </div>
            </div>
          )}
          {augmentedNot}
        </div>
      )}
      {mod === 'checkride' && (
        <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
          <span style={{ ...badge('amber') }}>CHECK RIDE ✓</span>
          <span style={{ fontSize:11, color:C.t3, fontFamily:'var(--mono)' }}>TRE/TRI</span>
          <HarfliGiris {...zAlan({ ...S.input, width:260 }, true, !!String(examiner || '').trim())} placeholder="NAME SURNAME"
                       data-testid={`${testid}-examiner`}
                       value={examiner} onChange={setExaminer} />
          <span style={{ fontSize:10, color:C.t3 }}>External examiner — recorded on the assignment; no FTL tracking (not company crew). Standard 2-pilot FDP applies.</span>
          <button type="button" style={{ ...S.btnS, color:C.t3 }} onClick={onCheckKaldir}>✕</button>
        </div>
      )}
    </div>
  );
}


// ── EKİP DÜZEYİ KAPILAR — ASSIGN ve EDIT ORTAK (29 Eyl 2026) ─────────────────
// OML ikilisi · MED kısıtlamaları · FCL.060(a)(3) seyir yedek yakınlığı ·
// FCL.065 yaş. Kural pilot ÇİFTİ/EKİP üzerindedir, satır başına değil.
// 🔴 29 Eyl'e kadar yalnız ASSIGN'da koşuyordu: EDIT'te pilot değiştirmek ya
//    da CRZ eklemek bu kapılardan HİÇ geçmiyordu (4 Eyl "EDIT aynı kapıdan
//    geçer" kararının eksik ayağı). Tek fonksiyon, iki çağrı (İlke 3).
export function ekipKapilari({ pilotlar = [], lisansMed = {}, duties = [], crzPilotlar = [],
                               tzMap = {}, simdi = new Date() }) {
  const secililer = pilotlar.map(p => {
    const r = lisansMed[p.id] || {};
    return {
      id: p.id, code: p.code,
      oml: (r.med_limitations || []).includes('OML'),
      // Kısıtlamaların TAMAMI motora gider; hangisinin atamaya etkisi
      // olduğuna `data/medLimitations.js` karar verir — burada ikinci bir
      // kod listesi tutulmaz (İlke 3).
      limits: r.med_limitations || [],
      oalTypes: r.oal_types || [],
      sslText: r.ssl_text || '',
      age: plmYas(r.date_of_birth),
      dob: r.date_of_birth || null,
      // Tip vasfı: uçak seçilmemişse tip bilinmez → `null` ("ölçülemedi"),
      // `false` değil; `omlKontrol` ikisini ayrı ele alır.
      typeOk: null,
    };
  });
  // `g` düz metin (ekranlar okur) · `kunyeli` aynı sırada { metin, ref } — kartın
  // ⓘ'si madde metnini künyeden açar (29 Eyl 2026 · bkz. FTLEngine.fitness).
  const g = [];
  const kunyeli = [];
  const engel = (metin, ref) => { g.push(metin); kunyeli.push({ metin, ref }); };
  // omlKontrol YALNIZ OML kuralıdır — ürettiği her gerekçe OML'nin gerekçesidir.
  omlKontrol(secililer).forEach(m => engel(m, 'SHT-MED OML'));

  // ── SAĞLIK KISITLAMALARI (6 Eyl 2026) ────────────────────────────
  // OML dışındaki kapılar: OCL · VCL (gece) · OAL (tip) · OSL/OPL/ORL.
  // Bağlam BİLİNMİYORSA "uygun" sayılmaz — motor AMBER döndürür ve o
  // uyarılar aşağıda ayrı gösterilir (İlke 1).
  //
  // 🔑 Serkan (6 Eyl): SSL için (a) şıkkı — *"engellemez ama gerekçe
  //    dispatcher'ın önünde durur."*
  const mk = medKisitlamaKontrol(secililer, { gece:null, tip:null, yolcu:null });
  g.push(...mk.gerekceler); kunyeli.push(...mk.kunyeli);

  // ── FCL.060(a)(3) — SEYİR YEDEK İKİNCİ PİLOT (6 Eyl 2026) ────────
  // 🔑 Serkan: *"CRZ CPT uçuş görevindedir ama PF veya PM değildir."*
  //    Bu yüzden o pilot (a)(1) yakınlığına girmez; kendi bendi vardır.
  //    Kural ANCAK biri CRZ CPT olarak seçildiğinde bağlar — sürekli bir
  //    durum değil, o atamanın şartıdır.
  // 🔑 29 Eyl 2026: roller artık BACAK başına — HERHANGİ bir bacakta CRZ
  //    olan her pilot bu bende tabidir (yalnız tablodaki CRZ değil).
  crzPilotlar.forEach(pid => {
    const p = pilotlar.find(x => x.id === pid);
    if (!p) return;
    const mine = duties.filter(d => d.pilot_id === pid);
    const pf = pfRecency(mine, pid, simdi, { baselineDates: [] }).state;
    const r = crzRecency(mine, pid, simdi, { tzMap, pfDurumu: pf });
    if (r.state !== 'red') return;
    engel(`FCL.060(a)(3) (${p.code}) — CRUISE RELIEF NOT CURRENT: `
      + `${r.sectors}/${r.required} long-range cruise-relief sector(s) in 90 days, `
      + 'no FFS refresher, and not current as PF'
      + (r.unmeasured ? ` · ${r.unmeasured} sector(s) could not be measured (aerodrome timezone missing)` : ''),
      'SHT-FCL FCL.060');
  });
  // FCL.065 — kişi başına olgu, ama sonucu EKİBE bağlı: 60-64 yalnız çok
  // pilotlu ekipte uçabilir, dolayısıyla ekip büyüklüğü bilinmeden karar
  // verilemez. O yüzden burada, satırda değil.
  // 🔴 29 Eyl 2026: burada `plmFcl065(p.age)` yazıyordu — fonksiyon DOĞUM
  //    TARİHİ bekler (AtplMedPanel.fcl065), yaş verilince `new Date(68)` = 1970
  //    olur, pilot ~56 yaşında sayılır ve kapı 5 Eyl'den beri HİÇ tetiklenmedi
  //    (65+ ticari uçuşa, 60-64 tek pilotlu uçuşa atanabiliyordu). Künye testi
  //    kapıyı ilk kez gerçekten çalıştırınca yakalandı (GerekceKunye.test.js).
  secililer.forEach(p => {
    const k = plmFcl065(p.dob, simdi);
    if (!k) return;
    if (k.state === 'red') engel(`FCL.065 (${p.code}) — 65 OR OVER: NOT PERMITTED IN COMMERCIAL AIR TRANSPORT`, 'SHT-FCL FCL.065');
    else if (secililer.length < 2) engel(`FCL.065 (${p.code}) — 60-64: MULTI-PILOT CREW REQUIRED`, 'SHT-FCL FCL.065');
  });
  return { gerekceler:g, uyarilar:mk.uyarilar, kunyeli };
}

// ── TANIMSIZ MEYDAN REMARKI (21 Eyl 2026) ────────────────────────────
//
// 🔑 Serkan: *"Planlama cikar (NOT IN AD DATABASE remarki ile beraber), ucus
//    yapilir."*  Remark bes yerde gorunur: roster satiri · atama ekrani · gorev
//    detayi · rapor PDF'i · arsiv kaydi. Birinde eksik kalirsa oraya bakan
//    DOGRULANMIS SANIR — o yuzden tek bilesen, bes cagri.
//
// ⚠️ TURETILIR, SAKLANMAZ: `ad_hoc_airports` doluysa remark vardir. Ikinci bir
//    bayrak tutsaydik, meydan duzeltilince bayrak bayatlar ve kayit kendi
//    kendisiyle celisirdi (27 Agu'daki "takili kalan dinlenme" dersi).
function AdHocRemark({ duty, style }) {
  const b = duty?.ad_hoc_airports;
  const kodlar = b ? Object.keys(b) : [];
  if (!kodlar.length) return null;
  const ozet = kodlar.map(k => {
    const a = b[k];
    const saat = a?.sunrise_utc && a?.sunset_utc
      ? `sunrise ${a.sunrise_utc}Z · sunset ${a.sunset_utc}Z`
      : 'polar day/night — day/night NOT MEASURED';
    return `${k} — ${a?.name || '?'} · UTC${dakikaFark(a?.utc_offset_min)} · ${saat}`;
  }).join('\n');
  return (
    <span data-testid="ad-hoc-remark" title={`Declared for this duty only, not added to the aerodrome database:\n${ozet}`}
          style={{ ...badge('orange'), marginLeft:6, ...style }}>
      NOT IN AD DATABASE{kodlar.length > 1 ? ` ×${kodlar.length}` : ''}
    </span>
  );
}

// VARSAYILAN ARALIK — BUGÜNÜ ORTALAR, −15 / +15 GÜN, UTC (30 Eyl 2026).
// 🔑 Serkan (30 Eyl): *"duty history'de -15/+15 günlük periyodu default görmek
//    istiyorum"* · *"aynı şekilde assign duty sayfasında da"* · *"ilerisini ve
//    gerisini görmek her iki pencere için önemli."* Duty History ve ASSIGN
//    sayfasındaki roster TEK fonksiyondan açılır (roster'ın "1 MONTH" düğmesiyle
//    aynı pencere). Önceki: Duty History ay başı → bugün, roster −7 / +7 (4 Eyl).
// 🔴 25 Eyl dersi korunur: gün UTC'den türetilir. Eskiden Duty History başlangıcı
//    YEREL ay başıydı; her ayın 1'inde TR gecesi (UTC hâlâ önceki ay) aralık ters
//    dönüyor, ekran "0 valid / 0 recorded" gösteriyordu. Serkan: *"lokal saat
//    çalışmıyoruz biz, UTC çalışıyoruz."*
export function varsayilanAralik(simdi = new Date()) {
  const gun = (n) => {
    const d = new Date(simdi.getTime());
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  };
  return { from: gun(-15), to: gun(15) };
}

// ── GÖREV DURUMU KARTI + ROZETİ — tek kaynak (3 Eki 2026, FTL adım 4c) ─────────────────────────────────────────────
// Kural ihlali kartının aynısı: her sebep ayrı satır, ⓘ madde metni + ne yapmalı (`durumNeYapmali`). DUTY HISTORY
// çizelgesindeki not ve ASSIGN DUTY roster'ındaki rozet (Serkan 3 Eki: *"olsun"*) aynı kartı açar.
function durumKartiGoster(d, { toast, kod = '' }) {
  const e = ekranDurumu(d);
  if (!e) return;
  const rota = d.duty_type === 'flight'
    ? (d.sectors || []).map(x => `${x.dep}-${x.actual_dest || x.dest}`).join(' ')
    : String(d.ground_kind || d.duty_type).replace(/_/g, ' ').toUpperCase();
  const kimlik = `${utcGunAy(`${d.duty_date}T00:00:00Z`)} ${rota} · ${kod || ''}`;
  if (e.durum === 'LEGAL') { toast(`${kimlik}: LEGAL — every FTL limit of this duty was measured and is met.`, 'success'); return; }
  if (e.durum == null) {
    toast('The server has not computed this duty\'s FTL status yet. Refresh in a few seconds; if it stays, tell GO2.',
          'error', { baslik: `NOT COMPUTED — ${kimlik}` });
    return;
  }
  const ad = e.durum === 'NOT_LEGAL' ? 'NOT LEGAL' : 'CANNOT VERIFY';
  toast(`${e.gerekce.length} reason${e.gerekce.length > 1 ? 's' : ''} — ⓘ next to each line gives the rule and what to do.`,
        'error', ihlalDetayi(e.gerekce.map(x => ({ metin: x.metin, ref: x.ref, neYapmali: durumNeYapmali(x, d),
                                                   neYapmaliKayit: durumNeYapmali(x, d) })), { baslik: `${ad} — ${kimlik}` }));
}
// Renkler çizelgedeki notlarla aynı anlam: yeşil LEGAL · kırmızı NOT LEGAL · amber CANNOT VERIFY · gri NOT COMPUTED.
// ── OFF + GÖREV AYNI GÜN — DUTY HISTORY rozeti, tek kaynak (4 Eki 2026) ─────────────────────────────────────────────────
// 🔑 Serkan (4 Eki 2026) A — *"mevzuata uygun olacak"*: Md.4(ü) boş gün "tüm görevlerden muaf"; gün içinde görev olan
//    OFF boş gün DEĞİLDİR. Eskiden (8 Ağu / 4 Eyl) gecelere değmeyen gündüz görevi "OFF TO DUTY — day off stands" idi ve
//    düşen OFF'un rozeti hiç yoktu (satırda yalnız görev kalıyordu, sayım sessizce azalıyordu). Artık düşen OFF söylenir.
// bilgi: `offToDuty` sonucu — standing true (gününe ve gecelerine değmiyor) · false (boş gün değil) · null (ölçülemedi).
// Geç tebliğ edilen OFF (Md.7(1)(c), 4 Eki 2026 — Serkan A): satır durur, boş gün sayılmaz; cümle motordan (tek kaynak).
function GecTebligRozeti({ t }) {
  if (!t?.gec) return null;
  return (
    <span data-testid="off-gec-teblig" style={{ ...badge('red'), marginLeft:6 }} title={gecTebligMetni(t)}>
      LATE NOTICE — NOT A DAY OFF
    </span>
  );
}

function OffGorevRozeti({ bilgi }) {
  if (!bilgi || bilgi.standing == null) return null;
  // GÖRÜNÜM (13 Eki 2026, Serkan): 24 saatten geç girilen OFF zaten REST'tir — üstündeki görev NOT ALMAZ (remarksız).
  if (bilgi.gec) return null;
  if (bilgi.standing) {
    return (
      <span data-testid="off-to-duty" style={{ ...badge('amber'), marginLeft:6 }}
            title={'This day is recorded as OFF. The duty touches neither its local day nor its nights, so the day off '
                   + 'stands (Md.4/ü).'}>
        OFF TO DUTY
      </span>
    );
  }
  // 13 Eki 2026 (Serkan): görev alan OFF bir plan değişikliğidir, ihlal değil → SARI "OFF → DUTY" (eskiden kırmızı
  // "OFF — NOT A DAY OFF … correct the OFF or the duty"). Ölçü aynı: bu gün boş gün SAYILMAZ (Md.4/ü, Md.5 sayımı).
  return (
    <span data-testid="off-gun-dusuyor" style={{ ...badge('amber'), marginLeft:6 }}
          title={'This day was planned as OFF and a duty was given on it, so it became a duty day (OFF → DUTY). '
                 + 'It does not count as a day off (Md.4/ü) — the days-off totals already leave it out.'}>
      OFF → DUTY
    </span>
  );
}

const DURUM_ROZETI = { LEGAL: ['green', 'LEGAL'], NOT_LEGAL: ['red', 'NOT LEGAL'], CANNOT_VERIFY: ['amber', 'CANNOT VERIFY'] };
function DurumRozeti({ d, toast, kod }) {
  const e = ekranDurumu(d);
  if (!e) return null;
  const [renk, ad] = e.durum ? DURUM_ROZETI[e.durum] : ['dim', 'NOT COMPUTED'];
  return (
    <span data-testid={`durum-rozeti-${d.id}`} title="FTL status — click for the reasons"
          style={{ ...badge(renk), marginLeft:4, cursor:'pointer' }}
          onClick={() => durumKartiGoster(d, { toast, kod })}>{ad}</span>
  );
}

// Satır grubu (EDIT / CANCEL / roster ay kâğıdı) — tek kaynak `rosterGrup.js` (21 Eki 2026 taşındı; dışarıya aynı adlarla).
export { satirGrubuAnahtari, satirGrubu, rosterGruplari };

// AY GEZGİNİ — DUTY HISTORY ve ROSTER ay kâğıdı ORTAK (21 Eki 2026, Serkan: *"ortak bir tasarım dili"*): ◀ ay ▶ ve
// başka bir aydayken THIS MONTH. Test kimlikleri ekranın önekiyle (`dh-ay`, `roster-ay` …).
function AyGezgini({ ay, setAy, etiket, onek }) {
  const bu = buAy();
  return (
    <div style={{ display:'flex', alignItems:'flex-end', gap:6 }}>
      <button style={S.btnS} data-testid={`${onek}-ay-geri`} title="Previous month"
              onClick={() => setAy(a => ayKaydir(a, -1))}>◀</button>
      <div style={{ width:130 }}>
        <span style={S.label}>Month</span>
        <div style={{ ...S.input, textAlign:'center', fontWeight:700 }} data-testid={`${onek}-ay`}>{etiket || '—'}</div>
      </div>
      <button style={S.btnS} data-testid={`${onek}-ay-ileri`} title="Next month"
              onClick={() => setAy(a => ayKaydir(a, 1))}>▶</button>
      {(ay.yil !== bu.yil || ay.ay !== bu.ay) && (
        <button style={S.btnS} data-testid={`${onek}-ay-bu`} onClick={() => setAy(buAy())}>THIS MONTH</button>
      )}
    </div>
  );
}

// ── GÖREVİN SONUCU — PLN ? · OPEN ? · RECORD AS FLOWN · MATCH REVIEW (21 Eki 2026, tek kaynak) ──────────────────────
// DUTY HISTORY'nin rozetleri / kutusu ve ROSTER'ın görev kartı AYNI pencereleri açar (Serkan: *"ortak bir tasarım dili"*;
// ilke: tek ekran tek kural). Durum ve pencereler burada; ekran yalnız `plnSor` / `acikKapat` / `incele` çağırır ve
// `pencereler`i çizer. Eskiden yalnız DUTY HISTORY'nin içindeydi.
function useGorevSonucu({ duties, pilots, ucuslar, myProfile, toast, homeBases, pilotDilim, ruleset, baselines, offTypes,
                          lisansMed, aircraft, tipVasiflari, reload }) {
  // PLN rozetine tiklanan gorev — "gerceklesti mi?" penceresi.
  const [resolving, setResolving] = useState(null);
  // ── GERÇEKLEŞTİ → EDIT (29 Eyl 2026) ─────────────────────────────────
  // Uçuş görevi gerçekleşmiş yapılırken EDIT penceresi açılır ("gerçekleşti"
  // modu): tek pencere, tek kayıt yolu. Grup = atamanın iptal edilmemiş bütün
  // satırları, tıklanan görev başta (roster'ın gruplamasıyla aynı anahtar).
  const [gercekGrup, setGercekGrup] = useState(null);
  const gercekAc = (d) => {
    const rows = (duties || []).filter(x => x.status !== 'cancelled'
      && (d.assignment_id ? x.assignment_id === d.assignment_id : x.id === d.id));
    setResolving(null);
    setGercekGrup({ key: d.assignment_id || `solo-${d.id}`, head: d,
                    rows: [d, ...rows.filter(x => x.id !== d.id)] });
  };
  // ── MATCH REVIEW KAPATILABILIR OLDU (22 Agu 2026) ──────────────────
  // 🔴 `archive-flight`'ta `match_review`'i TRUE yapan bes yer vardi, FALSE
  //    yapan TEK SATIR YOKTU. Bir kez kalkan bayrak sonsuza kadar kirmizi
  //    kaliyordu: insan bakip karar verse bile satir kirmizi duruyordu.
  //    Sahada 7 Agu'dan kalma iki gorev 15 gundur kirmiziydi.
  // 🔑 KAPATILAMAYAN UYARI, BAKILMAYAN UYARIYA DONUSUR — bugun `safe_bottom`
  //    ve `layout_stale` ile tam bunu yasadik. Bayrak artik gerekceyle
  //    kapatilir ve kapatma denetim izine gecer (silinmez, KAPANIR).
  const [reviewing, setReviewing] = useState(null);
  // 🔴 30 Eyl 2026 (FTL nöbetçisi A2): yazma yalnız `error`e bakıyordu — RLS reddi
  //    0 satır döner (İlke 2): bayrak AÇIK kalıyor, iz "false" diyor, ekran
  //    "resolved". Artık ortak `izliYaz`: dönen satırla doğrulanır, reddedilirse
  //    iz yanına düzeltme satırı düşer, kart NOT SAVED + ⓘ, pencere AÇIK kalır.
  const resolveReview = async (duty, reason) => {
    const h = await izliYaz({
      izTablosu: 'ftl_duty_edits', tablo: 'crew_duties', id: duty.id,
      // Not da temizlenir: bayrak kalkinca aciklama YALAN bir cumle olarak kalirdi.
      patch: { match_review: false, match_review_note: null },
      izler: [{ duty_id: duty.id, customer_id: duty.customer_id, pilot_id: duty.pilot_id,
                assignment_id: duty.assignment_id || null, edit_type: 'EDIT',
                field_name: 'match_review', old_value: 'true', new_value: 'false',
                reason: `Match review resolved: ${reason}`, edited_by: myProfile?.id ?? null }],
      duzeltme: { old_value: '(resolution logged)', new_value: '(NOT WRITTEN — review still open)' },
      logAdi: 'The edit log' });
    if (h) { toast(h.metin, 'error', h.detay); return; }
    toast('Match review resolved (logged).', 'success');
    setReviewing(null); reload();
  };
  // OPEN ? — açık uçuş görevi gerçek saatleriyle (RECORD AS FLOWN), yer görevi "gerçekleşti mi?" penceresiyle kapanır.
  const acikKapat = (d) => (d.duty_type === 'flight' && (d.sectors || []).length ? gercekAc(d) : setResolving(d));
  const pencereler = (
    <>
      {reviewing && (
        <ReasonModal aciklamaTur="degisiklik"
          title="RESOLVE MATCH REVIEW"
          warn={
            // Serkan (3 Eyl 2026): *"Tamam sorsun ama text yazsin… anlasin neyin
            // match etmedigini. Her uyarida aciklama olsun demistik, burda da olsun."*
            // ASIL SEBEP once yazilir; arsiv onu alan alan uretiyor
            // (`match_review_note`). Yoksa eski genel cumleye dusulur.
            `${fmtD(reviewing.duty_date)} — `
              + (reviewing.match_review_note
                  || 'the archive could not match this duty unambiguously.')
              + (reviewing.operation_type_source
                  ? ` Recorded source: ${reviewing.operation_type_source}.` : '')
              + ' Write what you checked and what is correct. The flag closes; the record and the'
              + ' audit trail keep it.'}
          confirmLabel="RESOLVE"
          onCancel={() => setReviewing(null)}
          onConfirm={(reason) => resolveReview(reviewing, reason)}
        />
      )}

      {resolving && (
        <PlannedOutcomeModal
          duty={resolving}
          // 🔑 5 Eki 2026 (Serkan): *"her iki durumda da tek tıkla bütün ekipten düşmeli, tek kaynak prensibi zaten
          //    politikamız"* — atamanın BÜTÜN EKİBİNİN planlı günleri birlikte iptal edilir. 🔴 Önce yalnız tıklanan pilot
          //    düşüyordu; aynı uçuş öteki pilotta PLN ? kalıyor, ayrıca cevaplanıyordu.
          rows={duties.filter(x => x.status === 'planned'
            && (resolving.assignment_id
                ? x.assignment_id === resolving.assignment_id
                : x.id === resolving.id))}
          myProfile={myProfile} offTypes={offTypes} toast={toast}
          onGerceklesti={gercekAc} pilots={pilots} pilotDilim={pilotDilim} duties={duties} ruleset={ruleset}
          onClose={() => setResolving(null)}
          onSaved={() => { setResolving(null); reload && reload(); }}
        />
      )}
      {gercekGrup && (
        <EditDutyModal
          group={gercekGrup} gercekGiris pilots={pilots} duties={duties} ucuslar={ucuslar}
          myProfile={myProfile} toast={toast} homeBases={homeBases} pilotDilim={pilotDilim}
          ruleset={ruleset} baselines={baselines} offTypes={offTypes} lisansMed={lisansMed} aircraft={aircraft} tipVasiflari={tipVasiflari}
          onClose={() => setGercekGrup(null)}
          onSaved={() => { setGercekGrup(null); reload && reload(); }}
        />
      )}
    </>
  );
  return { plnSor: setResolving, acikKapat, incele: setReviewing, pencereler };
}

// ── RAAQ ERKEN UYARISI (21 Eki 2026, Serkan: *"olsa bence güzel olur"*) ──────────────────────────────────────────────
// Uçuş sektörü satırının altında (ASSIGN · WHAT IF · planlı EDIT): DEP / DEST şirketin RAAQ kaydında yoksa ya da kategorisi
// yoksa amber not — iPad'de o meydanın RAAQ kartı kapanır. YALNIZ UYARI, kayıt engellenmez. Okunamazsa "could not be
// checked" + RETRY (okunamadı ≠ yok). Kural `raaqKaydi.js`'te (iPad'in `RaaqRules.normalize`ı ile aynı).
function RaaqUyarisi({ icaolar, raaq, testid }) {
  const kodlar = raaqKodlari(icaolar);
  if (!kodlar.length) return null;
  const not = { ...S.note, borderLeftColor:C.amber, color:C.amber, margin:'-2px 0 8px' };
  if (raaq.hata) {
    return (
      <div data-testid={testid} style={not}>
        RAAQ CHECK FAILED — {kodlar.join(', ')} could not be checked: {raaq.hata}. This does not mean a record is missing.{' '}
        <button type="button" style={S.btnS} onClick={raaq.yenile}>RETRY</button>
      </div>
    );
  }
  if (!raaq.kayitlar) return null;
  const eksik = kodlar.map(k => [k, raaqEksigi(k, raaq.kayitlar)]).filter(([, e]) => e);
  if (!eksik.length) return null;
  return (
    <div data-testid={testid} style={not}>
      {eksik.map(([k, e]) => <div key={k}>{k} — {e} — RAAQ will be blocked on the iPad</div>)}
    </div>
  );
}

// ── ASSIGN PENCERESİ (21 Eki 2026, 4. adım — Serkan B) ──────────────────────────────────────────────────────────────
// ROSTER kâğıdında günün boş yerine tıklayınca (ya da üstteki ASSIGN) aynı `AssignDuty` formu WHAT IF gibi gölgeli bir
// pencerede, o tarih hazır açılır (tarih değiştirilebilir). Yeni form YOK — WHAT IF ile aynı form, aynı kapılar, aynı
// CHECK AND CONFIRM. Katman 55: formun açtığı her pencerenin (gerekçe 60, RECORD AS FLOWN 200, CHECK AND CONFIRM 210,
// bildirimler 400) ALTINDA. Kayıt bitince `onAtandi` kapatır; ESC / ✕ sormadan kapatır (12 Eki 2026, A).
function AssignPenceresi({ tarih, onClose, onAtandi, ...formProps }) {
  usePencereKapat(onClose);
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', zIndex:55, overflowY:'auto',
                  display:'flex', justifyContent:'center', alignItems:'flex-start', padding:'24px 16px' }}
         data-testid="assign-pencere">
      <div style={{ background:'var(--bg2)', border:`1px solid ${C.border}`, borderRadius:10, width:'100%', maxWidth:1280 }}>
        <div style={{ ...S.panelH, position:'sticky', top:0, zIndex:2 }}>
          <span style={S.panelT}>ASSIGN DUTY — NEW</span>
          <KapatX onClose={onClose} testid="assign-x" />
        </div>
        <div style={{ padding:16 }}>
          <AssignDuty {...formProps} ilkTarih={tarih} onAtandi={onAtandi} />
        </div>
      </div>
    </div>
  );
}

// ── GÖREV KARTI — ROSTER ay kâğıdında bloğa tıklayınca (21 Eki 2026, 3. adım; Serkan tasarım A) ─────────────────────
// Tablodaki satırın bilgisi ve DÜĞMELERİ — aynı koşullar, aynı pencereler: EDIT / CANCEL (iptal edilmemiş grup), DELETE
// (`canHardDelete`), ayrıca DUTY HISTORY'nin akışları: planlı → PLN ?, açık → OPEN ?, eşleşme incelemesi → MATCH REVIEW
// (`useGorevSonucu`). Yeni pencere YOK: kart yalnız hangisinin açılacağını seçer, sonra kapanır.
function GorevKarti({ d, rows, nameOf, toast, statusBadge, onClose, onEylem }) {
  usePencereKapat(onClose);
  const iptal = rows.every(r => r.status === 'cancelled');
  const silinir = rows.every(canHardDelete);
  const review = rows.find(r => r.match_review);
  const tarihler = rows.flatMap(r => [r.duty_date, gorevSonGunu(r)]).filter(Boolean).sort();
  const t0 = tarihler[0], t1 = tarihler[tarihler.length - 1];
  const ekip = []; const gorulen = new Set();
  rows.forEach(r => { if (!gorulen.has(r.pilot_id)) { gorulen.add(r.pilot_id); ekip.push(r); } });
  const ucus = d.duty_type === 'flight';
  const satir = (ad, deger) => (
    <tr><td style={{ ...S.td, color:C.t3, width:120 }}>{ad}</td><td style={{ ...S.td, whiteSpace:'normal' }}>{deger}</td></tr>
  );
  const dugme = (tur, metin, stil = S.btnS) => (
    <button key={tur} type="button" style={stil} data-testid={`kart-${tur}`} onClick={() => onEylem(tur)}>{metin}</button>
  );
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.55)', display:'flex',
                  alignItems:'center', justifyContent:'center', zIndex:60 }}>
      <div data-testid="gorev-karti" style={{ background:C.bg2, border:`1px solid ${C.border}`, borderRadius:10,
                                              width:640, maxWidth:vw(94), maxHeight:vh(90), overflowY:'auto' }}>
        <div style={S.panelH}>
          <span style={S.panelT}>
            {(d.duty_type || '').toUpperCase()} · {t0 === t1 ? fmtD(t0) : `${fmtD(t0)} — ${fmtD(t1)}`} · {routeOf(d)}
          </span>
          <KapatX onClose={onClose} />
        </div>
        <div style={{ padding:16 }}>
          <table style={S.table}><tbody>
            {satir('Status', <>{statusBadge(d.status)}{review && <span style={{ ...badge('amber'), marginLeft:6 }}>REVIEW</span>}</>)}
            {d.duty_type !== 'off' && satir('Report', fmtDT(d.report_time))}
            {d.duty_type !== 'off' && satir('Duty end', fmtDT(d.duty_end))}
            {ucus && satir('FDP / MAX', <FdpMaxCell d={d} />)}
            {/* Tablonun kuralı: işletme türü yoksa sessiz geçilmez — NOT SET (azami UGS tablosunu o seçer). */}
            {ucus && satir('Operation', d.operation_type ? opLabel(d.operation_type)
              : <span style={badge('amber')}>NOT SET</span>)}
            {satir('Crew', ekip.map(r => {
              const rol = [...new Set((r.sectors || []).filter(x => !x.deadhead).map(x => x.role).filter(Boolean))].join('/');
              return (
                <span key={r.id} style={{ marginRight:10, whiteSpace:'nowrap' }}>
                  {nameOf(r.pilot_id)}{rol ? <span style={{ color:C.t3 }}> ({rol})</span> : null}
                  <DurumRozeti d={r} toast={toast} kod={nameOf(r.pilot_id)} />
                </span>
              );
            }))}
          </tbody></table>
          {(d.sectors || []).length > 0 && (
            <table style={{ ...S.table, marginTop:12 }} data-testid="kart-sektorler">
              <thead><tr><th style={S.th}>Sector</th><th style={S.th}>Off / ETD</th><th style={S.th}>On / ETA</th>
                <th style={S.th}>Aircraft</th></tr></thead>
              <tbody>{d.sectors.map((x, i) => (
                <tr key={i}>
                  <td style={S.td}>{x.dep}–{x.actual_dest || x.dest}{x.deadhead ? ' DH' : ''}</td>
                  <td style={S.td}>{x.off_block || x.etd || '—'}</td>
                  <td style={S.td}>{x.on_block || x.eta || '—'}</td>
                  <td style={S.td}>{x.reg ? String(x.reg).toUpperCase() : '—'}</td>
                </tr>
              ))}</tbody>
            </table>
          )}
          <div style={{ display:'flex', gap:8, justifyContent:'flex-end', flexWrap:'wrap', marginTop:16 }}>
            {d.status === 'planned' && d.duty_type !== 'off' && dugme('pln', 'PLN ?')}
            {d.status === 'open' && dugme('open', 'OPEN ?')}
            {review && dugme('review', 'MATCH REVIEW')}
            {!iptal && dugme('edit', 'EDIT')}
            {!iptal && dugme('cancel', 'CANCEL')}
            {silinir && dugme('delete', 'DELETE', S.btnSil)}
            <button type="button" style={S.btnS} onClick={onClose}>CLOSE</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function DutyRoster({ toast, myProfile, pilots, duties, ucuslar = {}, baselines, ruleset, homeBases, pilotDilim, offTypes, reload,
                     dutyLocations, addLocation, lisansMed = {}, aircraft = [], tipVasiflari = {},
                     focusDutyId = null, onFocusHandled = null, gosterilenAy, setGosterilenAy, gorunum, setGorunum,
                     onWhatIf = null }) {
  const today = new Date().toISOString().slice(0, 10);
  const plus = shiftDate;   // UTC gün ekleme (3 Eki 2026 — eskiden yerel saatle)
  // 🔑 Serkan (4 Eyl 2026): *"Geriye doğru 7 gün ve ileri 7 gün açılsın
  //    default'ta — 14 gün. Bu çok küçük, bakınca 2 haftalık görünsün, ne
  //    değişiklikler yapılmış vs."*
  // ⚠️ Eskiden BUGUNDEN ileri 14 gundu: gecmis hic gorunmuyordu, oysa roster'a
  //    bakmanin yarisi "ne degismis" sorusudur. Pencere artik BUGUNU ORTALAR.
  // 🔑 30 Eyl 2026 (Serkan): varsayılan −15 / +15 — Duty History ile aynı fonksiyon.
  const [from, setFrom] = useState(() => varsayilanAralik().from);
  const [to, setTo] = useState(() => varsayilanAralik().to);
  const [pending, setPending] = useState(null);   // {mode:'cancel'|'delete', rows:[...]}
  // CANCEL penceresi kâğıt kayda etkisini ÖNCEDEN söyler (5 Eki 2026, A); kaydet anında taze okunur (`apply`).
  const [iptalKagit, setIptalKagit] = useState(null);   // { etki, hata } · null = okunuyor / yok
  useEffect(() => {
    setIptalKagit(null);
    if (pending?.mode !== 'cancel') return undefined;
    let dead = false;
    kagitIptalEtkisi(pending.rows).then(r => { if (!dead) setIptalKagit(r); });
    return () => { dead = true; };
  }, [pending]);
  const [editing, setEditing] = useState(null);   // roster grubu — EditDutyModal

  const nameOf = (pid) => {
    const p = pilots.find(x => x.id === pid);
    return p ? (p.code || p.full_name || '—') : '—';
  };

  // Aralik + assignment_id'ye gore gruplama. assignment_id yoksa (eski satir)
  // satirin kendi id'si grup sayilir — gruplamasiz da calisir.
  // 4 Eki 2026: atamanın iptal edilmiş kayıtları ayrı satır (`rosterGruplari` → `satirGrubuAnahtari`).
  const groups = useMemo(() => rosterGruplari(duties, from, to), [duties, from, to]);
  // EKİP — motorun ölçüsü (K6, 21 Eki 2026): artırılmış ekip (bir bacakta CRZ CPT) ve dört pilot atamanın BÜTÜN
  // satırlarından okunur (`ekipBilgisi` — sunucu, görev durumu ve EDIT de bütün ekibe bakar).
  const ekipOf = useMemo(() => ekipBilgisi(duties), [duties]);
  // İPTALLER VARSAYILAN GİZLİ (4 Eki 2026, Serkan: *"canceled satırlarını gizle … check box … göster olsun, default kapalı
  //    gelsin"* · *"aksi halde çorba oluyor"*). İptal edilmiş kayıtlar artık her zaman kendi satırında (`rosterGruplari`),
  //    o yüzden süzgeç satır bazında. DELETE edilen görev kayıtta yoktur, zaten görünmez. Kayıt silinmez, yalnız gizlenir.
  const [iptalGoster, setIptalGoster] = useState(false);
  const iptalSayisi = groups.filter(g => g.rows.every(r => r.status === 'cancelled')).length;
  const gorunenGruplar = iptalGoster ? groups : groups.filter(g => !g.rows.every(r => r.status === 'cancelled'));
  // AY KÂĞIDI (21 Eki 2026, Serkan: DUTY HISTORY gibi tile tile, *"default ayla açılsın"*): roster içinde bulunulan ayın
  //    kâğıdıyla açılır; TABLE bugünkü tablo (kendi From / To aralığıyla). SHOW CANCELLED iki görünümde aynı süzgeç.
  // OFF → DUTY (27 Eki 2026): kâğıt OFF gününü DUTY SHEET'in ölçüsüyle okur — kural seti + pilotun ana üs dilimi + OFF türleri.
  const rosterKurali = useMemo(() => (ruleset ? effectiveRules(ruleset).rules : null), [ruleset]);
  const ayVeri = useMemo(() => (gorunum === 'sheet'
    ? rosterCizelgesi({ duties, pilots, yil: gosterilenAy.yil, ay: gosterilenAy.ay, iptalGoster,
                        rules: rosterKurali, pilotDilim, offTypes }) : null),
  [gorunum, duties, pilots, gosterilenAy, iptalGoster, rosterKurali, pilotDilim, offTypes]);
  const ayHtml = useMemo(() => (ayVeri ? rosterHtml(ayVeri) : null), [ayVeri]);
  // KÂĞITTA TIKLAMA (21 Eki 2026, 3. adım) — DUTY HISTORY kâğıdının işaretleri: blok → görev kartı, pilot kodu → durum
  // kartı, REVIEW → MATCH REVIEW. PLN ? / OPEN ? / MATCH REVIEW pencereleri DUTY HISTORY ile ortak (`useGorevSonucu`).
  const sonuc = useGorevSonucu({ duties, pilots, ucuslar, myProfile, toast, homeBases, pilotDilim, ruleset, baselines,
                                 offTypes, lisansMed, aircraft, tipVasiflari, reload });
  const [kart, setKart] = useState(null);
  // ASSIGN PENCERESİ (4. adım): `assignTarihi` doluyken açık; kutunun boş yeri o günü, üstteki ASSIGN bugünü verir.
  const [assignTarihi, setAssignTarihi] = useState(null);
  const atandi = (rows) => {
    setAssignTarihi(null);
    const t = (rows || [])[0]?.duty_date;
    if (t) setGosterilenAy({ yil: Number(t.slice(0, 4)), ay: Number(t.slice(5, 7)) });   // görev kendi ayında görünür
  };
  const kagitTikla = ({ durum, review, gorev, gun }) => {
    // Görev dışında kalan yer (`data-gun`): o günün ASSIGN'ı. Görev alanı boşsa (OFF satırı, `data-gorev=""`) hiçbir şey.
    if (gun && !durum && !review && gorev == null) { setAssignTarihi(gun); return; }
    const d = (duties || []).find(x => x.id === (durum || review || gorev));
    if (!d) return;
    if (durum) { durumKartiGoster(d, { toast, kod: nameOf(d.pilot_id) }); return; }
    if (review) { sonuc.incele(d); return; }
    setKart(d);
  };
  const kartEylemi = (tur) => {
    const rows = satirGrubu(duties, kart);
    const d = kart;
    setKart(null);
    if (tur === 'edit') setEditing({ key: satirGrubuAnahtari(d), rows, head: rows[0] || d });
    else if (tur === 'cancel' || tur === 'delete') setPending({ mode: tur, rows });
    else if (tur === 'pln') sonuc.plnSor(d);
    else if (tur === 'open') sonuc.acikKapat(d);
    else if (tur === 'review') sonuc.incele(rows.find(r => r.match_review) || d);
  };
  // Seçim kutusu tasarım S1 (5 Eki 2026) — tek bileşen `SecimKutusu`; iki görünümde aynı kutu, sayısı görünenin.
  const gorunenIptal = gorunum === 'sheet' ? ayVeri.iptalSayisi : iptalSayisi;
  // ASSIGN (bugünün tarihiyle) ve WHAT IF ? — iki görünümde aynı yer. WHAT IF ? 12 Eki'den beri sekme kutusunda, kesik
  // çerçeveli (*"TRY A PLAN FIRST — NOTHING IS SAVED"*); pencere açıkken arka sayfa gölgede.
  const atamaDugmeleri = (<>
    <button type="button" className={KUTU_SINIFI} style={sekmeStili(true)} data-testid="roster-assign-ac"
            title="Assign a new duty — today is filled in; click an empty part of a day box to start on that day"
            onClick={() => setAssignTarihi(new Date().toISOString().slice(0, 10))}>ASSIGN</button>
    {onWhatIf && (
      <button type="button" className={KUTU_SINIFI} style={{ ...sekmeStili(false), borderStyle:'dashed' }}
              data-testid="whatif-ac" title="TRY A PLAN FIRST — NOTHING IS SAVED" onClick={onWhatIf}>WHAT IF ?</button>
    )}
  </>);
  const iptalKutusu = (
    <SecimKutusu isaretli={iptalGoster} onClick={() => setIptalGoster(v => !v)} testid="roster-iptal-goster">
      SHOW CANCELLED{gorunenIptal ? ` (${gorunenIptal})` : ''}
    </SecimKutusu>
  );

  // ── CANDAN GELEN GOREVI AC (26 Agu 2026) ────────────────────────────────
  //
  // 🔴 TUZAK: roster varsayilan olarak BUGUNDEN itibaren gosterir. FDP asimi
  // ise gecmis bir ucusta olur — yani gorev varsayilan aralikta OLMAZ ve
  // "tikladim, hicbir sey acilmadi" olurdu. O yuzden once ARALIK genisletilir,
  // gorev listeye girdikten sonraki turda EDIT acilir.
  useEffect(() => {
    if (!focusDutyId) return;
    const d = (duties || []).find(x => x.id === focusDutyId);
    if (!d || !d.duty_date) return;                 // veri henuz gelmedi
    if (d.duty_date < from) { setFrom(d.duty_date); return; }
    if (d.duty_date > to)   { setTo(d.duty_date);   return; }
    const g = groups.find(x => x.rows.some(r => r.id === focusDutyId));
    if (!g) return;
    setGosterilenAy({ yil: Number(d.duty_date.slice(0, 4)), ay: Number(d.duty_date.slice(5, 7)) });
    setEditing(g);
    if (onFocusHandled) onFocusHandled();
  }, [focusDutyId, duties, groups, from, to, onFocusHandled, setGosterilenAy]);

  const statusBadge = (s) => {
    const kind = s === 'actual' ? 'green' : s === 'cancelled' ? 'dim' : s === 'open' ? 'amber' : 'blue';
    return <span style={badge(kind)}>{(s || '').toUpperCase()}</span>;
  };

  const apply = async (reason) => {
    const { mode, rows } = pending;
    try {
      // 0) KÂĞIT KAYIT (5 Eki 2026, Serkan A): ekibin TAMAMI iptal ediliyorsa uçuşun kâğıt kaydı geçersiz olur
      //    (silinmez — DELETED, gerekçeli; evrak kalır). 🔴 Önce: CANCEL kâğıt kayda dokunmuyordu, iptal edilen uçuş
      //    STATISTICS'te ve uçak/motor saatinde sayılmaya devam ediyordu. Etki TAZE okunur; okunamazsa iptal yapılmaz.
      let kagitEtki = [];
      if (mode !== 'delete') {
        const { etki, hata } = await kagitIptalEtkisi(rows);
        if (hata) { toast(`The paper OFP record of this flight could not be read — ${hata}. Nothing was cancelled.`, 'error'); return; }
        kagitEtki = etki;
      }
      const kagitIzi = (e, eski, yeni, neden = reason) => ({ duty_id: e.ilk.id, customer_id: e.ilk.customer_id,
        pilot_id: e.ilk.pilot_id, assignment_id: e.ilk.assignment_id || null, edit_type: 'EDIT', field_name: 'paper_ofp',
        old_value: eski, new_value: yeni, reason: neden, edited_by: myProfile?.id ?? null });
      // 1) DENETIM IZI ONCE yazilir — silme basarili olursa satir gider ama iz kalir.
      const edits = rows.map(d => ({
        duty_id: d.id, customer_id: d.customer_id, pilot_id: d.pilot_id,
        assignment_id: d.assignment_id || null,
        edit_type: mode === 'delete' ? 'DELETE' : 'CANCEL',
        field_name: 'status', old_value: d.status,
        new_value: mode === 'delete' ? '(deleted)' : 'cancelled',
        reason, edited_by: myProfile?.id ?? null,
      }));
      edits.push(...kagitEtki.map(e => kagitIzi(e, kagitOzeti(e.bacaklar), KAGIT_GECERSIZ_IZ)));
      const { error: eErr } = await supabase.from('ftl_duty_edits').insert(edits);
      if (eErr) { toast(`Audit write failed: ${eErr.message}`, 'error'); return; }

      const ids = rows.map(d => d.id);
      const sil = mode === 'delete';
      // 2) SİLME / İPTAL DÖNEN SATIRLARLA DOĞRULANIR (29 Eyl 2026 · FTL nöbetçisi A2).
      // 🔴 ÖNCESİ: yalnız `error`e bakılıyordu. RLS reddinde hata DÖNMEZ, 0 satır
      //    etkilenir (İlke 2): ekranda "N duty row(s) deleted", aşağıdaki DELETE
      //    REFUSED dalı hiç çalışmıyordu; iptalde de aynısı.
      const { data: donen, error } = sil
        ? await supabase.from('crew_duties').delete().in('id', ids).select('id')
        : await supabase.from('crew_duties').update({ status:'cancelled' }).in('id', ids).select('id');
      const olan = new Set((donen || []).map(r => r.id));
      const olmayan = error ? rows : rows.filter(d => !olan.has(d.id));
      if (olmayan.length) {
        const sebep = error?.message || 'no row returned (permission?)';
        // Iz ONCE yazildi (silinip iz kalmamasindansa iz kalip silinmemesi
        // yegdir). Silme/iptal reddedildiyse o iz artik YANLIS bir sey soyluyor;
        // ftl_duty_edits bilerek degistirilemez oldugu icin duzeltme satiri
        // yazilir — denetim izi kendini duzeltir, ustunu cizmez.
        // Ekipten biri iptal edilemediyse uçuşun canlı görevi var — kâğıt kayda DOKUNULMAZ, izi de düzeltilir.
        const { error: dErr } = await supabase.from('ftl_duty_edits').insert([...olmayan.map(d => ({
          duty_id: d.id, customer_id: d.customer_id, pilot_id: d.pilot_id,
          assignment_id: d.assignment_id || null, edit_type: 'EDIT',
          field_name: 'status', old_value: sil ? '(delete logged)' : '(cancel logged)',
          new_value: sil ? '(DELETE REFUSED — row still exists)' : '(CANCEL REFUSED — status unchanged)',
          reason: `${sil ? 'Delete' : 'Cancel'} refused by policy: ${sebep}`,
          edited_by: myProfile?.id ?? null,
        })), ...kagitEtki.map(e => kagitIzi(e, '(delete logged)', '(NOT DELETED — cancel refused)',
                                            `Cancel refused by policy: ${sebep}`))]);
        const yapilan = rows.filter(d => olan.has(d.id));
        toast(`${sil ? 'Delete' : 'Cancel'} refused for ${olmayan.map(d => nameOf(d.pilot_id)).join(', ')}.`
              + (yapilan.length ? ` ${sil ? 'Deleted' : 'Cancelled'} for ${yapilan.map(d => nameOf(d.pilot_id)).join(', ')}.` : '')
              + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
                      : ' The edit log records that it was refused.'),
              'error', yazmaDetayi({ kismen: yapilan.length > 0, hata: error }));
        // Bir kısmı olduysa ekran gerçeği göstersin; hiçbiri olmadıysa pencere açık kalır.
        if (yapilan.length) { setPending(null); reload(); }
        return;
      }
      // 3) KÂĞIT KAYIT GEÇERSİZ — iptal tamam (ekipte canlı görev kalmadı). Düşerse ekran susmaz, iz kendini düzeltir.
      let kagitNotu = '';
      for (const e of kagitEtki) {
        const g = await kagitKaydiGecersizKil({ anahtar: e.anahtar, kullaniciId: myProfile?.id ?? null,
          neden: `Flight cancelled (DUTY ROSTER): ${reason}`, beklenen: e.bacaklar.length });
        if (g.hata) {
          const { error: dErr } = await supabase.from('ftl_duty_edits').insert(kagitIzi(e, '(delete logged)',
            '(NOT DELETED — still counted)', `Paper record refused the change: ${g.hata}`));
          toast(`Duty cancelled, but the paper record ${kagitOzeti(e.bacaklar)} was not marked deleted — ${g.hata}. `
                + 'It is still counted in statistics and aircraft hours; tell the EFB admin.'
                + (dErr ? ` The edit-log correction could not be written either: ${dErr.message}` : ''), 'error');
        } else {
          kagitNotu += ` PAPER OFP record marked DELETED (${g.bacak} sector${g.bacak === 1 ? '' : 's'}) — `
                     + 'no longer counted in statistics or aircraft hours; documents kept.';
        }
      }
      toast(`${ids.length} duty row(s) ${sil ? 'deleted' : 'cancelled'}.${kagitNotu}`, 'success');
      setPending(null);
      reload();
    } catch (e) { toast(String(e), 'error'); }
  };

  return (
    <div style={S.panel}>
      <div style={S.panelH}>
        <span style={S.panelT}>{gorunum === 'sheet' ? 'Roster — month' : 'Roster — date range'}</span>
        <span style={{ fontSize:9, color:C.t3, letterSpacing:1, fontFamily:'var(--mono)' }} data-testid="roster-sayac">
          {gorunum === 'sheet'
            ? `${ayVeri.atamaSayisi} ASSIGNMENT(S)${!iptalGoster && ayVeri.iptalSayisi ? ` · ${ayVeri.iptalSayisi} CANCELLED HIDDEN` : ''}`
            : `${gorunenGruplar.length} ASSIGNMENT(S)${!iptalGoster && iptalSayisi ? ` · ${iptalSayisi} CANCELLED HIDDEN` : ''}`}
        </span>
      </div>

      {gorunum === 'sheet' && (<>
        <div style={{ display:'flex', gap:14, alignItems:'flex-end', padding:'14px 16px', flexWrap:'wrap' }}>
          <AyGezgini ay={gosterilenAy} setAy={setGosterilenAy} etiket={ayVeri.ayAdi} onek="roster" />
          {iptalKutusu}
          <div style={{ flex:1 }} />
          <button style={S.btnS} data-testid="roster-gorunum-tablo" onClick={() => setGorunum('table')}
                  title="The roster as a table, with a date range">TABLE</button>
          <button style={S.btnS} data-testid="roster-yazdir"
                  onClick={() => cizelgeYazdir(ayHtml, { pilot: { code: 'ALL CREW' }, veri: ayVeri, baslik: 'Roster' })}>🖨 PRINT / PDF</button>
          {atamaDugmeleri}
        </div>
        <div style={{ padding:'0 16px 16px' }} data-testid="roster-cizelge">
          <CizelgeKagidi html={ayHtml} onTikla={kagitTikla} />
        </div>
      </>)}

      {gorunum === 'table' && (<>
      <div style={{ display:'flex', gap:14, alignItems:'flex-end', padding:'14px 16px', flexWrap:'wrap' }}>
        <div style={{ width:170 }}><span style={S.label}>From</span>
          <input type="date" style={S.input} value={from} onChange={e => setFrom(e.target.value)} /></div>
        <div style={{ width:170 }}><span style={S.label}>To</span>
          <input type="date" style={S.input} value={to} onChange={e => setTo(e.target.value)} /></div>
        {/* Hizli araliklar da BUGUNU ORTALAR — varsayilanla ayni mantik. */}
        <button style={S.btnS} onClick={() => { setFrom(plus(today, -7)); setTo(plus(today, 7)); }}>2 WEEKS</button>
        <button style={S.btnS} onClick={() => { setFrom(plus(today, -15)); setTo(plus(today, 15)); }}>1 MONTH</button>
        {iptalKutusu}
        <div style={{ flex:1 }} />
        <button style={S.btnS} data-testid="roster-gorunum-cizelge" onClick={() => setGorunum('sheet')}
                title="The month as a calendar sheet">MONTH SHEET</button>
        {atamaDugmeleri}
      </div>

      {!gorunenGruplar.length ? (
        <div style={{ ...S.note, margin:'0 16px 16px' }}>NO DUTIES IN THIS RANGE.</div>
      ) : (
        <div style={{ overflowX:'auto' }}>
          <table style={S.table}>
            <thead><tr>
              <th style={S.th}>Date</th><th style={S.th}>Type</th><th style={S.th}>Route / Kind</th>
              <th style={S.th}>Operation</th>
              <th style={S.th}>Report</th><th style={S.th}>Duty end</th>
              <th style={S.th}>FDP / MAX</th><th style={S.th}>Crew</th>
              <th style={S.th}>Status</th><th style={S.th}></th>
            </tr></thead>
            <tbody>
              {gorunenGruplar.map(g => {
                const d = g.head;
                const allDeletable = g.rows.every(canHardDelete);
                const allCancelled = g.rows.every(r => r.status === 'cancelled');
                // COK GUNLU GOREV TEK SATIR (4 Agu, Serkan): OFF 10-15 gune,
                // ucus 2 gune yayilabilir — her gun icin ayni kodu tekrarlamak
                // yerine baslangic–bitis araligi + TEKIL ekip listesi basilir.
                // Veri modeli degismedi (FTL hesaplari gunluk satirlarla dogru).
                // 4 Eki 2026 (A): gece yarısını geçen görev bittiği güne kadar — "04 OCT — 05 OCT" (`gorevSonGunu`).
                const dates = g.rows.flatMap(r => [r.duty_date, gorevSonGunu(r)]).filter(Boolean).sort();
                const d0 = dates[0], d1 = dates[dates.length - 1];
                const crewUniq = []; const seenPid = new Set();
                g.rows.forEach(r => { if (!seenPid.has(r.pilot_id)) { seenPid.add(r.pilot_id); crewUniq.push(r); } });
                return (
                  <tr key={g.key} style={{ opacity: allCancelled ? .45 : 1 }}>
                    <td style={S.td}>{d0 === d1 ? fmtD(d0) : `${fmtD(d0)} — ${fmtD(d1)}`}</td>
                    <td style={S.td}>
                      {(d.duty_type || '').toUpperCase()}

                      {(d.ground_kind === 'airport_standby' || d.ground_kind === 'other_standby') && (
                        <span style={{ ...badge('amber'), marginLeft:6 }}>
                          STANDBY {d.ground_kind === 'airport_standby' ? 'Md.17/1' : 'Md.17/2'}
                        </span>
                      )}
                      {/* SIM cihazi roster'da da gorunur (Serkan, 4 Eyl):
                          *"ayni OFF TO DUTY gibi"* — cihaz currency'yi belirler. */}
                      {d.ground_kind === 'sim' && d.sim_device && (
                        <span data-testid="sim-device-roster"
                              title={d.sim_device === 'FFS_D'
                                ? 'Full flight simulator — the session counts as the programme minimum (3 take-offs and landings) towards FCL.060 recency.'
                                : 'FNPT — FCL.060 recency cannot be drawn from it.'}
                              style={{ ...badge(d.sim_device === 'FFS_D' ? 'blue' : 'dim'), marginLeft:6 }}>
                          {d.sim_device === 'FFS_D' ? 'FFS LEVEL D' : 'FNPT'}
                        </span>
                      )}
                    </td>
                    <td style={{ ...S.td, whiteSpace:'normal' }}>
                      {routeOf(d)}
                      {/* 🔑 Serkan (19 Eyl): *"Planlama cikar NOT IN AD DATABASE
                          remarki ile beraber."*  Remark TURETILIR, SAKLANMAZ
                          (Ilke 3): kutu doluysa gorev tanimsiz meydan tasiyor
                          demektir. Ayri bir bayrak konsaydi ikisi er ya da gec
                          celisirdi. */}
                      <AdHocRemark duty={d} />
                    </td>
                    {/* FAALIYET TIPI (Md.9) — 9 Agu 2026, Serkan: roster'da kolon
                        olsun. Eskiden yalniz air_taxi DISI tipler kucuk bir rozetle
                        gorunuyordu; air taxi ile "hic yazilmamis" ayirt edilemiyordu.
                        Nitelik azami UGS tablosunu sectigi icin (fdpLimitSet) bos
                        olmasi sessiz gecilemez. */}
                    <td style={S.td}>
                      {d.duty_type !== 'flight' ? <span style={{ color:C.t3 }}>—</span>
                        : d.operation_type ? (
                          <span style={badge(d.operation_type === 'air_taxi' ? 'dim' : 'blue')}>
                            {opLabel(d.operation_type)}
                          </span>
                        ) : <span style={badge('amber')}>NOT SET</span>}
                      {/* AÇIK MESAİ (Md.15) — 29 Eyl 2026: bayraktan değil KAYDIN
                          KENDİSİNDEN türetilir (bekleme + beyan edilen dinlenme yeri),
                          gerçekleşmişse gerçek saatlerden. Cevapsız split amber. */}
                      {d.duty_type === 'flight' && (() => {
                        // 🔴 21 Eki 2026 (K6): ekip yalnız bu satırın (tek pilotun) sektörlerinden okunuyordu — CRZ CPT ekipte
                        //    başka pilottaysa rozet ekibi iki pilotlu sanıyor, artırılmış ekiple BİRLEŞMEYEN split'e (Md.15(1)(d))
                        //    uzatma yazıyordu; dört pilotu hiç bilmiyordu. Artık motorun ekibi.
                        const ekip = ekipOf(d);
                        const am = gorevAcikMesai(d.sectors, d.accommodation ?? null,
                          effectiveRules(d.ruleset_snapshot || null).rules, d.operation_type,
                          { gercek: true, ucPilot: ekip.ucPilot, dortPilot: !!ekip.dortPilot,
                            dinlenmeOlanagi: d.inflight_rest_facility ?? null });
                        if (!am.isSplit || am.birlesmez) return null;
                        const baslik = `Split duty (Md.15) — wait ${fmtMin(am.beklemeMin)}, break `
                          + `${fmtMin(am.molaMin)}, rest ${d.accommodation || 'NOT DECLARED'}, FDP +${fmtMin(am.extensionMin)}`;
                        return (
                          <span data-testid="split-badge" title={baslik}
                                style={{ ...badge(am.cevapGerekli ? 'amber' : d.accommodation === 'hotel' ? 'blue' : 'dim'), marginLeft:6 }}>
                            {am.cevapGerekli ? 'SPLIT ?' : d.accommodation === 'hotel'
                              ? `SPLIT +${fmtMin(am.extensionMin)}` : 'SPLIT · ACFT'}
                          </span>
                        );
                      })()}
                    </td>
                    <td style={S.td}>{fmtDT(d.report_time)}</td>
                    <td style={S.td}>{fmtDT(d.duty_end)}</td>
                    <td style={S.td}><FdpMaxCell d={d} /></td>
                    <td style={S.td}>
                      {crewUniq.map(r => {
                        // 29 Eyl 2026: rol bacak başına — pilotun bacaklardaki
                        // rolleri (PF/PM), yalnız 1. bacağınki değil.
                        const role = [...new Set((r.sectors || []).filter(x => !x.deadhead)
                          .map(x => x.role).filter(Boolean))].join('/') || null;
                        return <span key={r.id} style={{ marginRight:8 }}>
                          {nameOf(r.pilot_id)}{role ? <span style={{ color:C.t3 }}> ({role})</span> : null}
                          {/* FTL DURUMU pilot başına (3 Eki 2026) — aynı uçuşta biri LEGAL, öteki NOT LEGAL olabilir. */}
                          <DurumRozeti d={r} toast={toast} kod={nameOf(r.pilot_id)} />
                          {/* NOBET KISALTMASI PILOT BAZLIDIR (Md.17) — gorev satirinda
                              degil ekip uyesinin yaninda gosterilir; ayni ucusta bir
                              pilotun tavani kisa, digerininki tam olabilir. */}
                          {r.standby_reduction_min > 0 && (
                            <span style={{ ...badge('amber'), marginLeft:4 }} title={r.standby_ref || 'SHT-FTL/HG Md.17'}>
                              SB −{fmtMin(r.standby_reduction_min)}
                            </span>
                          )}
                          {/* İNTİBAK yalnız KALKIŞ MEYDANINDAN FARKLIYSA gösterilir:
                              aynıysa bilgi taşımaz, gürültü olur (alan 8 dersi). */}
                          {r.acclimatised_to &&
                           String(r.acclimatised_to).toUpperCase() !== String((r.sectors || [])[0]?.dep || '').toUpperCase() && (
                            <span style={{ ...badge('amber'), marginLeft:4 }} title="SHT-FTL/HG Md.22(1) — Table 1 band read in this aerodrome's local time">
                              ACCL {r.acclimatised_to}
                            </span>
                          )}
                        </span>;
                      })}
                      {d.check_ride && (
                        <span style={{ ...badge('amber'), marginLeft:4 }}>
                          CHECK RIDE{d.external_examiner ? ` · TRE/TRI: ${d.external_examiner}` : ''}
                        </span>
                      )}
                    </td>
                    <td style={S.td}>{statusBadge(d.status)}{d.match_review && <span style={{ ...badge('amber'), marginLeft:6 }}
                        title="Why is this flagged?">REVIEW</span>}{d.match_review && <InfoDot note={d.match_review_note} />}
                      {/* SKPK gorunur olmali: kaydin azami UGS/dinlenmesi komutan
                          kararıyla degistirilmis demektir. SHGM suresi gecmisse
                          KIRMIZI — takipcinin uyarisi burada da tekrarlanir. */}
                      {((d.skpk_fdp_extension_min || 0) > 0 || (d.skpk_rest_reduction_min || 0) > 0) && (
                        <span style={{ ...badge(d.skpk_authority_due && !d.skpk_authority_reported_at
                                                 && sonTarihDurumu(d.skpk_authority_due)?.gecti ? 'red' : 'amber'), marginLeft:6 }}
                              title={d.skpk_ref || 'SHT-FTL/HG Md.12'}>
                          SKPK{d.skpk_fdp_extension_min ? ` +${fmtMin(d.skpk_fdp_extension_min)}` : ''}{d.skpk_rest_reduction_min ? ` −${fmtMin(d.skpk_rest_reduction_min)}` : ''}
                        </span>
                      )}
                    </td>
                    <td style={{ ...S.td, textAlign:'right' }}>
                      {/* 8 Agu (Serkan): EDIT her gorev tipinde — "sadece flt veya
                          off degil". Ucus modali sektor/crew/SKPK tasir; ground ve
                          off kendi dar modaline gider. */}
                      {!allCancelled && (
                        <button style={{ ...S.btnS, padding:'5px 10px', marginRight:6 }}
                                onClick={() => setEditing(g)}>EDIT</button>
                      )}
                      {!allCancelled && (
                        <button style={{ ...S.btnS, padding:'5px 10px', marginRight:6 }}
                                onClick={() => setPending({ mode:'cancel', rows:g.rows })}>CANCEL</button>
                      )}
                      {allDeletable && (
                        <button style={{ ...S.btnSil, padding:'5px 10px' }}
                                onClick={() => setPending({ mode:'delete', rows:g.rows })}>DELETE</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      </>)}

      <div style={{ ...S.note, margin:'0 16px 16px' }}>
        CANCEL gorevi listeden duser ama kayitta birakir — gerceklesmis gorevlerde tek yol budur.
        DELETE yalnizca hic gerceklesmemis gorevde cikar (planned · uçusa baglanmamis); bu sart
        veritabaninda da dayatilir. Her ikisi de gerekce ister ve denetim izine yazilir.
      </div>

      {pending && (
        <ReasonModal aciklamaTur="silme" onayTur="silme"
          title={pending.mode === 'delete' ? 'DELETE DUTY' : 'CANCEL DUTY'}
          confirmLabel={pending.mode === 'delete' ? 'DELETE & LOG' : 'CANCEL DUTY & LOG'}
          warn={pending.mode === 'delete'
            ? `${pending.rows.length} satir KALICI silinecek. Gorev hic gerceklesmedigi icin buna izin var; gerekce denetim izinde kalir.`
            : null}
          extra={pending.mode === 'cancel' && iptalKagit?.hata ? (
            <div data-testid="iptal-kagit-uyari" style={{ ...S.note, borderLeftColor:C.red, color:C.red }}>
              The paper OFP record of this flight could not be read — {iptalKagit.hata}. The cancel is refused until it can be read.
            </div>
          ) : pending.mode === 'cancel' && iptalKagit?.etki?.length ? (
            <div data-testid="iptal-kagit-uyari" style={{ ...S.note, borderLeftColor:C.amber, color:C.amber }}>
              {iptalKagit.etki.map(e => kagitOzeti(e.bacaklar)).join(' · ')} — this flight was recorded on a paper OFP.
              Cancelling the whole crew marks that record DELETED: it stays in ARCHIVED FLTS with a DELETED badge and your
              reason, but is no longer counted in statistics or aircraft hours. Its documents are kept.
            </div>
          ) : null}
          onCancel={() => setPending(null)}
          onConfirm={apply}
        />
      )}
      {assignTarihi && (
        <AssignPenceresi tarih={assignTarihi} onClose={() => setAssignTarihi(null)} onAtandi={atandi}
          {...{ toast, myProfile, pilots, duties, baselines, ruleset, offTypes, homeBases, pilotDilim, reload, dutyLocations,
                addLocation, aircraft, lisansMed, tipVasiflari }} />
      )}
      {kart && (
        <GorevKarti d={kart} rows={satirGrubu(duties, kart)} nameOf={nameOf} toast={toast} statusBadge={statusBadge}
                    onClose={() => setKart(null)} onEylem={kartEylemi} />
      )}
      {sonuc.pencereler}
      {editing && editing.head.duty_type === 'flight' && (
        <EditDutyModal
          group={editing} pilots={pilots} duties={duties} ucuslar={ucuslar} myProfile={myProfile}
          toast={toast} homeBases={homeBases} pilotDilim={pilotDilim}
          ruleset={ruleset} baselines={baselines} offTypes={offTypes} lisansMed={lisansMed} aircraft={aircraft} tipVasiflari={tipVasiflari}
          onClose={() => setEditing(null)}
          onSaved={() => { setEditing(null); reload(); }}
        />
      )}
      {editing && editing.head.duty_type !== 'flight' && (
        <EditNonFlightModal
          group={editing} pilots={pilots} offTypes={offTypes} myProfile={myProfile}
          toast={toast} dutyLocations={dutyLocations} addLocation={addLocation}
          duties={duties} baselines={baselines} ruleset={ruleset} pilotDilim={pilotDilim}
          onClose={() => setEditing(null)}
          onSaved={() => { setEditing(null); reload(); }}
        />
      )}
    </div>
  );
}

// ISO damgadan UTC "HH:MM". Panelin tum zamanlari UTC (Serkan ilkesi,
// commit 48f15ef) — yerel dilime CEVIRMEK burada HATA olurdu.
const hhmmUTC = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : d.toISOString().slice(11, 16);
};

// ═══ 0a-2) EDIT GROUND / OFF (8 Agu, Serkan: "her entry edit edilebilsin,
// gorev turu ne olursa olsun sadece flt veya off degil" + "OFF verilmis bir
// periyodu guncelleyebilmemiz lazim")
//
// Ucus modali sektor/crew/nobet/SKPK/UGS penceresi tasir — hicbiri ground/off
// icin gecerli degil. Burasi dar ve net: TUR, TARIH ARALIGI, (ground'da) SAATLER.
//
// TARIH ARALIGI: crew_duties PILOT x GUN satiridir. Aralik kisalinca satir
// SILINIR, uzayinca EKLENIR. Silmeyi DB politikasi yargilar (gerceklesmis gorev
// silinemez) — biz tahmin yurutmeyiz, reddi oldugu gibi gosteririz; mevcut
// DELETE akisindaki desenin aynisi.
// GEREKCE her zaman zorunlu (ftl_duty_edits'te CHECK var).
function EditNonFlightModal({ group, pilots, offTypes, myProfile, toast, onClose, onSaved,
                             dutyLocations = [], addLocation,
                             duties = [], baselines = {}, ruleset = null, pilotDilim = {} }) {
  const head = group.head;
  const isOff = head.duty_type === 'off';
  const rows = group.rows;
  const dates = [...new Set(rows.map(r => r.duty_date).filter(Boolean))].sort();

  const [kind, setKind] = useState(isOff ? (head.off_subtype || 'OFF') : (head.ground_kind || 'office'));
  // 🔑 SIM cihazi ve kalkis/inis sayilari DUZENLEMEDE de girilebilmeli — aksi
  //    halde ZATEN KAYITLI sim oturumlari (sahada 2 tane vardi) hicbir zaman
  //    doldurulamazdi. Atama formuna koyup burayi unutmak, bugun ucuncu kez
  //    yakalanan "kapi bir yol icin yazilmis" hatasinin aynisi olurdu.
  // 2 Eki 2026: kalkış/iniş sayıları SORULMAZ, yerine OPC / LPC (simYamasi eski sayı kolonlarına dokunmaz).
  const [simF, setSimF] = useState({ device: head.sim_device || '', checks: head.sim_checks || [] });
  const [from, setFrom] = useState(dates[0] || head.duty_date || '');
  const [to, setTo] = useState(dates[dates.length - 1] || head.duty_date || '');
  const [start, setStart] = useState(head.report_time ? hhmmUTC(head.report_time) : '09:00');
  // SIM: kutu SIM ENDS — kayıttaki bitişten simülatör sonrası süre (Md.10(c)) çıkarılır (`simSonrasiDk`, tek kural).
  const kayitKurali = useMemo(() => satirKurali(head, ruleset), [head, ruleset]);
  const ilkEnd = head.duty_end ? kutuBitisi(head, head.ground_kind, kayitKurali) : '17:00';
  const [end, setEnd] = useState(ilkEnd);
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  usePencereKapat(saving ? null : onClose);   // 12 Eki 2026: ESC + ✕ (pencereKapat.js); kaydederken kapanmaz
  // LOCATION (1 Eyl 2026) — yer gorevinin DILIM KAYNAGI. Ucus gorevlerinde
  // dilim meydandan geliyordu; yer gorevlerinde hicbir kaynak yoktu, o yuzden
  // `localNightsCovered` / `longRangeReturnRestMin` orada dilimsiz kaliyordu.
  const [loc, setLoc] = useState({ location: head.location || '', location_tz: head.location_tz || null });
  const locKural = isOff ? 'none' : locationKurali(kind);
  // OFF'un yeri (1 Eki 2026): ASSIGN ile AYNI kutu ve kural — boş = her pilotun kendi ana üssü.
  const locEksik = isOff ? (offYeriEksigi(loc) ? 'DAY OFF LOCATION (AIRPORT IN THE LIST)' : null)
    : locationEksigi(kind, { location: loc.location, locationTz: loc.location_tz, icao: loc.location });

  const pilotIds = useMemo(() => [...new Set(rows.map(r => r.pilot_id))], [rows]);
  const nameOf = (id) => { const p = pilots.find(x => x.id === id); return p ? (p.full_name || p.email || id) : id; };
  const newDates = useMemo(() => {
    if (!(from && to && from <= to)) return [];
    const out = []; let d = from; let guard = 0;
    while (d && d <= to && guard++ < 400) { out.push(d); d = nextDay(d); }
    return out;
  }, [from, to]);
  const removedDates = dates.filter(d => !newDates.includes(d));
  const addedDates = newDates.filter(d => !dates.includes(d));
  const realizedRemoved = rows.filter(r => removedDates.includes(r.duty_date) && r.status === 'actual');

  const kindChanged = isOff ? kind !== (head.off_subtype || 'OFF') : kind !== (head.ground_kind || 'office');

  // 🔴 4 Eyl 2026 — SIM ALANLARI KENDI BAYRAGINI TASIR.
  //    Ilk yazimda blok `if (kindChanged)` icindeydi: gorevin TURUNU
  //    degistirmeden yalnizca cihaz/sayi girildiginde dal hic calismiyordu ve
  //    kayit SESSIZCE dusuyordu — "Save" diyorsun, hicbir sey olmuyor.
  //    Sahada Serkan yakaladi: *"Girdim save ettim ama remark olarak FFS LVL D
  //    gorunmuyor."*  Disaridaki `if (kindChanged || timesChanged)` de ayni
  //    sebeple sim degisikligini iceri almiyordu.
  // Karar SAF FONKSIYONDA (`simYamasi`) — dal mantigi orada surulur.
  const simYama = isOff ? null : simYamasi(head, { ...simF, kind });
  const simChanged = !!simYama;
  // SIM'e geçiş / SIM'den çıkış da bitişi değiştirir (simülatör sonrası süre eklenir / kalkar).
  const timesChanged = !isOff && (start !== hhmmUTC(head.report_time) || end !== ilkEnd
    || (kind === 'sim') !== (head.ground_kind === 'sim'));
  const gorevBitisi = useCallback((d) => addMin(utcISO(toMin(end) < toMin(start) ? nextDay(d) : d, end),
    simSonrasiDk(kind, kayitKurali)), [end, start, kind, kayitKurali]);
  const locChanged = (loc.location || '') !== (head.location || '');
  // 🔴 29 Eyl 2026: `simChanged` burada YOKTU — yalnız SIM bilgisi değişince SAVE
  //    hiç açılmıyordu (yukarıdaki 4 Eyl yorumunun söz verdiğinin tersi).
  const dirty = kindChanged || timesChanged || simChanged || locChanged
             || removedDates.length > 0 || addedDates.length > 0;
  // 🔑 LOCATION ZORUNLU (Serkan, 1 Eyl): *"Location girilmeden office disinda
  // gnd gorevi girilemez."* Kapi burada: eksikse SAVE hic acilmaz ve eksik
  // ADIYLA yazilir (Ilke 7 — genel "eksik var" mesaji degil).
  // ── YER GÖREVİNİN YENİ HÂLİ — KAPI VE KAYIT AYNI HESAPTAN (30 Eyl 2026) ─────
  // 🔴 ÖNCESİ (ölçüldü): ① bu pencere YASALLIK KAPISINDAN HİÇ GEÇMİYORDU — standby
  //    dinlenmenin içine, çakışmaya, boş günün üstüne düzenlenebiliyordu (ASSIGN
  //    engellerdi; 4 Eyl "EDIT aynı kapıdan geçer" kuralının eksik ayağı) ② saat/tür
  //    değişince dinlenme (`min_rest_minutes`, `earliest_next_report`) eski bitişte
  //    kalıyordu ③ aralığa eklenen günlere dinlenme HİÇ yazılmıyordu → sonraki atama
  //    "CANNOT VERIFY REST" diye yasal bir görevi engelliyordu.
  // 🔑 Serkan: planlıda ENGEL, gerçekleşmişte KIRMIZI uyarı (*"red uyarısız kayıt
  //    olamaz"*); OFF, ASSIGN'da olduğu gibi bu kapıdan geçmez.
  const saatOk = (t) => /^\d{1,2}:\d{2}$/.test(t || '');
  const gorevKurali = useMemo(() => effectiveRules(head.ruleset_snapshot || ruleset).rules,
    [head.ruleset_snapshot, ruleset]);
  const yeniHal = useCallback((pid, d) => {
    if (isOff || !saatOk(start) || !saatOk(end)) return null;
    const s = utcISO(d, start);
    const e = gorevBitisi(d);
    const dMin = Math.round((new Date(e) - new Date(s)) / 60000);
    const gEff = (kind === 'airport_standby' || kind === 'other_standby')
      ? standbyEffect({ duty_type: 'ground', ground_kind: kind, report_time: s, duty_end: e }, gorevKurali) : null;
    const rest = yerGoreviDinlenmesi(kind, dMin, gEff, gorevKurali);
    const mevcut = rows.find(r => r.pilot_id === pid && r.duty_date === d);
    return { id: mevcut?.id || `yeni-${pid}-${d}`, pilot_id: pid, duty_type: 'ground', ground_kind: kind,
             duty_date: d, status: mevcut?.status || head.status || 'planned', report_time: s, duty_end: e,
             dutyMin: dMin, min_rest_minutes: rest, earliest_next_report: rest != null ? addMin(e, rest) : null };
  }, [isOff, start, end, kind, gorevKurali, rows, head.status, gorevBitisi]);
  // Her pilot, her yeni gün: ASSIGN'ın yer görevi yolundaki AYNI `fitness`. Pilotun
  // bu grup DIŞINDAKİ görevleri + grubun öteki günlerinin YENİ hâli (çıkarılan günler yok).
  // Md.16 ⑥ (4 Eki 2026): uzun menzil dinlenmesini tanımak için pilotların görevlerindeki meydanların dilimleri.
  const yerTzKodlari = useMemo(() => {
    const k = new Set();
    const ekle = (x) => { if (x && String(x).length === 4) k.add(String(x).toUpperCase()); };
    (duties || []).filter(d => pilotIds.includes(d.pilot_id) && d.status !== 'cancelled')
      .forEach(d => (d.sectors || []).forEach(x => { ekle(x.dep); ekle(x.dest); ekle(x.actual_dest); }));
    pilotIds.forEach(pid => ekle(pilotDilim[pid]?.icao));
    return [...k].sort().join(',');
  }, [duties, pilotIds, pilotDilim]);
  const [yerTz, setYerTz] = useState(null);
  useEffect(() => {
    if (!yerTzKodlari) { setYerTz({}); return; }
    let dead = false;
    (async () => { const m = await fetchTzMap(yerTzKodlari.split(',')); if (!dead) setYerTz(m || {}); })();
    return () => { dead = true; };
  }, [yerTzKodlari]);
  const yasallik = useMemo(() => {
    if (isOff || !ruleset) return [];
    const grup = new Set(rows.map(r => r.id));
    const out = [];
    for (const pid of pilotIds) {
      const disari = (duties || []).filter(d => d.pilot_id === pid && !grup.has(d.id));
      const hal = newDates.map(d => yeniHal(pid, d)).filter(Boolean);
      for (const g of hal) {
        const f = fitness({
          pilot: pilots.find(p => p.id === pid) || { id: pid }, baseline: baselines[pid] || null,
          duties: [...disari, ...hal.filter(x => x !== g)], ruleset,
          newDuty: { reportISO: g.report_time, sectors: [], dutyMin: g.dutyMin, dutyDate: g.duty_date,
                     duty_type: 'ground', ground_kind: g.ground_kind, dutyEndISO: g.duty_end, earliestNextReportISO: g.earliest_next_report },
          asOf: new Date(g.report_time), offTypes, tz: (pilotDilim || {})[pid]?.tz || null,
          tzMap: yerTz || {}, homeBase: pilotDilim[pid]?.kaynak === 'own' ? pilotDilim[pid].icao : null,   // Md.16 ⑥
        });
        if (!f.legal || (f.warnings || []).length) out.push({ pid, gun: g.duty_date, gercek: g.status === 'actual', f });
      }
    }
    return out;
  }, [isOff, ruleset, rows, pilotIds, duties, newDates, yeniHal, pilots, baselines, offTypes, pilotDilim, yerTz]);
  const yasakPlanli = yasallik.filter(x => !x.f.legal && !x.gercek);
  // ── OFF GİRİŞ KAPISI (1 Eki 2026) — ASSIGN'la AYNI kapı: döneme EKLENEN gün; yer ya da tür değiştiyse
  //    dönemin bütün günleri yeniden ölçülür (yeni yerin dilimi / sayılan türe geçiş). Ölçü motordan.
  const offEngeli = useMemo(() => {
    if (!isOff || !gorevKurali) return [];
    const olculen = (locChanged || kindChanged) ? newDates : addedDates;
    if (!olculen.length) return [];
    return pilotIds.flatMap(pid => {
      const r = rows.find(x => x.pilot_id === pid) || head;
      const yer = locChanged ? offYeriKaydi(loc, (pilotDilim || {})[pid])
                             : { location: r.location || null, location_tz: r.location_tz || null };
      return offGirisEngeli(olculen, (duties || []).filter(d => d.pilot_id === pid), gorevKurali,
        bosGunDilimi(yer, (pilotDilim || {})[pid]?.tz || null), { offTypes, subtype: kind })
        .map(e => { const p = pilots.find(x => x.id === pid);
                    return `${p?.code || p?.full_name || pid} ${offGirisEngeliMetni(e)}`; });
    });
  }, [isOff, gorevKurali, locChanged, kindChanged, newDates, addedDates, pilotIds, rows, head, loc, pilotDilim,
      duties, offTypes, kind, pilots]);
  // Geç tebliğ (Md.7(1)(c), 4 Eki 2026) — yalnız döneme EKLENEN günler (var olan günlerin tebliği girildikleri anda yapıldı).
  const offGecTeblig = useMemo(() => {
    if (!isOff || !gorevKurali || !addedDates.length) return [];
    return pilotIds.flatMap(pid => {
      const r = rows.find(x => x.pilot_id === pid) || head;
      const yer = locChanged ? offYeriKaydi(loc, (pilotDilim || {})[pid])
                             : { location: r.location || null, location_tz: r.location_tz || null };
      const p = pilots.find(x => x.id === pid);
      return gecTebligUyarisi(addedDates, gorevKurali, bosGunDilimi(yer, (pilotDilim || {})[pid]?.tz || null),
        { offTypes, subtype: kind }).map(m => `${p?.code || p?.full_name || pid} ${m}`);
    });
  }, [isOff, gorevKurali, addedDates, pilotIds, rows, head, locChanged, loc, pilotDilim, pilots, offTypes, kind]);
  // YER GÖREVİNİN SAATİ ZORUNLU (5 Eki 2026, Serkan A · *"yer görevi de olsa başlangıç ve bitiş olmalı"*). 🔴 Önce: saat
  //    silinince düğme açık kalıyor, kayıt görevin bitişini boş (`duty_end: null`) yazmaya çalışıyordu (ölçüldü). PLN ?'nin
  //    kapısıyla aynı cümle; zorunlu alan rengi aynı ölçüyü (`saatOk`) okur.
  const saatEksik = !isOff && (!saatOk(start) || !saatOk(end));
  const canSave = dirty && gerekceTamam(reason) && newDates.length > 0 && !saving && !locEksik
                  && !saatEksik && !yasakPlanli.length && !offEngeli.length;

  const audit = (r, field, oldV, newV) => ({
    duty_id: r.id, customer_id: r.customer_id, pilot_id: r.pilot_id,
    assignment_id: r.assignment_id || null, edit_type: 'EDIT',
    field_name: field, old_value: String(oldV ?? ''), new_value: String(newV ?? ''),
    reason: reason.trim(), edited_by: myProfile?.id ?? null,
  });

  const save = async () => {
    if (saatEksik) { toast('Start and end are required (HH:MM).', 'error'); return; }   // yedek kapı (düğme zaten kapalı)
    // Yedek kapı (düğme zaten kapalı): planlı günde kural ihlali varsa yazılmaz.
    if (yasakPlanli.length) {
      const b = pilotIhlalBildirimi(yasakPlanli.map(x => ({ kim: `${nameOf(x.pid)} ${fmtD(x.gun)}`, kaynak: x.f })));
      toast(b.mesaj, 'error', b.detay);
      return;
    }
    if (offEngeli.length) { toast(offEngeli.join(' · '), 'error'); return; }   // yedek kapı (düğme zaten kapalı)
    setSaving(true);
    try {
      // ── KAYIT SIRASI: İZ ÖNCE, YAZMA SONRA, HER YAZMA DÖNEN SATIRLA (29 Eyl 2026) ──
      // 🔴 ÖNCESİ (FTL nöbetçisi ölçüm 1 · A2): ① kalan günler güncelleniyor,
      //    izleri EN SONDA yazılıyordu — araya giren ekleme/silme düşerse yazılmış
      //    günler izsiz kalıyordu ② eklenen günlerin HİÇ izi yoktu ③ çıkarılan
      //    günlerin izinin hatası okunmuyordu ④ güncelleme/silme yalnız `error`e
      //    bakıyordu — RLS reddi 0 satır döner, hata dönmez (İlke 2) ⑤ yalnız
      //    LOCATION değişince döngüye girilmiyordu: yazma yok, iz yok, ekranda
      //    "Duty updated".
      // 🔑 Şimdi uçuş EDIT'i ve roster'la AYNI desen: bütün değişiklik önce
      //    hesaplanır, iz ÖNCE yazılır (hatası okunur, düşerse hiçbir şey
      //    yazılmaz), sonra yazmalar dönen satırla doğrulanır. İlk düşen yazmada
      //    durulur; yazılamayan ve hiç denenmeyen her gün TARİHİ ve PİLOTUYLA
      //    söylenir, izine DÜZELTME SATIRI düşer (iz kendini düzeltir, silinmez).
      const edits = [];
      const guncelle = [];   // [{ r, patch }]
      // 1) TUR / SAAT / SIM / YER — kalan gunlerdeki satirlar.
      const keep = rows.filter(r => newDates.includes(r.duty_date));
      if (kindChanged || timesChanged || simChanged || locChanged) {
        for (const r of keep) {
          const patch = {};
          if (kindChanged) {
            if (isOff) { patch.off_subtype = kind; edits.push(audit(r, 'off_subtype', r.off_subtype, kind)); }
            else { patch.ground_kind = kind; edits.push(audit(r, 'ground_kind', r.ground_kind, kind)); }
          }
          // SIM alanlari KENDI kosulunda: tur degismeden de kaydedilebilmeli.
          // FFS disinda sayi TUTULMAZ (null) — sayilmayan cihazda duran sayi,
          // sayiliyormus gibi gorunurdu (Ilke 1).
          if (simChanged) {
            const y = simYamasi(r, { ...simF, kind }) || {};
            Object.entries(y).forEach(([k, v]) => {
              patch[k] = v; edits.push(audit(r, k, r[k], v));
            });
          }
          if (locChanged) {
            // OFF: kutu boşaltıldıysa pilotun KENDİ ana üssü açıkça yazılır (offYeriKaydi) — tek kural.
            const yer = isOff ? offYeriKaydi(loc, pilotDilim[r.pilot_id])
                              : { location: loc.location || null, location_tz: loc.location_tz || null };
            patch.location = yer.location;
            patch.location_tz = yer.location_tz;
            edits.push(audit(r, 'location', r.location, yer.location));
          }
          if (timesChanged) {
            const s = utcISO(r.duty_date, start);
            const e = gorevBitisi(r.duty_date);
            patch.report_time = s; patch.duty_end = e;
            // İz görev penceresini görev penceresiyle karşılaştırır (SIM'de SIM ENDS değil, +Md.10(c) sonrası bitiş).
            edits.push(audit(r, 'times', `${hhmmUTC(r.report_time)}–${hhmmUTC(r.duty_end)}`, `${start}–${hhmmUTC(e)}`));
          }
          // DİNLENME (④, 3 Eki 2026 — tek motor tek yol): artık BURADA yazılmaz. Saat ya da tür değişince sunucu
          // yeniden hesaplar ve değişikliği SYSTEM RECALC satırıyla yazar (eski 'rest' iz satırı tekrarlı olurdu).
          // Boş yama gönderilmez (ör. SIM yaması bu satır için bir şey değiştirmiyorsa).
          if (Object.keys(patch).length) guncelle.push({ r, patch });
        }
      }
      // 2) YENI GUNLER — mevcut satirin kopyasi, pilot basina.
      // Kimlik YAZMADAN ÖNCE üretilir: eklenen günün izi o güne bağlanabilsin.
      const ins = [];
      if (addedDates.length) {
        // Yeni gunler de ayni kurala tabi (Ilke 2): regulasyon blogu actual,
        // gerisi gunu gelince. Ground gorevlerinde OFF kurali yok — prototipin
        // statusu korunur.
        const addedStatus = isOff
          ? offPeriodStatuses(newDates, {
              grantedLeave: !!(offTypes || []).find(t => t.code === kind)?.granted_leave,
              today: new Date().toISOString().slice(0, 10),
            })
          : {};
        for (const pid of pilotIds) {
          const proto = rows.find(r => r.pilot_id === pid) || head;
          for (const d of addedDates) {
            const base = {
              id: newUuid(),
              customer_id: proto.customer_id, pilot_id: pid, duty_type: head.duty_type,
              duty_date: d, status: addedStatus[d] || proto.status || 'planned',
              assignment_id: proto.assignment_id || null,
              ruleset_snapshot: proto.ruleset_snapshot || null,
            };
            if (isOff) { base.off_subtype = kind; Object.assign(base, offYeriKaydi(loc, pilotDilim[pid])); }
            else {
              base.ground_kind = kind;
              base.report_time = utcISO(d, start);
              base.duty_end = gorevBitisi(d);
              // Yeni gun de AYNI location'i tasir — aralik uzatilinca yeri
              // olmayan satir dogmaz (kapi tek yerde, Ilke 3).
              base.location = loc.location || null;
              base.location_tz = loc.location_tz || null;
              // Eklenen günün DİNLENMESİNİ sunucu yazar (④, 3 Eki 2026) — ekleme tetikleyiciyi ateşler, panel bekler.
            }
            ins.push(base);
          }
        }
      }
      // 3) CIKARILAN GUNLER.
      const drop = rows.filter(r => removedDates.includes(r.duty_date));

      // 4) İZ ÖNCE — üç işin izi TEK yazmada; düşerse hiçbir şey değişmez.
      const iz = [
        ...edits,
        ...ins.map(b => audit(b, 'duty_date', '(added to period)', b.duty_date)),
        ...drop.map(r => ({ ...audit(r, 'duty_date', r.duty_date, '(removed from period)'), edit_type: 'DELETE' })),
      ];
      if (!iz.length) { toast('No changes.', 'error'); setSaving(false); return; }
      const { error: izErr } = await supabase.from('ftl_duty_edits').insert(iz);
      if (izErr) throw new Error(`Audit write failed — nothing was changed: ${izErr.message}`);

      // 5) YAZMALAR — sırayla; her biri DÖNEN SATIRLA doğrulanır, ilk düşende durulur.
      const isler = [
        ...guncelle.map(({ r, patch }) => ({ tur: 'update', satirlar: [r],
          // ④ TEK YOL: kayda yalnız GİRDİ gider — türetilmişler görev tipine göre süzülür (sunucu yazar).
          yap: () => supabase.from('crew_duties').update(turetilmisleriAyikla(patch, r.duty_type)).eq('id', r.id).select('id') })),
        ...(ins.length ? [{ tur: 'add', satirlar: ins,
          yap: () => supabase.from('crew_duties').insert(ins.map(b => turetilmisleriAyikla(b, b.duty_type))).select('id') }] : []),
        ...(drop.length ? [{ tur: 'delete', satirlar: drop,
          yap: () => supabase.from('crew_duties').delete().in('id', drop.map(r => r.id)).select('id') }] : []),
      ];
      const DUZELTME = {   // [eski değer, yeni değer, gerekçedeki fiil]
        update: ['(edit logged)',   '(EDIT NOT WRITTEN)',                  'Update'],
        add:    ['(add logged)',    '(ADD NOT WRITTEN — day not created)', 'Add'],
        delete: ['(delete logged)', '(DELETE REFUSED — row still exists)', 'Delete'],
      };
      const yazilan = [];
      for (let i = 0; i < isler.length; i++) {
        const is = isler[i];
        const { data, error } = await is.yap();
        const donen = new Set((data || []).map(x => x.id));
        const tamam = error ? [] : is.satirlar.filter(s => donen.has(s.id));
        yazilan.push(...tamam);
        if (tamam.length === is.satirlar.length) continue;
        // DURULUR: bu işin yazılmayanları + sonraki işlerin HEPSİ yazılmadı.
        const sebep = error?.message || 'no row returned (permission?)';
        const olmayan = [
          ...is.satirlar.filter(s => !tamam.includes(s)).map(s => ({ s, tur: is.tur, denendi: true })),
          ...isler.slice(i + 1).flatMap(x => x.satirlar.map(s => ({ s, tur: x.tur, denendi: false }))),
        ];
        const { error: dErr } = await supabase.from('ftl_duty_edits').insert(olmayan.map(({ s, tur, denendi }) => ({
          ...audit(s, tur === 'update' ? 'update' : 'duty_date', DUZELTME[tur][0], DUZELTME[tur][1]),
          reason: denendi ? `${DUZELTME[tur][2]} refused: ${sebep}`
                          : `Not attempted — an earlier write was refused: ${sebep}`,
        })));
        const gun = (s) => `${nameOf(s.pilot_id)} ${fmtD(s.duty_date)}`;
        toast(`NOT SAVED: ${olmayan.map(o => gun(o.s)).join(', ')}.`
              + (yazilan.length ? ` Saved: ${yazilan.map(gun).join(', ')}.` : '')
              + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
                      : ' The edit log records what was not written.'),
              'error', yazmaDetayi({ kismen: yazilan.length > 0, hata: error }));
        setSaving(false);
        // Bir kısmı yazıldıysa ekran gerçeği göstersin; hiçbiri yazılmadıysa pencere açık kalır.
        if (yazilan.length) onSaved();
        return;
      }
      toast('Duty updated — audit logged.', 'success');
      if (!isOff) {
        await offRestUygula({ duties, ruleset, offTypes, pilotDilim, myProfile, toast,
                              gorevler: [...guncelle.map(x => ({ ...x.r, ...x.patch })), ...ins] });
      }
      onSaved();
    } catch (e) { toast(e.message, 'error'); }
    setSaving(false);
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:200,
                  display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'var(--bg2)', border:`1px solid ${C.border2}`, width:'100%', maxWidth:620,
                    maxHeight:vh(90), overflowY:'auto', padding:20 }}>
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:10, marginBottom:4 }}>
          <div style={S.panelT}>EDIT {isOff ? 'OFF' : 'GROUND'} — {pilotIds.map(nameOf).join(' · ')}</div>
          <KapatX onClose={onClose} disabled={saving} />
        </div>
        <div style={{ ...S.note, marginBottom:12 }}>
          {rows.length} row(s) · {dates.length} day(s). crew_duties is one row per pilot per day —
          shortening the period DELETES rows, extending it INSERTS rows. A realized duty cannot be
          deleted; the database decides and the refusal is shown here.
        </div>

        <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginBottom:12 }}>
          <div style={{ width:230 }}>
            <span style={S.label}>{isOff ? 'OFF type' : 'Kind'}</span>
            {isOff ? (
              <select style={S.input} value={kind} onChange={e => setKind(e.target.value)}>
                {(offTypes || []).map(t => <option key={t.code} value={t.code}>{t.code}</option>)}
              </select>
            ) : (
              <select style={S.input} value={kind} onChange={e => setKind(e.target.value)}>
                <option value="office">OFFICE</option><option value="training">TRAINING</option>
                <option value="sim">SIM</option><option value="theoretical">THEORETICAL TRAINING (Md.27/c)</option>
                <option value="airport_standby">AIRPORT STANDBY (Md.17/1)</option>
                <option value="other_standby">OTHER STANDBY (Md.17/2)</option>
                {/* DH BURADAN CIKTI (3 Eyl 2026): artik kendi gorev tipi
                    (FLT · GND · DH · OFF). GND'nin bir "cesidi" gibi durmasi
                    orguyu bozuyordu — DH'nin sektoru ve saatleri var, Md.14
                    ona ayri hukum veriyor. */}
              </select>
            )}
          </div>
          {!isOff && kind === 'sim' && (
            <div style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end' }}>
              <div>
                <span style={S.label}>Device</span>
                <select style={{ ...S.input, width:150 }} value={simF.device}
                        onChange={e => setSimF(f => ({ ...f, device: e.target.value }))}>
                  <option value="">— SELECT —</option>
                  <option value="FFS_D">FFS LEVEL D</option>
                  <option value="FNPT">FNPT</option>
                </select>
              </div>
              <SimKontrolKutulari secili={simF.checks} testid="edit-sim-kontrol"
                                  degistir={checks => setSimF(f => ({ ...f, checks }))} />
              <div style={{ ...S.note, borderLeftColor:C.accent, maxWidth:420 }}>{SIM_NOTU}</div>
              {simF.device === 'FNPT' && (
                <div style={{ ...S.note, borderLeftColor:C.amber, maxWidth:300 }}>
                  FNPT is not a full flight simulator — FCL.060 recency cannot be drawn from it.
                </div>
              )}
            </div>
          )}
          {!isOff && locKural !== 'none' && (
            <div style={{ width:280 }}>
              <span style={S.label}>Location</span>
              <LocationPicker kural={locKural} value={loc} locations={dutyLocations} zorunlu
                              onChange={setLoc} onAdd={addLocation} />
            </div>
          )}
          {isOff && (
            <div style={{ width:300 }}>
              <OffYeriSecici value={loc} onChange={setLoc} testId="duzelt-off-yeri"
                             evler={pilotIds.map(pid => pilotDilim[pid]?.kaynak === 'own' ? pilotDilim[pid].icao : null)} />
            </div>
          )}
          <div style={{ width:150 }}><span style={S.label}>From</span>
            <input type="date" {...zAlan(S.input, true, newDates.length > 0)} data-testid="duzelt-from" value={from} onChange={e => setFrom(e.target.value)} /></div>
          <div style={{ width:150 }}><span style={S.label}>To</span>
            <input type="date" {...zAlan(S.input, true, newDates.length > 0)} data-testid="duzelt-to" value={to} onChange={e => setTo(e.target.value)} /></div>
          {!isOff && (<>
            <div style={{ width:110 }}><span style={S.label}>Start (UTC)</span>
              <input {...zAlan(S.input, true, saatOk(start))} data-testid="edit-gnd-start" value={start} onChange={e => setStart(normTime(e.target.value))} /></div>
            <div style={{ width:110 }}><span style={S.label}>{kind === 'sim' ? 'Sim ends (UTC)' : 'End (UTC)'}</span>
              <input {...zAlan(S.input, true, saatOk(end))} data-testid="edit-gnd-end" value={end} onChange={e => setEnd(normTime(e.target.value))} /></div>
          </>)}
        </div>

        {(addedDates.length > 0 || removedDates.length > 0) && (
          <div style={{ ...S.note, borderLeftColor: realizedRemoved.length ? C.red : C.accent, marginBottom:12 }}>
            {addedDates.length > 0 && <div>+ {addedDates.length} day(s) added: {addedDates.join(', ')}</div>}
            {removedDates.length > 0 && <div>− {removedDates.length} day(s) removed: {removedDates.join(', ')}</div>}
            {realizedRemoved.length > 0 && (
              <div style={{ color:C.red, marginTop:4 }}>
                {realizedRemoved.length} of these are REALIZED — the database will refuse to delete them.
              </div>
            )}
          </div>
        )}

        {/* ── FTL DURUMU (30 Eyl 2026) — uçuş EDIT'iyle aynı kutu, aynı gerekçe listesi.
            Planlı günde kırmızı satır kaydı ENGELLER; gerçekleşmiş günde engellemez ama
            kırmızı görünür (Serkan: "red uyarısız kayıt olamaz"). Amber engellemez. */}
        {yasallik.length > 0 && (
          <div style={{ ...S.note, marginTop:12, borderLeftColor: yasakPlanli.length ? C.red : C.amber }}
               data-testid="gnd-edit-status">
            {yasallik.filter(x => !x.f.legal).map(x => {
              const kod = pilots.find(p => p.id === x.pid)?.code || nameOf(x.pid);
              return (
                <div key={`r-${x.pid}-${x.gun}`} style={{ color:C.red, fontSize:11 }}>
                  <b>{kod} {fmtD(x.gun)}</b> {x.gercek ? '— RECORDED DESPITE' : '— NOT LEGAL'}:
                  <div style={{ paddingLeft:12 }}>
                    <GerekceListesi kunyeli={kunyeliYaDuz(x.f)} testid={`gnd-edit-${kod}-${x.gun}`}
                                    neYapmali={x.gercek ? NE_YAPMALI.uculdu : NE_YAPMALI.pilot}
                                    neYapmaliKayit={x.gercek ? NE_YAPMALI.uculdu : undefined} />
                  </div>
                </div>
              );
            })}
            {yasallik.filter(x => (x.f.warnings || []).length).map(x => (
              <div key={`w-${x.pid}-${x.gun}`} style={{ color:C.amber, fontSize:11 }}>
                ⚠ <b>{pilots.find(p => p.id === x.pid)?.code || nameOf(x.pid)} {fmtD(x.gun)}</b> {x.f.warnings.join(' · ')}
              </div>
            ))}
            {yasakPlanli.length > 0 && (
              <div style={{ color:C.t3, fontSize:11, marginTop:4 }}>
                Editing a PLANNED duty is still planning — the same gate as assignment applies.
              </div>
            )}
          </div>
        )}

        {offEngeli.length > 0 && (
          <div style={{ ...S.note, marginTop:12, borderLeftColor:C.red }} data-testid="off-giris-engeli">
            {offEngeli.map(m => <div key={m} style={{ color:C.red, fontSize:11 }}>{m}</div>)}
          </div>
        )}
        {offGecTeblig.length > 0 && (
          <div style={{ ...S.note, marginTop:12, borderLeftColor:C.accent }} data-testid="off-gec-teblig-uyari">
            {offGecTeblig.map(m => <div key={m} style={{ color:C.accent, fontSize:11 }}>{m}</div>)}
          </div>
        )}

        <span style={S.label}>Reason (required)</span>
        <HarfliGiris as="textarea" {...zAlan({ ...S.input, height:70 }, true, gerekceTamam(reason))}
                  data-testid="duzelt-gerekce" value={reason} onChange={setReason}
                  placeholder="Why is this duty being changed?" />
        <GerekceIpucu metin={reason} testid="duzelt-gerekce-ipucu" />

        {/* Serkan (1 Eyl): "uyarsin, location girilmeden office disinda gnd
            gorevi girilemez." Dugmenin kapali olmasi yetmez — NE eksik oldugu
            ADIYLA yazilir (Ilke 7), yoksa pilot neden kaydedemedigini bilemez. */}
        {saatEksik && (
          <div data-testid="duzelt-saat-eksik" style={{ ...S.note, borderLeftColor:C.red, marginTop:12 }}>
            Start and end are required (HH:MM) — a ground duty without hours cannot be saved: its duty time and the rest
            after it are measured from them.
          </div>
        )}
        {locEksik && (
          <div style={{ ...S.note, borderLeftColor:C.red, marginTop:12 }}>
            {isOff
              ? <>{loc.location} is not in the airport list — check the ICAO code, or leave the box empty for the home base. It cannot be saved like this: the two local nights of the day off are measured in the time zone of that airport.</>
              : <>{locEksik} is required for a {String(kind || '').toUpperCase().replace(/_/g, ' ')} duty —
            it cannot be saved without it. Rest and local-night calculations read the timezone from here.</>}
          </div>
        )}

        <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:14 }}>
          <button style={S.btnS} onClick={onClose}>CANCEL</button>
          <button style={{ ...S.btnP, opacity: canSave ? 1 : .45 }} disabled={!canSave} onClick={save}>
            {saving ? 'SAVING…' : 'SAVE'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══ 0a) EDIT DUTY (4 Agu, Serkan: "bazen sadece plan saatleri veya dest
// degisiyor veya crew") — YALNIZ ucus gorevleri.
// Kurallar (3 Agu):
//  - Saat/pilot her zaman duzeltilebilir, GEREKCE ZORUNLU (DB'de CHECK var).
//  - ACTUAL ucusta blok/plan saatleri KILITLI — tek kaynak arsiv. Yalniz crew
//    duzeltilebilir (yanlis kayit duzeltmesi).
//  - Pencere kaydin KENDI ruleset_snapshot'i ile yeniden hesaplanir — bugunku
//    ruleset'le DEGIL (gorev yazildigi gunun kuralina tabidir).
//  - Zincir etkisi: yeni earliest_next_report'tan ONCE rapor saatli sonraki
//    gorev varsa OTOMATIK DUZELTILMEZ, amber uyari verilir.
//  - TZ: saatler meydan dilimleriyle mutlaklastirilir (dinlenme atlanmaz).
/** Uçulmuş bacağın SAAT/rota kısmı — bacak tipi (25 Eki 2026) aynı nesnede durur ama saat değişikliği sayılmaz. */
const saatKismi = (g) => {
  if (!g) return g;
  const { operation_type: _tip, opSrc: _kaynak, tipElle: _elle, ...saat } = g;
  return saat;
};

function EditDutyModal({ group, pilots, duties, ucuslar = {}, myProfile, toast, onClose, onSaved, homeBases,
                         pilotDilim = {}, ruleset = null, baselines = {}, offTypes = null, lisansMed = {},
                         gercekGiris = false, aircraft = [], tipVasiflari = {} }) {
  // `gercekGiris` (29 Eyl 2026): "gerçekleşti mi? → YES" ve OPEN rozeti buraya
  // gelir — görevi gerçekleşmiş yapan TEK pencere. Bu modda OFF/ON BLOCK her
  // sektörde zorunludur ve saatler girilmiş sayılır (değişmemiş olsa da yazılır).
  const head = group.head;
  // "Gerçekleşti" modunda görev KAYITTIR, planlama değil (4 Eyl kuralı): planlanan
  // saat alanları gizlenir, yasallık/ekip kapıları GÖRÜNÜR ama engellemez, SKPK
  // açılır — eski "gerçekleşti mi?" penceresi de planlama kapısı çalıştırmıyordu.
  const isActual = head.status === 'actual' || head.duty_finished || gercekGiris;
  // ── AÇIK MESAİ: DİNLENME YERİ BEYANI (29 Eyl 2026, Md.15) ──────────────────
  // Kayıttaki beyanla açılır; YOKSA VARSAYILMAZ. Eskiden dört hesap
  // `konaklama` diyordu — kimse söylemeden otel sayılıp
  // uzatma veriliyordu. Açık mesai kutusu sorar, cevapsız kayıt olmaz.
  const [konaklama, setKonaklama] = useState(head.accommodation ?? null);
  const konaklamaDegisti = (konaklama ?? null) !== (head.accommodation ?? null);
  // `_kaynak`: bacağın kayıttaki sektör sırası (araya eklenen yeni bacakta null) — eşleme SIRA NUMARASIYLA yapılmaz
  // (5 Eki 2026): ortadan silme ya da araya ekleme bir bacağın DH / tip / plan bağını komşusuna kaydırırdı.
  // `reg` (21 Eki 2026, K2): planlı sektörün tescili — ASSIGN ile aynı; zorunlu, tip yetkisi ondan.
  // FAALİYET TİPİ BACAK BAŞINA (25 Eki 2026, tasarım A): her bacak kendi tipini taşır; tipsiz eski bacak (22 Ağu öncesi)
  // görevin tipiyle açılır — o tip zaten ona uygulanıyordu. DH sektör değildir (Md.14/1/b), tipi yok.
  // Kural tek yerde (`bacakTipi`, FTLEngine — STATISTICS'in OPERATION süzgeci de onu okur, 31 Eki 2026).
  const ilkBacakTipi = (x) => bacakTipi(x, head);
  const [legs, setLegs] = useState(() => (head.sectors || []).map((x, i) => ({
    dep: x.dep || '', dest: x.dest || '', etd: x.etd || '', eta: x.eta || '', reg: x.reg || '', _kaynak: i,
    ...ilkBacakTipi(x) })));
  // RAAQ ERKEN UYARISI (21 Eki 2026) — ASSIGN ile aynı not; yalnız planlı görevin sektörlerinde (uçulmuşta sektör satırı yok,
  // RAAQ zaten geride kaldı). Görevin kendi şirketi.
  const raaq = useRaaqKayitlari(head.customer_id || myProfile?.customer_id,
                                !isActual && head.duty_type === 'flight' ? legs.flatMap(l => [l.dep, l.dest]) : []);

  // ── GERÇEKLEŞEN SAATLER (7 Eyl 2026) ─────────────────────────────
  // 🔑 Serkan: *"Burada saatler yok, olsa güncellerdim hepsinin."*
  //
  // 🔴 ÖLÇÜLDÜ: gerçek saatler YALNIZ BİR KEZ, "oldu mu?" akışında
  //    girilebiliyordu. Düzenleme ekranı sektörlerin sadece PLANLANAN
  //    alanlarını (dep/dest/etd/eta) taşıyor ve o blok `!isActual` içinde,
  //    yani gerçekleşmiş görevde hiç çizilmiyor. Sonuç: eksik girilmiş bir
  //    T/O–LND sonradan TAMAMLANAMIYOR (28.07 ve 30.07 uçuşlarında öyle
  //    kaldı), yanlış girilen de DÜZELTİLEMİYOR.
  //
  // 🔴 İKİNCİ KUSUR — YAYILMIYORDU: bir uçuş iki pilotla uçulduğunda
  //    kapatma yalnız o pilotun satırını yazıyordu. 06.09 LTFE–LTAC'ta
  //    AAK `actual`/FDP 150, SEL hâlâ `planned`/FDP 120 kaldı — aynı uçuş,
  //    iki farklı gerçek. Uçağın blok saati ekipte ORTAKTIR; burada girilen
  //    saat atamadaki BÜTÜN pilotlara yazılır. FDP ise kişiye özeldir,
  //    her satırda KENDİ `report_time`'ından hesaplanır.
  // 🔴 19 EYL 2026 — SAATLER TEK SAHİPTEN.
  //    Eskiden dört alan da sektörden okunuyordu; `archive-flight` oraya yalnız
  //    `off_block`/`on_block` yazdığı için T/O ve LND HER SEFERİNDE BOŞ
  //    geliyordu (Serkan sahada gördü, 10 Eyl görevi). Değerler kayıp değildi —
  //    `archived_flights`ta duruyordu, panel o tabloyu hiç okumuyordu.
  const gercekBos = () => (head.sectors || []).map(x => {
    const t = sektorSaatleri(x, x.plan_id ? ucuslar[String(x.plan_id)] : null);
    // 🔑 ROTA DA DÜZENLENEBİLİR (20 Eyl 2026). Serkan: *"Bir uçuş planladım
    //    XXXX–YYYY; divert oldum. Editten gittim, dest değiştirdim; editi
    //    kapatırken sebep soracak, oraya DIVERT yazdım."* Sektör satırı
    //    bugüne kadar DÜZ YAZIYDI — gerekçe kapısı, denetim izi ve roster
    //    change raporu hazırdı ama değiştirilecek alan yoktu.
    // DIVERT (5 Eki 2026, Serkan): kayıttaki inilen meydan (`actual_dest`, iPad'le AYNI alan) planlanandan farklıysa
    // bacak divert'tir; ekranda DIVERT açık ve inilen meydan dolu gelir.
    const indi = x.actual_dest && x.actual_dest !== x.dest ? x.actual_dest : '';
    return { dep: x.dep || '', dest: x.dest || '', divert: !!indi, landed: indi,
             off_block: t.off_block, takeoff_time: t.takeoff_time,
             landing_time: t.landing_time, on_block: t.on_block, ...ilkBacakTipi(x) };
  });
  const [gercek, setGercek] = useState(gercekBos);
  // ── UÇULMUŞ GÖREVE ARAYA BACAK (5 Eki 2026, Serkan: "her bacağın altında add sector here") ─────────────────────
  // `akt`: ekrandaki sektör sırası — kayıttaki sektör (`kaynak` = kayıttaki sırası) ya da araya eklenen YENİ bacak (`yeni`).
  // `gercek`, `kagitInis` ve `roller` bu sırayla hizalıdır. Yeni bacak elle girilir → kâğıt OFP bacağıdır (iPad'den değil).
  const [akt, setAkt] = useState(() => (head.sectors || []).map((_, i) => ({ kaynak: i })));
  const aktifSektorler = useMemo(() => akt.map(a => (a.kaynak != null ? ((head.sectors || [])[a.kaynak] || {}) : a.yeni)),
    [akt, head.sectors]);
  /** Bir ekip satırının sektörleri ekrandaki sırayla — araya eklenen bacak her satıra aynı yerden girer. */
  const satirSektorleri = useCallback((rs) => akt.map(a => (a.kaynak != null ? ((rs || [])[a.kaynak] || {}) : { ...a.yeni })), [akt]);
  const yeniBacakVar = akt.some(a => a.kaynak == null);
  /** Bacak bir iPad arşiv uçuşuna bağlı mı (onun saatlerinin sahibi arşivdir; kâğıt kayda yazılmaz). */
  const arsivliBacak = (x) => !!(x?.plan_id && ucuslar[String(x.plan_id)]);
  // ── DIVERT (5 Eki 2026, Serkan: *"planlama aşamasında belirlenmiş varış meydanı dışında bir meydanda biterse uçuş divert
  //    girilir"* · elle girilen uçuşta varışın altında DIVERT düğmesi, yeni varış elle girilir). Varış = PLANLANAN meydan,
  //    serbest değiştirilmez; inilen meydan `actual_dest`e yazılır (iPad'le tek alan — motor, DUTY HISTORY "›X DVT",
  //    STATISTICS rozeti oradan okur). iPad bacağında divert iOS'tan otomatik gelir — düğme yok.
  /** Bacağın inilen meydanı: iPad bacağında arşivden (kayıttaki), kâğıt bacakta EDIT'teki DIVERT'ten; yoksa undefined. */
  const inilenMeydan = (x, i) => (arsivliBacak(x) ? (x?.actual_dest || undefined)
    : (gercek[i]?.divert && gercek[i]?.landed ? gercek[i].landed : undefined));
  // ── TANIMSIZ MEYDAN BEYANI (21 Eyl 2026) ──────────────────────────
  // GOREVIN kendi kutusundan tohumlanir; duzenlemede meydan degisirse beyan da
  // degisebilsin diye yerel durumda tutulur ve kayitta geri yazilir.
  const [adHoc, setAdHoc] = useState(() => ({ ...(head.ad_hoc_airports || {}) }));
  const beyanEkle = (icao, kayit) =>
    setAdHoc(p => ({ ...p, [String(icao).toUpperCase()]: kayit }));
  const setGrc = (i, k, v) => setGercek(gs => gs.map((g, j) => j === i ? { ...g, [k]: v } : g));
  const [date, setDate] = useState(head.duty_date);
  // BACAK SIRASI (Md.4(1)(v) turnaround, Md.7(1)(e) — 5 Eki 2026, Serkan A): uçulmuşta dört gerçek zaman, planlıda ETD/ETA.
  const siraHatasi = useMemo(() => (head.duty_type !== 'flight' ? null
    : (isActual || gercekGiris) ? bacakSirasiHatasi(gercek, ['off_block', 'takeoff_time', 'landing_time', 'on_block'])
      : bacakSirasiHatasi(legs, ['etd', 'eta'])), [head.duty_type, isActual, gercekGiris, gercek, legs]);

  // ── KÂĞIT OFP, EDIT'TE DE SORULUR (19 Eyl 2026) ───────────────────
  // 🔑 Serkan: *"Editten uçuşu açınca da sorması lazım; edit kısmında paper
  //    OFP tıklayınca bunu istatistiğe PAPER OFP olarak yazmalı."*
  // 🔴 Kutu bugüne kadar YALNIZ "gerçekleşti mi?" modalındaydı. Bir görev
  //    EDIT'ten ya da geçmiş tarihli ASSIGN'den gerçekleşmiş yapıldığında
  //    hiç sorulmuyordu — 14 · 17 · 18 Eylül uçuşları bu yüzden roster'da
  //    ACTUAL ama STATISTICS'te YOKTU.
  // ⚠️ Arşivi OLAN uçuşta kutu ÇIKMAZ: o uçuş EFB ile uçulmuştur, "kâğıt OFP"
  //    demek yanlış beyan olurdu (İlke 1).
  const arsivVar = (head.sectors || []).some(x => x.plan_id && ucuslar[String(x.plan_id)]);
  // Görevde kâğıt OFP'ye yazılabilecek bacak var mı — iPad arşivine bağlı olmayan uçuş bacağı (5 Eki 2026: karışık görev).
  const kagitBacakVar = (head.sectors || []).some(x => kagitBacagiMi(x, ucuslar));
  const [paperOfp, setPaperOfp] = useState(false);
  const [paperReg, setPaperReg] = useState('');
  // Kâğıt OFP: sektör başına iniş sayısı + tipi (22 Eyl 2026, Serkan).
  const [kagitInis, setKagitInis] = useState([]);
  const setInis = (i, k, v) => setKagitInis(gs => {
    const y = [...gs]; y[i] = { ...(y[i] || {}), [k]: v }; return y;
  });
  const [ucaklar, setUcaklar] = useState([]);
  // 🔴 19 EYL 2026 — KUTUYU İŞARETLEMEK "DEĞİŞİKLİK" SAYILMIYORDU.
  //    Serkan sahada denedi: yalnız PAPER OFP'yi işaretleyip kaydedince
  //    *"COULD NOT SAVE — NOTHING WAS WRITTEN / No changes."* çıktı ve hiçbir
  //    şey yazılmadı. Sebep: `edits` boş kalınca erken dönülüyor ve kâğıt
  //    yazma bloğu o satırın ALTINDA kalıyordu. Beyanın kendisi zaten ize
  //    yazılması gereken bir eylemdir — artık hem sayılıyor hem kaydediliyor.
  const [paperBaslangic, setPaperBaslangic] = useState({ isaretli:false, reg:'' });
  // ── UÇAK LİSTESİ HER ZAMAN YÜKLENİR (29 Eyl 2026) ──────────────────────
  // 🔑 Serkan (sahadan, kâğıt OFP girerken): *"uçak seçemiyorum."*
  // 🔴 ÖLÇÜLDÜ: liste yalnız görev ACTUAL iken yükleniyordu
  //    (`if (!isActual || arsivVar) return`), ama kâğıt OFP kutusu PLANNED
  //    görevde de çiziliyor — kutu açılıyor, liste BOŞ geliyordu. Sorgu
  //    hatası da okunmuyordu. Artık kutu hangi görevde çiziliyorsa liste orada
  //    yüklenir ve okunamazsa kutunun içinde ADIYLA yazar (İlke 2).
  const [ucakHata, setUcakHata] = useState(null);
  // ── KÂĞIT OFP EVRAKI (2 Eki 2026) — kayıtlı olanlar · SAVE'de yüklenecekler · SAVE'de kaldırılacaklar ──
  const [kagitEvrak, setKagitEvrak] = useState([]);
  const [yeniEvrak, setYeniEvrak] = useState([]);
  const [kaldirilacakEvrak, setKaldirilacakEvrak] = useState(() => new Set());
  const [evrakRet, setEvrakRet] = useState([]);
  const [evrakOkumaHata, setEvrakOkumaHata] = useState(null);
  const evrakEkle = (dosyalar) => {
    const ret = [], uygun = [];
    dosyalar.forEach(d => { const h = kagitEvrakDenetle(d); if (h) ret.push(h); else uygun.push(d); });
    setEvrakRet(ret);
    setYeniEvrak(ys => [...ys, ...uygun]);
  };
  const evrakKaldirIsaretle = (id) => setKaldirilacakEvrak(k => {
    const y = new Set(k); if (y.has(id)) y.delete(id); else y.add(id); return y;
  });
  // Kâğıt kaydın anahtarı yazıcınınkiyle AYNI (`kagitAnahtari`): eskiden okuma yalnız `assignment_id`ye
  // bakıyordu, bağı olmayan görevde kayıtlı kâğıt OFP kutuda işaretsiz görünürdü.
  const kagitAnahtarim = kagitAnahtari(head);
  // Uçak listesi ve evrak kutu görününce yüklenir — araya eklenen bacak iPad görevinde de kutuyu açar (5 Eki 2026;
  // 🔴 önce yalnız kayıtta kâğıt bacak varken yükleniyordu: yeni bacakta tescil listesi boş, kaydetmenin yolu yoktu).
  // Mevcut kâğıt kayıt (işaret, tescil, inişler) YALNIZ kayıtta kâğıt bacak varken okunur.
  const kagitKutusu = kagitBacakVar || yeniBacakVar;
  useEffect(() => {
    if (!kagitKutusu) return;
    let dead = false;
    (async () => {
      const anahtar = kagitAnahtarim;
      const [{ data: ac, error: acErr }, { data: mf, error: mfErr }, { data: ev, error: evErr }] = await Promise.all([
        supabase.from('aircraft').select('registration')
          .eq('customer_id', head.customer_id).order('registration'),
        (anahtar && kagitBacakVar)
          ? supabase.from('manual_flights').select('reg,seq,landing_count,lnd_type')
              .eq('assignment_id', anahtar).is('deleted_at', null)
          : Promise.resolve({ data: [] }),
        kagitEvraklari(anahtar),
      ]);
      if (dead) return;
      // Evrak okunamazsa "evrak yok" denmez — sebebi kutuda yazar (İlke 2).
      setKagitEvrak(ev || []);
      setEvrakOkumaHata(evErr ? `DOCUMENTS COULD NOT BE READ — ${evErr.message}` : null);
      setUcakHata(acErr ? `AIRCRAFT LIST COULD NOT BE READ — ${acErr.message}`
                : mfErr ? `EXISTING PAPER OFP RECORD COULD NOT BE READ — ${mfErr.message}` : null);
      setUcaklar((ac || []).map(r => r.registration).filter(Boolean));
      // Kayıt ZATEN varsa kutu işaretli gelir — kullanıcı her düzenlemede
      // yeniden işaretlemek zorunda kalmasın, ve kazara kaldırdığında bunu
      // GÖREREK yapsın.
      if ((mf || []).length) {
        setPaperOfp(true); setPaperReg(mf[0].reg || '');
        setPaperBaslangic({ isaretli: true, reg: mf[0].reg || '' });
        // 🔑 29 Eyl 2026: kayıtlı İNİŞ SAYISI ve TİPİ de gelir. Gelmezse bu
        //    görevde yapılan her düzeltme (saat, rol) kâğıt kaydı yeniden
        //    yazarken "LANDINGS missing" diye düşüyor, bacak rolleri kâğıt
        //    kayda hiç ulaşmıyordu. Değer kayıttan okunur, uydurulmaz.
        // Kayıttaki `seq` UÇUŞ bacağı sırasıdır (DH yazılmaz) — ekrandaki dizi
        // ise görevin bütün sektörleri; k'inci uçuş bacağının yeri aranır.
        const ucusYeri = (head.sectors || []).map((x, i) => (kagitBacagiMi(x, ucuslar) ? i : null))
          .filter(i => i != null);
        const inisler = [];
        (mf || []).forEach((m, k) => {
          const i = ucusYeri[Number.isInteger(m.seq) ? m.seq - 1 : k];
          if (i == null) return;
          inisler[i] = { ...(m.landing_count != null ? { landings: String(m.landing_count) } : {}),
                         ...(m.lnd_type ? { lnd_type: m.lnd_type } : {}) };
        });
        setKagitInis(inisler);
      }
    })();
    return () => { dead = true; };
  }, [kagitKutusu, kagitBacakVar, head.customer_id, kagitAnahtarim, head.sectors, ucuslar]);
  // Görev bir arşiv uçuşuna bağlıysa tarihi burada değiştirilemez: o eşleşmede
  // tek kaynak uçuştur (18 Eyl 2026).
  const planaBagli = (head.sectors || []).some(x => x.plan_id);
  // 🔴 6 Eyl 2026 — SAHA: Serkan *"bugünkü uçuşun rol değişimini yapamıyorum"*.
  //    `oldRole` YOKTU: kayıt açılırken rol okunuyor ama ESKİSİ saklanmıyordu,
  //    dolayısıyla değişip değişmediği hiç sorulamıyordu.
  // 🔑 29 Eyl 2026: rol artık pilot satırında DEĞİL, bacak tablosunda
  //    (`roller`). Üyenin anahtarı (`key`) satırın kimliğidir; pilot takası
  //    (`pickPilot`) rolleri satırda bırakır, yalnız isimler yer değiştirir.
  const [crew, setCrew] = useState(() => group.rows.map(r => ({
    key: r.id, rowId: r.id, oldPilot: r.pilot_id, pilot: r.pilot_id, yeni: false })));
  // ── BACAK BAŞINA ROLLER (29 Eyl 2026) ───────────────────────────────────
  // 🔑 Serkan: *"4 bacak uçuş girilse dahi her bacak için ayrı ayrı edit
  //    edilebilmeli."*
  // 🔴 ESKİ HÂL: pilot başına TEK rol kutusu vardı ve kayıt o rolü bütün
  //    bacaklara yazıyordu; bacak başına farklı rol ne girilebiliyor ne de
  //    korunabiliyordu. Üstelik gerçekleşmiş görevde aynı kayıtta hem saat
  //    hem rol değişince rol yazımı sektörleri ESKİ kayıttan yeniden kuruyor
  //    ve yeni girilen saatleri siliyordu (FDP ve iz yeni saati, sektör eski
  //    saati gösteriyordu). Artık rol EN SON ve yalnız `role` alanına uygulanır
  //    (`rolleriUygula`) — başka hiçbir alan değişmez.
  // Dizi `head.sectors` ile hizalıdır; planlı görevde bacak eklenip silinince
  // birlikte kayar (`bacakEkle` / `bacakSil`).
  const ilkRoller = useMemo(() => haritalariKur(head.sectors || [],
    group.rows.map(r => ({ key: r.id, sectors: r.sectors || [] }))), [head.sectors, group.rows]);
  const [roller, setRoller] = useState(ilkRoller);
  const ucPilotEski = crzVar(ilkRoller);
  const ucPilotYeni = crzVar(roller);
  // 4 pilotlu ekip (5 Eki 2026, Md.11(4)): aynı bacakta iki CRZ — tavan +3:00. Ekip düzeni değişimi ikisini birlikte sayar.
  const dortPilotEski = dortPilotVar(ilkRoller);
  const dortPilotYeni = dortPilotVar(roller);
  const ucPilotDegisti = ucPilotEski !== ucPilotYeni || dortPilotEski !== dortPilotYeni;
  const bacakRolDegis = (i, h) => setRoller(rs => rs.map((x, j) => (j === i ? h : x)));
  // ── 3. KİŞİ (CRZ CPT / CHECK RIDE) EDIT'TE DE (29 Eyl 2026) ──────────────
  // 🔴 Kutu yalnız ASSIGN'daydı; sonradan üçüncü kişi eklenemiyordu. CRZ
  //    şirket pilotudur → atamaya YENİ bir görev satırı eklenir, FDP/dinlenme
  //    aynı kapıdan hesaplanır. CHECK RIDE denetçisi şirket pilotu değildir →
  //    yalnız ad ve bayrak, FTL'i tutulmaz (4 Ağu kararı).
  const [ucuncuMod, setUcuncuMod] = useState(
    head.check_ride ? 'checkride' : (ucPilotEski ? 'crz' : null));
  const [examiner, setExaminer] = useState(head.external_examiner || '');
  // 🔑 4 PİLOTLU EKİP (5 Eki 2026, Serkan): EDIT'te de birden çok yeni CRZ — her biri ayrı üye (`yeni-crz-1`, `-2`),
  //    kayıtta her biri YENİ görev satırı. Ekip en çok 2 + AZAMI_CRZ pilot (Md.11(4)). 🔴 Önce tek `yeni-crz` vardı.
  const YENI_CRZ = 'yeni-crz';
  const yeniUyeler = crew.filter(c => c.yeni);
  const [crzSlot, setCrzSlot] = useState(false);   // ikinci CRZ seçicisi açık mı
  const crzEkle = (pid) => {
    if (!pid || crew.some(c => c.pilot === pid) || crew.length >= 2 + AZAMI_CRZ) return;
    const key = [1, 2, 3].map(n => `${YENI_CRZ}-${n}`).find(k => !crew.some(c => c.key === k));
    setCrew(cs => [...cs, { key, rowId: null, oldPilot: null, pilot: pid, yeni: true }]);
    setRoller(rs => uyeEkle(rs, key));
    setCrzSlot(false);
  };
  const crzKaldir = (key) => {
    setCrew(cs => cs.filter(c => c.key !== key));
    setRoller(rs => uyeCikar(rs, key));
  };
  const yeniCrzleriKaldir = () => yeniUyeler.forEach(c => crzKaldir(c.key));
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  usePencereKapat(saving ? null : onClose);   // 12 Eki 2026: ESC + ✕ (pencereKapat.js); kaydederken kapanmaz
  // FAALIYET TIPI (Md.9) — 9 Agu 2026, Serkan: "duty planlarken gorev atamasi
  // yapilirken seciliyor, bu guncellenebilmeli FTL acisindan". Planlamada
  // ticari secilip ucusun genel havacilik cikmasi gercek bir durum; nitelik
  // AZAMI UGS TABLOSUNU secer (fdpLimitSet), yani yanlis nitelik yanlis limit
  // demektir. ACTUAL gorevde de degistirilebilir — hata zaten ucus BITTIKTEN
  // sonra fark ediliyor.
  // 🔑 25 EKİ 2026 — TİP BACAK BAŞINA (Serkan, tasarım A; 22 Ağu kuralı EDIT'e de indi). Tek seçici kalktı: tip her bacağın
  //    satırında, ASSIGN'la aynı kutuda (`OperasyonSecici`). 🔴 Önce: tek kutu vardı ve kayıt o tipi BÜTÜN bacaklara
  //    yazıyordu (planlıda hiç yazmıyordu — motor bacak tipini okuduğu için düzeltme geri dönüyordu); FERRY · AIR TAXI ·
  //    FERRY görevi ya düzleşiyor ya MATCH REVIEW'da kalıyordu. Görevin YÖNETİCİ tipi seçilmez, bacaklardan çıkar
  //    (en dar limitli, 2 Eyl) — planlıda pencere, uçulmuşta sunucunun motoru söyler.
  // Ekrandaki bacaklar: planlıda `legs`, uçulmuşta `gercek` (ikisi de ekrandaki sırayla); kayıttaki sırası ayrı tutulur.
  const ekranBacaklari = isActual ? gercek : legs;
  const kayitSirasi = (i) => (isActual ? akt[i]?.kaynak : legs[i]?._kaynak);
  const ucusBacagiMi = (i) => { const k = kayitSirasi(i); return !(k != null && (head.sectors || [])[k]?.deadhead); };
  // Önizlemelerin bağımlılığı olduğu için sabit referans (her çizimde yeni dizi motoru boşuna yeniden koştururdu).
  const bacakTipleri = useMemo(() => ekranBacaklari.map((b, i) => {
    const k = isActual ? akt[i]?.kaynak : b?._kaynak;
    return (k != null && (head.sectors || [])[k]?.deadhead) ? '' : (b?.operation_type || '');
  }), [ekranBacaklari, isActual, akt, head.sectors]);
  const tipler = useMemo(() => [...new Set(bacakTipleri.filter(Boolean))], [bacakTipleri]);
  // Kayıtlı bir bacağın tipi değişti mi — araya eklenen bacak zaten yeni kayıttır (kendi yolunda yazılır).
  const tipDegisti = ekranBacaklari.some((b, i) => {
    const k = kayitSirasi(i);
    return k != null && ucusBacagiMi(i)
      && (b?.operation_type || '') !== (ilkBacakTipi((head.sectors || [])[k]).operation_type || '');
  });
  // Pencerenin ve önizlemenin YEDEK tipi (bacaklar tipsizse) — tek tipliyse o, değilse kayıttaki.
  const varsayilanTip = (tipler.length === 1 ? tipler[0] : null) || head.operation_type || 'air_taxi';
  const setBacakTipi = (i, v) => {
    // `tipElle`: bu EDIT'te değiştirildi. `opSrc` kayıttaki kaynaktır — ASSIGN orada da 'manual' yazar, işaret ayrı tutulur.
    const yaz = (dizi) => dizi.map((b, j) => (j === i ? { ...b, operation_type: v, tipElle: true } : b));
    if (isActual) setGercek(yaz); else setLegs(yaz);
  };
  // Md.27 EĞİTİM TÜRÜ PİLOT BAŞINA (5 Eki 2026, Serkan: *"öğrenci 4 saat limiti öğretmene uygulanmamalı"*) — ekip anahtarı →
  // tür, kayıttaki değerle başlar; seçilmeden kayıt yok (planlı ve uçulmuş). 🔴 Önce EDIT türü göstermiyordu bile.
  const [egitimTurleri, setEgitimTurleri] = useState(() => Object.fromEntries(group.rows.map(r => [r.id, r.training_kind || ''])));
  // Görevin kendi kural seti kopyasında şirket esası seçiliyse Md.27 yok — tür sorulmaz (31 Eki 2026, Serkan B).
  const egitimliEdit = head.duty_type === 'flight' && tipler.includes('training')
    && !esasSecili(effectiveRules(head.ruleset_snapshot || null).rules);
  // Planin ne dedigini GOSTER (sihirbazdaki ile ayni sorgu, ayni eslesme):
  // atama plandan ONCE yapildiysa sihirbaz air_taxi varsayilaninda kalir ve
  // hata ancak burada fark edilir. Neye gore duzelttigi gorunmeli (Ilke 1).
  // 21 Eki 2026 (Serkan A): yalnız AYNI GÜNÜN planı — tek kaynak `ayniGunPlani` (ucusPlani.js); okunamadı ≠ yok.
  // 25 Eki 2026: BACAK BACAK (ASSIGN gibi) — eskiden ilk kalkış → son varış aranıyordu; çok bacaklı görevde (LTAC→…→LTAC)
  // hiçbir planla eşleşmezdi. Sorgu yalnız rota/tarih değişince yenilenir (tip değişince değil).
  const [planSonuclari, setPlanSonuclari] = useState([]);
  const rotaAnahtari = ekranBacaklari.map((b, i) => `${ucusBacagiMi(i) ? 1 : 0}:${b?.dep || ''}-${b?.dest || ''}`).join('|');
  useEffect(() => {
    let dead = false;
    (async () => {
      const r = await Promise.all(rotaAnahtari.split('|').map((s) => {
        const [ucus, rota] = s.split(':');
        const [dep, dest] = (rota || '').split('-');
        if (ucus !== '1' || !dep || dep.length !== 4 || !dest || dest.length !== 4 || !date) return null;
        return ayniGunPlani({ dep, dest, tarih: date, customerId: head.customer_id });
      }));
      if (!dead) setPlanSonuclari(r);
    })();
    return () => { dead = true; };
  }, [rotaAnahtari, date, head.customer_id]);
  // Bacağın kayda gidecek tip KAYNAĞI: elle değiştiyse planına göre ("manual correction …" — arşiv bunu insan kararı sayar,
  // ezmez), değişmediyse kayıttaki.
  const bacakKaynagi = (i, sektor) => {
    const b = ekranBacaklari[i];
    if (b?.tipElle) return elleDuzeltmeKaynagi(planSonuclari[i], b.operation_type);
    return sektor?.operation_type_source ?? (b?.opSrc || null);
  };
  /** Ekrandaki bacağın tip alanları (DH'de ve tipsizde boş). */
  const bacakTipAlani = (i, sektor) => (ucusBacagiMi(i) && bacakTipleri[i]
    ? { operation_type: bacakTipleri[i], operation_type_source: bacakKaynagi(i, sektor) } : {});
  // Bacak bacak plan notları — ASSIGN'ın notlarıyla aynı biçim; uyuşmazlık da yazılır (eski tek satırın "DOES NOT MATCH"i).
  const planNotlari = ekranBacaklari.flatMap((b, i) => {
    const r = planSonuclari[i];
    if (!r || !ucusBacagiMi(i)) return [];
    if (['okunamadi', 'belirsiz'].includes(r.durum)) return [`SECTOR ${i + 1}: ${r.metin}`];
    if (r.durum === 'var' && r.plan?.operation_type && r.plan.operation_type !== b?.operation_type) {
      return [`SECTOR ${i + 1}: DOES NOT MATCH FLIGHT PLAN — plan says ${opLabel(r.plan.operation_type)}`
        + `${r.plan.operation_type_source ? ` (${r.plan.operation_type_source})` : ''}`];
    }
    return [];
  });
  // ── SKPK (Md.12) — SKPK bir PLANLAMA araci degil, OLMUS BITMIS bir olayin
  // kaydidir ("gorev baslangici SONRASINDA baslayan ongorulemeyen haller").
  // Bu yuzden yalniz planned OLMAYAN gorevlerde acilir.
  const skpkAllowed = head.status !== 'planned' || gercekGiris;
  const [skpkExt, setSkpkExt] = useState(() => fmtMin(head.skpk_fdp_extension_min || 0) === '—' ? '' : (head.skpk_fdp_extension_min ? fmtMin(head.skpk_fdp_extension_min) : ''));
  const [skpkRed, setSkpkRed] = useState(() => head.skpk_rest_reduction_min ? fmtMin(head.skpk_rest_reduction_min) : '');
  const [skpkReason, setSkpkReason] = useState(head.skpk_reason || '');
  // Komutan raporu SKPK girilince zorunlu (kayıttaki kapıyla aynı koşul) — alanın rengi ve alt satırı bunu izler.
  const skpkGirildi = (toMin(skpkExt) || 0) > 0 || (toMin(skpkRed) || 0) > 0;
  // Uçuş içi dinlenme olanağı (Md.11(1)(4), 4 Eki 2026) — kayıttaki beyan; CRZ CPT varken zorunlu, değişirse iz yazılır.
  const [dinlenme, setDinlenme] = useState(head.inflight_rest_facility || '');
  // CRZ aynı kalıp yalnız beyan değişse de azami UGS değişir (uzatma yalnız 'in_use') — tavan yeniden kurulur, iz yazılır.
  const dinlenmeDegisti = head.duty_type === 'flight'
    && (ucPilotYeni ? (dinlenme || null) : null) !== (head.inflight_rest_facility ?? null);
  // İz satırında azami UGS değişiminin SEBEBİ — gerçekleşmiş ve planlı görevde aynı cümle.
  const ekipMetni = (uc, dort) => (dort ? '4-pilot augmented crew (two CRZ CPT)'
    : uc ? '3-pilot augmented crew (one CRZ CPT)' : 'standard crew (no CRZ CPT)');
  const tavanSebebi = () => (ucPilotDegisti
    ? `crew ${ekipMetni(ucPilotEski, dortPilotEski)} → ${ekipMetni(ucPilotYeni, dortPilotYeni)}, SHT-FTL/HG Md.11`
    : dinlenmeDegisti
      ? `in-flight rest facility ${({ in_use: 'IN USE', not_in_use: 'NOT IN USE' })[dinlenme] || 'not set'}, SHT-FTL/HG Md.11(1)(4)`
      : `split duty rest place ${konaklama || 'not set'}, SHT-FTL/HG Md.15`);

  const snapshotRuleset = head.ruleset_snapshot || null;
  const timeOk = (t) => /^\d{2}:\d{2}$/.test(t || '');
  // Faaliyet tipi gorevin KENDI kaydindan gelir (Md.9) — snapshot ile birlikte
  // gorevin yazildigi andaki kural evreni korunur. Opsiyonlar TEK KAYNAK:
  // ortak pencere ve pilot-bazli (nobet kisaltmali) pencere ayni sette kurulur.
  // 🔴 27 AGU 2026 — DUZENLEME YOLUNDA UZUN MENZIL HIC YOKTU: ne Md.22(3)
  // UGS tavani ne Md.16(3) dinlenmesi. Atama dogru hesaplasa bile ilk
  // duzenlemede kayboluyordu. Olcu Md.4(ee)'ye gore gorevde ugranan BUTUN
  // meydanlarin dilim araligidir.
  // 🔑 30 Eyl 2026 (B2-3): burada yalnız meydan dilimleri OKUNUR; ölçü motorda
  //    (`uzunMenzilOlcumu`) — görevin tarihinde, rapor ve görev sonunda, büyük olan,
  //    kesir yukarı, eşik kural setinden. `null` = henüz okunmadı.
  const [tzEdit, setTzEdit] = useState(null);
  useEffect(() => {
    const icaos = [...new Set(legs.flatMap(l => [l.dep, l.dest])
      .filter(x => x && x.length === 4).map(x => x.toUpperCase()))];
    if (!icaos.length) { setTzEdit({}); return; }
    let dead = false;
    (async () => { const m = await fetchTzMap(icaos); if (!dead) setTzEdit(m); })();
    return () => { dead = true; };
  }, [legs]);

  const winOptsTemel = useMemo(() => ({
    // Artırılmış ekip (Md.11): herhangi bir bacakta CRZ CPT varsa.
    threePilot: ucPilotYeni,
    fourPilot: dortPilotYeni,   // aynı bacakta iki CRZ (5 Eki 2026)
    inflightRest: ucPilotYeni ? (dinlenme || null) : null,
    operationType: varsayilanTip,   // yalnız yedek — bacaklar kendi tipini taşır, pencere yöneticiyi onlardan bulur (25 Eki 2026)
    // Eğitim türü pilot başına (`egitimTurleri`), aynı gün teori kayıttan (Md.27(1)(ç), sunucu) — ortak pencerede ikisi de yok.
    singlePilot: crew.length === 1,
  }), [crew, varsayilanTip, ucPilotYeni, dortPilotYeni, dinlenme]);
  const editKurallari = useMemo(() => effectiveRules(snapshotRuleset).rules, [snapshotRuleset]);
  const umEdit = useMemo(() => uzunMenzilOlcumu(legs, tzEdit || {}, editKurallari,
      gorevAnlari(legs, konaklama, snapshotRuleset, winOptsTemel, date)),
    [legs, tzEdit, editKurallari, konaklama, snapshotRuleset, winOptsTemel, date]);
  // Md.22(3): uzun menzilde standart ekipte tablo, kural setindeki sınırla (`uzunMenzilTabani`).
  const winOpts = useMemo(() => ({ ...winOptsTemel, longRange: umEdit.uzunMenzil === true }),
    [winOptsTemel, umEdit.uzunMenzil]);
  // BANT SAATİ İÇİN MEYDAN DİLİMİ (Md.22/2): saatler UTC girildiği için Tablo 1
  // doğrudan UTC ile okunamaz. Görev İNTİBAK ETTİĞİ meydanı kaydında taşıyor
  // (`acclimatised_to`); yoksa kalkış meydanı kullanılır.
  const [bandTz, setBandTz] = useState(null);
  const bandIcao = (head.acclimatised_to || legs[0]?.dep || '').toUpperCase();
  useEffect(() => {
    if (!bandIcao || bandIcao.length !== 4) { setBandTz(null); return; }
    let dead = false;
    (async () => { const m = await fetchTzMap([bandIcao]); if (!dead) setBandTz(m?.[bandIcao] || null); })();
    return () => { dead = true; };
  }, [bandIcao]);

  const win = useMemo(() => {
    if (isActual || !snapshotRuleset) return null;
    const complete = legs.filter(l => timeOk(l.etd) && timeOk(l.eta));
    if (complete.length !== legs.length || !legs.length) return null;
    const w0 = dutyWindow(legs, konaklama, snapshotRuleset, winOpts);
    if (!w0 || !bandTz) return w0;                  // dilim yoksa bant UYDURULMAZ
    const ref = utcISO(date, legs[0]?.etd) || new Date().toISOString();
    const band = bandReportHHMM(w0.report, 0, tzOffsetMin(bandTz, new Date(ref).getTime()));
    return band ? dutyWindow(legs, konaklama, snapshotRuleset,
                             { ...winOpts, bandReport: band, acclimatisedTo: bandIcao }) : w0;
  }, [legs, snapshotRuleset, isActual, konaklama, winOpts, bandTz, bandIcao, date]);

  // ── GERÇEKLEŞMİŞ GÖREVDE TİP DEĞİŞİRSE NE OLUR (19 Eyl 2026) ──────
  //
  // 🔑 Serkan: *"Edit ekranı edit edebilmeli. Eğer yeni veri motorda bir kural
  //    setine takılırsa uyarı verecek, edit edilmez diyecek, sebebini de
  //    verecek."*
  //
  // Faaliyet tipi AZAMİ UGS TABLOSUNU seçer (Md.22 hava taksi · Md.25 genel
  // havacılık · Md.26 hava işi · Md.27 eğitim). Gerçekleşmiş bir görevin tipini
  // düzeltmek, o görevin tavanını da değiştirir — görev yasaldan **aşımlıya**
  // (ya da tersine) dönebilir. Bu SESSİZCE olmaz: sonucu kaydetmeden önce,
  // PİLOT PİLOT yazarız.
  //
  // ⚠️ Ölçü `win` DEĞİL: `win` gerçekleşmiş görevde bilerek `null`dur (4 Eyl —
  //    yoksa uçmuş görev için hiçbir şey ölçülemezdi). Burada KAYITLI sektörler
  //    ve KAYITLI rapor saati kullanılır. İkinci bir formül YAZILMAZ; aynı
  //    `dutyWindow` çağrılır (İlke 3).
  //
  // ⚠️ Aşım çıkması kaydı ENGELLEMEZ. Uçuş olmuştur; doğru tip yazılınca aşım
  //    GÖRÜNÜR hale gelir — gizlenmesi değil görünmesi doğrudur (İlke 1,
  //    4 Eyl kararı: gerçekleşmiş görev bir KAYITtır). Engellenen tek şey,
  //    beyanın kendisinin mevzuat tavanını delmesidir (SKPK'daki gibi).
  //
  // 🔑 29 Eyl 2026 — EKİP DE TAVANI SEÇER: CRZ CPT eklenince (ya da kalkınca)
  //    Md.11 artırılmış ekip uzatması devreye girer/çıkar. Aynı ölçü, aynı
  //    panel: tip ya da ekip değiştiyse sonuç pilot pilot yazılır. Eskiden
  //    burada `threePilot` HİÇ geçilmiyordu — 3 pilotlu gerçekleşmiş bir
  //    görevin tipi düzeltilince artırılmış ekip uzatması sessizce düşerdi.
  // 🔑 TEK MOTOR (3 Eki 2026, adım 1b): eski → yeni azami UGS artık SUNUCUNUN yazacağı değerdir
  //    (`duzenlemeOnizlemesi` → `zincirHesabi`): önceki görev, intibak ve bant (Md.22), uzun menzil, ekip — hepsi aynı.
  // 🔴 ÖNCESİ: burada `dutyWindow` bant saati VERİLMEDEN çağrılıyordu → Tablo 1 UTC ile okunuyordu. 10 Eyl LTAC→LTBA:
  //    rapor 12:05Z (yerel 15:05) → doğrusu 12:30, ekran ve kayıt 13:30 (1 saat gevşek). Sunucu 3 Eki'de düzeltti.
  // Dilimler (görevin ve pilotların zincirindeki meydanlar) gelmeden ölçü yok — yanlış "ölçülemedi" gösterilmez.
  const onizlemePilotlari = useMemo(() => [...new Set([...(group.rows || []).map(r => r.pilot_id),
    ...crew.map(c => c.pilot)].filter(Boolean))], [group.rows, crew]);
  const onizlemeKodlari = useMemo(() => {
    const k = new Set();
    const ekle = (x) => { if (x && String(x).length === 4) k.add(String(x).toUpperCase()); };
    (duties || []).filter(d => onizlemePilotlari.includes(d.pilot_id) && d.status !== 'cancelled').forEach(d => {
      (d.sectors || []).forEach(x => { ekle(x.dep); ekle(x.dest); ekle(x.actual_dest); });
      ekle(d.acclimatised_to);
    });
    (head.sectors || []).forEach(x => { ekle(x.dep); ekle(x.dest); });
    (gercek || []).forEach(g => { ekle(g?.dep); ekle(g?.dest); });
    legs.forEach(l => { ekle(l.dep); ekle(l.dest); });
    return [...k].sort().join(',');
  }, [duties, onizlemePilotlari, head.sectors, gercek, legs]);
  const [onizlemeTz, setOnizlemeTz] = useState(null);
  useEffect(() => {
    if (!onizlemeKodlari) { setOnizlemeTz({}); return; }
    let dead = false;
    (async () => { const m = await fetchTzMap(onizlemeKodlari.split(',')); if (!dead) setOnizlemeTz(m || {}); })();
    return () => { dead = true; };
  }, [onizlemeKodlari]);

  const actualOpEtkisi = useMemo(() => {
    if (!isActual || !(tipDegisti || ucPilotDegisti || konaklamaDegisti || dinlenmeDegisti) || !snapshotRuleset) return null;
    const sektorler = (head.sectors || []).filter(x => !x.deadhead);
    if (!sektorler.length || !onizlemeTz) return null;
    // Kaydedildikten SONRAKİ satır: gerçek saatler (gerçek planı ezer), BACAKLARIN tipi, dinlenme yeri, tarih. Tip bacak
    // başına (25 Eki 2026) — eskiden tek tip bütün bacaklara yazılıyor, karışık görev "düzleştirme" uyarısı veriyordu.
    // Görevin yönetici tipini motor bacaklardan bulur; satırdaki tip yalnız yedek.
    const kaydedilecek = (r) => ({ ...r, duty_date: date || r.duty_date, accommodation: konaklama,
      inflight_rest_facility: ucPilotYeni ? (dinlenme || null) : null,
      ...(tipDegisti ? { operation_type: varsayilanTip } : {}),
      sectors: satirSektorleri(r.sectors || head.sectors || []).map((x, i) => ({ ...x,
        off_block: gercek[i]?.off_block || x.off_block || null, on_block: gercek[i]?.on_block || x.on_block || null,
        ...(tipDegisti && !x.deadhead && bacakTipleri[i] ? { operation_type: bacakTipleri[i] } : {}) })) });
    // Yeni eklenen CRZ'nin henüz kaydı yok — ekibin ortak saatleriyle ölçülür (geçici kimlik).
    const uyeler = [...group.rows.map(r => ({ r, key: r.id, yeni: false })),
      ...yeniUyeler.map(u => ({ r: { ...head, id: `yeni:${u.key}`, pilot_id: u.pilot, acclimatised_to: null,
                                     max_fdp_minutes: null, fdp_minutes: null }, key: u.key, yeni: true }))];
    const o = duzenlemeOnizlemesi({ satirlar: uyeler.map(u => kaydedilecek(u.r)), tumGorevler: duties || [],
      tz: onizlemeTz, anaUslar: homeBases || {},
      baslangic: [head.duty_date, date].filter(Boolean).sort()[0] || null,
      ekipDuzenlenen: { tekPilot: crew.filter(c => c.pilot).length === 1, ucPilot: ucPilotYeni, dortPilot: dortPilotYeni } });
    const satirlar = uyeler.map(({ r, key, yeni }) => {
      const h = o[r.id];
      const yeniMax = h?.alanlar?.max_fdp_minutes ?? null;
      const fdp = h?.alanlar?.fdp_minutes ?? (yeni ? null : (r.fdp_minutes ?? null));
      return { r, key, yeni, eskiMax: yeni ? null : (r.max_fdp_minutes ?? null), yeniMax, fdp,
               eksik: h ? h.eksik : ['not computed'],
               asiyorEski: !yeni && r.max_fdp_minutes != null && r.fdp_minutes != null && r.fdp_minutes > r.max_fdp_minutes,
               asiyorYeni: yeniMax != null && fdp != null && fdp > yeniMax };
    });
    // Yönetici tip — sunucunun motorunun yazacağı (ilk üyenin; bacaklar ekipte ortak).
    return { satirlar, yeniTip: o[uyeler[0]?.r?.id]?.alanlar?.operation_type ?? null,
             olculemeyen: satirlar.some(x => x.yeniMax == null || x.eksik.length),
             olculemeyenSebep: [...new Set(satirlar.flatMap(x => x.eksik))],
             ekipDegisti: ucPilotDegisti, konaklamaDegisti, dinlenmeDegisti };
  }, [isActual, tipDegisti, ucPilotDegisti, ucPilotYeni, dortPilotYeni, konaklamaDegisti, konaklama, dinlenmeDegisti, satirSektorleri,
      dinlenme, gercek, date, crew, bacakTipleri, varsayilanTip,
      yeniUyeler, snapshotRuleset, head, group.rows, duties, onizlemeTz, homeBases]);

  // ── PLANLI GÖREV — TEK MOTOR ÖNİZLEMESİ (3 Eki 2026, adım 1b-i) ───────────────────────────────────────
  // Kapı (`editFit`) ve ekrandaki REPORT / FDP / MAX satırı pilot başına buradan: sunucunun kaydedince yazacağı değer
  // (`duzenlemeOnizlemesi` → `zincirHesabi`). Eskiden tek ortak pencere (`win`) bandı kayıttaki `acclimatised_to` ile
  // okuyordu; nöbet ayrıca hesaplanıyordu. Kayıtta girilen gerçek saatler (RECORD AS FLOWN) varsa onlar ezer.
  const planliOnizleme = useMemo(() => {
    if (isActual || !snapshotRuleset || !onizlemeTz || head.duty_type !== 'flight') return null;
    if (!legs.length || !legs.every(l => l.dep && l.dest && timeOk(l.etd) && timeOk(l.eta))) return null;
    const sektorler = legs.map((l, i) => {
      const k = l._kaynak;   // kaynak sırası — araya eklenen bacakta yok (5 Eki 2026)
      const eski = k != null ? ((head.sectors || [])[k] || {}) : {};
      const g = k != null ? gercek[k] : null;
      return { ...eski, dep: String(l.dep).toUpperCase(), dest: String(l.dest).toUpperCase(), etd: l.etd, eta: l.eta,
               off_block: g?.off_block || eski.off_block || null, on_block: g?.on_block || eski.on_block || null,
               operation_type: l.operation_type || eski.operation_type || varsayilanTip };   // bacağın kendi tipi (25 Eki 2026)
    });
    const uyeler = crew.filter(c => c.pilot).map(c => {
      const r = (group.rows || []).find(x => x.id === c.rowId) || null;
      const taban = r || { ...head, id: `yeni:${c.key}`, acclimatised_to: null, max_fdp_minutes: null };
      return { c, satir: { ...taban, pilot_id: c.pilot, duty_date: date || taban.duty_date, accommodation: konaklama,
                           inflight_rest_facility: ucPilotYeni ? (dinlenme || null) : null,
                           ...(egitimliEdit ? { training_kind: egitimTurleri[c.key] || null } : {}),
                           operation_type: varsayilanTip, sectors: sektorler } };
    });
    if (!uyeler.length) return null;
    const o = duzenlemeOnizlemesi({ satirlar: uyeler.map(u => u.satir), tumGorevler: duties || [], tz: onizlemeTz,
      anaUslar: homeBases || {}, baslangic: [head.duty_date, date].filter(Boolean).sort()[0] || null,
      ekipDuzenlenen: { tekPilot: uyeler.length === 1, ucPilot: ucPilotYeni, dortPilot: dortPilotYeni } });
    return Object.fromEntries(uyeler.map(u => [u.c.key, o[u.satir.id] || null]));
  }, [isActual, snapshotRuleset, onizlemeTz, head, legs, gercek, varsayilanTip, crew, group.rows, date,
      konaklama, duties, homeBases, ucPilotYeni, dortPilotYeni, dinlenme, egitimliEdit, egitimTurleri]);
  // Önizleme hazır değilken (dilimler yükleniyor) planlı görev kaydedilmez — kapı eski sayıyla karar vermesin.
  const onizlemeBekliyor = !isActual && head.duty_type === 'flight' && !!win && !planliOnizleme;

  // GÖREVİN YÖNETİCİ TİPİ (25 Eki 2026) — seçilmez, bacaklardan çıkar: planlıda pencerenin (`win`), uçulmuşta tip
  // değiştiyse sunucunun motorunun (önizleme), değişmediyse kayıttakinin söylediği. Açık mesai, SKPK ve kayıt bunu okur.
  const opType = !isActual ? (win?.operationType || varsayilanTip)
    : (tipDegisti ? (actualOpEtkisi?.yeniTip || varsayilanTip) : (head.operation_type || varsayilanTip));

  // ── AÇIK MESAİ — EKRANDAKİ SONUÇ (29 Eyl 2026) ───────────────────────────
  // Planlı görevde pencerenin (`win`) hesabı; gerçekleşmiş görevde GERÇEK
  // on/off-block'lardan, aynı kural (`gorevAcikMesai`) — gerçek planı ezer.
  const editSplit = useMemo(() => {
    if (head.duty_type !== 'flight') return null;
    if (!isActual) return win?.split || null;
    if (!snapshotRuleset) return null;
    const { rules } = effectiveRules(snapshotRuleset);
    const sek = aktifSektorler.map((x, i) => ({ ...x,
      off_block: gercek[i]?.off_block || null, on_block: gercek[i]?.on_block || null }));
    return gorevAcikMesai(sek, konaklama, rules, opType,
      { gercek: true, ucPilot: ucPilotYeni, dortPilot: dortPilotYeni, dinlenmeOlanagi: ucPilotYeni ? (dinlenme || null) : null });
  }, [head.duty_type, aktifSektorler, isActual, win, snapshotRuleset, gercek, konaklama, opType, ucPilotYeni, dortPilotYeni,
      dinlenme]);

  // ── DUZENLEME AYNI KAPIDAN GECER (4 Eyl 2026, Serkan onayi) ────────
  //
  // 🔴 OLCULDU: bu modal 600 satirdi ve icinde TEK BIR yasallik kontrolu
  //    yoktu — `fitness` 0 · `daysOffSummary` 0 · `offDayRelease` 0. FDP'yi
  //    ve azami UGS'yi yeniden hesaplayip KAYDEDIYOR, ekranda "EXCEEDED"
  //    yazisini gosteriyor, ama hicbir seyi engellemiyordu. Yani atama
  //    ekranindan yapilamayan sey DUZENLEYEREK yapilabiliyordu: gorevi bos
  //    gunun ustune kaydirmak, dinlenmenin icine sokmak, cakistirmak,
  //    kumulatif limiti asmak.
  //
  // 🔑 Serkan: *"Rostering yapildiginda VE GUNCELLEME YAPTIGINDA uyari
  //    vermesi lazim."* Ayri bir kontrol YAZILMAZ; atama ekraninin cagirdigi
  //    `fitness` cagrilir (Ilke 3) — duzenlenen satir `excludeId` ile disarida
  //    birakilir, yoksa gorev KENDISIYLE cakisir.
  //
  // PLANLI / GERCEKLESMIS AYRIMI (Serkan onayi): planli gorevi duzenlemek
  // hala PLANLAMADIR → atama ile ayni kapi, ENGELLER. Gerceklesmis gorev bir
  // KAYITTIR, ucus olmustur → engellenmez, gerekceler gosterilir (gerekce
  // yazmak zaten her duzenlemede zorunlu).
  const editFit = useMemo(() => {
    if (!ruleset || !date) return [];
    const w = win;
    // Gerceklesmis gorevde `win` BILEREK null'dir (pencere yeniden
    // hesaplanmaz) — o zaman KAYITLI saatlere duseriz. Yoksa ucus olmus bir
    // gorev icin hicbir sey olculemez ve ekran sessiz kalirdi (Ilke 1).
    const reportISO = w?.report ? utcISO(date, w.report) : (head.report_time || null);
    const dutyEndISO = w?.report && w?.dutyMin && reportISO
      ? new Date(new Date(reportISO).getTime() + w.dutyMin * 60000).toISOString()
      : (head.duty_end || null);
    return crew.filter(c => c.pilot).map(c => {
      const mine = (duties || []).filter(d => d.pilot_id === c.pilot);
      // 🔑 30 Eyl 2026 (B3): düzenlenen görevin dinlenme bitişi — sonraki görevi
      //    deliyorsa planlıda ENGEL, uçulmuşta KIRMIZI uyarı (RECORDED DESPITE).
      //    Planlıda pencereden ve kayıttaki karar noktasından (`restForDuty`),
      //    uçulmuşta satırın KAYITLI dinlenme bitişi.
      const satir = (group.rows || []).find(r => r.id === c.rowId);
      // Md.16(3)(b) rotasyon (4 Eki 2026) — sunucuyla aynı fonksiyon; önceki görevlerin dilimleri önizleme haritasından.
      const atBaseEnr = endedAtBase(legs[legs.length - 1]?.dest, homeBases?.[c.pilot]);
      const rotEnr = w?.dutyMin && dutyEndISO && !umEdit.olculemedi && atBaseEnr && umEdit.uzunMenzil !== true
        ? rotasyondaUzunMenzil({ id: c.rowId, sectors: legs }, mine, { anaUs: homeBases?.[c.pilot] || null,
            tz: { ...(onizlemeTz || {}), ...(tzEdit || {}) }, raporISO: reportISO }) : null;
      const restEnr = w?.dutyMin && dutyEndISO && !umEdit.olculemedi && !(rotEnr && rotEnr.uzunMenzil == null)
        ? restForDuty({ dutyMin: w.dutyMin, atBase: atBaseEnr,
            longRange: umEdit.uzunMenzil === true, rotasyonUzunMenzil: rotEnr?.uzunMenzil === true,
            dutyEndISO, arrivalTz: umEdit.varisTz, rules: editKurallari }).restMin
        : null;
      const enr = restEnr != null ? addMin(dutyEndISO, restEnr)
        : (w ? null : (satir?.earliest_next_report || head.earliest_next_report || null));
      // 1b-i (3 Eki 2026): planlı görevde rapor / bitiş / dinlenme bitişi TEK MOTOR önizlemesinden, pilot başına.
      const on = !isActual ? planliOnizleme?.[c.key]?.alanlar : null;
      const pRapor = on?.report_time || reportISO;
      const pBitis = on?.duty_end || dutyEndISO;
      const pDutyMin = on?.report_time && on?.duty_end
        ? Math.round((new Date(on.duty_end) - new Date(on.report_time)) / 60000) : (w?.dutyMin || null);
      const pEnr = on ? (on.earliest_next_report || null) : enr;
      const f = fitness({
        pilot: pilots.find(p => p.id === c.pilot) || { id: c.pilot },
        baseline: baselines[c.pilot] || null,
        duties: mine, ruleset,
        tzMap: { ...(onizlemeTz || {}), ...(tzEdit || {}) }, homeBase: homeBases?.[c.pilot] || null,   // Md.16 ⑥
        newDuty: { reportISO: pRapor, sectors: legs, dutyMin: pDutyMin,
                   dutyDate: date, dutyEndISO: pBitis, earliestNextReportISO: pEnr },
        asOf: pRapor ? new Date(pRapor) : new Date(),
        // 🔑 Duzenlenen satir disarida: kendisiyle cakismasin.
        excludeId: c.rowId, offTypes,
        // 🔴 21 EYL 2026 — DILIM BURAYA HIC GECILMIYORDU. Md.5 bos gun olcumu
        //    `zonedISO`'nun eski yedek kuraliyla MAKINENIN dilimine dusuyordu:
        //    ayni gorev ASSIGN ekraninda pilotun ana ussune, EDIT modalinda
        //    tarayiciya gore olculuyordu. 4 Eyl'de "EDIT ayni kapidan gecer"
        //    denmisti; kapinin dilim ayagi eksik kalmis (Ilke 3).
        tz: (pilotDilim || {})[c.pilot]?.tz || null,
      });
      const p = pilots.find(x => x.id === c.pilot);
      // 🔑 Serkan 3 Eki 2026 "A": planlı görevde azami UGS aşımı KURAL İHLALİDİR (nöbet indirimi dahil).
      // Bağlı yer görevi (ofis / ders / simülatör) UGS'yi başlattıysa sebep de söylenir — sunucunun cümlesi (5 Eki 2026).
      const bagliId = !isActual ? planliOnizleme?.[c.key]?.aciklama?.sim?.id : null;
      const bagliNot = bagliId ? baglantiNotu((duties || []).find(d => d.id === bagliId)) : '';
      const ekler = on?.fdp_exceeded
        ? [{ metin: planliAsimMetni(on.fdp_minutes, on.max_fdp_minutes) + bagliNot, ref: maxFdpKunyesi(hesapTuru(on.operation_type, editKurallari)) }] : [];
      // Md.27 (5 Eki 2026, Serkan A): eğitim uçuş süresi sınırı da — metin ve künye sunucunun gerekçesinden (önizleme).
      (on?.ftl_gerekce || []).filter(g => EGITIM_ENGEL_TURLERI.includes(g.tur)).forEach(g => ekler.push({ metin: g.metin, ref: g.ref }));
      if (!isActual && egitimliEdit && !egitimTurleri[c.key]) ekler.push({ metin: EGITIM_TURU_SECILMEDI, ref: 'SHT-FTL/HG Md.27(1)' });
      // TİP YETKİSİ (21 Eki 2026, K2) — ASSIGN ile aynı kural (`roller.tipYetkisiEngelleri`). Planlıda sektör tescilleri formdan,
      // uçulmuşta kayıttan; ayrım yukarıdaki kuralla aynı: planlıda kaydı durdurur, uçulmuşta görünür ama durdurmaz (4 Eyl).
      if (p && head.duty_type === 'flight') {
        tipYetkisiEngelleri(p, isActual ? aktifSektorler : legs, aircraft, tipVasiflari).forEach(m => ekler.push({ metin: m, ref: null }));
      }
      if (ekler.length) {
        return { code: p?.code || '—', ...f, legal: false, reasons: [...(f.reasons || []), ...ekler.map(e => e.metin)],
                 kunyeli: [...kunyeliYaDuz(f), ...ekler] };
      }
      return { code: p?.code || '—', ...f };
    });
  }, [ruleset, baselines, offTypes, crew, duties, pilots, legs, win, date, pilotDilim, planliOnizleme, isActual,
      egitimTurleri, egitimliEdit,
      head.report_time, head.duty_end, head.earliest_next_report, group.rows, umEdit, editKurallari, homeBases,
      onizlemeTz, tzEdit, aircraft, tipVasiflari, aktifSektorler, head.duty_type]);

  // GORUNURLUK ile ENGELLEME ayri: gerceklesmis gorevde gerekceler GORUNUR
  // ama kaydi durdurmaz. Ikisini tek listeye baglamak, ucus olmus bir gorevin
  // gerekcelerini de gizliyordu (4 Eyl, testte yakalandi).
  const editUygunsuz = editFit.filter(f => !f.legal);
  const editEngeller = isActual ? [] : editUygunsuz;
  const editUyarilar = editFit.filter(f => (f.warnings || []).length);

  // ── EKİP DÜZEYİ KAPILAR EDIT'TE DE (29 Eyl 2026) ─────────────────────────
  // ASSIGN ile AYNI fonksiyon (`ekipKapilari`). Planlı görevde engeller
  // (düzenlemek hâlâ planlamadır), gerçekleşmiş görevde GÖRÜNÜR ama engellemez
  // — 4 Eyl kuralı, yukarıdaki `editEngeller` ile aynı ayrım.
  // FCL.060(a)(3) CRZ yakınlığı meydan dilimi ister (uzun menzil ölçüsü);
  // CRZ olan pilotların görev meydanlarının dilimi çekilir.
  const crzPilotlari = useMemo(() => crzUyeleri(roller)
    .map(k => crew.find(c => c.key === k)?.pilot).filter(Boolean), [roller, crew]);
  const [crzTz, setCrzTz] = useState({});
  useEffect(() => {
    if (!crzPilotlari.length) return;
    const refs = new Set();
    (duties || []).filter(d => crzPilotlari.includes(d.pilot_id)).forEach(d => {
      (d.sectors || []).forEach(x => [x.dep, x.dest, x.actual_dest]
        .forEach(a => a && refs.add(String(a).toUpperCase())));
    });
    if (!refs.size) return;
    let dead = false;
    (async () => { const m = await fetchTzMap([...refs]); if (!dead) setCrzTz(m || {}); })();
    return () => { dead = true; };
  }, [crzPilotlari, duties]);
  const ekipKapisi = useMemo(() => ekipKapilari({
    pilotlar: crew.map(c => pilots.find(p => p.id === c.pilot)).filter(Boolean),
    lisansMed, duties, crzPilotlar: crzPilotlari, tzMap: crzTz,
  }), [crew, pilots, lisansMed, duties, crzPilotlari, crzTz]);
  const ekipEngeller = isActual ? [] : ekipKapisi.gerekceler;

  /** Bir pilotun bu gorev icin NOBET durumu (Md.17) — gorevin KENDI snapshot'iyla.
   *  EDIT'te iki yoldan gerekir: (1) saat/sektor degisti, (2) PILOT DEGISTI.
   *  (2) ozellikle onemli: nobette beklemis bir pilot yerine gecirildiginde
   *  azami UGS sessizce eski degerde kalirsa gorev yasadisi hale gelir. */
  const standbyFor = (pilotId, dutyDate, reportISO) => {
    if (!snapshotRuleset || !win) return { pWin: win, sb: null, sbDuty: null };
    const { rules } = effectiveRules(snapshotRuleset);
    const sbDuty = standbyBefore(duties, pilotId, dutyDate, reportISO);
    const sbEffect = sbDuty
      // Md.17(e): 6→8 saat YALNIZ UGS gerçekten uzatıldıysa.
      ? standbyEffect(sbDuty, rules, { fdpExtended: !!(win.split.extensionMin > 0 || win.augmented), cagriISO: reportISO })
      : null;
    const pWin = sbEffect?.fdpReductionMin
      ? dutyWindow(legs, konaklama, snapshotRuleset,
                   { ...winOpts, standbyReductionMin: sbEffect.fdpReductionMin })
      : win;
    return { pWin, sb: sbEffect ? standbyLimits(sbEffect, pWin.fdpMin) : null, sbDuty };
  };

  // ── SKPK (Md.12) — pilot bazli ────────────────────────────────────
  // TABAN DEGERLER HER ZAMAN GERI ALINARAK bulunur: kayittaki max_fdp ve
  // min_rest onceki bir SKPK'nin etkisini ZATEN icerebilir. Uzerine tekrar
  // eklersek ayni SKPK iki kez uygulanir (duzenleme her acildiginda buyur).
  // Bu yuzden: taban = kayitli deger EKSI kayitli SKPK etkisi. Idempotent.
  const skpkFor = (row) => {
    if (!snapshotRuleset || !skpkAllowed) return null;
    const { rules } = effectiveRules(snapshotRuleset);
    // Eğitimde SKPK azami UGS'ye hiç eklenmez (Md.27(1)(b), 5 Eki 2026) — tabandan da çıkarılmaz.
    const ugsUzatmaz = !skpkUgsUzatirMi(opType);
    const baseMaxFdp = row.max_fdp_minutes != null
      ? row.max_fdp_minutes - (ugsUzatmaz ? 0 : (row.skpk_fdp_extension_min || 0)) : null;
    const baseEarnedRest = row.min_rest_minutes != null
      ? row.min_rest_minutes - 2 * (row.skpk_rest_reduction_min || 0) : null;
    // Gerceklesen UGS: rapor → son ON BLOCK. Md.12(1)(c)(2) "GERCEKLESTIRILEN
    // UGS'nin artirilmasi" der — plan degil, OLAN.
    // 🔴 SAAT DİLİMİ DÜZELTMESİ (18 Eyl 2026 — saha).
    //    Buradaki eski yorum *"on_block YEREL HH:MM dizgesidir"* diyordu ve
    //    rapor saatini görevin diliminde yerelleştiriyordu. **Varsayım
    //    yanlıştı:** bu modülün her saati UTC'dir — ekranın kendi başlığı
    //    `ACTUAL TIMES — UTC, HH:MM`, modül başlığı `ALL TIMES UTC`.
    //    Sonuç: yerel rapor, UTC on_block ile karşılaştırılıyordu. LTBA (+03)
    //    16 Eyl görevinde rapor 06:00 UTC → 09:00 yerel sanıldı, on_block
    //    07:50 UTC geride kaldı, "ertesi gün" sayıldı ve **FDP 22:50** çıktı.
    //    Sunucu aynı görevde 110 dk (1:50) diyordu; aşım YOKTU.
    // ⚠️ Zararı gürültü değildi: ekran olmayan bir aşım gösterip **SKPK
    //    teklif ediyordu**. Kabul edilse, yaşanmamış bir komutan takdiri
    //    kayda geçecek ve Md.12/1/c/1-2 bildirim yükümlülüğü doğuracaktı.
    //    Yanlış alarm da tehlikelidir (İlke 1).
    //    Artık karşılaştırma TEK ÇERÇEVEDE: ikisi de UTC. `report_tz` bu
    //    hesapta gerekmez, o yüzden tz'si olmayan görevde de öneri çalışır.
    const lastOn = (row.sectors || []).slice(-1)[0]?.on_block;
    const repUtcHHMM = row.report_time
      ? new Date(row.report_time).toISOString().slice(11, 16) : null;
    const actualFdpMin = (repUtcHHMM && lastOn)
      ? spanMin(repUtcHHMM, lastOn) : (row.fdp_minutes ?? null);
    const prev = previousDuty(duties, row.pilot_id, row.report_time, row.id);
    const skpk = skpkLimits(
      { fdpExtensionMin: toMin(skpkExt) || 0, restReductionMin: toMin(skpkRed) || 0 },
      rules,
      // Ekip artırılmış mı — bütün ekip için TEK cevap (ekrandaki ekip; Md.12(1)(a), Serkan 4 Eki 2026 A). Eskiden
      // pilotun kendi satırındaki CRZ rolüne bakıyordu: CRZ'ye +3:00, PF/PM'e +2:00.
      { augmented: !!ucPilotYeni, ugsUzatmaz,
        baseMaxFdpMin: baseMaxFdp, fdpMin: actualFdpMin,
        earnedRestMin: baseEarnedRest,
        prevMinRestMin: prev?.min_rest_minutes ?? null,
        // Gerçekte alınan dinlenme — Md.12(1)(c)(2) "gerçekleştirilen kısaltma" (4 Eki 2026).
        actualRestMin: prev?.duty_end && row.report_time
          ? Math.round((Date.parse(row.report_time) - Date.parse(prev.duty_end)) / 60000) : null,
        prevHadSkpkExtension: (prev?.skpk_fdp_extension_min || 0) > 0,
        dutyEndISO: row.duty_end });
    return { skpk, prev, baseMaxFdp, baseEarnedRest, actualFdpMin, ugsUzatmaz };
  };

  const nameOf = (pid) => { const x = pilots.find(p => p.id === pid); return x ? (x.code || x.full_name) : '—'; };
  const setLeg = (i, k, v) => setLegs(ls => ls.map((l, j) => j === i ? { ...l, [k]: v } : l));
  // Bacak eklenip silinince roller de BİRLİKTE kayar — yoksa bir bacağın rolü
  // komşusuna geçerdi. Yeni bacak son uçuş bacağının rollerini alır.
  // 5 Eki 2026: bacak `i`'nin ARKASINA girer ("+ ADD"); rolleri üstündeki bacaktan (yoksa son uçuş bacağı).
  const bacakEkle = (i = legs.length - 1) => {
    setLegs(ls => arayaKoy(ls, i, { dep: ls[i]?.dest || '', dest: ls[i + 1]?.dep || '', etd:'', eta:'', reg: ls[i]?.reg || '', _kaynak: null,
                                    operation_type: ls[i]?.operation_type || varsayilanTip, opSrc: '', tipElle: true }));
    setRoller(rs => {
      const ust = rs[i] || [...rs].reverse().find(Boolean);
      return arayaKoy(rs, i, ust ? { ...ust } : Object.fromEntries(crew.map((c, k) => [c.key, k === 0 ? 'PF' : 'PM'])));
    });
  };
  // Uçulmuş göreve araya bacak — `i`'nin ARKASINA; kalkış/varış komşulardan, rolleri üstteki bacaktan (5 Eki 2026).
  const gercekBacakEkle = (i) => {
    const ust = aktifSektorler[i] || {}, alt = aktifSektorler[i + 1] || {};
    const dep = inilenMeydan(ust, i) || gercek[i]?.dest || ust.dest || '';   // divert'te inilen meydandan kalkılır
    const dest = gercek[i + 1]?.dep || alt.dep || '';
    // Tip üstteki bacaktan (25 Eki 2026: ekranda seçilen) — satırın sonunda değiştirilebilir.
    const tip = gercek[i]?.operation_type || ust.operation_type || varsayilanTip;
    const yeni = { dep, dest, operation_type: tip, eklendi: true };
    const anahtar = newUuid();
    setAkt(a => arayaKoy(a, i, { kaynak: null, yeni, anahtar }));
    setGercek(g => arayaKoy(g, i, { dep, dest, divert: false, landed: '',
                                     off_block: '', takeoff_time: '', landing_time: '', on_block: '',
                                     operation_type: tip, opSrc: '', tipElle: true }));
    setKagitInis(k => arayaKoy([...k], i, undefined));
    setRoller(rs => arayaKoy(rs, i, rs[i] ? { ...rs[i] } : Object.fromEntries(crew.map((c, k) => [c.key, k === 0 ? 'PF' : 'PM']))));
  };
  /** Uçulmuş bacağın dört saati zorunlu mu — kapılar: dört zaman (`ucusZamanlariEksigi`, yeni / kâğıt bacak), kâğıt kayıt
   *  (`kagitOfpEksigi`) ve arşiv düzeltmesi ("a flight flown with the iPad keeps all four times"). Üçü de gerçekleşmiş uçuş
   *  görevinin DH olmayan her bacağını kapsar; zorunlu alan rengi bunu okur (5 Eki 2026). */
  const saatZorunlu = (i) => head.duty_type === 'flight' && (gercekGiris || isActual)
    && !!aktifSektorler[i] && !aktifSektorler[i].deadhead;
  /** DIVERT düğmesi: yalnız UÇULMUŞ (ya da uçuldu diye kaydedilen) görevin elle girilen (iPad'e bağlı olmayan) uçuş bacağı. */
  const divertAcilabilir = (i) => saatZorunlu(i) && !arsivliBacak(aktifSektorler[i]);
  /** İnilen meydan geçerli mi — 4 harf ve planlanandan FARKLI (planlandığı yere inen divert olamaz). Kapı ve renk aynı ölçü. */
  const inilenGecerli = (i) => /^[A-Z]{4}$/.test(String(gercek[i]?.landed || ''))
    && gercek[i].landed !== (gercek[i]?.dest || aktifSektorler[i]?.dest);
  /** Yalnız araya eklenen (henüz kaydedilmemiş) bacak kaldırılır — kayıtlı bacak burada silinmez. */
  const gercekBacakSil = (i) => {
    if (akt[i]?.kaynak != null) return;
    const at = (d) => [...d].filter((_, j) => j !== i);
    setAkt(at); setGercek(at); setKagitInis(at); setRoller(at);
  };
  const bacakSil = (i) => {
    if (legs.length <= 1) return;
    setLegs(ls => ls.filter((_, j) => j !== i));
    setRoller(rs => rs.filter((_, j) => j !== i));
  };
  // Rol tablosunun satırları: planlı görevde düzenlenen bacaklar, gerçekleşmiş
  // görevde kayıtlı bacaklar (rota düzeltmesi etiketlere yansır).
  const rolSektorleri = isActual
    ? aktifSektorler.map((x, i) => ({ ...x, dep: gercek[i]?.dep || x.dep, dest: gercek[i]?.dest || x.dest,
                                      actual_dest: inilenMeydan(x, i) }))
    : legs.map(l => ({ ...l, deadhead: l._kaynak != null && !!(head.sectors || [])[l._kaynak]?.deadhead }));
  // 9 Agu (Serkan): "pilotlarin 3'u de gorunsun". Eskiden baska satirda
  // kullanilan pilot listeden DUSURULUYORDU — 3 kisilik filoda 2 kisilik ekipte
  // her hucrede yalniz 2 isim cikiyor, ucuncusu hic gorunmuyordu. Artik hepsi
  // listelenir; zaten atanmis birini secerseniz iki pilot TAKAS edilir, boylece
  // mukerrer atama da olusmaz.
  const options = () => pilots.filter(ucusEkibindenMi);

  /** Bir satira pilot secildiginde: o pilot BASKA satirdaysa ikisini takasla.
   *  Rol degistirmenin en kolay yolu da bu — PF/PM'i el ile ters cevirmek yerine
   *  isimleri degistirmek yeter. */
  const pickPilot = (i, pid) => setCrew(cs => {
    const j = cs.findIndex((x, k) => k !== i && x.pilot === pid);
    return cs.map((x, k) => {
      if (k === i) return { ...x, pilot: pid };
      if (k === j) return { ...x, pilot: cs[i].pilot };   // takas
      return x;
    });
  });

  const save = async () => {
    if (!gerekceTamam(reason)) { toast(gerekceIpucuMetni(reason), 'error'); return; }
    if (head.duty_type === 'flight' && ucPilotYeni && !dinlenme) {
      toast('Choose the IN-FLIGHT REST FACILITY: IN USE or NOT IN USE (SHT-FTL/HG Md.11(1)).', 'error'); return;
    }
    // Md.27 (5 Eki 2026, Serkan A): eğitim türü her pilot için seçilmeden kayıt yok — planlıda da uçulmuşta da (sınır ondan).
    if (egitimliEdit) {
      const turYok = crew.filter(c => c.pilot && !egitimTurleri[c.key]).map(c => nameOf(c.pilot));
      if (turYok.length) { toast(`${EGITIM_TURU_SECILMEDI}: ${turYok.join(', ')} — choose it in CREW.`, 'error'); return; }
    }
    // Planli gorevde yasallik kapisi — gerceklesmis gorevde YOK (ucus olmustur,
    // kayit duzeltmek engellenmez; gerekce zaten zorunlu).
    // 30 Eyl 2026 (adım ①): ASSIGN ile AYNI kural ihlali kartı. İhlal varken
    // SAVE zaten kapalı; bu iki kapı yedektir, ama düz metin biçimi kalmasın.
    if (editEngeller.length) {
      const b = pilotIhlalBildirimi(editEngeller.map(f => ({ kim: f.code, kaynak: f })));
      toast(b.mesaj, 'error', b.detay);
      return;
    }
    if (ekipEngeller.length) {
      toast('This crew cannot fly together — the reasons are listed below.', 'error',
            ihlalDetayi(ekipKapisi.kunyeli.map(k => ({ metin: k.metin, ref: k.ref, neYapmali: NE_YAPMALI.ekip }))));
      return;
    }
    // ── UÇULMUŞ BACAK: DÖRT ZAMAN ZORUNLU (2 Eki 2026, Serkan: "off block take off land on blok girilmek zorunda") ──
    // 🔴 ÖNCESİ: yalnız RECORD AS FLOWN modunda ve yalnız OFF/ON blok; T/O–LND boş geçiyordu → havada süre yok →
    //    uçak/motor saatine girmiyordu. Kural motorda (`ucusZamanlariEksigi`). Arşivden gelen uçuşta saatlerin sahibi
    //    arşivdir (iPad End Flt dördünü zorunlu tutar) — burada ölçülmez.
    // 5 Eki 2026: araya eklenen bacak arşivli görevde de dört zamanı ister (elle girilen kâğıt bacağıdır).
    if (head.duty_type === 'flight' && (gercekGiris || isActual) && (!arsivVar || yeniBacakVar)) {
      const eksik = ucusZamanlariEksigi(aktifSektorler.map((x, i) => ({ ...(gercek[i] || {}), dep: x.dep, dest: x.dest,
                                                                       deadhead: x.deadhead || (arsivVar && akt[i].kaynak != null) })));
      if (eksik.length) { toast(`A flown sector needs all four times — ${eksik.join(' · ')}`, 'error'); return; }
    }
    if (siraHatasi) { toast(`SECTOR TIMES OVERLAP — ${siraHatasi}`, 'error'); return; }
    // DIVERT (5 Eki 2026): açılmışsa inilen meydan zorunlu ve planlanandan farklı olmalı.
    const divertEksik = aktifSektorler.flatMap((x, i) => {
      const g = gercek[i] || {};
      if (!divertAcilabilir(i) || !g.divert || inilenGecerli(i)) return [];
      const ad = `Sector ${i + 1} ${g.dep || x.dep}-${g.dest || x.dest}`;
      return [/^[A-Z]{4}$/.test(String(g.landed || ''))
        ? `${ad}: LANDED AT is the planned arrival — that is not a divert; remove DIVERT (✕)`
        : `${ad}: LANDED AT missing (4-letter ICAO)`];
    });
    if (divertEksik.length) { toast(`DIVERT — ${divertEksik.join(' · ')}`, 'error'); return; }
    // Araya eklenen bacak elle girilmiştir → kâğıt OFP ile uçulmuştur; işaret yoksa uçak saatine hiç girmezdi (5 Eki 2026).
    if (yeniBacakVar && !paperOfp) {
      toast('A sector added to a flown duty was flown on a paper OFP — tick PAPER OFP and choose the aircraft, '
            + 'or it would never reach aircraft and engine hours.', 'error'); return;
    }
    // ── AÇIK MESAİ CEVABI ZORUNLU (29 Eyl 2026, Md.15) ─────────────────────
    if (editSplit?.isSplit && editSplit.cevapGerekli) {
      toast('SPLIT DUTY — choose where the break is taken (HOTEL or ON AIRCRAFT) before saving (SHT-FTL/HG Md.15).', 'error');
      return;
    }
    // ── EKİP KAPILARI (29 Eyl 2026) — eksik ADIYLA söylenir ────────────────
    if (head.duty_type === 'flight') {
      const rolHatalari = rolSektorleri.map((s, i) => {
        if (s?.deadhead || !roller[i]) return null;
        const e = bacakHatasi(roller[i]);
        return e ? `${s?.dep || '?'}-${s?.dest || '?'}: ${e}` : null;
      }).filter(Boolean);
      if (rolHatalari.length) { toast(`CREW ROLES — ${rolHatalari.join(' · ')}`, 'error'); return; }
      if (ucuncuMod === 'crz' && !ucPilotYeni) {
        toast('CRZ CPT is on — pick the 3rd pilot, or close the box.', 'error'); return;
      }
      if (ucuncuMod === 'crz' && crzSlot) {
        toast('A 4th pilot is being added — pick the CRZ CPT from the list, or close the list (✕).', 'error'); return;
      }
      if (ucuncuMod === 'checkride' && !examiner.trim()) {
        toast('Enter TRE/TRI name for the check ride.', 'error'); return;
      }
      // Yeni satır atamaya `assignment_id` ile bağlanır; bağ yoksa satır
      // yetim kalır ve ekipte görünmez — eklemeyiz, söyleriz.
      if (yeniUyeler.length && !head.assignment_id) {
        toast('This duty has no assignment link — a crew member cannot be added to it.', 'error'); return;
      }
    }
    setSaving(true);
    try {
      const edits = [];
      const updates = [];
      // EDIT'te eklenen CRZ'nin satırı — iz ve güncellemeden SONRA eklenir.
      const yeniSatirlar = [];
      // Her üyenin kayda giden SON sektörleri — kâğıt OFP ekibi bundan okunur.
      const sonSektorler = {};
      let tzWarn = null, chainWarn = [];

      // — SAATLER / SEKTORLER (yalniz planned) —
      let reportISO = head.report_time, endISO = head.duty_end;
      const sectorsChanged = !isActual &&
        JSON.stringify(legs) !== JSON.stringify((head.sectors || []).map(x => ({ dep:x.dep||'', dest:x.dest||'', etd:x.etd||'', eta:x.eta||'' })));
      const dateChanged = !isActual && date !== head.duty_date;
      // Gerçek saatler AYRI durumda tutulur; `sectorsChanged`in JSON
      // karşılaştırması bozulmasın (o yalnız planlanan alanlara bakar).
      const gercekIlk = gercekBos();
      // Ekrandaki sırayla hizalı ilk değerler — araya eklenen bacağın ilk değeri yok (5 Eki 2026).
      const ilkAkt = akt.map(a => (a.kaynak != null ? gercekIlk[a.kaynak] : null));
      // "Gerçekleşti" modunda saatler her durumda yazılır: OPEN görevde arşivden
      // dolu gelen saatler DEĞİŞMEMİŞ görünür ama görev ancak onlarla kapanır.
      // Bacak tipi (25 Eki 2026) aynı nesnede durur ama SAAT değildir — yalnız tipi değişen bacak "saati elle girildi"
      // sayılmaz, saat yolu da çalışmaz. Tip kendi bloğunda yazılır (`tipDegisti`).
      const gercekChanged = gercekGiris || JSON.stringify(gercek.map(saatKismi)) !== JSON.stringify(ilkAkt.map(saatKismi));
      // ── TEK SAHİP 2. ADIM (5 Eki 2026, Serkan): iPad uçuşunda (arşivi olan bacak) düzeltilen saat ARŞİVE de yazılır —
      //    ARCHIVED FLTS'in yoluyla (gerekçeli istemci + admin_edits izi + rapor yeniden üretimi). Uçak saatleri, FTL ve rapor
      //    aynı değeri gösterir; önce yalnız görev değişiyor, sonraki yeniden üretim onu arşivin saatine geri çekiyordu.
      const arsivDuz = gercekChanged
        ? arsivSaatDuzeltmeleri({ sektorler: aktifSektorler, yeni: gercek, ilk: ilkAkt, ucuslar, tarih: date }) : [];
      const arsivEksik = arsivDuz.filter(a => a.eksik.length || !a.afId);
      if (arsivEksik.length) {
        toast(`${arsivEksik.map(a => a.rota).join(', ')}: a flight flown with the iPad keeps all four times (OFF BLOCK, T/O, `
              + 'LND, ON BLOCK) — correct them, they cannot be emptied. Nothing was saved.', 'error');
        setSaving(false); return;
      }
      // Sektör sayısı başın görevine uymayan ekip satırına saat YAZILMAZ —
      // hangi bacağa hangi saatin gittiği belirsizdir; adıyla söylenir
      // (eski "gerçekleşti mi?" penceresinin kuralı, 8 Eyl).
      const sektorUyumsuzlar = [];
      // ── GERÇEKLEŞMİŞ GÖREVDE TARİH DÜZELTMESİ (18 Eyl 2026) ────────────
      // 🔑 Serkan: *"burada tarih seçilemiyor, saatler güncellenir ama tarih
      //    güncellenemez"* — 16 Eylül'e girilen görev aslında 17 Eylül'dü ve
      //    arayüzden düzeltmenin yolu yoktu.
      // ⚠️ ARŞİV UÇUŞUNA BAĞLIYSA KİLİTLİ: o eşleşmede tek kaynak uçuştur;
      //    görevin tarihini tek başına oynatmak ikisini ayırır. Bağlı kaydın
      //    tarihi uçuş üzerinden düzeltilir.
      const tarihDegistiActual = isActual && !planaBagli && date !== head.duty_date;
      // Planlı görevde ekip büyüyüp küçülünce (CRZ) pencere YENİDEN kurulur:
      // artırılmış ekip azami UGS'yi değiştirir (Md.11) ve yeni pilotun satırı
      // aynı hesaptan doğar — ikinci bir formül yazılmaz (İlke 3).
      const pencereKur = sectorsChanged || dateChanged
        || (!isActual && (ucPilotDegisti || konaklamaDegisti || dinlenmeDegisti));
      if (pencereKur) {
        if (!win) { toast('Complete all sector fields.', 'error'); setSaving(false); return; }
        if (legs.some(l => !l.dep || !l.dest)) { toast('DEP/DEST required.', 'error'); setSaving(false); return; }
        // TESCİL ZORUNLU (21 Eki 2026, K2) — ASSIGN ile aynı cümle; 21 Eki'den önceki planlı görevde de düzenlerken seçilir.
        const tescilsiz = legs.map((l, i) => (l.reg ? null : `${i + 1} ${l.dep || '?'}→${l.dest || '?'}`)).filter(Boolean);
        if (tescilsiz.length) {
          toast(`AIRCRAFT missing — sector ${tescilsiz.join(', ')}. Choose the registration: the type rating and the minimum crew come from it.`, 'error');
          setSaving(false); return;
        }
        // SAATLER UTC (Serkan ilkesi): mutlaklastirma duz. Uzun menzil TEK
        // ölçüden (B2-3); ölçülemezse kayıt durur — "değil" sayılmaz.
        if (!tzEdit || umEdit.olculemedi) {
          toast(dilimOkunamadiMetni(umEdit.eksik, umEdit.kuralEksik), 'error'); setSaving(false); return;
        }
        reportISO = utcISO(date, win.report);
        const lastEta = legs[legs.length - 1].eta;
        const crossesMidnight = toMin(lastEta) < toMin(win.report);
        const endDate = crossesMidnight ? nextDay(date) : date;
        // 4 Eki 2026: pencerenin kendi uçuş sonrası süresi (Md.10, `bildirimSureleri`) — eskiden ham kural setinden yanlış adla
        // okunup hep 30'a düşüyordu.
        endISO = addMin(utcISO(endDate, lastEta), win.postFlightMin);
        if (umEdit.uzunMenzil) tzWarn = uzunMenzilUyarisi(umEdit.farkSaat);
      }

      // — FAALIYET TIPI (Md.9). Nitelik azami UGS tablosunu sectigi icin
      //   max_fdp_minutes de yeniden yazilir; yoksa nitelik duzelir ama limit
      //   eski tabloda kalirdi.
      // 🔴 19 EYL 2026: `&& !isActual` KALKTI. Gerçekleşmiş görevde tip
      //    düzeltilemiyordu; sistem MATCH REVIEW ile uyumsuzluğu söyleyip
      //    düzeltmeye izin vermiyordu. Azami UGS gerçekleşmiş görevde
      //    `actualOpEtkisi`den gelir (`win` orada bilerek null).
      // 🔴 29 EYL 2026 — TİPLİ SEKTÖRLER AŞAĞIDA TABAN OLUR. Bu blok sektörlerin
      //    tipini hemen yazıyordu; ama aşağıdaki saat/rol blokları sektörleri
      //    ESKİ kayıttan (`row.sectors`) yeniden kurup üzerine yazıyordu — aynı
      //    kayıtta tip + saat değişince bacakların tipi sessizce eskiye
      //    dönüyordu. Artık aşağıdaki her blok bu diziden başlar.
      const tipliSektorler = {};
      if (tipDegisti) {
        // 🔑 25 Eki 2026: tip BACAK BAŞINA yazılır — her bacak ekranda seçileni alır, ötekiler kayıttaki tipinde kalır
        //    (eskiden tek tip bütün bacaklara yazılıyordu; planlıda hiç yazılmıyordu). DH tipsizdir (Md.14/1/b).
        // Kayıttaki k'inci bacağın ekrandaki yeri — araya eklenen bacak sırayı kaydırır (5 Eki 2026 kuralı).
        const ekranYeri = (k) => (isActual ? akt.findIndex(a => a.kaynak === k) : legs.findIndex(l => l._kaynak === k));
        const tipOzeti = (ss, yedek) => (ss || []).filter(x => !x?.deadhead)
          .map(x => `${x.dep || '?'}-${x.dest || '?'} ${x.operation_type || yedek || '—'}`).join(' · ');
        // Satırdaki tip görevin YÖNETİCİSİ (motor da aynısını yazar); kaynağı karışıkta kural, tek tipte bacağınki.
        const ilkUcus = bacakTipleri.findIndex(Boolean);
        const gorevKaynagi = tipler.length > 1
          ? `mixed duty — most restrictive applies (${tipler.join(' + ')})`
          : (ilkUcus >= 0 ? bacakKaynagi(ilkUcus, null) : null);
        for (const r of group.rows) {
          const etki = actualOpEtkisi?.satirlar.find(x => x.r.id === r.id);
          const upd = { operation_type: opType, operation_type_source: gorevKaynagi };
          if ((r.sectors || []).length) {
            upd.sectors = r.sectors.map((x, k) => {
              if (x?.deadhead) return x;
              const i = ekranYeri(k);
              return i < 0 ? x : { ...x, ...bacakTipAlani(i, x) };
            });
            tipliSektorler[r.id] = upd.sectors;
          }
          const yeniMax = isActual ? etki?.yeniMax : win?.maxFdpMin;
          if (yeniMax != null) {
            upd.max_fdp_minutes = yeniMax;
            // Aşım bayrağı da tazelenir; yoksa tip düzelir ama satır eski
            // yargıyı taşırdı (27 Ağu "takılı kalan dinlenme" dersi).
            if (r.fdp_minutes != null) upd.fdp_exceeded = r.fdp_minutes > yeniMax;
          }
          // ── TİP DE İZDEN SONRA, ÖTEKİLERLE BİRLİKTE YAZILIR (2 Eki 2026) ──────────────────
          // 🔴 ÖNCESİ: tip burada HEMEN yazılıyordu, izi ise en sonda. Arada beş ret kapısı var (SKPK kaptan
          //    raporu · meydan dilimi · kural sınırı · kâğıt OFP eksiği · iz yazma hatası): biri reddedince
          //    ekran "kaydedilmedi" diyor ama TİP DEĞİŞMİŞ KALIYOR, kimin neden değiştirdiği hiçbir yerde
          //    yazmıyordu. Üstelik bu yazma dönen satıra bakmıyordu (İlke 2 — RLS 0 satırda hata vermez).
          // Sonraki bloklar veritabanını yeniden OKUMAZ (tipli bacaklar `tipliSektorler`den) — erken yazmaya
          // ihtiyaç duyan yok. Listeye AYNI sırada girer: aynı satırın sonraki yazmaları üstüne yazar, kayıt
          // bugünküyle aynı çıkar; yazma da öbürleri gibi dönen satırla doğrulanır.
          updates.push({ id: r.id, pilot: r.pilot_id, upd });
          edits.push({
            duty_id: r.id, customer_id: r.customer_id, pilot_id: r.pilot_id,
            assignment_id: r.assignment_id || null, edit_type: 'EDIT',
            field_name: 'operation_type',
            old_value: tipOzeti(r.sectors, r.operation_type), new_value: tipOzeti(upd.sectors || r.sectors, opType),
            reason: reason.trim(), edited_by: myProfile?.id ?? null,
          });
        }
      }

      // ── MATCH REVIEW, ELLE DÜZENLENİNCE DÜŞER (19 Eyl 2026) ──────────
      //
      // 🔑 Serkan: *"Artık elle edit edildiği için remark kalkmalı; mantık
      //    bunu gerektirir."*
      //
      // 🔑 BAYRAĞIN ANLAMI: *"bu satıra bir insan baksın"*, *"veri yanlış"*
      //    DEĞİL. `archive-flight` onu dört sebeple kaldırıyor (tip uyuşmazlığı
      //    ×2 · belirsiz eşleşme · kapanmış göreve gelen uçuş) ve hepsinin
      //    notu aynı şeyi ister: AÇ, BAK, KARAR VER. Bir insan açıp GEREKÇEYLE
      //    kaydettiyse o iş yapılmıştır.
      //
      // 🔴 ÖNCEKİ HAL: bayrağı kaldıran tek yol AYRI bir "resolve" kutusuydu.
      //    Sebebi düzeltiyordun (10 Eyl: GENERAL_AVIATION → AIR_TAXI, plan
      //    zaten AIR_TAXI diyordu) ama kırmızı rozet duruyordu — düzeltilmiş
      //    veriyle çelişen bir uyarı. 22 Ağu'da *"kapatılamayan uyarı,
      //    bakılmayan uyarıya dönüşür"* demiştik; bu onun ikiz kardeşi.
      //
      // ⚠️ SESSİZ DEĞİL: kalkış `ftl_duty_edits`e YAZILIR, gerekçesiyle.
      //    Denetçi *"bu REVIEW hangi düzenlemeyle, neden kapandı"* sorusunun
      //    cevabını izde bulur. Aynı desen `resolveReview` ile birebir.
      for (const r of group.rows) {
        if (!r.match_review) continue;
        edits.push({
          duty_id: r.id, customer_id: r.customer_id, pilot_id: r.pilot_id,
          assignment_id: r.assignment_id || null, edit_type: 'EDIT',
          field_name: 'match_review', old_value: 'true', new_value: 'false',
          reason: `Match review cleared by manual edit: ${reason.trim()}`,
          edited_by: myProfile?.id ?? null,
        });
        // Not da temizlenir: bayrak kalkinca aciklama YALAN bir cumle olarak
        // kalirdi (`resolveReview` ile ayni kural).
        updates.push({ id: r.id, pilot: r.pilot_id, upd: { match_review: false, match_review_note: null } });
      }

      // Regulasyon TAVANLARI (nobet Md.17 / SKPK Md.12) — delinirse yazma YOK.
      const blocked = [];
      // Meydan dilimleri kayıt boyunca bir kez okunur — ekipte rota ortaktır
      // (30 Eyl 2026 · B2-1: RECORD AS FLOWN dinlenmesi uzun menzili ölçer).
      const tzOnbellek = {};
      const tzAl = async (sektorler) => {
        const kodlar = [...new Set(sektorler.flatMap(x => [x.dep, x.actual_dest ?? x.dest])
          .filter(Boolean).map(x => String(x).toUpperCase()))];
        const yok = kodlar.filter(k => !(k in tzOnbellek));
        if (yok.length) Object.assign(tzOnbellek, (await fetchTzMap(yok)) || {});   // okunamazsa eksik kalır → NOT SAVED
        return tzOnbellek;
      };
      const dilimYok = [];
      // Yeni eklenen CRZ'nin henüz satırı yok: atamanın ORTAK alanları başın
      // satırından kopyalanır; pilota özgü olanlar (nöbet, intibak) boş başlar
      // ve aşağıdaki AYNI bloklarda o pilot için hesaplanır (İlke 3).
      const KOPYALANAN = ['assignment_id', 'customer_id', 'ruleset_id', 'ruleset_snapshot',
        'duty_date', 'report_tz', 'status', 'duty_finished', 'duty_type', 'operation_type',
        'operation_type_source', 'training_kind', 'same_day_theory', 'report_time', 'duty_end',
        'ad_hoc_airports', 'split_duty', 'break_minutes', 'accommodation', 'max_fdp_minutes',
        'fdp_minutes', 'fdp_exceeded', 'check_ride', 'external_examiner',
        'skpk_fdp_extension_min', 'skpk_rest_reduction_min', 'skpk_reason', 'skpk_reported_at',
        'skpk_ref', 'skpk_authority_due', 'min_rest_minutes', 'earliest_next_report',
        'mandatory_report_due'];
      const yeniSatirTaban = (pid) => {
        const t = { id: null };
        KOPYALANAN.forEach(k => { if (head[k] !== undefined) t[k] = head[k]; });
        return { ...t, pilot_id: pid,
                 ...(tipDegisti ? { operation_type: opType } : {}),
                 sectors: tipliSektorler[head.id] || head.sectors || [],
                 standby_reduction_min: null, standby_duty_id: null, standby_ref: null,
                 acclimatised_to: null };
      };
      const rolDizisi = (s) => (s || []).filter(x => !x?.deadhead)
        .map(x => String(x?.role || '')).join('|');
      for (const c of crew) {
        const row = c.yeni ? yeniSatirTaban(c.pilot) : group.rows.find(r => r.id === c.rowId);
        // İz: mevcut üyede alan alan · yeni üyede TEK satır ('crew_added', aşağıda)
        // — onun her alanı "yok → var" olurdu ve iz gürültüye boğulurdu.
        const iz = c.yeni ? [] : edits;
        // Sektörlerin TABANI: tip bloğu yazdıysa o dizi, yoksa kayıt.
        const tabanSektorler = tipliSektorler[row.id] || row.sectors || [];
        const upd = {};
        // ── ARTIRILMIŞ EKİP, GERÇEKLEŞMİŞ GÖREVDE (29 Eyl 2026) ─────────────
        // CRZ eklendi/kalktı → azami UGS Md.11'e göre yeniden okunur; sonuç
        // kaydetmeden ÖNCE ekranda pilot pilot yazıyor (`actualOpEtkisi`).
        // Aşağıdaki saat bloğu aşım bayrağını bu tavanla kurar — önce bu.
        // 29 Eyl 2026: açık mesai dinlenme yeri değişince de (Md.15) aynı ölçü.
        if (isActual && (ucPilotDegisti || konaklamaDegisti || dinlenmeDegisti)) {
          const e = actualOpEtkisi?.satirlar.find(x => x.key === c.key);
          if (e?.yeniMax != null) {
            upd.max_fdp_minutes = e.yeniMax;
            if (row.fdp_minutes != null) upd.fdp_exceeded = row.fdp_minutes > e.yeniMax;
            if (e.yeniMax !== row.max_fdp_minutes) {
              iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
                assignment_id: row.assignment_id || null, edit_type: 'EDIT',
                field_name: 'max_fdp (crew)',
                old_value: fmtMin(row.max_fdp_minutes), new_value: fmtMin(e.yeniMax),
                reason: `${reason.trim()} — ${tavanSebebi()}`,
                edited_by: myProfile?.id ?? null });
            }
          }
        }
        // ── AÇIK MESAİ DİNLENME YERİ İZİ (29 Eyl 2026) ─────────────────────
        if (head.duty_type === 'flight' && (konaklama ?? null) !== (row.accommodation ?? null)) {
          upd.accommodation = konaklama;
          iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
            assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'accommodation',
            old_value: row.accommodation ?? 'none', new_value: konaklama ?? 'none',
            reason: `${reason.trim()} — split duty rest place (SHT-FTL/HG Md.15)`,
            edited_by: myProfile?.id ?? null });
        }
        // ── UÇUŞ İÇİ DİNLENME OLANAĞI İZİ (Md.11(1)(4), 4 Eki 2026) — CRZ kalkarsa beyan da kalkar ───────
        {
          const dinlenmeYeni = head.duty_type === 'flight' && ucPilotYeni ? (dinlenme || null) : null;
          if (head.duty_type === 'flight' && dinlenmeYeni !== (row.inflight_rest_facility ?? null)) {
            upd.inflight_rest_facility = dinlenmeYeni;
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'inflight_rest_facility',
              old_value: row.inflight_rest_facility ?? 'none', new_value: dinlenmeYeni ?? 'none',
              reason: `${reason.trim()} — in-flight rest facility (SHT-FTL/HG Md.11(1)(4))`,
              edited_by: myProfile?.id ?? null });
          }
        }
        // ── EĞİTİM TÜRÜ PİLOT BAŞINA (Md.27, 5 Eki 2026, Serkan A) — değiştiyse yazılır, iz düşer ───────────
        if (egitimliEdit && (egitimTurleri[c.key] || null) !== (row.training_kind ?? null)) {
          upd.training_kind = egitimTurleri[c.key] || null;
          iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
            assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'training_kind',
            old_value: row.training_kind ?? 'none', new_value: upd.training_kind ?? 'none',
            reason: `${reason.trim()} — training kind (SHT-FTL/HG Md.27(1))`, edited_by: myProfile?.id ?? null });
        }
        // ── CHECK RIDE (29 Eyl 2026) — EDIT'te de açılır/kapanır ────────────
        {
          const checkYeni = ucuncuMod === 'checkride';
          const denetciYeni = checkYeni ? examiner.trim().toUpperCase() : null;
          if (head.duty_type === 'flight'
              && (checkYeni !== !!row.check_ride
                  || (denetciYeni || null) !== (row.external_examiner || null))) {
            upd.check_ride = checkYeni;
            upd.external_examiner = denetciYeni;
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT',
              field_name: 'check_ride',
              old_value: row.check_ride ? `CHECK RIDE — TRE/TRI ${row.external_examiner || '?'}` : 'none',
              new_value: checkYeni ? `CHECK RIDE — TRE/TRI ${denetciYeni}` : 'none',
              reason: reason.trim(), edited_by: myProfile?.id ?? null });
          }
        }
        // ── TANIMSIZ MEYDAN BEYANI (21 Eyl 2026) ────────────────────────
        // Beyan DEGISTIYSE yazilir; degismediyse gereksiz yere dokunulmaz.
        // Kullanilmayan beyan temizlenir: kisi yanlis yazip beyan etmis, sonra
        // duzeltmis olabilir — olu beyan kayitta kalirsa denetimde "buraya da
        // ucruldu" sanilir (Ilke 1).
        {
          const kullanilan = new Set([
            ...legs.flatMap(l => [l.dep, l.dest]),
            ...Object.values(gercek || {}).flatMap(g => [g?.dep, g?.dest]),
          ].filter(Boolean).map(x => String(x).toUpperCase()));
          const temiz = Object.fromEntries(
            Object.entries(adHoc).filter(([k]) => kullanilan.has(k)));
          const yeniBeyan = Object.keys(temiz).length ? temiz : null;
          if (JSON.stringify(yeniBeyan) !== JSON.stringify(row.ad_hoc_airports ?? null)) {
            upd.ad_hoc_airports = yeniBeyan;
            // 🔴 29 Eyl 2026: anahtar `field` idi — tabloda böyle bir sütun yok
            //    (`field_name`), iz yazımı bu satır yüzünden BÜTÜNÜYLE düşüyor
            //    ve düzenleme kaydedilemiyordu.
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT',
              field_name: 'ad_hoc_airports',
              old_value: JSON.stringify(row.ad_hoc_airports ?? null),
              new_value: JSON.stringify(yeniBeyan),
              reason: `${reason} (aerodrome declaration)`, edited_by: myProfile?.id ?? null });
          }
        }
        const crewChanged = c.pilot !== c.oldPilot;
        // Rol değişimi artık bacak başına ve döngünün SONUNDA uygulanır
        // (`rolleriUygula`) — 6 Eyl'in "yalnız PF↔PM değişince No changes"
        // kusuru orada da kapalı kalır: rol dizisi değiştiyse yazılır.
        if (crewChanged) {
          upd.pilot_id = c.pilot;
          iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.oldPilot,
            assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'crew',
            old_value: nameOf(c.oldPilot), new_value: nameOf(c.pilot),
            reason: reason.trim(), edited_by: myProfile?.id ?? null });
        }
        // NOBET (Md.17) — pilot bazli. Saat/sektor DEGISMESE BILE pilot degistiyse
        // yeniden cozulur: yeni pilotun nobeti varsa azami UGS onun icin kisadir.
        const { pWin, sb, sbDuty } = (!isActual && win && (pencereKur || crewChanged))
          ? standbyFor(c.pilot, date, reportISO)
          : { pWin: win, sb: null, sbDuty: null };
        if (sb && !sb.ok) blocked.push(...kunyeliYaDuz(sb).map(k => ({ kim: nameOf(c.pilot),
          metin: k.metin, ref: k.ref, neYapmali: NE_YAPMALI.pilot })));
        if (!isActual && crewChanged && !pencereKur && win) {
          // Yalniz ekip degisti: saatler ayni kalir, NOBET TURETILEN alanlar yenilenir.
          const oldRed = row.standby_reduction_min || 0;
          const newRed = sb?.fdpReductionMin || 0;
          if (newRed !== oldRed || (row.standby_duty_id || null) !== (sbDuty?.id || null)) {
            upd.max_fdp_minutes = pWin.maxFdpMin;
            upd.fdp_exceeded = !!pWin.fdpExceeded;
            upd.standby_reduction_min = newRed || null;
            upd.standby_duty_id = sbDuty?.id || null;
            upd.standby_ref = sb ? standbyRef(sbDuty, sb) : null;
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'standby/max_fdp',
              old_value: `MAX ${fmtMin(row.max_fdp_minutes)} · standby −${fmtMin(oldRed)}`,
              new_value: `MAX ${fmtMin(pWin.maxFdpMin)} · standby −${fmtMin(newRed)}${sb ? ` (${sb.reference})` : ''}`,
              reason: reason.trim(), edited_by: myProfile?.id ?? null });
          }
        }
        // ── GERÇEKLEŞEN SAATLER: ATAMADAKİ HER PİLOTA YAZILIR ────────
        // Uçağın off/on block saati ekipte ORTAKTIR — iki kez girilecek bir
        // şey değil. FDP ise kişiye özeldir: her satırda KENDİ report_time'ı
        // kullanılır (rapor saatleri farklı olabilir).
        // Tarih düzeltilirse rapor saati de AYNI gün kadar kaymalı. Kaymazsa
        // FDP, yeni günün inişini eski günün raporundan çıkarır — bugün
        // düzelttiğimiz `ts()` kusurunun birebir aynısı doğardı.
        if (tarihDegistiActual) {
          const kayma = Math.round(
            (new Date(`${date}T00:00:00Z`).getTime()
             - new Date(`${row.duty_date}T00:00:00Z`).getTime()) / 86400000);
          upd.duty_date = date;
          if (row.report_time) {
            upd.report_time = new Date(new Date(row.report_time).getTime()
                                       + kayma * 86400000).toISOString();
          }
          iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
            assignment_id: row.assignment_id || null, edit_type: 'EDIT',
            field_name: 'duty_date',
            old_value: row.duty_date, new_value: date,
            reason: reason.trim(), edited_by: myProfile?.id ?? null });
        }

        // KÂĞIT TESCİLİ (21 Eki 2026, K2): kâğıdın AIRCRAFT'ı GERÇEKTİR — saat değişmese de kâğıt bacaklara yazılır (planlanan
        // tescili ezer; iPad arşivine bağlı bacağa dokunulmaz) ve ize düşer. Saat bloğu aşağıda çalışırsa aynı değeri korur.
        if (isActual && paperOfp && paperReg && !c.yeni) {
          const t = String(paperReg).toUpperCase();
          const temel = upd.sectors || tabanSektorler;
          const eski = temel.filter(x => !arsivliBacak(x)).map(x => x?.reg || '—');
          if (eski.some(r => String(r).toUpperCase() !== t)) {
            upd.sectors = temel.map(x => (arsivliBacak(x) ? x : { ...x, reg: t }));
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'reg',
              old_value: [...new Set(eski)].join(' · '), new_value: t,
              reason: reason.trim(), edited_by: myProfile?.id ?? null });
          }
        }

        // Gerçekleşmiş görevde yeni eklenen CRZ'nin FDP'si ve dinlenmesi de
        // ekibin ortak saatlerinden, KENDİ ana üssüne göre hesaplanır.
        const sektorUyumsuz = !c.yeni && (row.sectors || []).length !== (head.sectors || []).length;
        if (sektorUyumsuz && (gercekChanged || tarihDegistiActual)) sektorUyumsuzlar.push(nameOf(c.pilot));
        if ((gercekChanged || tarihDegistiActual || (isActual && c.yeni)) && !sektorUyumsuz) {
          // Ekrandaki sırayla — araya eklenen bacak her ekip satırına aynı yerden girer (5 Eki 2026).
          const taban = satirSektorleri(upd.sectors || tabanSektorler);
          const simdiDamga = new Date().toISOString();
          const yeniSektorler = taban.map((x, i) => {
            const g = gercek[i] || {};
            // "ELLE GİRİLDİ" DAMGASI (29 Eyl 2026 — eski "gerçekleşti mi?"
            // penceresinden taşındı): saati bir insan yazdıysa ve sektör bir
            // arşiv uçuşuna bağlı değilse. Sonradan gelen arşiv bu sektörü
            // `plan_id` olmadığı için bulur ve ölçülen değerle üstüne yazar.
            const elle = !x.plan_id && (g.off_block || g.on_block)
              && (gercekGiris || JSON.stringify(saatKismi(g)) !== JSON.stringify(saatKismi(ilkAkt[i] || {})));
            return { ...x,
              dep:           g.dep  || x.dep,
              dest:          g.dest || x.dest,
              // İnilen meydan (DIVERT): kâğıt bacakta EDIT'ten, iPad bacağında arşivden; yoksa alan kalkar (JSON'da düşer).
              actual_dest:   inilenMeydan(x, i),
              off_block:     g.off_block     || null,
              takeoff_time:  g.takeoff_time  || null,
              landing_time:  g.landing_time  || null,
              on_block:      g.on_block      || null,
              ...(elle ? { entered_manually: true, entered_by: myProfile?.id ?? null,
                           entered_at: simdiDamga } : {}),
              // Araya bacak eklendiyse sıra yeniden numaralanır (kâğıt kayıt bacağı `seq` ile eşler).
              ...(yeniBacakVar ? { seq: i + 1 } : {}),
              // Bacağın tipi ekrandan (25 Eki 2026) — araya eklenen bacağınki de (değişmediyse kayıttaki kalır).
              ...(x.deadhead ? {} : bacakTipAlani(i, x)),
              // KÂĞIT OFP'nin AIRCRAFT'ı GERÇEKTİR (21 Eki 2026, K2): kâğıt bacağın planlanan tescilini ezer — iPad arşivine
              // bağlı bacağın tescili arşivden gelir, ona dokunulmaz.
              ...(paperOfp && paperReg && !arsivliBacak(x) ? { reg: String(paperReg).toUpperCase() } : {}) };
          });
          upd.sectors = yeniSektorler;

          // GÜN DEVRİ: saatler HH:MM'dir; geriye giden her saat ertesi gündür.
          // (Eskiden `PlannedOutcomeModal.saveFlown` da aynı hesabı yapıyordu; 29 Eyl'de kalktı, `199a421`.
          //  Gerçekleşen görev artık yalnız bu pencereden kaydedilir.)
          let gun = upd.duty_date || row.duty_date, onceki = null, sonOnISO = null;
          for (const sk of yeniSektorler) {
            for (const alan of ['off_block', 'on_block']) {
              const m = toMin(sk[alan]);
              if (m == null) continue;
              if (onceki != null && m < onceki) gun = nextDay(gun);
              onceki = m;
              if (alan === 'on_block') sonOnISO = utcISO(gun, sk[alan]);
            }
          }

          // ── RAPOR SAATİ GERÇEK OFF-BLOCK'TAN TÜRETİLİR (21 Eyl 2026) ──────
          // 🔑 Serkan: *"Actual off block girildiğinde reporting time, actual
          //    off block − 60 dk olarak tanımlanmalı."* · *"Gerçek bu şekilde
          //    oluyor zaten; aksi hâlde sürekli ihlal olur."*
          //    Dayanak Md.10(1)(a) + Md.4(aa)/(çç): sayaç OFF-BLOCK'ta başlar.
          //
          // 🔴 ÖLÇÜLDÜ (21 Eyl): kural `archive-flight`te VARDI, bu kapıda
          //    YOKTU. 17 Eylül uçuşu kâğıt OFP ile elle girildi (`backdated_entry`
          //    → *"FLT DONE BY CREW"*), gerçek off-block **06:45** yazıldı,
          //    rapor **06:00**'da kaldı — kayıtlı hâliyle Md.10 tabanının 15 dk
          //    altında. İzde tek bir `report_time` satırı yoktu: kural hiç
          //    çağrılmamıştı. 46 görevde tek canlı vaka buydu ve sebebi kuralın
          //    eksikliği değil, İKİNCİ KAPI'ydı (İlke 3).
          const turW = raporSaatiTuret(yeniSektorler[0]?.off_block,
                                       upd.duty_date || row.duty_date,
                                       row.ruleset_snapshot);
          // ── UZUN MENZİL — TEK ÖLÇÜ (30 Eyl 2026 · B2-3, kural C·2c) ──────────
          // GERÇEK rotadan (düzeltilen rota, divert — Md.4(ee)), görevin anlarıyla:
          // rapor (gerçek off-block'tan türeyen) ve görev sonu. Azami FDP'den ÖNCE
          // ölçülür: tavan (Md.22(3)) ve dinlenme (Md.16(3)) AYNI ölçüyü kullanır.
          // Dilim okunamazsa "uzun menzil değil" SAYILMAZ: kayıt durur (İlke 1 · 2).
          const kuralR = effectiveRules(row.ruleset_snapshot || null).rules;
          // Md.10 tek kaynak (4 Eki 2026): eskiden yalnız şirket alanı ?? 30 — mevzuat tabanı ve eğitim (c) görülmüyordu.
          const postMin = gorevUcusSonrasiDk({ ...row, sectors: yeniSektorler });
          const um = uzunMenzilOlcumu(yeniSektorler, await tzAl(yeniSektorler), kuralR,
            { raporISO: turW?.reportISO || row.report_time,
              bitisISO: sonOnISO && postMin != null ? addMin(sonOnISO, postMin) : null });
          const umStandart = um.uzunMenzil === true;
          if (turW && new Date(turW.reportISO).getTime()
                      !== new Date(row.report_time || 0).getTime()) {
            upd.report_time = turW.reportISO;
            // Rapor kayarsa Md.22 Tablo-1 BANDI da kayabilir; eski tavanı
            // bırakmak sessiz bir yanlıştır — aşım ya kaçar ya uydurulur.
            // 29 Eyl 2026: DH sektör sayılmaz, CRZ varsa artırılmış ekip (Md.11)
            // — arşivle AYNI fonksiyon, aynı girdiler.
            const yeniTavan = azamiUgsYeniden({ ...row, report_time: turW.reportISO,
                                                sectors: yeniSektorler, accommodation: konaklama },
              ucusSektorSayisi(yeniSektorler), row.operation_type || null, crew.length === 1,
              ucPilotYeni, umStandart, dortPilotYeni);
            if (yeniTavan != null) upd.max_fdp_minutes = yeniTavan;
            // İZ: saat SESSİZCE değişmez (İlke 4). Gerekçe türetmenin kendisini
            // yazar ki denetçi "bu rapor nereden geldi" sorusunu izde bulsun.
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT',
              field_name: 'report_time',
              old_value: String(row.report_time || '').slice(0, 16),
              new_value: String(turW.reportISO).slice(0, 16),
              reason: `${reason.trim()} — derived from actual off-block `
                    + `${yeniSektorler[0].off_block} minus ${turW.preMin} min (Md.10)`,
              edited_by: myProfile?.id ?? null });
          }

          // ── AÇIK MESAİ, GERÇEK SAATLERLE (29 Eyl 2026, Md.15) ─────────────
          // Bekleme gerçek on-block → off-block'tan ölçülür; uzatma değiştiyse
          // (bekleme kısaldı/uzadı ya da dinlenme yeri değişti) tavan yeniden
          // okunur — rapor kaymasa bile. Kayıt alanları da gerçeğe çekilir.
          {
            const kuralSatir = effectiveRules(row.ruleset_snapshot || null).rules;
            const tipSatir = tipDegisti ? opType : (row.operation_type || null);
            const eskiAm = gorevAcikMesai(tabanSektorler, row.accommodation ?? null, kuralSatir, tipSatir,
                                          { gercek: true, ucPilot: ucPilotEski, dortPilot: dortPilotEski,
                                            dinlenmeOlanagi: row.inflight_rest_facility ?? null });
            const yeniAm = gorevAcikMesai(yeniSektorler, konaklama, kuralSatir, tipSatir,
                                          { gercek: true, ucPilot: ucPilotYeni, dortPilot: dortPilotYeni,
                                            dinlenmeOlanagi: ucPilotYeni ? (dinlenme || null) : null });
            const splitYeni = !!(yeniAm.isSplit && !yeniAm.birlesmez);
            if (splitYeni !== !!row.split_duty) upd.split_duty = splitYeni;
            const beklemeYeni = yeniAm.bekleme?.min ?? null;
            if (beklemeYeni !== (row.break_minutes ?? null)) upd.break_minutes = beklemeYeni;
            if (!upd.report_time && (yeniAm.extensionMin || 0) !== (eskiAm.extensionMin || 0)) {
              const t = azamiUgsYeniden({ ...row, sectors: yeniSektorler, accommodation: konaklama },
                ucusSektorSayisi(yeniSektorler), tipSatir, crew.length === 1, ucPilotYeni, umStandart, dortPilotYeni);
              if (t != null) upd.max_fdp_minutes = t;
            }
          }
          if (upd.max_fdp_minutes != null && upd.max_fdp_minutes !== row.max_fdp_minutes) {
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'max_fdp',
              old_value: fmtMin(row.max_fdp_minutes), new_value: fmtMin(upd.max_fdp_minutes),
              reason: `${reason.trim()} — recomputed from the actual times (report band, split duty Md.15, crew Md.11)`,
              edited_by: myProfile?.id ?? null });
          }
          const snapC = row.ruleset_snapshot?.company || {};
          const repISO = upd.report_time || row.report_time;
          if (sonOnISO && repISO && postMin != null) {
            const bitisMs = new Date(sonOnISO).getTime() + postMin * 60000;
            const fdpMin = Math.round((new Date(sonOnISO).getTime()
                                       - new Date(repISO).getTime()) / 60000);
            const tavan = upd.max_fdp_minutes != null ? upd.max_fdp_minutes : row.max_fdp_minutes;
            upd.duty_end = new Date(bitisMs).toISOString();
            upd.fdp_minutes = fdpMin;
            upd.fdp_exceeded = tavan != null && fdpMin > tavan;
            // ── DİNLENME: TEK KARAR NOKTASI (30 Eyl 2026 · FTL nöbetçisi B2-1) ──
            // 🔴 ÖNCESİ: bu yol `minRestMinutes`'i HAM MEVZUATLA çağırıyordu — uzun
            //    menzil (Md.16(3): üs dışında max(görev, 14:00), üsse dönüşte 48 saat
            //    + 2 yerel gece) ve şirketin sıkılaştırdığı dinlenme YOKTU. ASSIGN,
            //    planlı EDIT ve arşiv `restForDuty` + `effectiveRules` kullanıyordu;
            //    RECORD AS FLOWN kayda en son yazan yol olduğu için doğru değeri eziyordu.
            // Uzun menzil yukarıda TEK kez ölçüldü (`um`, gerçek rota ve görevin anları).
            if (um.olculemedi) {
              dilimYok.push(...um.eksik);
            } else {
              const sonSk = yeniSektorler[yeniSektorler.length - 1];
              const dinlenme = restForDuty({ dutyMin: fdpMin + postMin,
                atBase: endedAtBase(sonSk?.actual_dest ?? sonSk?.dest, homeBases?.[c.pilot]),
                longRange: um.uzunMenzil, dutyEndISO: new Date(bitisMs).toISOString(),
                arrivalTz: um.varisTz, rules: kuralR }).restMin;
              upd.min_rest_minutes = dinlenme;
              upd.earliest_next_report = new Date(bitisMs + dinlenme * 60000).toISOString();
            }
            // Gerçek saat girildiyse görev GERÇEKLEŞMİŞTİR — 06.09'da SEL'in
            // `planned` kalması bu yüzden oldu.
            if (yeniSektorler.every(x => x.off_block && x.on_block)) {
              upd.status = 'actual'; upd.duty_finished = true;
              // 29 Eyl 2026: durum değişimi de ize düşer (eski pencere yazıyordu,
              // EDIT yazmıyordu) — planlı görevin gerçekleştiği an kayıtta görünsün.
              if (row.status !== 'actual') {
                iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
                  assignment_id: row.assignment_id || null, edit_type: 'EDIT',
                  field_name: 'status', old_value: row.status || null, new_value: 'actual',
                  reason: reason.trim(), edited_by: myProfile?.id ?? null });
              }
            }
            // Md.12(1)(c) zorunlu rapor tarihi (süre şirketin: mandatory_report_hours; Md.13 değil — o kümülatiftir) — aşım varsa (eski pencere ve arşivle
            // AYNI kural; EDIT yolunda eksikti, aşımlı görev raporsuz kalıyordu).
            if (upd.fdp_exceeded) {
              // Süre şirketin; yoksa son tarih yok (`skpkRaporSonTarihi`, 5 Eki 2026 — eskiden `?? 72`).
              upd.mandatory_report_due = skpkRaporSonTarihi(new Date(bitisMs).toISOString(), snapC.mandatory_report_hours);
            }
          }
          // 🔑 ROTA DEĞİŞİMİ AYRI İZ SATIRI. Saatlerle aynı satıra karışsaydı
          //    denetçi *"varış meydanı değişmiş"* olgusunu göremezdi; divert
          //    bu satırda okunur (gerekçeye DIVERT yazılır).
          const eskiRota = (row.sectors || []).map(x => `${x.dep || '?'}-${x.dest || '?'}`).join(' · ');
          const yeniRota = yeniSektorler.map(x => `${x.dep || '?'}-${x.dest || '?'}`).join(' · ');
          if (eskiRota !== yeniRota) {
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT',
              field_name: 'route', old_value: eskiRota, new_value: yeniRota,
              reason: reason.trim(), edited_by: myProfile?.id ?? null });
          }
          // 🔑 DIVERT AYRI İZ SATIRI (5 Eki 2026): rota (plan) değişikliği divert değildir — divert yalnız inilen meydanın
          //    planlanandan farklı olmasıdır; denetçi onu kendi satırında görür.
          const divertOzeti = (ss) => (ss || []).filter(x => x?.actual_dest && x.actual_dest !== x.dest)
            .map(x => `${x.dep || '?'}-${x.dest || '?'} landed ${x.actual_dest}`).join(' · ') || 'none';
          const eskiDivert = divertOzeti(row.sectors), yeniDivert = divertOzeti(yeniSektorler);
          if (eskiDivert !== yeniDivert) {
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT',
              field_name: 'divert', old_value: eskiDivert, new_value: yeniDivert,
              reason: reason.trim(), edited_by: myProfile?.id ?? null });
          }
          iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
            assignment_id: row.assignment_id || null, edit_type: 'EDIT',
            field_name: 'actual times',
            old_value: (row.sectors || []).map(x => `${x.off_block || '—'}/${x.on_block || '—'}`).join(' · '),
            new_value: yeniSektorler.map(x => `${x.off_block || '—'}/${x.on_block || '—'}`).join(' · '),
            reason: reason.trim(), edited_by: myProfile?.id ?? null });
        }

        if (pencereKur) {
          upd.duty_date = date;
          // Rol burada YAZILMAZ — döngünün sonunda bacak tablosundan uygulanır.
          // Bacağın tipi ekrandan (25 Eki 2026) — araya eklenen bacak da kendi tipiyle girer.
          upd.sectors = legs.map((l, i) => {
            const taban = l._kaynak != null ? (tabanSektorler[l._kaynak] || {}) : {};
            return { ...taban, ...bacakTipAlani(i, taban), seq: i + 1,
              dep: l.dep.toUpperCase(), dest: l.dest.toUpperCase(), etd: l.etd, eta: l.eta, reg: String(l.reg || '').toUpperCase() || null };
          });
          upd.report_time = reportISO; upd.duty_end = endISO;
          // Açık mesai (Md.15) — pencere yeniden kurulunca kaydı da ondan (29 Eyl).
          upd.split_duty = !!(pWin.split?.isSplit && !pWin.split?.birlesmez);
          upd.break_minutes = pWin.breakMin ?? null;
          upd.accommodation = upd.split_duty ? konaklama : null;
          upd.max_fdp_minutes = pWin.maxFdpMin; upd.fdp_minutes = pWin.fdpMin;
          upd.fdp_exceeded = !!pWin.fdpExceeded;
          upd.standby_reduction_min = sb?.fdpReductionMin || null;
          upd.standby_duty_id = sbDuty?.id || null;
          upd.standby_ref = sb ? standbyRef(sbDuty, sb) : null;
          const newDutyMin = pWin.dutyMin || 0;
          // 🔴 27 AGU 2026 — MANDAL KALKTI. Eskiden:
          //     Math.max(newDutyMin, row.min_rest_minutes || 0)
          // yani taban MEVZUAT degil SATIRIN KENDI ESKI DEGERIYDI. Gorev
          // kisalinca dinlenme geri inemiyor, artik var olmayan bir gorevin
          // suresinde takili kaliyordu (SEL/AAK 27 Agu: 13:00 gorev, 14:00 rest).
          // 🔑 Serkan: "gerceklesmis zamanlar her zaman gercegi belirleyecek."
          const atBaseEdit = endedAtBase(legs[legs.length - 1]?.dest, homeBases?.[c.pilot]);
          // Kural gorevin KENDI snapshot'indan: kayit hangi kurallarla acildiysa
          // onlara tabidir, bugunku ruleset'e degil.
          upd.min_rest_minutes = restForDuty({ dutyMin: newDutyMin, atBase: atBaseEdit,
            longRange: umEdit.uzunMenzil === true, dutyEndISO: endISO, arrivalTz: umEdit.varisTz,
            rules: editKurallari }).restMin;
          upd.earliest_next_report = addMin(endISO, upd.min_rest_minutes);
          if (sectorsChanged || dateChanged) {
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'sectors/times',
              // 3 Eki 2026 (1c): girilen DEĞERİ yazar — tarih + bacak ETD/ETA. Rapor ve görev sonu türetilmiştir;
              // onları sunucu yazar ve SYSTEM RECALC satırında görünür.
              old_value: `${head.duty_date} · ${(head.sectors||[]).map(x=>`${x.dep}-${x.dest} ${x.etd || '—'}-${x.eta || '—'}`).join(' · ')}`,
              new_value: `${date} · ${legs.map(x=>`${String(x.dep).toUpperCase()}-${String(x.dest).toUpperCase()} ${x.etd || '—'}-${x.eta || '—'}`).join(' · ')}`,
              reason: reason.trim(), edited_by: myProfile?.id ?? null });
          } else if (pWin.maxFdpMin !== row.max_fdp_minutes) {
            // Yalnız EKİP (CRZ) ya da açık mesai dinlenme yeri değişti: saatler aynı,
            // tavan değişti.
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT',
              field_name: ucPilotDegisti || dinlenmeDegisti ? 'max_fdp (crew)' : 'max_fdp (split duty)',
              old_value: fmtMin(row.max_fdp_minutes), new_value: fmtMin(pWin.maxFdpMin),
              reason: `${reason.trim()} — ${tavanSebebi()}`,
              edited_by: myProfile?.id ?? null });
          }
          // ZINCIR UYARISI: bu pilotun sonraki gorevi yeni dinlenme penceresini deliyor mu?
          // 30 Eyl 2026 (B3): AN karşılaştırılır, METİN değil ("+00:00" ile ".000Z" aynı an).
          const an = (x) => new Date(x).getTime();
          const nxt = (duties || []).filter(x => x.pilot_id === c.pilot && x.id !== row.id &&
            x.status !== 'cancelled' && x.report_time && an(x.report_time) > an(endISO))
            .sort((a, b) => an(a.report_time) - an(b.report_time))[0];
          if (nxt && upd.earliest_next_report && an(nxt.report_time) < an(upd.earliest_next_report)) {
            chainWarn.push(`${nameOf(c.pilot)}: next duty ${fmtDT(nxt.report_time)} < earliest ${fmtDT(upd.earliest_next_report)}`);
          }
        }

        // ── SKPK (Md.12) ────────────────────────────────────────────
        // Komutanın kararı TÜM EKİBİ bağlar (tek uçuş, tek karar) — bu yüzden
        // gruptaki her satıra aynı uzatma/kısaltma işlenir; ama TABAN ve
        // "hak edilen dinlenme" pilot bazlıdır, o yüzden hesap satır satır.
        const extIn = toMin(skpkExt) || 0, redIn = toMin(skpkRed) || 0;
        const skpkChanged = skpkAllowed && (
          extIn !== (row.skpk_fdp_extension_min || 0) ||
          redIn !== (row.skpk_rest_reduction_min || 0) ||
          (skpkReason || '').trim() !== (row.skpk_reason || ''));
        if (skpkChanged) {
          // Md.12(1)(c)(1): SKPK varsa işleticiye rapor İSTİSNASIZ sunulur —
          // gerekçesiz SKPK kaydı yasaktır (boş gerekçe yasağıyla aynı ilke).
          if ((extIn > 0 || redIn > 0) && !gerekceTamam(skpkReason)) {
            toast('COMMANDER\'S REPORT is mandatory for any SKPK (SHT-FTL/HG Md.12/1/c/1).', 'error');
            setSaving(false); return;
          }
          const s = skpkFor(row);
          if (s && !s.skpk.ok) blocked.push(...kunyeliYaDuz(s.skpk).map(k => ({ kim: nameOf(c.pilot),
            metin: k.metin, ref: k.ref, neYapmali: NE_YAPMALI.skpk })));
          const baseMax = upd.max_fdp_minutes != null ? upd.max_fdp_minutes : s?.baseMaxFdp;
          const baseRest = upd.min_rest_minutes != null && pencereKur
            ? upd.min_rest_minutes : s?.baseEarnedRest;
          const newMax = baseMax != null ? baseMax + extIn : null;
          const newRest = baseRest != null ? baseRest + (redIn * 2) : null;
          const endForRest = upd.duty_end || row.duty_end;
          if (newMax != null) upd.max_fdp_minutes = newMax;
          if (s?.skpk.fdpStillExceeded != null) upd.fdp_exceeded = !!s.skpk.fdpStillExceeded;
          if (newRest != null) {
            upd.min_rest_minutes = newRest;
            upd.earliest_next_report = addMin(endForRest, newRest);
          }
          upd.skpk_fdp_extension_min = extIn || null;
          upd.skpk_rest_reduction_min = redIn || null;
          upd.skpk_reason = skpkReason.trim() || null;
          // İşleticiye rapor damgası: ilk kez kaydedildiğinde atılır, sonraki
          // düzeltmelerde KORUNUR (raporun ne zaman sunulduğu geriye kaymaz).
          upd.skpk_reported_at = (extIn > 0 || redIn > 0)
            ? (row.skpk_reported_at || new Date().toISOString()) : null;
          upd.skpk_authority_due = s?.skpk.authorityDueISO || null;
          if (!s?.skpk.authorityReportRequired) upd.skpk_authority_reported_at = null;
          upd.skpk_ref = s ? skpkRef(s.skpk) : null;
          iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
            assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'skpk',
            old_value: `FDP +${fmtMin(row.skpk_fdp_extension_min || 0)} · REST −${fmtMin(row.skpk_rest_reduction_min || 0)}`,
            new_value: `FDP +${fmtMin(extIn)} · REST −${fmtMin(redIn)}${s?.skpk.authorityReportRequired ? ' · DGCA REPORT DUE' : ''} — ${skpkReason.trim() || '(cleared)'}`,
            reason: reason.trim(), edited_by: myProfile?.id ?? null });
          // Telafi zinciri: artan dinlenme sonraki görevi deliyor mu?
          const an2 = (x) => new Date(x).getTime();
          const nx = (duties || []).filter(x => x.pilot_id === c.pilot && x.id !== row.id &&
            x.status !== 'cancelled' && x.report_time && an2(x.report_time) > an2(endForRest))
            .sort((a, b) => an2(a.report_time) - an2(b.report_time))[0];
          if (nx && upd.earliest_next_report && an2(nx.report_time) < an2(upd.earliest_next_report)) {
            chainWarn.push(`${nameOf(c.pilot)}: SKPK compensation pushes rest to ${fmtDT(upd.earliest_next_report)}, next duty starts ${fmtDT(nx.report_time)}`);
          }
        }

        // ── ROLLER EN SON, YALNIZ `role` ALANINA (29 Eyl 2026) ───────────────
        // Taban, yukarıdaki blokların kurduğu SON sektör dizisidir (saat, rota,
        // tip dahil). Rolden başka hiçbir alan değişmez — saat + rol aynı
        // kayıtta değişince yeni saatlerin silindiği kusur burada kapandı.
        {
          const eskiS = row.sectors || [];
          const rollu = rolleriUygula(upd.sectors || tabanSektorler, roller, c.key);
          if (rolDizisi(eskiS) !== rolDizisi(rollu)) {
            iz.push({ duty_id: row.id, customer_id: row.customer_id, pilot_id: c.pilot,
              assignment_id: row.assignment_id || null, edit_type: 'EDIT', field_name: 'role',
              old_value: rolOzeti(eskiS), new_value: rolOzeti(rollu),
              reason: reason.trim(), edited_by: myProfile?.id ?? null });
            upd.sectors = rollu;
          } else if (upd.sectors) {
            upd.sectors = rollu;
          }
          sonSektorler[c.key] = rollu;
        }

        if (c.yeni) {
          // Yeni CRZ satırı: iz TEK satır, ekleme de izden SONRA (aşağıda).
          const { id: _yok, ...taban } = row;
          yeniSatirlar.push({ ...taban, ...upd, pilot_id: c.pilot,
                              sectors: sonSektorler[c.key], created_by: myProfile?.id ?? null });
          edits.push({ duty_id: head.id, customer_id: head.customer_id, pilot_id: c.pilot,
            assignment_id: head.assignment_id || null, edit_type: 'EDIT',
            field_name: 'crew_added', old_value: '—',
            new_value: `${nameOf(c.pilot)} — ${rolOzeti(sonSektorler[c.key])}`,
            reason: reason.trim(), edited_by: myProfile?.id ?? null });
        } else if (Object.keys(upd).length) updates.push({ id: row.id, pilot: c.pilot, upd });
      }

      // B2-1: meydan dilimi okunamadıysa dinlenme hesaplanamaz — hiçbir şey yazılmaz.
      if (dilimYok.length) {
        toast(dilimOkunamadiMetni(dilimYok), 'error');
        setSaving(false); return;
      }
      // REGULASYON KAPISI (Md.17 nobet / Md.12 SKPK): tavan deliniyorsa YAZILMAZ.
      // Iz de yazilmaz — degisiklik hic olmadi, reddedildi.
      // 30 Eyl 2026 (adım ①): ortak kural ihlali kartı — her gerekçe ayrı satır,
      // ⓘ'de maddenin kendi metni. Nöbet yalnız planlı, SKPK yalnız uçulmuş
      // görevde ölçülür; başlık buna göre (uçulmuş görev "planlanamaz" değildir).
      if (blocked.length) {
        toast(`${[...new Set(blocked.map(b => b.kim))].join(', ')}: this change breaks a regulatory limit — `
              + 'the reasons are listed below.', 'error',
              ihlalDetayi(blocked, { baslik: isActual ? KAYIT_BASLIK : IHLAL_BASLIK }));
        setSaving(false); return;
      }
      // ── KÂĞIT OFP: EKSİK VARSA HİÇBİR ŞEY YAZILMAZ (2 Eki 2026) ─────────────
      // 🔑 Serkan: *"tescil, saatler, PM PF rolleri, inişin türü bunlar zorunlu olmalı, aksi halde tasnif
      //    edilemez"* · *"ekran da kaydetmeden önce söyler"*.
      // 🔴 ÖNCESİ: tescil hiç denetlenmiyordu; iniş/saat eksiği ise ancak görev KAYDEDİLDİKTEN sonra yazıcıda
      //    yakalanıyordu → "Duty saved, but the PAPER OFP record failed" — görev uçuldu, istatistikte yok.
      // Yazıcının girdisi BURADA bir kez kurulur (son roller dahil) ve aynı fonksiyonla ölçülür; yazıcı da
      // aynı girdiyle çağrılır — ekranın denetlediği ile yazılan ayrışamaz.
      const kagitGirdi = (paperOfp && (kagitBacakVar || yeniBacakVar)) ? {
        // Taze beyan da gitsin: kagit OFP satirinin gece/gunduzu ayni
        // duzenlemede girilen meydan verisinden okunmali.
        duty: { ...head, ad_hoc_airports: Object.keys(adHoc).length ? adHoc : null,
                pilot_id: group.rows[0]?.pilot_id },
        // Yalnız kâğıt bacakları — iPad arşivine bağlı bacak kâğıt kayda YAZILMAZ (uçak saati iki kez sayılırdı; 5 Eki 2026).
        sectors: aktifSektorler.map((x, i) => ({ ...x, ...(gercek[i] || {}), ...(kagitInis[i] || {}),
                                                 actual_dest: inilenMeydan(x, i),
                                                 ...(yeniBacakVar ? { seq: i + 1 } : {}) }))
          .filter(x => !arsivliBacak(x)),
        reg: paperReg, reason, editedBy: myProfile?.id,
        // EKİBİN TAMAMI, KAYDA GİDEN SON rolleriyle (29 Eyl 2026): bacakta
        // PF/PM/CRZ değiştiyse kâğıt kayıt da aynı kayıtta değişir.
        ekip: crew.map(c => ({ pilot_id: c.pilot, sectors: sonSektorler[c.key] || [] })) } : null;
      if (kagitGirdi) {
        const eksik = kagitOfpEksigi(kagitGirdi);
        if (eksik.length) {
          toast(`PAPER OFP incomplete — nothing was saved. ${eksik.join(' | ')}`, 'error');
          setSaving(false); return;
        }
      }
      // ── KÂĞIT OFP BEYANI BİR DEĞİŞİKLİKTİR ────────────────────────
      // Kutu (ya da tescil) değiştiyse bu tek başına kaydedilebilir bir
      // eylemdir ve ize geçer: *"bu uçuş kâğıt OFP ile uçuldu"* bir BEYANdır;
      // denetimde kimin, ne zaman, hangi gerekçeyle söylediği sorulur.
      const paperChanged = (kagitBacakVar || yeniBacakVar) && (
        paperOfp !== paperBaslangic.isaretli ||
        (paperOfp && (paperReg || '') !== (paperBaslangic.reg || '')));
      // ── İŞARET KALDIRILDI → KÂĞIT KAYIT GEÇERSİZ (5 Eki 2026, Serkan A) ──
      // 🔴 ÖNCESİ: yalnız iz yazılıyordu ("PAPER OFP → none"); kâğıt kayıt canlı kalıyor, STATISTICS'te ve uçak/motor
      //    saatinde sayılmaya devam ediyordu. Kayıt silinmez — DELETED olur (gerekçeli, ARCHIVED FLTS'te rozetle);
      //    evrak kalır; işaret geri konunca yazıcı kaydı geri açar. Canlı bacaklar İZDEN ÖNCE okunur (iz neyin
      //    geçersiz kılındığını adıyla söylesin; okunamazsa hiçbir şey yazılmaz).
      let kagitCanli = [];
      if (paperBaslangic.isaretli && !paperOfp) {
        const { bacaklar, hata } = await kagitCanliBacaklari(kagitAnahtarim);
        if (hata) { toast(`The PAPER OFP record could not be read — ${hata}. Nothing was saved.`, 'error'); setSaving(false); return; }
        kagitCanli = bacaklar;
      }
      if (paperChanged) {
        edits.push({
          duty_id: head.id, customer_id: head.customer_id, pilot_id: head.pilot_id,
          assignment_id: head.assignment_id || null, edit_type: 'EDIT',
          field_name: 'paper_ofp',
          old_value: kagitCanli.length ? kagitOzeti(kagitCanli)
            : paperBaslangic.isaretli ? `PAPER OFP ${paperBaslangic.reg || '(no reg)'}` : 'none',
          new_value: paperOfp ? `PAPER OFP ${paperReg || '(no reg)'}` : kagitCanli.length ? `none — ${KAGIT_GECERSIZ_IZ}` : 'none',
          reason: reason.trim(), edited_by: myProfile?.id ?? null,
        });
      }
      // ── EVRAK DEĞİŞİKLİĞİ DE BİR DEĞİŞİKLİKTİR (2 Eki 2026) — her dosya kendi iz satırıyla, gerekçeyle. ──
      //    İz ÖNCE yazılır (aşağıda, öbürleriyle birlikte); dosya işi kâğıt kayıt yazıldıktan SONRA yapılır —
      //    evrak kuralı var olan kâğıt uçuşu ister (20261002c). Kaldırılan dosya tamamen silinir; adı izde kalır.
      const evrakIzTabani = { duty_id: head.id, customer_id: head.customer_id, pilot_id: head.pilot_id,
        assignment_id: head.assignment_id || null, edit_type: 'EDIT', field_name: 'paper_ofp_document',
        reason: reason.trim(), edited_by: myProfile?.id ?? null };
      const kaldirilanEvrak = kagitGirdi ? kagitEvrak.filter(d => kaldirilacakEvrak.has(d.id)) : [];
      const eklenenEvrak = kagitGirdi ? yeniEvrak : [];
      kaldirilanEvrak.forEach(d => edits.push({ ...evrakIzTabani,
        old_value: `${d.file_name} (${mbYaz(d.file_size)})`, new_value: 'REMOVED — file deleted' }));
      eklenenEvrak.forEach(f => edits.push({ ...evrakIzTabani,
        old_value: '—', new_value: `${f.name} (${mbYaz(f.size)})` }));

      // ── TEK MOTOR TEK YOL (3 Eki 2026, adım 1c) ─────────────────────────────────────────────────────────
      // 🔑 Serkan: *"tek motorumuz tek yolumuz olması gerekir"* — EDIT türetilmiş FTL değeri YAZMAZ: rapor, görev sonu,
      //    UGS, azami UGS, aşım, dinlenme, sonraki görev, intibak, nöbet indirimi, zorunlu rapor tarihini yalnız sunucu
      //    yazar (kayıt değişince tetikleyici → ftl-yeniden-hesapla, SYSTEM RECALC izi "after … by <kullanıcı>").
      // Yukarıdaki hesaplar KAPILARI ve uyarıları besler (nöbet / SKPK tavanı, meydan dilimi, zincir uyarısı); kayda
      // giden her güncelleme ve yeni satır BURADA süzülür. Türetilmiş değeri anlatan EDIT iz satırları da yazılmaz —
      // o değişiklik SYSTEM RECALC satırında, onu tetikleyen bu düzenlemeyle yan yana görünür (tekrarlı iz yok).
      const ayikla = (o) => turetilmisleriAyikla(o, 'flight');   // EDIT yalnız uçuş görevini açar
      for (let i = updates.length - 1; i >= 0; i--) {
        updates[i] = { ...updates[i], upd: ayikla(updates[i].upd) };
        if (!Object.keys(updates[i].upd).length) updates.splice(i, 1);
      }
      for (let i = 0; i < yeniSatirlar.length; i++) yeniSatirlar[i] = ayikla(yeniSatirlar[i]);
      for (let i = edits.length - 1; i >= 0; i--) if (EDIT_TURETILMIS_IZ.has(edits[i].field_name)) edits.splice(i, 1);

      if (!edits.length) { toast('No changes.', 'error'); setSaving(false); return; }
      // IZ ONCE yazilir (silme/iptalle ayni ilke).
      const { error: eErr } = await supabase.from('ftl_duty_edits').insert(edits);
      if (eErr) { toast(`Audit write failed: ${eErr.message}`, 'error'); setSaving(false); return; }
      // ── ARŞİV ÖNCE (tek sahip): arşiv yazılamazsa görev de yazılmaz — iki kayıt ayrışmaz. Arşiv yazılıp görev düşerse rapor
      //    yeniden üretimi görevi sahibinden (arşiv) düzeltir. Yazma DÖNEN SATIRLA doğrulanır.
      if (arsivDuz.length) {
        let sbA;
        try { sbA = await withReason(reason.trim()); } catch (e2) { toast(String(e2.message || e2), 'error'); setSaving(false); return; }
        for (const a of arsivDuz) {
          // 21 Eki 2026 (Serkan "a"): arşivin izi (admin_edits) de ÖNCE — eskiden arşiv yazılıp iz SONRA yazılıyordu, iz düşerse
          // düzeltme raporun AMENDED bandına girmezdi. Tek kaynak `arsivIzi.izOnceYaz` (ARCHIVED FLTS ile aynı).
          const sonucA = await izOnceYaz(sbA, a.izler.map(z => ({ archived_flight_id: a.afId, plan_id: a.planId, field_name: z.alan,
            old_value: z.eski, new_value: z.yeni, reason: reason.trim(), edit_type: 'EDIT', edited_by: myProfile?.id ?? null })),
            () => sbA.from('archived_flights').update(a.guncelle).eq('id', a.afId).select('id'), 'EDIT NOT WRITTEN');
          if (!sonucA.tamam) {
            const sebepA = sonucA.sebep;
            await supabase.from('ftl_duty_edits').insert({ duty_id: head.id, customer_id: head.customer_id,
              pilot_id: head.pilot_id, assignment_id: head.assignment_id || null, edit_type: 'EDIT',
              field_name: 'archive', old_value: '(edit logged)', new_value: '(ARCHIVE NOT WRITTEN — duty not saved)',
              reason: `Archived flight ${a.rota} refused the correction: ${sebepA}`, edited_by: myProfile?.id ?? null });
            toast(`NOT SAVED — the archived flight ${a.rota} could not be corrected (${sebepA}). The duty was not changed `
                  + `either, so the two records still match; the edit log records it.${sonucA.izNotu}`, 'error');
            arsivDuz.slice(0, arsivDuz.indexOf(a)).forEach(b => raporuYenile(b.planId)
              .then(r => { if (!r.tamam) toast(`${b.rota}: ${r.metin}`, 'error'); }));
            setSaving(false); return;
          }
        }
      }
      // ── GÖREV YAZMASI DÖNEN SATIRLA DOĞRULANIR (29 Eyl 2026 · FTL nöbetçisi A2) ──
      // 🔴 ÖNCESİ: yalnız `error`e bakılıyordu. RLS reddettiğinde hata DÖNMEZ,
      //    0 satır etkilenir (İlke 2): iz yazılmış, görev değişmemiş, ekranda
      //    "Duty updated". Hemen aşağıdaki CRZ eklemesi bunu zaten doğru yapıyordu.
      // 🔑 Satır dönmezse kayıt DURUR (ilk hatada durmak eski davranıştı).
      //    Yazılamayan ve hiç denenmeyen görevler ADIYLA söylenir. Onlar için
      //    yukarıda yazılmış iz artık yanlış bir şey söylüyor; `ftl_duty_edits`
      //    değiştirilemez olduğu için DÜZELTME SATIRI yazılır (silme reddindeki
      //    desen) — iz kendini düzeltir, üstünü çizmez.
      const yazilan = new Set();
      const pilotOf = (id) => updates.find(x => x.id === id)?.pilot
        ?? (group.rows || []).find(x => x.id === id)?.pilot_id;
      for (let i = 0; i < updates.length; i++) {
        const u = updates[i];
        const { data: donen, error } = await supabase.from('crew_duties')
          .update(u.upd).eq('id', u.id).select('id');
        if (!error && donen?.length === 1) { yazilan.add(u.id); continue; }
        const sebep = error?.message || 'no row returned (permission?)';
        // Aynı görevin sonraki bir yazması da düşebilir: kalanların HEPSİ yazılmadı sayılır.
        const yazilmayan = [...new Set(updates.slice(i).map(x => x.id))];
        const { error: dErr } = await supabase.from('ftl_duty_edits').insert(yazilmayan.map(id => {
          const r = (group.rows || []).find(x => x.id === id) || {};
          return { duty_id: id, customer_id: r.customer_id ?? head.customer_id, pilot_id: pilotOf(id),
                   assignment_id: r.assignment_id || head.assignment_id || null, edit_type: 'EDIT',
                   field_name: 'update', old_value: '(edit logged)', new_value: '(EDIT NOT WRITTEN)',
                   reason: `Update refused: ${sebep}`, edited_by: myProfile?.id ?? null };
        }));
        const yazildi = [...yazilan].filter(id => !yazilmayan.includes(id));
        toast(`NOT SAVED for ${yazilmayan.map(id => nameOf(pilotOf(id))).join(', ')}.`
              + (yazildi.length ? ` Saved for ${yazildi.map(id => nameOf(pilotOf(id))).join(', ')}.` : '')
              + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
                      : ' The edit log records that it was not written.'),
              'error', yazmaDetayi({ kismen: yazildi.length > 0, hata: error }));
        setSaving(false);
        // Bir kısmı yazıldıysa ekran GERÇEĞİ göstersin (CRZ eklemesindeki gibi yeniden okunur).
        if (yazildi.length) onSaved();
        return;
      }
      // ── EDIT'TE EKLENEN CRZ SATIRI (29 Eyl 2026) ─────────────────────────
      // İz yukarıda yazıldı ('crew_added'). Ekleme dönen satırla DOĞRULANIR:
      // RLS reddettiğinde hata yerine 0 satır dönebilir (İlke 2) — "hata yok,
      // demek ki oldu" demeyiz.
      if (yeniSatirlar.length) {
        const { data: eklenen, error: yErr } = await supabase.from('crew_duties')
          .insert(yeniSatirlar).select('id');
        if (yErr || !eklenen || eklenen.length !== yeniSatirlar.length) {
          // Görev YAZILDI (kısmi): başlık PARTLY SAVED. Bu yol düzeltme satırı
          // yazmıyor — ⓘ "EDIT REPORT'ta NOT WRITTEN satırı var" DEMEZ.
          toast('Duty updated, but the CRZ CPT was NOT added.', 'error', yazmaDetayi({
            kismen: true, hata: yErr, izCumlesi: null,
            neYapmali: 'The duty itself is saved. Open it with EDIT and add the CRZ CPT again.' }));
          setSaving(false); onSaved(); return;
        }
      }
      // ── KÂĞIT OFP KAYDI (7 Eyl 2026 · 19 Eyl'de genişletildi) ────
      //
      // 🔑 Serkan (19 Eyl): *"Editten uçuşu açınca da sorması lazım; edit
      //    kısmında paper OFP tıklayınca bunu istatistiğe PAPER OFP olarak
      //    yazmalı."*
      //
      // 🔴 ESKİ HAL İKİ KERE YANLIŞTI:
      //    ① Kutu burada HİÇ YOKTU — beyan yalnız "gerçekleşti mi?" modalında
      //      sorulabiliyordu. EDIT'ten gerçekleşmiş yapılan uçuş hiçbir uçuş
      //      tablosuna girmiyordu.
      //    ② Yazma `.update()` idi: satır yoksa HİÇBİR ŞEY yapmıyor, üstelik
      //      HATA DA DÖNDÜRMÜYORDU (0 satır). Kod "oldu" sanıyordu —
      //      CLAUDE.md İlke 2'nin kelimesi kelimesine tarif ettiği tuzak.
      //    Sonucu sahada ölçüldü: 14 · 17 · 18 Eylül uçuşları roster'da
      //    ACTUAL, saatleri FTL kümülatiflerine giriyor, ama STATISTICS'te,
      //    uçak saatinde ve iniş sayısında YOKLAR.
      //
      // Artık TEK YAZICI (`paperOfpYaz`): satır yoksa OLUŞTURUR, varsa tazeler.
      // Kutu işaretli değilse hiçbir şey yazılmaz — ve kutunun kendisi bunun
      // sonucunu ekranda söyler ("will NOT appear in statistics...").
      if (kagitGirdi) {
        const { error: mErr } = await paperOfpYaz(kagitGirdi);
        // EVRAK — kâğıt kayıt yazıldıysa. Yazılamadıysa evrak da yazılmaz (kural var olan kâğıt uçuşu ister) ve
        // iz düzeltilir: yukarıda "eklendi / kaldırıldı" yazan satırlar artık doğru değil.
        const evrakSorunu = [];
        if (mErr) {
          [...kaldirilanEvrak.map(d => `${d.file_name} (${mbYaz(d.file_size)})`),
           ...eklenenEvrak.map(f => `${f.name} (${mbYaz(f.size)})`)]
            .forEach(ad => evrakSorunu.push({ ad, hata: `${ad}: not saved — the PAPER OFP record was not written` }));
        } else {
          for (const d of kaldirilanEvrak) {
            const r = await kagitEvrakKaldir(d);
            if (r.hata) evrakSorunu.push({ ad: `${d.file_name} (${mbYaz(d.file_size)})`, hata: r.hata });
          }
          for (const f of eklenenEvrak) {
            const r = await kagitEvrakEkle({ anahtar: kagitAnahtari(kagitGirdi.duty), customerId: head.customer_id,
                                             dosya: f, yukleyen: myProfile?.id ?? null, id: newUuid() });
            if (r.hata) evrakSorunu.push({ ad: `${f.name} (${mbYaz(f.size)})`, hata: r.hata });
          }
        }
        if (evrakSorunu.length) {
          const { error: dErr } = await supabase.from('ftl_duty_edits').insert(evrakSorunu.map(x => ({
            ...evrakIzTabani, old_value: x.ad, new_value: '(DOCUMENT NOT WRITTEN)', reason: x.hata })));
          toast(`DOCUMENTS NOT SAVED — ${evrakSorunu.map(x => x.hata).join(' | ')}`
                + (dErr ? ` · the edit-log correction could not be written either: ${dErr.message}` : ''), 'error');
        }
        setYeniEvrak([]); setKaldirilacakEvrak(new Set()); setEvrakRet([]);
        // Görev YAZILDI; kâğıt kaydı düşerse SUSMAYIZ.
        if (mErr) toast('Duty saved, but the PAPER OFP record failed.', 'error', yazmaDetayi({
          kismen: true, hata: mErr, izCumlesi: null,
          neYapmali: 'The duty itself is saved; only the paper OFP record (statistics, aircraft hours, '
                   + 'landings) is missing. Tell the EFB admin so it can be written again.' }));
      }
      let kagitNotu = '';
      if (!kagitGirdi && kagitCanli.length) {
        const g = await kagitKaydiGecersizKil({ anahtar: kagitAnahtarim, kullaniciId: myProfile?.id ?? null,
          neden: `PAPER OFP unticked in EDIT DUTY: ${reason.trim()}`, beklenen: kagitCanli.length });
        if (g.hata) {
          // İz "DELETED" dedi ama olmadı — iz kendini düzeltir (üstünü çizmez), ekran susmaz.
          const { error: dErr } = await supabase.from('ftl_duty_edits').insert({ duty_id: head.id,
            customer_id: head.customer_id, pilot_id: head.pilot_id, assignment_id: head.assignment_id || null,
            edit_type: 'EDIT', field_name: 'paper_ofp', old_value: '(delete logged)',
            new_value: '(NOT DELETED — still counted)', reason: `Paper record refused the change: ${g.hata}`,
            edited_by: myProfile?.id ?? null });
          toast(`Duty saved, but the PAPER OFP record was not marked deleted — ${g.hata}. It is still counted in `
                + 'statistics and aircraft hours; tell the EFB admin.'
                + (dErr ? ` The edit-log correction could not be written either: ${dErr.message}` : ''), 'error');
        } else {
          kagitNotu = ` PAPER OFP record marked DELETED (${g.bacak} sector${g.bacak === 1 ? '' : 's'}) — `
                    + 'no longer counted in statistics or aircraft hours; documents kept.';
        }
      }

      toast(gercekGiris ? `Duty recorded as flown (${edits.length} change(s) logged).${kagitNotu}`
                        : `Duty updated (${edits.length} change(s) logged).${kagitNotu}`, 'success');
      // Arşiv düzeltildiyse rapor PDF'i düzeltme işaretleriyle yeniden üretilir — görev yazmalarından SONRA (yeniden üretim
      // sektörleri bütün olarak yazar; önce koşsa bu düzenlemenin öteki değişikliklerini ezebilirdi).
      arsivDuz.forEach(a => raporuYenile(a.planId)
        .then(r => toast(r.tamam ? `${a.rota}: archived flight corrected and its report regenerated with amendments.`
                                 : `${a.rota}: archived flight corrected, but ${r.metin}`, r.tamam ? 'success' : 'error')));
      if (sektorUyumsuzlar.length) {
        toast(`${sektorUyumsuzlar.join(', ')}: times NOT written — the sector list does not match this `
              + 'flight. Fix their duty from EDIT DUTY.', 'error');
      }
      if (tzWarn) toast(tzWarn, 'error');
      chainWarn.forEach(w => toast(`CHAIN: ${w} — NOT auto-fixed, review.`, 'error'));
      await offRestUygula({ duties, ruleset, offTypes, pilotDilim, myProfile, toast, gorevler: [
        ...updates.map(u => ({ ...((group.rows || []).find(x => x.id === u.id) || {}), ...u.upd, id: u.id })),
        ...yeniSatirlar] });
      onSaved();
    } catch (e) { toast(String(e.message || e), 'error'); }
    setSaving(false);
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:200,
                  display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'var(--bg2)', border:`1px solid ${C.border2}`, width:'100%', maxWidth:680,
                    maxHeight:vh(90), overflowY:'auto', padding:20 }}>
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:10, marginBottom:4 }}>
          <div style={S.panelT} data-testid="edit-baslik">
            {gercekGiris ? 'RECORD AS FLOWN' : 'EDIT DUTY'} — {fmtD(head.duty_date)}
          </div>
          <KapatX onClose={onClose} disabled={saving} />
        </div>
        {gercekGiris && (
          <div style={{ ...S.note, marginBottom:10, borderLeftColor:C.accent }} data-testid="gercek-giris-notu">
            Record what actually happened. All times UTC, HH:MM — OFF BLOCK and ON BLOCK are
            mandatory on every sector: the report time is derived from the actual off-block,
            and the duty window, FDP and the next earliest report are calculated from them.
            Set the crew roles per sector, add a third pilot or a check ride, correct a divert,
            and tick PAPER OFP if it was flown without the EFB. If the EFB archive for this
            flight arrives later, its measured times replace what you enter here.
          </div>
        )}
        <div style={{ ...S.note, marginBottom:14 }}>
          {isActual
            ? 'ACTUAL duty: times, date and crew can be corrected with a reason. Every change is logged; FDP and rest are recomputed.'
            : 'Window is recomputed with the duty\'s OWN ruleset snapshot. Times use airport timezones.'}
        </div>

        {/* FAALIYET TIPI (Md.9) — 9 Agu 2026, Serkan: "ucus planlanirken ticari mi
            genel havacilik mi secilir, baslamadan bir degisiklik olursa edit
            edilebilir". Nitelik AZAMI UGS tablosunu secer (fdpLimitSet).

            🔴 19 EYL 2026 — KILIT KALKTI. Gerceklesmis gorevde alan `disabled`di;
            gerekcesi *"FDP yazildigi andaki kurala gore hesaplandi, sessizce
            degismesin"*di. Ama sonucu TERSINE isliyordu: sistem MATCH REVIEW ile
            *"girilen tip ucrulanla uyusmuyor"* diyor, duzeltmeye IZIN VERMIYORDU.
            Mevcut cozum yolu yalnizca BAYRAGI gerekceyle kapatiyor (`reviewing`) —
            yani yanlis tip kayitta kalip uyari susuyordu. Tam tersi olmali:
            sebebi duzelt, uyari kendiliginden dussun.
            🔑 Serkan (19 Eyl): *"Edit ekraninda her sey secilebilir olmali ki
            edit edebileyim."*
            ⚠️ "Sessizce degismesin" kaygisi HAKLI ve korundu: tip degisince azami
            UGS yeniden hesaplanir ve gorev yasaldan asimliya donebilir. Bu yuzden
            sonuc KAYDETMEDEN ONCE ekranda yazar (asagidaki `actualOpEtkisi`).
            Gerekce ve denetim izi zaten zorunlu.
            🔑 25 EKİ 2026 (Serkan, tasarım A): tip BACAK SATIRININ SONUNDA seçilir (ASSIGN'la aynı kutu); burada yalnız
            görevin YÖNETİCİ tipi görünür — ASSIGN'la aynı parça (`OperasyonBasligi`). Plan karşılaştırması bacak bacak. */}
        <div style={{ marginBottom:12 }}>
          <OperasyonBasligi tip={opType} testid="edit-operation-type" notTestid="edit-plan-notu" notlar={planNotlari}
            bilgi={isActual ? 'REALIZED DUTY — correcting a sector\'s type rewrites MAX FDP; the effect is shown below before you save' : null} />
        </div>
        {tipler.length > 1 && (
          <KarisikGorevNotu tipler={tipler} yoneten={opType} maxFdpMin={isActual ? null : (win?.maxFdpMin ?? null)} />
        )}

        {/* 🔑 SESSİZ DEĞİŞİM YOK: tip düzeltmesi azami UGS'yi yeniden yazar,
            sonucu KAYDETMEDEN ÖNCE pilot pilot görünür. Aşım çıkması kaydı
            engellemez (uçuş olmuştur) ama GİZLENMEZ de — İlke 1. */}
        {actualOpEtkisi && (
          <div data-testid="op-type-etki" style={{ ...S.note, marginBottom:12,
                 borderLeftColor: actualOpEtkisi.satirlar.some(x => x.asiyorYeni) ? C.red : C.accent,
                 color: actualOpEtkisi.satirlar.some(x => x.asiyorYeni) ? C.red : C.t2 }}>
            <b>EFFECT OF THIS CORRECTION</b> — MAX FDP comes from the operation type (Md.9)
            {actualOpEtkisi.ekipDegisti ? ' and the crew: a CRZ CPT makes it an augmented crew (Md.11)' : ''}
            {actualOpEtkisi.konaklamaDegisti ? ' and the split duty rest place (Md.15)' : ''}
            {actualOpEtkisi.dinlenmeDegisti && !actualOpEtkisi.ekipDegisti
              ? ' and the in-flight rest facility: the augmented crew extension applies only when it is IN USE (Md.11(1)(4))' : ''}.
            {actualOpEtkisi.satirlar.map(x => (
              <div key={x.key} style={{ marginTop:4 }}>
                {nameOf(x.r.pilot_id)}{x.yeni ? ' (NEW)' : ''} · MAX FDP {x.yeni ? '—' : fmtMin(x.eskiMax)} → <b>{fmtMin(x.yeniMax)}</b>
                {x.fdp != null && <> · ACTUAL FDP {fmtMin(x.fdp)}</>}
                {x.asiyorYeni
                  ? <b> — EXCEEDS BY {fmtMin(x.fdp - x.yeniMax)}</b>
                  : (x.asiyorEski ? ' — no longer exceeded' : '')}
              </div>
            ))}
            {actualOpEtkisi.olculemeyen && (
              <div data-testid="op-type-etki-olculemedi" style={{ marginTop:4 }}>
                ⚠ CANNOT VERIFY for at least one pilot — {actualOpEtkisi.olculemeyenSebep.join(' · ')}. The limit is
                not guessed; the server computes what it can and marks the duty.
              </div>
            )}
            {actualOpEtkisi.satirlar.some(x => x.asiyorYeni) && (
              <div style={{ marginTop:4 }}>
                This does NOT block the save: the flight was flown and the record must show
                what happened. It is recorded, and the overrun becomes visible.
              </div>
            )}
          </div>
        )}

        {/* ── GERÇEKLEŞEN SAATLER ────────────────────────────────────
            🔑 Serkan (7 Eyl 2026): *"Burada saatler yok, olsa güncellerdim
               hepsinin."*
            🔴 Sektör bloğu `!isActual` içinde — gerçekleşmiş görevde hiç
               çizilmiyordu; eksik girilen bir T/O–LND sonradan tamamlanamıyor,
               yanlış girilen düzeltilemiyordu. Bu blok İKİSİNDE de görünür.
            Girilen saat atamadaki BÜTÜN pilotlara yazılır (uçağın blok saati
            ekipte ortaktır); FDP her satırda kendi rapor saatinden hesaplanır. */}
        {head.duty_type === 'flight' && (head.sectors || []).length > 0 && (
          <div style={{ marginBottom:12 }}>
            <span style={S.label}>Actual times — UTC, HH:MM</span>
            {/* Uçulmuş görevde tip satırın SONUNDA (25 Eki 2026, tasarım A); planlıda Sectors satırında. */}
            <div style={{ display:'grid', gridTemplateColumns: isActual ? '86px 1fr 1fr 1fr 1fr 2.3fr 34px' : '86px 1fr 1fr 1fr 1fr 34px',
                          gap:8, marginBottom:4 }}>
              <span />
              {['OFF BLOCK', 'T/O', 'LND', 'ON BLOCK', ...(isActual ? ['OPERATION'] : []), ''].map(h => (
                <span key={h} style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)',
                                       letterSpacing:1 }}>{h}</span>
              ))}
            </div>
            {aktifSektorler.flatMap((sk, i) => [
              <div key={akt[i].kaynak ?? akt[i].anahtar} data-testid={`gercek-satir-${i}`}
                   style={{ display:'grid', gridTemplateColumns: isActual ? '62px 62px 1fr 1fr 1fr 1fr 2.3fr 34px' : '62px 62px 1fr 1fr 1fr 1fr 34px',
                                    gap:8, marginBottom:6, alignItems:'center' }}>
                <MeydanGirisi style={{ ...S.input, textAlign:'center' }}
                             placeholder="DEP" data-testid={`gercek-${i}-dep`}
                             value={gercek[i]?.dep || ''}
                             onChange={v => setGrc(i, 'dep', v)}
                             beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
                {/* VARIŞ = PLANLANAN MEYDAN (5 Eki 2026, Serkan): serbest değiştirilmez — plan değişikliği planlamada yapılır,
                    başka meydana inildiyse altındaki DIVERT. Araya eklenen yeni bacağın rotası elle girilir (planı odur). */}
                {akt[i].kaynak == null ? (
                  <MeydanGirisi style={{ ...S.input, textAlign:'center' }}
                               placeholder="DEST" data-testid={`gercek-${i}-dest`}
                               value={gercek[i]?.dest || ''}
                               onChange={v => setGrc(i, 'dest', v)}
                               beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
                ) : (
                  <div data-testid={`gercek-${i}-dest`}
                       title="Planned arrival — a change of plan is made in planning; if the aircraft landed elsewhere, use DIVERT"
                       style={{ ...S.input, textAlign:'center', color: gercek[i]?.divert ? C.t3 : 'var(--t1)',
                                textDecoration: gercek[i]?.divert ? 'line-through' : 'none' }}>
                    {gercek[i]?.dest || sk.dest || '—'}
                  </div>
                )}
                {['off_block', 'takeoff_time', 'landing_time', 'on_block'].map(k => (
                  <input key={k} {...zAlan(S.input, saatZorunlu(i), saatGecerli(gercek[i]?.[k]))} placeholder="HH:MM" maxLength={5}
                         data-testid={`gercek-${i}-${k}`}
                         value={gercek[i]?.[k] || ''}
                         onChange={e => setGrc(i, k, normTime(e.target.value))} />
                ))}
                {isActual && (ucusBacagiMi(i)
                  ? <OperasyonSecici {...zAlan({ ...S.input, fontSize:11 }, true, !!gercek[i]?.operation_type)}
                                     data-testid={`gercek-${i}-op`} value={gercek[i]?.operation_type || ''}
                                     onChange={e => setBacakTipi(i, e.target.value)} />
                  : <span style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)' }}>DH</span>)}
                {akt[i].kaynak == null
                  ? <button type="button" data-testid={`gercek-${i}-sil`} title="Remove this new sector"
                            style={{ ...S.btnSil, padding:'8px 8px' }} onClick={() => gercekBacakSil(i)}>✕</button>
                  : <span />}
              </div>,
              // DIVERT satırı (5 Eki 2026, tasarım onaylı): kâğıt bacakta düğme → "LANDED AT *" + DIVERT + ✕; iPad bacağında
              // iOS'tan gelen divert yalnız gösterilir (düzeltmesi arşivden).
              ...((divertAcilabilir(i) || (arsivliBacak(sk) && sk.actual_dest && sk.actual_dest !== sk.dest)) ? [
                <div key={`dv-${akt[i].kaynak ?? akt[i].anahtar}`} data-testid={`gercek-${i}-divert-satir`}
                     style={{ display:'flex', gap:8, alignItems:'center', margin:'-2px 0 8px 70px', flexWrap:'wrap' }}>
                  {arsivliBacak(sk) ? (<>
                    <span style={badge('red')}>DIVERT</span>
                    <span style={{ fontSize:10, color:C.t2, fontFamily:'var(--mono)' }}>landed {sk.actual_dest} — from the iPad</span>
                  </>) : !gercek[i]?.divert ? (
                    <button type="button" data-testid={`gercek-${i}-divert`} style={{ ...S.btnS, padding:'4px 10px', fontSize:10 }}
                            title="The aircraft landed somewhere other than the planned arrival"
                            onClick={() => setGercek(gs => gs.map((g, j) => (j === i ? { ...g, divert: true } : g)))}>DIVERT…</button>
                  ) : (<>
                    <span style={{ fontSize:9, color:C.red, fontFamily:'var(--mono)', letterSpacing:1 }}>LANDED AT *</span>
                    <MeydanGirisi {...zAlan({ ...S.input, textAlign:'center', width:90 }, true, inilenGecerli(i))}
                                 placeholder="ICAO" data-testid={`gercek-${i}-landed`}
                                 value={gercek[i]?.landed || ''} onChange={v => setGrc(i, 'landed', v)}
                                 beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
                    <span style={badge('red')}>DIVERT</span>
                    <button type="button" data-testid={`gercek-${i}-divert-kaldir`} title="Not a divert — remove"
                            style={{ ...S.btnS, padding:'4px 8px', fontSize:10 }}
                            onClick={() => setGercek(gs => gs.map((g, j) => (j === i ? { ...g, divert: false, landed: '' } : g)))}>✕</button>
                  </>)}
                </div>] : []),
              ...(akt[i].kaynak == null ? [
                <div key={`yeni-${akt[i].anahtar}`} data-testid={`gercek-${i}-yeni`}
                     style={{ fontSize:10, color:C.accent, fontFamily:'var(--mono)', margin:'-2px 0 6px' }}>
                  NEW SECTOR — flown on a paper OFP; saved for the whole crew
                </div>] : []),
              <EkleSecici key={`ekle-${akt[i].kaynak ?? akt[i].anahtar}`} testid={`gercek-bacak-ekle-${i}`}
                          secenekler={[{ tur:'sector', etiket:'SECTOR', onSec: () => gercekBacakEkle(i) }]} />,
            ])}
            <div style={{ fontSize:10, color:C.t3, lineHeight:1.6 }}>
              These are the aircraft&apos;s times — saving writes them to every pilot on this
              assignment. Each pilot&apos;s FDP and rest are recalculated from their own report
              time. Leave a field empty if it was never recorded; it stays unmeasured rather
              than guessed.
            </div>
            {/* 🔑 Kutu burada, saatlerin HEMEN ALTINDA: saati giren kişi aynı
                ekranda "bu uçuş nereye yazılacak" sorusunu da görsün. Arşivi
                olan uçuşta çıkmaz — orada kâğıt OFP demek yanlış beyandır. */}
            {(kagitBacakVar || yeniBacakVar) && (
              <PaperOfpKutusu isaretli={paperOfp} setIsaretli={setPaperOfp}
                              reg={paperReg} setReg={setPaperReg} ucaklar={ucaklar}
                              testid="edit-paper-ofp" ucakHata={ucakHata} kayitVar={paperBaslangic.isaretli}
                              zorunlu={yeniBacakVar}
                              sektorler={aktifSektorler.map((x, i) => ({ ...x, ...(gercek[i] || {}), _arsiv: arsivliBacak(x) }))}
                              inisler={kagitInis} setInis={setInis}
                              evrak={{ liste: kagitEvrak, yeni: yeniEvrak, kaldirilacak: kaldirilacakEvrak, ret: evrakRet,
                                       okumaHata: evrakOkumaHata, ekle: evrakEkle, kaldir: evrakKaldirIsaretle,
                                       yeniCikar: (i) => setYeniEvrak(ys => ys.filter((_, j) => j !== i)) }} />
            )}
          </div>
        )}

        {/* 🔑 GERÇEKLEŞMİŞ GÖREVDE TARİH (18 Eyl 2026) — Serkan: *"burada tarih
            seçilemiyor, saatler güncellenir ama tarih güncellenemez"*. 16 Eylül'e
            girilen görev aslında 17 Eylül'dü; düzeltmenin yolu yoktu.
            Bağlı kayıtta kilitli kalır — sebebi ekranda yazılı, sessizce
            devre dışı bırakılmaz. */}
        {isActual && (<>
          <span style={S.label}>Date</span>
          <input type="date" style={{ ...S.input, width:170, marginBottom:4 }}
                 value={date} disabled={planaBagli}
                 onChange={e => setDate(e.target.value)} />
          <div style={{ fontSize:9, marginBottom:10, fontFamily:'var(--mono)',
                        color: planaBagli ? C.t3 : (date !== head.duty_date ? (C.amber || 'var(--amber)') : C.t3) }}>
            {planaBagli
              ? 'LOCKED — this duty is attached to an archived flight; correct the date there.'
              : date !== head.duty_date
                ? `DATE WILL MOVE ${fmtD(head.duty_date)} → ${fmtD(date)} — report and duty end shift with it; FDP and rest are recomputed.`
                : 'Correct a mis-entered date here. Times stay as recorded.'}
          </div>
        </>)}

        {!isActual && (<>
          <span style={S.label}>Date</span>
          <input type="date" style={{ ...S.input, width:170, marginBottom:10 }} value={date} onChange={e => setDate(e.target.value)} />
          <span style={S.label}>Sectors</span>
          {legs.flatMap((l, i) => [
            <div key={i} style={{ display:'grid', gridTemplateColumns:'26px 1fr 1fr 1fr 1fr 2.35fr 2fr 38px', gap:8, marginBottom:6, alignItems:'center' }}>
              <div style={{ fontSize:11, color:C.t3, textAlign:'center', fontFamily:'var(--mono)' }}>{i + 1}</div>
              <MeydanGirisi {...zAlan(S.input, true, !!l.dep)} value={l.dep} onChange={v => setLeg(i, 'dep', v)} data-testid={`edit-leg-${i}-dep`}
                beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
              <MeydanGirisi {...zAlan(S.input, true, !!l.dest)} value={l.dest} onChange={v => setLeg(i, 'dest', v)} data-testid={`edit-leg-${i}-dest`}
                beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
              <input {...zAlan(S.input, true, saatGecerli(l.etd))} value={l.etd} data-testid={`edit-leg-${i}-etd`} onChange={e => setLeg(i, 'etd', normTime(e.target.value))} />
              <input {...zAlan(S.input, true, saatGecerli(l.eta))} value={l.eta} data-testid={`edit-leg-${i}-eta`} onChange={e => setLeg(i, 'eta', normTime(e.target.value))} />
              {/* TİP (25 Eki 2026, tasarım A) — ASSIGN'daki kutunun aynısı, aynı yerde: ETA'dan sonra, AIRCRAFT'tan önce. */}
              {ucusBacagiMi(i)
                ? <OperasyonSecici {...zAlan({ ...S.input, fontSize:11 }, true, !!l.operation_type)} data-testid={`edit-leg-${i}-op`}
                                   value={l.operation_type || ''} onChange={e => setBacakTipi(i, e.target.value)} />
                : <span style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)' }}>DH</span>}
              {/* TESCİL (21 Eki 2026, K2) — ASSIGN'daki AIRCRAFT ile aynı: zorunlu, AIRCRAFTS'tan (yalnız aktif); boş sonrakiler dolar. */}
              <select {...zAlan({ ...S.input, fontSize:11 }, true, !!l.reg)} data-testid={`edit-leg-${i}-reg`} value={l.reg || ''}
                      onChange={e => { const v = e.target.value;
                        setLegs(ls => ls.map((x, j) => j === i ? { ...x, reg: v } : (j > i && !x.reg ? { ...x, reg: v } : x))); }}>
                <option value="">— AIRCRAFT —</option>
                {(aircraft || []).filter(a => a.active !== false)
                  .map(a => <option key={a.registration} value={a.registration}>{a.registration} ({a.ac_type})</option>)}
              </select>
              {/* SEKTOR SIL (4 Agu, Serkan: "ucusun birini alabilmem lazim") —
                  en az 1 bacak kalir; pencere yeni listeden yeniden hesaplanir. */}
              <button style={{ ...S.btnSil, padding:'8px 10px' }}
                      onClick={() => bacakSil(i)}>✕</button>
            </div>,
            <RaaqUyarisi key={`raaq-${i}`} icaolar={[l.dep, l.dest]} raaq={raaq} testid={`edit-raaq-uyari-${i}`} />,
            <EkleSecici key={`ekle-${i}`} testid={`edit-bacak-ekle-${i}`}
                        secenekler={[{ tur:'sector', etiket:'SECTOR', onSec: () => bacakEkle(i) }]} />,
          ])}
          {planliOnizleme && (() => {
            // Md.27 (5 Eki 2026): eğitim uçuş süresi aşımı da kaydı durdurur — önizleme aynı gerekçeyi söyler.
            const egitimAsimi = (a) => (a?.ftl_gerekce || []).filter(g => EGITIM_ENGEL_TURLERI.includes(g.tur));
            const asim = Object.values(planliOnizleme).some(h => h?.alanlar?.fdp_exceeded || egitimAsimi(h?.alanlar).length);
            return (
              <div data-testid="edit-onizleme" style={{ ...S.note, borderLeftColor: asim ? C.red : C.accent, margin:'8px 0' }}>
                {crew.filter(c => c.pilot).map(c => {
                  const h = planliOnizleme[c.key]; const a = h?.alanlar || {};
                  return (
                    <div key={c.key} data-testid={`edit-onizleme-${c.key}`}>
                      {nameOf(c.pilot)} · REPORT {a.report_time ? utcSaat(a.report_time) : '—'} · FDP {fmtMin(a.fdp_minutes)} / MAX {fmtMin(a.max_fdp_minutes)}
                      {a.standby_reduction_min ? ` · STANDBY −${fmtMin(a.standby_reduction_min)}` : ''}
                      {a.fdp_exceeded ? ' · EXCEEDED — CANNOT BE SAVED' : ''}
                      {egitimAsimi(a).map(g => ` · ${g.metin} — CANNOT BE SAVED`).join('')}
                      {h?.eksik?.length ? ` · CANNOT VERIFY: ${h.eksik.join(' | ')}` : ''}
                    </div>
                  );
                })}
                {dortPilotYeni ? <div>4-PILOT CREW — augmented, two CRZ CPT (SHT-FTL/HG Md.11(4))</div>
                  : ucPilotYeni ? <div>3-PILOT CREW — augmented (SHT-FTL/HG Md.11)</div> : null}
              </div>
            );
          })()}
          {onizlemeBekliyor && (
            <div data-testid="edit-onizleme-bekliyor" style={{ ...S.note, margin:'8px 0' }}>FTL CHECK IN PROGRESS…</div>
          )}
          {/* NOBET (Md.17) — pilot bazli oldugu icin yukaridaki tek satir yetmez.
              Kaydetmeden ONCE hangi pilotun tavaninin nereye dustugu gorunur. */}
          {win && (() => {
            const est = utcISO(date, win.report);
            const rows = crew.map(c => ({ c, ...standbyFor(c.pilot, date, est) })).filter(r => r.sb);
            if (!rows.length) return null;
            return rows.map(({ c, pWin, sb }, i) => (
              <div key={c.rowId || i} style={{ ...S.note, margin:'0 0 8px',
                     borderLeftColor: sb.ok ? C.accent : C.red, color: sb.ok ? C.t2 : C.red }}>
                {nameOf(c.pilot)} — {sb.kind === 'airport_standby' ? 'AIRPORT' : 'OTHER'} STANDBY {fmtMin(sb.standbyMin)} ({sb.reference})
                {sb.fdpReductionMin > 0 ? ` · MAX FDP −${fmtMin(sb.fdpReductionMin)} → ${fmtMin(planliOnizleme?.[c.key]?.alanlar?.max_fdp_minutes ?? pWin.maxFdpMin)}` : ' · NO FDP REDUCTION'}
                <GerekceListesi kunyeli={kunyeliYaDuz(sb)} testid={`edit-sb-${i}`} neYapmali={NE_YAPMALI.pilot} />
              </div>
            ));
          })()}
        </>)}

        {siraHatasi && (
          <div data-testid="edit-sira-hatasi" style={{ ...S.note, borderLeftColor:C.red, color:C.red, margin:'8px 0' }}>
            SECTOR TIMES OVERLAP — {siraHatasi}
          </div>
        )}
        {/* ROTA KOPUKLUĞU (5 Eki 2026, Serkan) — uyarı, engel değil. */}
        {head.duty_type === 'flight' && rotaKopukluklari(rolSektorleri).map(m => (
          <div key={m} data-testid="edit-rota-kopuk" style={{ ...S.note, borderLeftColor:'var(--amber)', color:'var(--amber)', margin:'8px 0' }}>{m}</div>
        ))}
        <span style={S.label}>Crew</span>
        {crew.map((c, i) => {
          // Rol artık BACAK tablosunda seçilir (29 Eyl 2026); burada üyenin
          // bacaklardaki rollerinin özeti durur. Pilot değiştirmek (takas)
          // rolleri satırda bırakır, yalnız isimler yer değiştirir.
          const rolleri = [...new Set(roller.filter(Boolean).map(h => h[c.key]).filter(Boolean))];
          return (
            <div key={c.key} data-testid={`edit-crew-${i}`}
                 style={{ display:'grid', gridTemplateColumns: egitimliEdit ? '110px 1fr 230px' : '110px 1fr', gap:8,
                          marginBottom:6, alignItems:'center' }}>
              <span style={{ fontSize:11, fontFamily:'var(--mono)', color:C.t2 }}>
                {c.yeni && <span style={{ ...badge('blue'), marginRight:6 }}>NEW</span>}
                {rolleri.join(' / ') || '—'}
              </span>
              {c.yeni
                ? <b style={{ fontSize:12, fontFamily:'var(--mono)' }}>{nameOf(c.pilot)} — {pilots.find(p => p.id === c.pilot)?.full_name || ''}</b>
                : (
                  <select style={S.input} value={c.pilot} data-testid={`edit-crew-${i}-pilot`}
                          onChange={e => pickPilot(i, e.target.value)}>
                    {options().map(pp => <option key={pp.id} value={pp.id}>{pp.code} — {pp.full_name}</option>)}
                  </select>
                )}
              {/* Md.27 (5 Eki 2026, Serkan A): eğitim türü pilot başına. */}
              {egitimliEdit && (
                <select {...zAlan(S.input, !!c.pilot, !!egitimTurleri[c.key])} data-testid={`edit-crew-${i}-egitim-turu`}
                        value={egitimTurleri[c.key] || ''}
                        onChange={e => setEgitimTurleri(t => ({ ...t, [c.key]: e.target.value }))}>
                  <option value="">— TRAINING KIND —</option>
                  {ucusEgitimTurleri(editKurallari)
                    .map(([k, v]) => <option key={k} value={k}>{v.label} — {fmtMin(v.flight_time_min)}</option>)}
                </select>
              )}
            </div>
          );
        })}

        {/* ── 3. KİŞİ KUTUSU — ASSIGN İLE ORTAK (29 Eyl 2026) ──────────────── */}
        {head.duty_type === 'flight' && crew.length >= 2 && (() => {
          // 5 Eki 2026 (4 pilotlu ekip): ASSIGN ile aynı akış — CRZ listesi, ilk CRZ'den sonra yine + ADD COCKPIT CREW,
          // seçici YALNIZ ekipte olmayan pilotlar (Serkan: "unselected crews"). Kayıtlı CRZ'nin REMOVE'u yok (CREW'de değişir).
          const crzKeyleri = crzUyeleri(roller);
          const kayitliVar = crzKeyleri.some(k => !crew.find(x => x.key === k)?.yeni);
          const secilebilir = options().filter(p => !crew.some(c => c.pilot === p.id));
          const seciciAcik = ucuncuMod === 'crz' && (crzKeyleri.length === 0 || crzSlot);
          const kapat = () => { yeniCrzleriKaldir(); setCrzSlot(false); setUcuncuMod(null); };
          return (
            <UcuncuKisiKutusu
              testid="edit-third-crew"
              mod={ucuncuMod}
              setMod={(m) => { setUcuncuMod(m); if (m !== 'crz') { yeniCrzleriKaldir(); setCrzSlot(false); } }}
              crzler={crzKeyleri.map(k => {
                const u = crew.find(x => x.key === k);
                return { key: k, ad: `${nameOf(u?.pilot)}${u?.yeni ? ' (NEW)' : ''}`,
                         onKaldir: u?.yeni ? () => { crzKaldir(k); if (crzKeyleri.length <= 1) setUcuncuMod(null); } : null };
              })}
              crzSecici={seciciAcik ? (
                <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                  <select {...zAlan({ ...S.input, width:260 }, true, false)} data-testid="edit-crz-pick" value=""
                          onChange={e => crzEkle(e.target.value)}>
                    <option value="">{crzKeyleri.length ? '— SELECT 2ND CRZ CPT —' : '— SELECT CRZ CPT —'}</option>
                    {secilebilir.map(p => <option key={p.id} value={p.id}>{p.code} — {p.full_name}</option>)}
                  </select>
                  {crzKeyleri.length > 0 && (
                    <button type="button" data-testid="edit-crz-pick-kapat" style={{ ...S.btnS, color:C.t3 }}
                            onClick={() => setCrzSlot(false)}>✕</button>
                  )}
                  <span style={{ fontSize:10, color:C.t3 }}>Only pilots not yet in this crew are listed.</span>
                </div>
              ) : null}
              onCrzEkle={ucuncuMod === 'crz' && crzKeyleri.length >= 1 && crew.length < 2 + AZAMI_CRZ && !crzSlot
                ? () => setCrzSlot(true) : null}
              onKutuKapat={crzKeyleri.length === 0 ? kapat : null}
              dinlenme={dinlenme} setDinlenme={setDinlenme}
              augmentedNot={(<>
                {!isActual && ucPilotYeni && <AugmentedNot win={win} />}
                {kayitliVar && (
                  <div style={{ ...S.note, marginTop:6 }}>
                    To replace a recorded CRZ CPT, change the pilot in CREW above; to move the role,
                    use the sector table below.
                  </div>
                )}
                {yeniUyeler.length > 0 && (
                  <div style={{ ...S.note, marginTop:6 }}>
                    {yeniUyeler.map(u => nameOf(u.pilot)).join(' and ')} {yeniUyeler.length > 1 ? 'are' : 'is'} added to this
                    assignment as a NEW duty record on save — FDP and rest are computed for them the same way as for the rest
                    of the crew.
                  </div>
                )}
              </>)}
              examiner={examiner} setExaminer={setExaminer}
              onCheckKaldir={() => { setUcuncuMod(null); setExaminer(''); }} />
          );
        })()}

        {/* ── BACAK BAŞINA ROLLER (29 Eyl 2026) ────────────────────────────── */}
        {head.duty_type === 'flight' && (
          <BacakRolleri
            testid="edit-leg-roles"
            sektorler={rolSektorleri}
            uyeler={crew.map(c => ({ key: c.key, ad: nameOf(c.pilot) }))}
            haritalar={roller}
            onDegis={bacakRolDegis} />
        )}

        {/* ── AÇIK MESAİ (SPLIT DUTY) — ASSIGN ile AYNI kutu (29 Eyl 2026) ──── */}
        <AcikMesaiKutusu split={editSplit} konaklama={konaklama} setKonaklama={setKonaklama}
                         testid="edit-split" />

        {/* ── SKPK — SORUMLU KAPTAN PILOT KARARI (SHT-FTL/HG Md.12) ──────
              Yalniz GERCEKLESMIS gorevde: Md.12(1) "gorev baslangici SONRASINDA
              baslayan ongorulemeyen haller" der — SKPK planlama araci degildir.
              Girilen degerler kaydin azami UGS'sini ve dinlenmesini DEGISTIRIR;
              bu yuzden ayri bir bolum, gizli bir yan etki degil. ── */}
        {skpkAllowed && (
          <div style={{ border:`1px dashed ${C.border2}`, padding:'12px 14px', margin:'14px 0' }}>
            <div style={{ ...S.panelT, marginBottom:6 }}>COMMANDER'S DISCRETION — SKPK (Md.12)</div>
            <div style={{ ...S.note, marginBottom:10 }}>
              Record what the commander actually did AFTER duty start because of unforeseen circumstances.
              Leave blank if none. Any entry changes this duty's MAX FDP and rest, is reported to the
              operator (Md.12/1/c/1), and — if it exceeds 01:00 — must reach the DGCA within 28 days (Md.12/1/c/2).
            </div>
            <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:10 }}>
              <div style={{ width:150 }}><span style={S.label}>FDP extension</span>
                <input style={S.input} placeholder="HH:MM" value={skpkExt} data-testid="skpk-ext"
                       onChange={e => setSkpkExt(normTime(e.target.value))} /></div>
              <div style={{ width:150 }}><span style={S.label}>Rest reduction</span>
                <input style={S.input} placeholder="HH:MM" value={skpkRed} data-testid="skpk-red"
                       onChange={e => setSkpkRed(normTime(e.target.value))} /></div>
            </div>
            {/* PILOT BAZLI SONUC — taban ve hak edilen dinlenme pilota gore degisir */}
            {group.rows.map(row => {
              const s = skpkFor(row);
              if (!s) return null;
              const k = s.skpk;
              const showSuggest = !skpkExt && s.actualFdpMin != null && s.baseMaxFdp != null
                                  && s.actualFdpMin > s.baseMaxFdp;
              return (
                <div key={row.id} style={{ ...S.note, marginBottom:8,
                       borderLeftColor: k.ok ? C.accent : C.red, color: k.ok ? C.t2 : C.red }}>
                  <b>{nameOf(row.pilot_id)}</b>
                  {' · '}MAX FDP {fmtMin(s.baseMaxFdp)}{k.extensionMin > 0 && !s.ugsUzatmaz ? ` → ${fmtMin(k.maxFdpWithSkpkMin)}` : ''}
                  {k.extensionMin > 0 && s.ugsUzatmaz && <span data-testid="skpk-egitim-notu"> · {SKPK_EGITIM_NOTU.toUpperCase()}</span>}
                  {s.actualFdpMin != null && <> · ACTUAL FDP {fmtMin(s.actualFdpMin)}{k.fdpStillExceeded ? ' — STILL EXCEEDED' : ''}</>}
                  {k.reductionMin > 0 && <>
                    {' · '}EARNED REST BEFORE {fmtMin(s.prev?.min_rest_minutes)} − {fmtMin(k.reductionMin)} = {fmtMin(k.restAfterReductionMin)} (floor {fmtMin(k.restFloorMin)})
                    {' · '}NEXT REST {fmtMin(s.baseEarnedRest)} → {fmtMin(k.minRestWithCompensationMin)} (2× Md.12/2)
                  </>}
                  {k.applied && <> · {k.authorityReportRequired
                    ? `DGCA REPORT DUE ${fmtD(k.authorityDueISO)}`
                    : 'OPERATOR REPORT ONLY (≤01:00)'}</>}
                  <GerekceListesi kunyeli={kunyeliYaDuz(k)} testid={`edit-skpk-${row.id}`} neYapmali={NE_YAPMALI.skpk} />
                  {showSuggest && (
                    <div style={{ marginTop:6 }}>
                      {/* ILKE 1: hesaplanan degeri KENDIMIZ yazmayiz — oneririz,
                          insan onaylar. Uydurma yok, sessiz yazma da yok. */}
                      <button style={{ ...S.btnS, padding:'4px 10px' }}
                              onClick={() => setSkpkExt(fmtMin(s.actualFdpMin - s.baseMaxFdp))}>
                        USE {fmtMin(s.actualFdpMin - s.baseMaxFdp)} (actual {fmtMin(s.actualFdpMin)} − max {fmtMin(s.baseMaxFdp)})
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
            <span style={S.label}>Commander's report (mandatory when SKPK is used — Md.12/1/c/1)</span>
            <HarfliGiris as="textarea" {...zAlan({ ...S.input, minHeight:60, resize:'vertical' }, skpkGirildi, gerekceTamam(skpkReason))}
                      value={skpkReason} onChange={setSkpkReason} data-testid="skpk-gerekce"
                      placeholder="Unforeseen circumstances and what the commander decided…" />
            {/* Zorunlu yalnız SKPK girilince (Md.12/1/c/1) — boşken kırmızı satır yanıltırdı. Kural ortak (21 Eki 2026, K7). */}
            {skpkGirildi && <GerekceIpucu metin={skpkReason} testid="skpk-gerekce-ipucu" />}
            {head.skpk_reported_at && (
              <div style={{ ...S.note, marginTop:8 }}>
                REPORTED TO OPERATOR {fmtDT(head.skpk_reported_at)}
                {head.skpk_authority_due && <> · DGCA DUE {fmtD(head.skpk_authority_due)}
                  {head.skpk_authority_reported_at
                    ? ` · SENT ${fmtD(head.skpk_authority_reported_at)}`
                    : ' · NOT SENT YET'}</>}
              </div>
            )}
          </div>
        )}

        {/* ── FTL DURUMU (4 Eyl 2026) ────────────────────────────────
            Kaydetmeden ONCE gorunur. Planli gorevde kirmizi satir kaydi
            engeller; gerceklesmis gorevde engellemez ama GORUNUR — ucus
            olmustur, kaydi duzeltmek yasak degildir, gormezden gelmek yasaktir
            (Ilke 1). Amber uyarilar hicbir zaman engellemez. */}
        {(editUygunsuz.length > 0 || editUyarilar.length > 0) && (
          <div style={{ ...S.note, marginTop:12,
                        borderLeftColor: editEngeller.length ? C.red : C.amber }}
               data-testid="edit-ftl-status">
            {/* 30 Eyl 2026 (adım ①): her gerekçe ayrı satır, yanında ⓘ — kural
                ihlali kartıyla aynı açıklama. Uçulmuş görevde ⓘ engel değil kayıt der. */}
            {editUygunsuz.map(f => (
              <div key={`r-${f.code}`} style={{ color:C.red, fontSize:11 }}>
                <b>{f.code}</b> {isActual ? '— RECORDED DESPITE' : '— NOT LEGAL'}:
                <div style={{ paddingLeft:12 }}>
                  <GerekceListesi kunyeli={kunyeliYaDuz(f)} testid={`edit-ftl-${f.code}`}
                                  neYapmali={NE_YAPMALI.pilot}
                                  neYapmaliSec={isActual ? uculduNeYapmali : null} />
                </div>
              </div>
            ))}
            {editUyarilar.map(f => (
              <div key={`w-${f.code}`} style={{ color:C.amber, fontSize:11 }}>
                ⚠ <b>{f.code}</b> {f.warnings.join(' · ')}
              </div>
            ))}
            {!isActual && editEngeller.length > 0 && (
              <div style={{ color:C.t3, fontSize:11, marginTop:4 }}>
                Editing a PLANNED duty is still planning — the same gate as assignment applies.
              </div>
            )}
          </div>
        )}

        {/* ── EKİP DÜZEYİ KAPILAR — ASSIGN ile AYNI (29 Eyl 2026) ─────────── */}
        {(ekipKapisi.gerekceler.length > 0 || ekipKapisi.uyarilar.length > 0) && (
          <div style={{ ...S.note, marginTop:12,
                        borderLeftColor: ekipEngeller.length ? C.red : C.amber }}
               data-testid="edit-crew-level">
            <GerekceListesi kunyeli={ekipKapisi.kunyeli} testid="edit-crew"
                            onEk={isActual ? 'RECORDED DESPITE — ' : ''}
                            neYapmali={isActual ? NE_YAPMALI.uculdu : NE_YAPMALI.ekip}
                            neYapmaliKayit={isActual ? NE_YAPMALI.uculdu : undefined} />
            {ekipKapisi.uyarilar.map((u, i) => (
              <div key={`u-${i}`} style={{ color:C.amber, fontSize:11 }}>{u}</div>
            ))}
            <div style={{ color:C.t3, fontSize:10, marginTop:4 }}>
              Crew-level rules (medical limitations, FCL.060(a)(3) cruise relief, FCL.065 age) — the same
              check as ASSIGN. {isActual ? 'A flown duty is a record: shown, not blocked.' : 'Red blocks the save on a planned duty.'}
            </div>
          </div>
        )}

        <span style={S.label}>Reason (mandatory — audit trail)</span>
        <HarfliGiris as="textarea" {...zAlan({ ...S.input, minHeight:70, resize:'vertical' }, true, gerekceTamam(reason))}
                     value={reason} onChange={setReason} data-testid="edit-gerekce"
                     placeholder={gercekGiris ? 'Why are these times being entered by hand? (e.g. the EFB did not run this flight)' : undefined} />
        <GerekceIpucu metin={reason} testid="edit-gerekce-ipucu" />

        <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14 }}>
          <button style={S.btnS} onClick={onClose}>CANCEL</button>
          <button style={{ ...S.btnP, opacity: gerekceTamam(reason) && !saving && !editEngeller.length && !ekipEngeller.length ? 1 : .45 }}
                  disabled={!gerekceTamam(reason) || saving || editEngeller.length > 0 || ekipEngeller.length > 0 || onizlemeBekliyor}
                  onClick={save}>{gercekGiris ? 'SAVE AS FLOWN' : 'SAVE & LOG'}</button>
        </div>
      </div>
    </div>
  );
}

// ═══ 0b) FTL EDIT REPORT — DENETIM IZI (ftl_duty_edits) ═══════════
// Serkan: "crew modulde yapilan edit ve delete islemlerinin log kayitlarini
// goremiyorum — FTL edit report olsun."
// Gorulmeyen denetim izi yarim denetim izidir. Ozellikle SILINEN gorevlerde
// bu kayit TEK kanittir: satir artik yok, geriye yalniz mezar tasi kaliyor.
// Tablo bilerek degistirilemez ve silinemez (UPDATE/DELETE policy YOK).
function EditReport({ pilots, duties, customerId }) {
  // ── 3. ADIM: ARALIK SORGUDA + SAYFA BAŞINA 100 (6 Eki 2026 · 24 ay şartı) ─────────────────────────────────────────────
  // 🔑 Serkan (6 Eki): *"burada yüzlerce report var, hani 100/100 gösterecektik"* · tarih aralığı **C** — BY DUTY DATE /
  //    BY CHANGE DATE seçimi, varsayılan **B** (görev tarihi): *"varsayılan B ve C dediğin gibi yapalım"*.
  // 🔴 ÖNCESİ: iz kayıtlarının TAMAMI FTL paneli açılırken okunuyor, aralık ekranda süzülüyor ve aralıktaki her şey tek
  //    uzun listede diziliyordu; tarih yalnız DEĞİŞİKLİK gününe göreydi.
  // 🔑 ŞİMDİ: yalnız seçilen aralığın o sayfası (100) sunucudan okunur; sayaç "N RECORDS IN RANGE"; PRINT / PDF aralığın
  //    TAMAMINI parça parça okuyup basar. Görev tarihi iz satırında (`duty_date`, göç 20261006a — veritabanı doldurur).
  //    Tarihi bilinmeyen iz (görevi 6 Eki'den önce silinmiş, en çok 19) BY DUTY DATE'te sessizce kaybolmaz: not söyler.
  const today = new Date().toISOString().slice(0, 10);
  const plus = shiftDate;   // UTC gün ekleme (3 Eki 2026 — eskiden yerel saatle)
  const [pilotId, setPilotId] = useState('');
  const [from, setFrom] = useState(() => plus(today, -30));
  const [to, setTo] = useState(today);
  const [tarihTuru, setTarihTuru] = useState('gorev');   // 'gorev' (BY DUTY DATE, varsayılan) | 'degisiklik' (BY CHANGE DATE)
  const [sayfa, setSayfa] = useState(1);
  const [veri, setVeri] = useState({ satirlar: [], toplam: 0, tarihsiz: 0, yuklendi: false });
  const [okumaHatasi, setOkumaHatasi] = useState(null);
  const [baskiHatasi, setBaskiHatasi] = useState(null);
  const [basiliyor, setBasiliyor] = useState(false);
  const [yenile, setYenile] = useState(0);

  const pilotName = (id) => {
    const p = pilots.find(x => x.id === id);
    return p ? `${p.code || '—'} — ${p.full_name || ''}`.trim() : '—';
  };
  const dutyOf = (id) => (duties || []).find(d => d.id === id);
  // Görev silinmişse de iz kendi görev tarihini taşır (göç 20261006a) — "— deleted —" yanında gün yazılır.
  const gorevMetni = (e) => {
    const d = dutyOf(e.duty_id);
    if (d) return `${fmtD(d.duty_date)} ${routeOf(d)}`;
    return e.duty_date ? `${fmtD(e.duty_date)} — deleted —` : '— deleted —';
  };

  // Filtre değişince ilk sayfa.
  useEffect(() => { setSayfa(1); }, [pilotId, from, to, tarihTuru]);

  // Aralık TEK yerde: sayfa okuması da baskının tam okuması da bunu çağırır (iki ayrı süzgeç yazılmaz).
  const aralik = useCallback((q) => {
    let s = q.eq('customer_id', customerId);
    if (pilotId) s = s.eq('pilot_id', pilotId);
    if (tarihTuru === 'gorev') {
      return s.gte('duty_date', from).lte('duty_date', to)
        .order('duty_date', { ascending: false }).order('created_at', { ascending: false });
    }
    return s.gte('created_at', `${from}T00:00:00Z`).lte('created_at', `${to}T23:59:59.999Z`)
      .order('created_at', { ascending: false });
  }, [customerId, pilotId, from, to, tarihTuru]);
  const kisi = useCallback((q) => (pilotId ? q.eq('pilot_id', pilotId) : q), [pilotId]);

  useEffect(() => {
    if (!customerId || !from || !to) return undefined;
    let iptal = false;
    (async () => {
      setVeri(v => ({ ...v, yuklendi: false }));
      const bas = (sayfa - 1) * SAYFA_BOYU;
      const [s, t] = await Promise.all([
        aralik(supabase.from('ftl_duty_edits').select('*', SAYILI)).order('id', { ascending: true }).range(bas, bas + SAYFA_BOYU - 1),
        tarihTuru === 'gorev'
          ? kisi(supabase.from('ftl_duty_edits').select('id', { count: 'exact', head: true }).eq('customer_id', customerId).is('duty_date', null))
          : Promise.resolve({ count: 0, error: null }),
      ]);
      if (iptal) return;
      const metin = sayfaHataMetni(s, bas, SAYFA_BOYU) || (t.error ? (t.error.message || String(t.error)) : null);
      if (metin) {
        setOkumaHatasi([{ ad: 'EDIT REPORT (ftl_duty_edits)', metin }]);
        setVeri({ satirlar: [], toplam: 0, tarihsiz: 0, yuklendi: true });
        return;
      }
      setOkumaHatasi(null);
      setVeri({ satirlar: s.data || [], toplam: s.count ?? 0, tarihsiz: t.count || 0, yuklendi: true });
    })();
    return () => { iptal = true; };
  }, [aralik, kisi, sayfa, customerId, from, to, tarihTuru, yenile]);

  const kindBadge = (t) => {
    const k = t === 'DELETE' ? 'red' : t === 'CANCEL' ? 'amber'
            : t === 'CREW_CHANGE' ? 'blue' : t === 'AUTO_CREATED' ? 'dim' : 'blue';
    return <span style={badge(k)}>{t}</span>;
  };

  // AYRI PENCEREYE BAS — window.print() dogrudan cagrilirsa admin panelinin
  // TAMAMI (sol menu, sekmeler, filtreler) kagida gider. DutyHistory zaten
  // boyle yapiyor; ayni desen.
  // 🔑 Baskı sayfadaki 100'ü değil ARALIĞIN TAMAMINI basar (parça parça okunur). Pencere TIKLAMA ANINDA açılır —
  //    okuma bittikten sonra açılsaydı tarayıcı açılır pencereyi engelleyebilirdi; okuma düşerse pencere kapanır ve
  //    sebep ekranda yazar (yarım rapor basılmaz — Serkan A).
  const printReport = async () => {
    const w = window.open('', '_blank', 'width=1000,height=700');
    if (!w) return;
    w.document.write('<p style="font-family:sans-serif;font-size:12px">Preparing the report…</p>');
    setBasiliyor(true); setBaskiHatasi(null);
    const tam = await hepsiniOku(() => aralik(supabase.from('ftl_duty_edits').select('*', SAYILI)));
    const { dustu, oku } = okumaDenetimi();
    const rows = oku('EDIT REPORT (ftl_duty_edits)', tam) || [];
    setBasiliyor(false);
    if (dustu.length) { w.close(); setBaskiHatasi(dustu); return; }
    const body = rows.map(e => {
      const duty = gorevMetni(e);
      return `<tr class="${e.edit_type === 'DELETE' ? 'del' : ''}">
        <td>${esc(fmtDT(e.created_at))}</td>
        <td><b>${esc(duzenleyenKodu(e.edited_by, pilots))}</b></td>
        <td>${esc(pilotName(e.pilot_id))}</td>
        <td>${esc(duty)}</td>
        <td class="k">${esc(e.edit_type)}</td>
        <td>${esc(e.field_name)}</td>
        <td><s class="old">${esc(e.old_value)}</s> &rarr; <b class="new">${esc(e.new_value)}</b></td>
        <td class="rsn">${esc(e.reason)}</td></tr>`;
    }).join('');
    const who = pilotId ? pilotName(pilotId) : 'ALL PILOTS';
    w.document.open();
    w.document.write(`<!doctype html><html><head><title>FTL Edit Report</title><style>
      body{font-family:-apple-system,'Helvetica Neue',sans-serif;color:#0f172a;background:#fff;margin:28px;font-size:12px}
      h1{font-size:15px;letter-spacing:2px;margin:0 0 2px}
      .sub{font-size:10px;color:#64748b;margin-bottom:14px}
      .meta{display:flex;gap:28px;border:1px solid #e2e8f0;border-radius:6px;padding:10px 14px;margin-bottom:14px;background:#f8fafc}
      .meta div{font-size:11px}.meta b{display:block;font-size:9px;color:#64748b;letter-spacing:1px;margin-bottom:2px}
      table{width:100%;border-collapse:collapse;font-family:ui-monospace,Menlo,monospace;font-size:10.5px}
      th{background:#f1f5f9;border-bottom:1px solid #cbd5e1;padding:6px 8px;text-align:left;font-size:9px;letter-spacing:1px;color:#475569}
      td{padding:5px 8px;border-bottom:1px solid #eef2f7;vertical-align:top}
      td.k{font-weight:800;letter-spacing:1px}
      tr.del td.k{color:#b91c1c}
      .old{color:#b91c1c}.new{color:#15803d}
      .rsn{white-space:normal;font-family:-apple-system,sans-serif}
      .note{font-size:9px;color:#64748b;margin-top:10px;border-top:1px solid #e2e8f0;padding-top:8px}
      @media print{body{margin:10mm}}
    </style></head><body>
      <h1>FTL EDIT REPORT — DUTY AUDIT TRAIL</h1>
      <div class="sub">GO2 Aviation &middot; Generated ${utcGunAySaat(new Date().toISOString(), { z: true })} &middot; ftl_duty_edits</div>
      <div class="meta">
        <div><b>PILOT</b>${esc(who)}</div>
        <div><b>PERIOD</b>${esc(from)} &rarr; ${esc(to)}</div>
        <div><b>DATE BY</b>${tarihTuru === 'gorev' ? 'DUTY DATE' : 'CHANGE DATE'}</div>
        <div><b>ENTRIES</b>${rows.length}</div>
      </div>
      <table><thead><tr><th>WHEN</th><th>BY</th><th>PILOT</th><th>DUTY</th><th>ACTION</th>
        <th>FIELD</th><th>OLD &rarr; NEW</th><th>REASON</th></tr></thead>
      <tbody>${body || '<tr><td colspan="8">No edits recorded in selected period.</td></tr>'}</tbody></table>
      <div class="note">These records cannot be modified or deleted (no UPDATE/DELETE policy).
        A reason is mandatory and enforced at database level. Where DUTY reads DELETED the duty row
        no longer exists — this entry is the only remaining record of it. All times UTC.</div>
    <script>window.onload=function(){window.print();}</${'script'}></body></html>`);
    w.document.close();
  };

  const son = sayfaSayisi(veri.toplam);
  return (
    <div style={S.panel}>
      <div style={S.panelH}>
        <span style={S.panelT}>FTL edit report — audit trail</span>
        <span style={{ fontSize:9, color:C.t3, letterSpacing:1, fontFamily:'var(--mono)' }}>
          ftl_duty_edits · immutable · no delete
        </span>
      </div>

      <div style={{ display:'flex', gap:14, alignItems:'flex-end', padding:'14px 16px', flexWrap:'wrap' }}>
        <div style={{ width:260 }}><span style={S.label}>Pilot</span>
          <select style={S.input} value={pilotId} onChange={e => setPilotId(e.target.value)}>
            <option value="">ALL PILOTS</option>
            {pilots.filter(ucusEkibindenMi)
                   .map(p => <option key={p.id} value={p.id}>{p.code} — {p.full_name}</option>)}
          </select></div>
        <div style={{ width:170 }}><span style={S.label}>From</span>
          <input type="date" style={S.input} value={from} onChange={e => setFrom(e.target.value)} /></div>
        <div style={{ width:170 }}><span style={S.label}>To</span>
          <input type="date" style={S.input} value={to} onChange={e => setTo(e.target.value)} /></div>
        <div style={{ width:190 }}><span style={S.label}>Date by</span>
          <select style={S.input} value={tarihTuru} onChange={e => setTarihTuru(e.target.value)} data-testid="iz-tarih-turu">
            <option value="gorev">BY DUTY DATE</option>
            <option value="degisiklik">BY CHANGE DATE</option>
          </select></div>
        <div style={{ flex:1 }} />
        <button style={S.btnS} onClick={printReport} disabled={basiliyor} data-testid="iz-yazdir">
          {basiliyor ? 'PREPARING…' : 'PRINT / PDF'}</button>
      </div>

      {baskiHatasi && (
        <OkumaHatasi testid="iz-baski-hatasi" style={{ margin:'0 16px 12px' }} satirlar={baskiHatasi} onRetry={printReport}
          baslik="PRINT NOT MADE — the full range could not be read; a partial report is not printed." />
      )}

      {okumaHatasi ? (
        <OkumaHatasi testid="iz-okuma-hatasi" style={{ padding:'0 16px 16px' }} satirlar={okumaHatasi}
          onRetry={() => setYenile(n => n + 1)}
          baslik="EDIT REPORT COULD NOT BE LOADED — the records are not shown with partial data." />
      ) : (<>
        <div style={{ ...S.label, padding:'0 16px 10px' }} data-testid="iz-aralik-sayisi">
          {veri.yuklendi ? `${veri.toplam} RECORDS IN RANGE · PAGE ${sayfa} / ${son}` : 'LOADING…'}
        </div>
        {tarihTuru === 'gorev' && veri.tarihsiz > 0 && (
          <div style={{ ...S.note, margin:'0 16px 12px' }} data-testid="iz-tarihsiz-not">
            {veri.tarihsiz} record{veri.tarihsiz === 1 ? '' : 's'} belong to duties deleted before 6 OCT 2026 — their duty
            date is unknown; see BY CHANGE DATE.
          </div>
        )}
        {veri.yuklendi && !veri.satirlar.length ? (
          <div style={{ ...S.note, margin:'0 16px 16px' }}>NO EDITS RECORDED IN THIS RANGE.</div>
        ) : (
          <div style={{ overflowX:'auto' }}>
            <table style={S.table}>
              <thead><tr>
                <th style={S.th}>When</th><th style={S.th}>By</th><th style={S.th}>Pilot</th><th style={S.th}>Duty</th>
                <th style={S.th}>Action</th><th style={S.th}>Field</th>
                <th style={S.th}>Old → New</th><th style={S.th}>Reason</th>
              </tr></thead>
              <tbody>
                {veri.satirlar.map(e => (
                  <tr key={e.id} data-testid="iz-satir">
                    <td style={S.td}>{fmtDT(e.created_at)}</td>
                    {/* 2 Eki 2026 (Serkan): "kim yaptı yazsın … sadece ekip kodu" — tek kaynak duzenleyen.js */}
                    <td style={{ ...S.td, fontWeight:700 }} data-testid="duzenleyen">{duzenleyenKodu(e.edited_by, pilots)}</td>
                    <td style={S.td}>{pilotName(e.pilot_id)}</td>
                    <td style={S.td}>
                      {dutyOf(e.duty_id) ? gorevMetni(e) : <span style={{ color:C.t3 }}>{gorevMetni(e)}</span>}
                    </td>
                    <td style={S.td}>{kindBadge(e.edit_type)}</td>
                    <td style={S.td}>{e.field_name || '—'}</td>
                    <td style={{ ...S.td, whiteSpace:'normal' }}>
                      <span style={{ color:C.red, textDecoration:'line-through' }}>{e.old_value || '—'}</span>
                      <span style={{ color:C.t3 }}> → </span>
                      <span style={{ color:C.green, fontWeight:700 }}>{e.new_value || '—'}</span>
                    </td>
                    <td style={{ ...S.td, whiteSpace:'normal', fontWeight:400 }}>{e.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <Sayfalama sayfa={sayfa} toplam={veri.toplam} onSayfa={setSayfa} testid="iz-sayfa" />
      </>)}

      <div style={{ ...S.note, margin:'12px 16px 16px' }}>
        Bu kayitlar degistirilemez ve silinemez. Gerekce zorunludur — bos gerekce
        veritabani seviyesinde reddedilir. "Duty" sutununda <b>— deleted —</b> yaziyorsa
        gorev satiri artik yoktur; o gorevden geriye YALNIZ bu kayit kalmistir.
      </div>
    </div>
  );
}

// ═══ 1) ASSIGN DUTY ═══════════════════════════════════════════════
/** OFF kaydına yazılacak yer: kutuya meydan yazıldıysa o (dilimiyle); boşsa pilotun KENDİ ana üssü (dilimiyle).
 *  Ana üssü yoksa (şirket üssüne düşülmüş ölçü) yer YAZILMAZ — seçilmemiş bir yer kayda geçmez; ölçü eskisi gibi. */
export function offYeriKaydi(kutu, ev) {
  if (kutu?.location) return { location: kutu.location, location_tz: kutu.location_tz || null };
  if (ev?.kaynak === 'own' && ev.icao && ev.tz) return { location: ev.icao, location_tz: ev.tz };
  return { location: null, location_tz: null };
}

/** OFF'un yeri — ASSIGN · iptal → OFF · EDIT OFF, ÜÇÜ DE bu kutuyu kullanır (tek tip). `evler`: seçili pilotların ana
 *  üssü (ICAO; yoksa null) — boş kutunun ne demek olduğu yazılır. */
export function OffYeriSecici({ value, onChange, evler = [], testId = 'off-yeri' }) {
  const tekil = [...new Set(evler.filter(Boolean))];
  const evMetni = !evler.length ? 'the pilot\'s home base'
    : tekil.length === 1 && evler.every(Boolean) ? `home base ${tekil[0]}`
    : 'each pilot\'s own home base' + (tekil.length ? ` (${tekil.join(' · ')})` : '');
  return (
    <LocationPicker kural="icao" value={value} onChange={onChange} testId={testId}
      icaoEtiketi="Where is the day off spent? (ICAO)"
      icaoPlaceholder={tekil.length === 1 && evler.every(Boolean) ? tekil[0] : 'HOME BASE'}
      icaoNotu={`Leave empty for ${evMetni}. The two local nights of the day off are measured in that airport's time zone (Md.4/ü).`} />
  );
}

// ── WHAT IF PENCERESİ (12 Eki 2026, Serkan) ──────────────────────────────────
// 🔑 *"görevi planlamadan simüle edebileyim — o an var olan veriyi base olarak kullanıp ileriye dönük görev atamaları
//    yapıp resmi görelim"* · *"bu simülatörde kaydetme yok; legalite sağlanırsa çıkıp ASSIGN'den normal yollarla girilir"*
//    · *"WHAT IF ekranı açıkken diğer tuşlara basılamasın — gölgeli görünüm; close edince ana sayfaya dönüp baştan gerçek
//    assign'a devam edebilsin"* · *"reset butonu olsun"* · NOT LEGAL de denemeye girer, gerekçesiyle.
// TEK KAYNAK: içerideki form ASSIGN'in KENDİSİ (`AssignDuty`, `whatIf` kipi) — kapılar, motor, satır kurulumu aynı kod.
// Denemeler YALNIZ bu pencerenin belleğinde durur: hiçbir tabloya yazılmaz, pencere kapanınca (CLOSE / ✕ / ESC) silinir.
// Formun gördüğü roster = gerçek kayıtlar + denemeler: ikinci deneme birincinin etkisini görür.
// Sıradaki adımlar (Serkan onaylı tasarım): WHAT IF SHEET (DUTY SHEET + çapraz silik PREVIEW + pilot sekmeleri) ·
// NOT LEGAL gerekçe kartı.
let whatIfSayaci = 0;   // deneme satırı kimliği (whatif-<n>-<i>) — sayfa ömrü boyunca tekil
// ── GÜN ŞERİDİ (15 Eki 2026, Serkan) ────────────────────────────────────────────────────────────────────────────────
// 🔑 *"what if ekranında çoklu görev (4-5 günlük bir seri) planlamam için"* · *"günlere görev girili, her girişten sonra what if
//    çalışır, legalite uyarı text ile gelir, yoksa yeşil legal"* · *"add to what if neden diyoruz?"* · *"tek reset bütün günleri
//    siler"* · *"ardışık 7 gün"* · 28 gün (A, *"o daha mantıklı"*). Şerit başlangıçtan 28 gün; ekranda 7, oklarla haftalık.
// Her gün KENDİ formudur (`AssignDuty`, `sabitTarih`): tıklanan günün formu açılır, öteki günlerin formu bellekte kalır
// (gizli). Formun gördüğü roster = gerçek kayıtlar + ÖTEKİ günlerin denemeleri; bir gün değişince ötekiler yeniden sınanır.
const WHATIF_GUN_SAYISI = 28;
const WHATIF_GORUNEN = 7;
function WhatIfPenceresi({ onClose, duties, ...formProps }) {
  const bugun = new Date().toISOString().slice(0, 10);
  const [bas, setBas] = useState(bugun);
  const [ofset, setOfset] = useState(0);
  const [secili, setSecili] = useState(bugun);
  const [acilan, setAcilan] = useState([bugun]);          // formu açılmış günler
  const [sonuclar, setSonuclar] = useState({});           // gün → { durum: legal|notlegal|eksik|bos, satirlar, sonuc, metin }
  const [surum, setSurum] = useState(0);                  // RESET → bütün günlerin formu baştan kurulur
  const [tabanAni] = useState(() => new Date().toISOString());
  const [sheetAcik, setSheetAcik] = useState(false);
  usePencereKapat(onClose);
  const gunler = useMemo(() => Array.from({ length: WHATIF_GUN_SAYISI }, (_, i) => shiftDate(bas, i)), [bas]);
  const denemeSatirlari = useMemo(() => gunler.flatMap(g => sonuclar[g]?.satirlar || []), [gunler, sonuclar]);
  const gunGorevleri = useMemo(() => Object.fromEntries(acilan.map(g => [g, [...(duties || []),
    ...gunler.filter(x => x !== g).flatMap(x => sonuclar[x]?.satirlar || [])]])), [acilan, duties, gunler, sonuclar]);
  const doluMu = Object.values(sonuclar).some(r => r && r.durum !== 'bos');
  const sec = (g) => { setSecili(g); setAcilan(a => (a.includes(g) ? a : [...a, g])); };
  const sifirla = () => { setSonuclar({}); setAcilan([secili]); setSurum(n => n + 1); setSheetAcik(false); };
  // Yeni şehir de YAZILMAZ: seçim yalnız bu denemede geçerli (konum + dilim forma döner).
  const yereldeEkle = async (loc) => loc;
  const gunEtiketi = (g) => utcGun(`${g}T00:00:00Z`).slice(0, 6).toUpperCase();
  const rozet = (r) => {
    if (!r || r.durum === 'bos') return { metin: '—', renk: C.t3 };
    if (r.durum === 'legal') return { metin: 'LEGAL', renk: C.green };
    if (r.durum === 'notlegal') return { metin: 'NOT LEGAL', renk: C.red };
    return { metin: 'INCOMPLETE', renk: C.amber };
  };
  const r = sonuclar[secili];
  const gorunen = gunler.slice(ofset, ofset + WHATIF_GORUNEN);
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', zIndex:190, overflowY:'auto',
                  display:'flex', justifyContent:'center', alignItems:'flex-start', padding:'24px 16px' }}
         data-testid="whatif-pencere">
      <div style={{ background:'var(--bg2)', border:`1.5px dashed ${C.accent}`, borderRadius:10, width:'100%', maxWidth:1280 }}>
        <div style={{ ...S.panelH, position:'sticky', top:0, zIndex:2 }}>
          <span>
            <span style={S.panelT}>WHAT IF — NOTHING IS SAVED</span>
            <span style={{ fontSize:10, color:C.t3, fontFamily:'var(--mono)', marginLeft:12 }} data-testid="whatif-taban">
              BASE: ROSTER AS OF {utcGunAySaat(tabanAni, { z: true })} · SAME FORM AND CHECKS AS ASSIGN DUTY · CHECKED AFTER EACH ENTRY
            </span>
          </span>
          <KapatX onClose={onClose} testid="whatif-x" />
        </div>
        <div style={{ padding:16 }}>
          {/* GÜN ŞERİDİ */}
          <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:14, flexWrap:'wrap' }} data-testid="whatif-gunler">
            <div style={{ width:150 }}>
              <span style={S.label}>Series starts</span>
              <input type="date" style={S.input} value={bas} disabled={doluMu} data-testid="whatif-bas"
                     title={doluMu ? 'RESET first — the series already has duties' : undefined}
                     onChange={e => { if (!e.target.value) return; setBas(e.target.value); setOfset(0); setSecili(e.target.value);
                                      setAcilan([e.target.value]); setSonuclar({}); setSurum(n => n + 1); }} />
            </div>
            <button type="button" style={{ ...S.btnS, padding:'8px 10px', alignSelf:'flex-end' }} data-testid="whatif-geri"
                    disabled={ofset === 0} onClick={() => setOfset(o => Math.max(0, o - WHATIF_GORUNEN))}>◀</button>
            {gorunen.map(g => {
              const z = rozet(sonuclar[g]);
              return (
                <button key={g} type="button" data-testid={`whatif-gun-${g}`} onClick={() => sec(g)}
                        style={{ ...S.btnS, alignSelf:'flex-end', minWidth:96, padding:'6px 8px', textAlign:'left',
                                 borderColor: g === secili ? C.accent : C.border, borderWidth: g === secili ? 2 : 1 }}>
                  <div style={{ fontSize:12, color:C.t1 }}>{gunEtiketi(g)}</div>
                  <div style={{ fontSize:10, color:z.renk, fontWeight:700 }} data-testid={`whatif-gun-${g}-durum`}>{z.metin}</div>
                </button>
              );
            })}
            <button type="button" style={{ ...S.btnS, padding:'8px 10px', alignSelf:'flex-end' }} data-testid="whatif-ileri"
                    disabled={ofset + WHATIF_GORUNEN >= WHATIF_GUN_SAYISI}
                    onClick={() => setOfset(o => Math.min(WHATIF_GUN_SAYISI - WHATIF_GORUNEN, o + WHATIF_GORUNEN))}>▶</button>
          </div>

          {/* GÜNLERİN FORMLARI — yalnız seçili gün görünür; öteki günlerin girişi bellekte kalır */}
          {acilan.map(g => (
            <div key={`${surum}-${g}`} style={{ display: g === secili ? 'block' : 'none' }} data-testid={`whatif-form-${g}`}>
              <AssignDuty {...formProps} duties={gunGorevleri[g] || duties} reload={() => {}} addLocation={yereldeEkle} whatIf
                          sabitTarih={g} gunSonucu={(x) => setSonuclar(s => ({ ...s, [g]: x }))} />
            </div>
          ))}

          {/* SEÇİLİ GÜNÜN SONUCU — her girişten sonra */}
          <div data-testid="whatif-sonuc" style={{ marginTop:14, padding:'10px 12px', borderRadius:6, fontSize:12,
               border:`1.5px solid ${r?.durum === 'legal' ? C.green : r?.durum === 'notlegal' ? C.red : r?.durum === 'eksik' ? C.amber : C.border}` }}>
            <div style={{ fontFamily:'var(--mono)', fontSize:11, color:C.t3, marginBottom:6 }}>{gunEtiketi(secili)} — WHAT IF RESULT</div>
            {(!r || r.durum === 'bos') && <div style={{ color:C.t3 }}>Enter a duty for this day — it is checked automatically after each entry.</div>}
            {r?.durum === 'eksik' && <div style={{ color:C.amber }}>{(r.metin || []).slice(-1)[0] || 'Incomplete.'}</div>}
            {r?.durum === 'legal' && (
              <div style={{ color:C.green, fontWeight:700 }} data-testid="whatif-legal">
                LEGAL — {r.sonuc.map(x => x.kod).join(' · ')}
              </div>
            )}
            {r?.durum === 'notlegal' && r.sonuc.map(x => (
              <div key={x.pid} style={{ marginBottom:6 }}>
                <span style={{ color: x.legal ? C.green : C.red, fontWeight:700 }}>{x.kod} — {x.legal ? 'LEGAL' : 'NOT LEGAL'}</span>
                {!x.legal && x.nedenler.map((n, i) => <div key={i} style={{ color:C.red, paddingLeft:12 }}>{n.metin}</div>)}
              </div>
            ))}
          </div>

          <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:14 }}>
            <button type="button" style={S.btnP} disabled={!denemeSatirlari.length} data-testid="whatif-sheet-ac"
                    onClick={() => setSheetAcik(true)}>WHAT IF SHEET</button>
            <button type="button" style={dugmeStili('silme')} disabled={!doluMu} data-testid="whatif-reset"
                    onClick={sifirla}>RESET</button>
            <button type="button" style={S.btnS} onClick={onClose} data-testid="whatif-kapat">CLOSE</button>
          </div>
        </div>
      </div>
      {sheetAcik && denemeSatirlari.length > 0 && (
        <OnizlemeCizelgesi kip="whatif" onizlemeSatirlari={denemeSatirlari} gorevler={[...(duties || []), ...denemeSatirlari]}
                           tabanAni={tabanAni} pilots={formProps.pilots} baselines={formProps.baselines}
                           ruleset={formProps.ruleset} offTypes={formProps.offTypes} pilotDilim={formProps.pilotDilim}
                           toast={formProps.toast}
                           onReset={sifirla} onClose={() => setSheetAcik(false)} />
      )}
    </div>
  );
}

// ── ÖNİZLEME ÇİZELGESİ — WHAT IF SHEET + ASSIGN ONAYI, TEK PENCERE (12 Eki 2026) ─────────────────────────────────────
// 🔑 Serkan: *"assign ettiğimizde de bu tablo görüntüsü açılsa, sonra ikinci bir onaylama ile görevi assign etsek? …
//    tek tip ekran yönetimi olsun"* · *"karmaşık hale gelmesin"*. İki kip, fark YALNIZ başlık, şerit ve alttaki iki düğme:
//    `whatif` → WHAT IF SHEET · PREVIEW — NOTHING IS SAVED · RESET / CLOSE
//    `assign` → ASSIGN DUTY — CHECK AND CONFIRM · NOT SAVED YET · BACK / CONFIRM ASSIGN (yalnız gerçek roster + yeni görev)
// WHAT IF SHEET (Serkan: *"simüle görevler girilir ve duty sheet'te görünür — görsel destek önemli"* ·
// *"SIM yazmasın, hücre üzerinde çapraz silik PREVIEW yazsın"* · *"pilotların isimleri görünsün, tıklayınca ikisinin duty
// sheet'i arasında geçiş"* · *"WHAT IF'te illegalite açıklaması da olsun: ne, neden, nasıl mümkün değil"*).
// Çizelge DUTY HISTORY / PREVIOUS MONTH ile AYNI motor ve AYNI HTML (`gorevCizelgesi` + `cizelgeHtml`); fark yalnız: görev
// listesi gerçek kayıt + denemeler, başlık WHAT IF SHEET, denemenin günü PREVIEW filigranlı. Durum notuna tıklamak gerçek
// görevdeki kartı açar (`durumKartiGoster` — ne · neden · madde ⓘ · ne yapılabilir). Kâğıt işaretleri (PAPER / NO DOCS)
// burada çizilmez (`kagit` yok). PRINT YOK: deneme bir belge değildir.
function OnizlemeCizelgesi({ kip = 'whatif', onizlemeSatirlari, gorevler, tabanAni = null, pilots, baselines, ruleset,
                             offTypes, pilotDilim, toast, onReset, onClose, onConfirm, busy = false }) {
  const atama = kip === 'assign';
  usePencereKapat(busy ? null : onClose);   // atamada ESC/✕ = BACK; kaydedilirken kapanmaz
  const pilotIdleri = [...new Set(onizlemeSatirlari.map(r => r.pilot_id))];
  const [pid, setPid] = useState(pilotIdleri[0]);
  const pilot = (pilots || []).find(p => p.id === pid) || null;
  // Bu pilotun denemelerinin ayları — çizelge ilk denemenin ayıyla açılır; birden çok ay varsa aralarında geçilir.
  const aylar = [...new Set(onizlemeSatirlari.filter(r => r.pilot_id === pid).map(r => String(r.duty_date).slice(0, 7)))].sort();
  const [ay, setAy] = useState(null);
  const gosterilenAy = aylar.includes(ay) ? ay : aylar[0];
  const dilim = (pilotDilim || {})[pid] || { tz: null, icao: null };
  const rules = useMemo(() => effectiveRules(ruleset).rules, [ruleset]);
  const html = useMemo(() => {
    if (!pilot || !gosterilenAy) return '';
    const [yil, a] = gosterilenAy.split('-').map(Number);
    const veri = gorevCizelgesi({ duties: gorevler, pilotId: pid, baseline: (baselines || {})[pid] || null, rules,
                                  tz: dilim.tz, offTypes, yil, ay: a, kagit: null });
    return cizelgeHtml(veri, { pilot, ussu: dilim.icao, baseline: (baselines || {})[pid] || null,
                               onizleme: atama ? 'NEW DUTY — NOT SAVED YET' : true });
  }, [pilot, gosterilenAy, gorevler, pid, baselines, rules, dilim.tz, dilim.icao, offTypes, atama]);
  const tikla = ({ durum }) => {
    const d = durum && (gorevler || []).find(x => x.id === durum);
    if (d) durumKartiGoster(d, { toast, kod: pilot?.code });
  };
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', zIndex:210, overflowY:'auto',
                  display:'flex', justifyContent:'center', alignItems:'flex-start', padding:'20px 16px' }}
         data-testid={atama ? 'atama-onay' : 'whatif-sheet'}>
      <div style={{ background:'var(--bg2)', border:`1.5px dashed ${C.accent}`, width:'100%', maxWidth:980, padding:16 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, marginBottom:10 }}>
          <span style={S.panelT}>{atama ? 'ASSIGN DUTY — CHECK AND CONFIRM' : 'WHAT IF SHEET'}</span>
          <KapatX onClose={onClose} disabled={busy} testid={atama ? 'atama-onay-x' : 'whatif-sheet-x'} />
        </div>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:10 }}>
          {pilotIdleri.map(id => {
            const p = (pilots || []).find(x => x.id === id);
            return (
              <button key={id} type="button" className={KUTU_SINIFI} style={sekmeStili(id === pid)}
                      data-testid={`whatif-sheet-pilot-${p?.code || id}`} onClick={() => setPid(id)}>
                {p ? `${p.code} — ${String(p.full_name || '').toUpperCase()}` : id}
              </button>
            );
          })}
        </div>
        <div style={{ ...S.note, borderLeftColor:C.accent, borderStyle: atama ? 'solid' : 'dashed', color:C.accent, marginBottom:10 }}
             data-testid={atama ? 'atama-onay-serit' : 'whatif-sheet-serit'}>
          {atama
            ? 'NOT SAVED YET — CONFIRM ASSIGN WRITES THIS DUTY. THE SHEET SHOWS THE REAL ROSTER WITH THE NEW DUTY MARKED PREVIEW.'
            : `PREVIEW — NOTHING IS SAVED · BASE: ROSTER AS OF ${utcGunAySaat(tabanAni, { z: true })}`}
          {aylar.length > 1 && (
            <span style={{ marginLeft:12 }}>
              {aylar.map(m => (
                <button key={m} type="button" className={KUTU_SINIFI} style={{ ...sekmeStili(m === gosterilenAy), marginLeft:6 }}
                        data-testid={`whatif-sheet-ay-${m}`} onClick={() => setAy(m)}>{utcGun(`${m}-01T00:00:00Z`).slice(3)}</button>
              ))}
            </span>
          )}
        </div>
        <CizelgeKagidi html={html} onTikla={tikla} />
        <div style={{ display:'flex', justifyContent:'space-between', gap:10, marginTop:14 }}>
          {atama ? (<>
            <button type="button" style={S.btnS} data-testid="atama-onay-geri" disabled={busy} onClick={onClose}>BACK</button>
            <button type="button" style={S.btnP} data-testid="atama-onay-confirm" disabled={busy}
                    onClick={onConfirm}>{busy ? 'SAVING...' : 'CONFIRM ASSIGN'}</button>
          </>) : (<>
            <button type="button" style={dugmeStili('silme')} data-testid="whatif-sheet-reset" onClick={onReset}>RESET</button>
            <button type="button" style={S.btnS} data-testid="whatif-sheet-kapat" onClick={onClose}>CLOSE</button>
          </>)}
        </div>
      </div>
    </div>
  );
}

function AssignDuty({ toast, myProfile, pilots, duties, baselines, ruleset, offTypes, homeBases, pilotDilim, reload,
                      lisansMed = {}, tipVasiflari = {}, dutyLocations = [], addLocation, aircraft = [],
                      // WHAT IF (12 Eki 2026, Serkan): AYNI form, WHAT IF penceresinin içinde. `whatIf` iken hiçbir tabloya
                      // yazılmaz; `duties` gerçek roster + öteki günlerin denemeleridir (pencere verir).
                      // 15 Eki 2026 (Serkan: *"her girişten sonra what if çalışır, legalite uyarı text ile gelir, yoksa yeşil
                      // legal"*): şeritteki her gün kendi formudur — `sabitTarih` günü kilitler, sınama her girişten sonra
                      // KENDİLİĞİNDEN koşar ve sonucu `gunSonucu`na verir (ADD TO WHAT IF kalktı).
                      whatIf = false, sabitTarih = null, gunSonucu = null,
                      // ASSIGN PENCERESİ (21 Eki 2026, Serkan B): ROSTER kâğıdında tıklanan gün `ilkTarih` olarak gelir (kilitli
                      // DEĞİL — formdan değiştirilebilir); kayıt bitince `onAtandi(kaydedilen)` pencereyi kapatır.
                      ilkTarih = null, onAtandi = null }) {
  const toastDisari = toast;
  const [dutyType, setDutyType] = useState('flight');
  const [date, setDate] = useState(() => sabitTarih || ilkTarih || new Date().toISOString().slice(0, 10));
  // BACAK BASINA FAALIYET TIPI (Serkan, 22 Agu): *"cok bacakli bir planlamada
  // ucusun tipini secerken her bacak icin ayri ayri secelim."* Her bacak kendi
  // planindan tipini ceker (RMK/BUSINESS -> hava taksi, RMK/PRIVATE -> genel
  // havacilik); elle degistirilebilir, kaynagi kayda gecer. Gorevin YONETICI
  // tipi bacaklarin EN KISITLAYICISIDIR (motor hesaplar).
  // `reg` (21 Eki 2026, K2): sektörün tescili — AIRCRAFTS'tan seçilir, zorunlu; tip yetkisi ve asgari ekip ondan.
  const [legs, setLegs] = useState([{ dep:'', dest:'', etd:'', eta:'', operation_type:'', opSrc:'', reg:'' }]);
  // Dinlenme yeri VARSAYILMAZ (29 Eyl 2026) — açık mesai kutusu sorar.
  const [accommodation, setAccommodation] = useState(null);
  const [selected, setSelected] = useState({}); // pilotId -> 'PF'|'PM'|'CREW'
  const [gnd, setGnd] = useState({ kind:'office', start:'09:00', end:'17:00' });
  // LOCATION (1 Eyl 2026) — yer gorevinin dilim kaynagi; office'te sorulmaz,
  // DH'de bacaklardan gelir, digerlerinde ZORUNLU (Serkan).
  const [gndLoc, setGndLoc] = useState({ location:'', location_tz:null });
  // ── DH / KONUMLANDIRMA (SHT-FTL/HG Md.14, 22 Agu 2026) ─────────────
  // Serkan: *"DH girilirse bunun da bir baslangic ve bitis saati ve dep/dest
  // meydani ve ucalacak ucusun flt number girilir; coklu sektorlu bir DH
  // olabilir, ADD SECTOR ile aktarmali ucuslari da ekleyebilmemiz lazim."*
  //
  // 🔑 Md.14(1)(a): *"Konumlandirmalarda harcanan TUM ZAMAN, gorev suresi
  //    olarak kayit altina alinacaktir."* -> gorev = ILK KALKIS ... SON INIS,
  //    aradaki bekleme DAHIL. "Ucus suresi kadar" degil.
  // 🔑 Md.14(1)(b): konumlandirma SEKTOR SAYILMAZ -> Tablo-1'in sektor
  //    kolonunu etkilemez. `duty_type: 'ground'` oldugu icin bu kendiliginden
  //    saglanir: `maxFdpMinutes` yalniz ucus gorevinden okunur.
  // 🔑 Md.4(n): yerel ulasim (dinlenme yerinden meydana gidis) konumlandirma
  //    DEGILDIR -> rapor payi YOKTUR, gorev ucusun kendisiyle baslar.
  // 🔑 Ucus SAATI kumulatiflerine girmez: `FTLEngine.fltMin` yalniz
  //    `duty_type === 'flight'` sayar (Serkan: "flt time limitlerini belirlemez").
  const [dhLegs, setDhLegs] = useState([{ dep:'', dest:'', start:'', end:'', flt:'' }]);
  const setDhLeg = (i, k, v) => setDhLegs(ls => ls.map((l, j) => j === i ? { ...l, [k]: v } : l));
  /// DH + ARDINDAN UCUS (Serkan, 22 Agu): *"DH arkasina DH sektor ekleme veya
  /// FLT duty ekleme opsiyonu koyacagiz — ADD SECTOR / ADD FLT DUTY."* 14 Eki 2026'dan beri tek "+ ADD" → SECTOR:
  /// son DH'nin arkasina ucus bacagi gorev tipini UCUSA cevirir; DH bacaklari korunur ve
  /// sektor listesinin BASINA `deadhead: true` olarak eklenir. Md.14(1)(b):
  /// ucus oncesi konumlandirma UGS'ye girer ama SEKTOR sayilmaz — motor bunu
  /// `deadhead` bayragindan okur (FTLEngine.dutyWindow / fltMin).
  const [dhBeforeFlight, setDhBeforeFlight] = useState(false);
  const dhPrefix = useMemo(() => (
    (dutyType === 'flight' && dhBeforeFlight)
      // NOT: `timeOk` bu memo'dan SONRA tanimlaniyor (gecici olu bolge) —
      // kontrol burada yerinde yapilir.
      ? dhLegs.filter(l => l.dep && l.dest && /^\d{2}:\d{2}$/.test(l.start || '') && /^\d{2}:\d{2}$/.test(l.end || ''))
              .map(l => ({ dep: l.dep.toUpperCase(), dest: l.dest.toUpperCase(),
                           etd: l.start, eta: l.end,
                           flight_no: (l.flt || '').toUpperCase() || null, deadhead: true }))
      : []
  ), [dutyType, dhBeforeFlight, dhLegs]);
  // ── UÇUŞTAN SONRA KONUMLANDIRMA — PAKET GÖREV (14 Eki 2026, Serkan: *"uçuş + DH veya DH + uçuş gibi paket görev
  //    planlayabilmem için ASSIGN'de uçuşun arkasına ADD SECTOR ve ADD DUTY butonu olmalı"*). DH aynı görevin SONUNA
  //    `deadhead` bacak olarak eklenir; motor (dutyWindow / gorevHesabi, 4 Eki) zaten böyle sayar: UGS son UÇUŞ bacağının
  //    inişinde biter (Md.4(z) — görevli ekip olduğu son sektör; Md.14(1)(b) sonraki konumlandırma UGS değil, sektör değil),
  //    görev DH'nin inişinde biter (Md.14(1)(a)), dinlenme oradan sayılır (Md.14(1)(c)).
  const [dhAfterFlight, setDhAfterFlight] = useState(false);
  const [dhSonraLegs, setDhSonraLegs] = useState([{ dep:'', dest:'', start:'', end:'', flt:'' }]);
  const setDhSonraLeg = (i, k, v) => setDhSonraLegs(ls => ls.map((l, j) => j === i ? { ...l, [k]: v } : l));
  const dhSuffix = useMemo(() => (
    (dutyType === 'flight' && dhAfterFlight)
      ? dhSonraLegs.filter(l => l.dep && l.dest && /^\d{2}:\d{2}$/.test(l.start || '') && /^\d{2}:\d{2}$/.test(l.end || ''))
              .map(l => ({ dep: l.dep.toUpperCase(), dest: l.dest.toUpperCase(), etd: l.start, eta: l.end,
                           flight_no: (l.flt || '').toUpperCase() || null, deadhead: true }))
      : []
  ), [dutyType, dhAfterFlight, dhSonraLegs]);
  // ── PAKET SIM (14 Eki 2026) — görevin başında / sonunda, uçuşla aynı kayıtta; pilot seçilir. null = yok.
  const [paketSim, setPaketSim] = useState({ once: null, sonra: null });
  const paketSimDegistir = (yer) => (alan, deger) => setPaketSim(p => ({ ...p, [yer]: { ...p[yer], [alan]: deger } }));
  /// Motorun ve kaydin gordugu TAM liste: once konumlandirma, sonra ucus, sonra ucustan sonraki konumlandirma.
  const legsAll = useMemo(() => [...dhPrefix, ...legs, ...dhSuffix], [dhPrefix, legs, dhSuffix]);
  // BACAK SIRASI (Md.4(1)(v) turnaround, Md.7(1)(e) — 5 Eki 2026, Serkan A): bir bacak öncekinin inişinden önce kalkamaz.
  const siraHatasi = useMemo(() => (dutyType === 'flight' ? bacakSirasiHatasi(legsAll)
    : dutyType === 'dh' ? bacakSirasiHatasi(dhLegs.map(l => ({ dep: l.dep, dest: l.dest, etd: l.start, eta: l.end })))
      : null), [dutyType, legsAll, dhLegs]);
  // ── BACAK BAŞINA ROLLER (29 Eyl 2026) ─────────────────────────────────
  // Ekip tablosundaki tıklama GÖREV düzeyindeki rolü verir; varsayılan olarak
  // bütün bacaklara aynen yayılır. Bacak tablosundaki değişiklik YALNIZ aynı
  // ekip + aynı bacak sayısı için geçerlidir: tabloda bir şey değişirse
  // (pilot eklendi/çıktı, PF↔PM, bacak eklendi/silindi) bacaklar tablodaki
  // rollere döner — eski bir bacak seçimi değişmiş ekibe SESSİZCE taşınmaz.
  const ekipImzasi = JSON.stringify([Object.entries(selected).sort(), legs.length]);
  const [bacakDegisim, setBacakDegisim] = useState({ imza: '', haritalar: [] });
  const bacakRolleri = useMemo(() => legs.map((_, i) => {
    const o = bacakDegisim.imza === ekipImzasi ? bacakDegisim.haritalar[i] : null;
    return o || { ...selected };
  }), [legs, selected, bacakDegisim, ekipImzasi]);
  const bacakRolDegis = (i, h) => setBacakDegisim(b => {
    const haritalar = b.imza === ekipImzasi ? [...b.haritalar] : [];
    haritalar[i] = h;
    return { imza: ekipImzasi, haritalar };
  });
  const [off, setOff] = useState({ subtype:'OFF', endDate:'' });
  // 🔑 OFF'UN YERİ (1 Eki 2026, Serkan: "OFF girilirken lokasyon da girilir" · "ICAO kod girelim, hızlı" · "LTAC ise
  //    home base algılanacak"): boş = her pilotun KENDİ ana üssü, kaydederken AÇIKÇA yazılır (ana üs sonra değişirse
  //    eski OFF'un ölçüsü sessizce değişmesin). Yazılırsa o meydan, dilimiyle (meydan listesinden).
  const [offLoc, setOffLoc] = useState({ location:'', location_tz:null });
  const [saving, setSaving] = useState(false);
  const setSavingDisari = setSaving;
  // GERIYE DONUK GIRIS ONAYI: satirlar hazir ama HENUZ YAZILMADI. Popup
  // onaylanana kadar burada bekler (Serkan, 21 Agu: "bu gorev gecmise yonelik,
  // emin misin diye sorsun").
  const [backdated, setBackdated] = useState(null);
  // ASSIGN ONAYI (12 Eki 2026): kapılardan geçmiş, HENÜZ YAZILMAMIŞ satırlar — çizelge penceresinde CONFIRM ASSIGN bekler.
  const [atamaOnayi, setAtamaOnayi] = useState(null);
  // Çizelgede gösterilecek hâli: geçici kimlik + PREVIEW işareti + ASSIGN'in kapısından geçtiği için LEGAL (OFF'ta durum yok).
  const onaySatirlari = useMemo(() => (atamaOnayi ? atamaOnayi.rows.map((r, i) => ({ ...r, id: `atama-${i}`, whatif: true,
    ...(r.duty_type !== 'off' ? { ftl_durum: 'LEGAL', ftl_gerekce: [] } : {}) })) : null), [atamaOnayi]);
  // ── GEÇMİŞTEKİ UÇUŞ: ÖNCE PLANLI, SONRA RECORD AS FLOWN (2 Eki 2026) ────
  // 🔑 Serkan: geriye dönük uçuşta dört GERÇEK zaman sorulur (*"a"*) — planlanan ETD/ETA gerçek blok diye
  //    YAZILMAZ. Görev planlı kaydedilir, RECORD AS FLOWN açılır; rapor/FDP/dinlenme ve PAPER OFP oradan (tek yer).
  // 🔴 ÖNCESİ (19 Eyl–2 Eki): onay penceresi ETD/ETA'yı OFF/ON blok yazıyor, T/O–LDG boş kalıyordu; o pencerenin
  //    PAPER OFP kutusu bu yüzden kaldırıldı (kâğıt kayıt artık RECORD AS FLOWN'da sorulur).
  const [gecmisUcus, setGecmisUcus] = useState(null);
  // 3 PILOTLU OPS / CHECK RIDE (4 Agu, Serkan). extraMode:
  //   null → kapali · 'pick' → secim acik · 'crz' → CRZ CPT modu (listeden
  //   3. pilot secilir, EASA CS FTL.1.205(c) augmented FDP devreye girer) ·
  //   'checkride' → dis TRE/TRI adi elle girilir + CHECK RIDE isareti.
  // Pairing (PF/PM) mantigina DOKUNMAZ. Check ride augmented FDP GETIRMEZ
  // (jump seat denetcisi dinlenme rotasyonu saglamaz).
  const [extraMode, setExtraMode] = useState(null);
  // Uçuş içi dinlenme olanağı (Md.11(1)(4), 4 Eki 2026) — CRZ CPT seçilince zorunlu; '' = seçilmedi.
  const [dinlenme, setDinlenme] = useState('');
  // 4 pilotlu ekip (5 Eki 2026, Md.11(4)): ilk CRZ seçildikten sonra "+ ADD COCKPIT CREW" ikinci CRZ seçicisini açar.
  const [crzSlot, setCrzSlot] = useState(false);
  useEffect(() => { if (extraMode !== 'crz') { setDinlenme(''); setCrzSlot(false); } }, [extraMode]);
  const crzIds = useMemo(() => Object.keys(selected).filter(k => selected[k] === 'CRZ CPT'), [selected]);
  const crzSec = (pid) => {
    if (!pid) return;
    setSelected(s0 => (s0[pid] || Object.values(s0).filter(r => r === 'CRZ CPT').length >= AZAMI_CRZ)
      ? s0 : { ...s0, [pid]: 'CRZ CPT' });
    setCrzSlot(false);
  };
  const crzCikar = (pid) => {
    setSelected(s0 => { const n = { ...s0 }; delete n[pid]; return n; });
    if (crzIds.length <= 1) setExtraMode(null);
  };
  const [examiner, setExaminer] = useState('');
  // FAALIYET TIPI (SHT-FTL/HG Md.9): hangi faaliyeti icra ediyorsak O bolumun
  // limitleri gecerlidir. air_taxi/aerial_work → Md.22 Tablo 1,
  // general_aviation → Md.25 (duz), training → Md.27 (UGS 12h + ucus siniri).
  const [opType, setOpType] = useState('air_taxi');
  // Md.27 EĞİTİM TÜRÜ PİLOT BAŞINA (5 Eki 2026, Serkan: *"öğrenci 4 saat limiti öğretmene uygulanmamalı"*) — pilot id → tür.
  // Varsayılan YOK: seçilmeyen pilot NOT LEGAL görünür, satırındaki seçiciden seçilir. 🔴 Önce görev başına tek tür vardı,
  // varsayılanı öğretmendi (6 saat) — eğitim alan da 6 saat alıyordu.
  const [egitimTurleri, setEgitimTurleri] = useState({});

  const timeOk = (t) => /^\d{2}:\d{2}$/.test(t || '');
  // UZUN MENZIL TESPITI (SHT-FTL/HG Md.4(ee)): kalkis-varis dilim farki >=4h.
  // Meydan tz'leri async cekilir; gelene kadar longRange=false, gelince pencere
  // canli yeniden hesaplanir (Md.22(3) siniri motor icinde, `uzunMenzilTabani`).
  // Ana us dilimleri: YEREL GECE (Md.4(ff)) ekip uyesinin ana ussunun yerel
  // saatiyle olculur — dispatcher'in tarayici dilimiyle degil.
  // ── TANIMSIZ MEYDAN BEYANI (21 Eyl 2026) ──────────────────────────
  // 🔑 Serkan: *"Bu meydan database'e girmez. Boyle durumlarda hep elle
  //    eklenir, bir kereye mahsus."*  Beyan GOREVIN kendi satirinda durur
  //    (`crew_duties.ad_hoc_airports`), kuresel `airports` tablosuna YAZILMAZ.
  //    ICAO anahtarli tek kutu: ucus ayni meydana iki kez ugrarsa iki kopya
  //    olusmaz ve celisemez.
  const [adHoc, setAdHoc] = useState({});
  const beyanEkle = (icao, kayit) =>
    setAdHoc(p => ({ ...p, [String(icao).toUpperCase()]: kayit }));

  // Dilim artik PANELDE tek yerde cozuluyor (`pilotDilim`) — burada ikinci bir
  // kopya tutulmuyordu ama ucuncu/dorduncu ekran hic cozmuyordu (Ilke 3).
  const hbTz = useMemo(() => {
    const out = {};
    Object.entries(pilotDilim || {}).forEach(([pid, d]) => { if (d?.tz) out[pid] = d.tz; });
    return out;
  }, [pilotDilim]);

  // FAALIYET TIPI PLANDAN (6 Agu 2026, Serkan): ucusun niteligi ATC FPL'inde
  // zaten yazili (RMK/BUSINESS FLIGHT → hava taksi, RMK/PRIVATE FLIGHT → GH).
  // Ayni tarih+DEP+DEST'te plan varsa tip ONDAN gelir; elle secim yine mumkun
  // ama kaynak kayda gecer — hangi limitin NEDEN uygulandigi belgelenir.
  const [planOp, setPlanOp] = useState(null);   // {type, source, planId}
  const [opManual] = useState(false);   // eski gorev-basi secim izi (bacak basina gecildi)
  // ── BACAK BASINA PLAN ARAMASI (22 Agu) ─────────────────────────────
  // Eski arama gorev BASINA tekti: ilk bacagin dep'i + son bacagin dest'i.
  // Cok bacakli gorevde o kombinasyon zaten hicbir planla eslesmiyordu
  // (LTAC→LFMN diye bir plan yok; LTAC→LTFE ve LTFE→LFMN var). Artik her
  // bacak KENDI planindan tipini okur — 22 Agu'da bir gorevin bir bacagi
  // BUSINESS, oteki PRIVATE cikti ve bu ancak arsivde fark edildi.
  // 🔑 21 Eki 2026 (Serkan A): YALNIZ AYNI GÜNÜN planı — tek kaynak `ayniGunPlani` (ucusPlani.js). O gün plan yoksa
  //    (ya da okunamadıysa, ya da tipi farklı birden çok plan varsa) bacak OTOMATİK DOLMAZ; daha önce plandan dolmuş
  //    tip de silinir (rota değişti, o plan artık bu bacağın planı değil) — planlamacı seçer, alan zorunlu (amber).
  const [planNotlari, setPlanNotlari] = useState([]);   // okunamadı / belirsiz — bacak bacak, ekranda yazılır
  useEffect(() => {
    if (dutyType !== 'flight') { setPlanNotlari([]); return; }
    let dead = false;
    (async () => {
      const notlar = [];
      for (let i = 0; i < legs.length; i++) {
        const l = legs[i];
        if (!l.dep || l.dep.length !== 4 || !l.dest || l.dest.length !== 4 || !date) continue;
        if (l.opSrc === 'manual') continue;              // elle secildiyse DOKUNMA
        const r = await ayniGunPlani({ dep: l.dep, dest: l.dest, tarih: date, customerId: myProfile?.customer_id });
        if (dead) return;
        if (['okunamadi', 'belirsiz'].includes(r.durum)) notlar.push(`SECTOR ${i + 1}: ${r.metin}`);
        const hit = r.durum === 'var' ? r.plan : null;
        setLegs(ls => ls.map((x, j) => {
          if (j !== i || x.opSrc === 'manual') return x;
          if (hit) return x.operation_type === hit.operation_type ? x
            : { ...x, operation_type: hit.operation_type, opSrc: hit.operation_type_source || 'flight plan' };
          return x.opSrc ? { ...x, operation_type: '', opSrc: '' } : x;   // plandan dolmuştu, artık eşleşen plan yok
        }));
      }
      if (!dead) setPlanNotlari(notlar);
    })();
    return () => { dead = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dutyType, date, legs.map(l => `${l.dep}>${l.dest}`).join('|')]);
  useEffect(() => {
    if (dutyType !== 'flight') { setPlanOp(null); return; }
    const dep = legs[0]?.dep, dest = legs[legs.length - 1]?.dest;
    if (!dep || dep.length !== 4 || !dest || dest.length !== 4 || !date) { setPlanOp(null); return; }
    let dead = false;
    (async () => {
      const r = await ayniGunPlani({ dep, dest, tarih: date, customerId: myProfile?.customer_id });
      if (dead) return;
      const hit = r.durum === 'var' ? r.plan : null;
      setPlanOp(hit ? { type: hit.operation_type, source: hit.operation_type_source, planId: hit.id, reg: hit.reg } : null);
    })();
    return () => { dead = true; };
  }, [dutyType, legs, date, myProfile?.customer_id]);
  useEffect(() => {
    if (planOp?.type && !opManual) setOpType(planOp.type);
  }, [planOp, opManual]);

  // ── İNTİBAK (Md.22/1) — PİLOT BAZLI ────────────────────────────────
  // Zincir görev geçmişinden çözülür: pilotun bu görevden ÖNCEKİ görevi, onun
  // intibak referansı (acclimatised_to, yoksa kalkış meydanı), aradaki dinlenme
  // ve ana üssü. Sonuç Tablo 1'in hangi bantla okunacağını belirler.
  // Nöbet gibi PİLOT BAZLIDIR: aynı uçuşa atanan iki pilot farklı yerlerden
  // gelmiş olabilir, biri intibaklı diğeri değil.
  const [acclTz, setAcclTz] = useState({});   // icao -> IANA tz (ihtiyaç duyulanlar)
  useEffect(() => {
    if (dutyType !== 'flight') return;
    const dep = legs[0]?.dep;
    const refs = new Set();
    if (dep && dep.length === 4) refs.add(dep.toUpperCase());
    Object.values(homeBases || {}).forEach(h => h && refs.add(String(h).toUpperCase()));
    (duties || []).forEach(d => {
      if (d.acclimatised_to) refs.add(String(d.acclimatised_to).toUpperCase());
      const s0 = (d.sectors || [])[0];
      if (s0?.dep) refs.add(String(s0.dep).toUpperCase());
      const sl = (d.sectors || []).slice(-1)[0];
      if (sl?.actual_dest) refs.add(String(sl.actual_dest).toUpperCase());
      if (sl?.dest) refs.add(String(sl.dest).toUpperCase());
    });
    if (!refs.size) return;
    let dead = false;
    (async () => {
      const m = await fetchTzMap([...refs]);
      if (!dead) setAcclTz(m || {});
    })();
    return () => { dead = true; };
  }, [dutyType, legs, duties, homeBases]);

  // 🔑 30 Eyl 2026 (B2-3): burada yalnız meydan dilimleri OKUNUR (`null` = henüz
  //    okunmadı); ölçü motorda (`uzunMenzilOlcumu`) — görevin tarihinde, rapor ve
  //    görev sonunda, büyük olan, kesir yukarı, eşik kural setinden. DH öneki de
  //    görevin meydanıdır (kayıttaki sektörlerle aynı liste: `legsAll`).
  const [tzAssign, setTzAssign] = useState(null);
  // 21 Eki 2026 (W4b): okuma düşerse harita `null` kalır (okunmadı) — kayıt zaten durur; ekran "TIME ZONE UNKNOWN — add the
  // aerodrome to AIRPORTS" DEMEZ (var olan meydanlar için yanlış iş), "could not be read" der, RETRY verir.
  const [tzAssignHata, setTzAssignHata] = useState(false);
  const [tzAssignDeneme, setTzAssignDeneme] = useState(0);
  // RAAQ ERKEN UYARISI (21 Eki 2026): uçuş sektörlerinin DEP / DEST'i şirketin RAAQ kaydında var mı, kategorisi var mı.
  const raaq = useRaaqKayitlari(myProfile?.customer_id, dutyType === 'flight' ? legs.flatMap(l => [l.dep, l.dest]) : []);
  // 🔴 27 AGU 2026 — OLCU YANLIS YERDEN ALINIYORDU.
  // Eskiden yalniz ILK KALKIS ile SON VARIS karsilastiriliyordu; git-gel
  // ucusta ikisi AYNI meydan oldugu icin fark HER ZAMAN 0 cikiyordu. Yani
  // Tokyo'ya gidip ayni gorevde donsen bile uzun menzil TESPIT EDILEMIYORDU
  // ve Md.22(3)'un uzun menzil siniri bugune kadar bir kez bile devreye girmedi.
  // Md.4(ee) "bir UGS ICINDE gecilen" der — olculecek sey gorevde UGRANAN
  // BUTUN meydanlarin dilim ARALIGIDIR.
  useEffect(() => {
    if (dutyType !== 'flight') { setTzAssign(null); setTzAssignHata(false); return; }
    const icaos = [...new Set(legsAll.flatMap(l => [l.dep, l.dest])
      .filter(x => x && x.length === 4).map(x => x.toUpperCase()))];
    if (!icaos.length) { setTzAssign({}); setTzAssignHata(false); return; }
    let dead = false;
    (async () => { const m = await fetchTzMap(icaos); if (!dead) { setTzAssign(m); setTzAssignHata(!m); } })();
    return () => { dead = true; };
  }, [dutyType, legsAll, tzAssignDeneme]);
  // PENCERE OPSIYONLARI TEK KAYNAK: ortak (nobetsiz) pencere ile her pilotun
  // KENDI (nobet kisaltmali) penceresi ayni opsiyonlarla kurulur — ikisi zamanla
  // ayrismasin diye tek yerde duruyor.
  // KALKIŞ MEYDANININ UTC OFSETİ — ortak pencerenin bandı için.
  // Saatler UTC girildiği için Tablo 1'i doğrudan UTC ile okumak YANLIŞ olur
  // (Md.22/2 "görev başlangıç saati YEREL" der). Ortak pencere, ekibin çoğunun
  // hâli olan "kalkış meydanına intibaklı" varsayımıyla bandı çözer; pilot
  // bazlı GERÇEK bant aşağıda intibak zinciriyle yeniden hesaplanır.
  const depOffsetMin = useMemo(() => {
    const tz = acclTz[String(legs[0]?.dep || '').toUpperCase()];
    if (!tz) return null;
    const ref = utcISO(date, legs[0]?.etd) || new Date().toISOString();
    return tzOffsetMin(tz, new Date(ref).getTime());
  }, [acclTz, legs, date]);

  const winOptsTemel = useMemo(() => ({
    operationType: opType,
    // Eğitim türü pilot başına (`egitimTurleri`), aynı gün teori kayıttan (Md.27(1)(ç), sunucu) — ortak pencerede ikisi de yok.
    threePilot: extraMode === 'crz',
    // İki CRZ CPT (4 pilotlu ekip, 5 Eki 2026) — Md.11(4) iki ilave pilot.
    fourPilot: extraMode === 'crz' && crzIds.length >= 2,
    inflightRest: extraMode === 'crz' ? (dinlenme || null) : null,
    singlePilot: Object.keys(selected).length === 1,
  }), [opType, extraMode, dinlenme, selected, crzIds]);
  // Şirket esası seçiliyse Md.27 yok — eğitim türü sorulmaz (31 Eki 2026, Serkan B).
  const egitimliAssign = legs.some(l => l.operation_type === 'training') && !esasSecili(effectiveRules(ruleset).rules);
  const umAssign = useMemo(() => dutyType !== 'flight' ? null
    : uzunMenzilOlcumu(legsAll, tzAssign || {}, effectiveRules(ruleset).rules,
                       gorevAnlari(legsAll, accommodation, ruleset, winOptsTemel, date)),
    [dutyType, legsAll, tzAssign, ruleset, accommodation, winOptsTemel, date]);
  // Dilimi BILINMEYEN meydanlar ekranda YAZAR — sessizce "uzun menzil degil" demeyiz.
  const tzBilinmeyen = tzAssign ? (umAssign?.eksik || []) : [];
  const winOpts = useMemo(() => ({ ...winOptsTemel, longRange: umAssign?.uzunMenzil === true }),
    [winOptsTemel, umAssign]);

  const win = useMemo(() => {
    if (dutyType !== 'flight') return null;
    const complete = legs.filter(l => timeOk(l.etd) && timeOk(l.eta));
    if (complete.length !== legs.length) return null;
    // DH oneki VARSA pencere onunla baslar (Md.14/1/b) — motor `deadhead`
    // bayragini gorup rapor payini eklemez ve sektor saymaz.
    const tumu = [...dhPrefix, ...complete, ...dhSuffix];   // 14 Eki 2026: uçuştan sonraki DH de (görev sonu oradan)
    const w0 = dutyWindow(tumu, accommodation, ruleset, winOpts);
    if (!w0 || depOffsetMin == null) return w0;   // tz yoksa bant çözülmez (uydurma yok)
    const band = bandReportHHMM(w0.report, 0, depOffsetMin);
    return band ? dutyWindow(tumu, accommodation, ruleset, { ...winOpts, bandReport: band }) : w0;
  }, [legs, dhPrefix, dhSuffix, accommodation, ruleset, dutyType, winOpts, depOffsetMin]);

  const { rules } = useMemo(() => effectiveRules(ruleset), [ruleset]);
  // Geç tebliğ uyarısı (Md.7(1)(c), 4 Eki 2026 — Serkan A): OFF formu, kaydetmeden önce. Kayıt engellenmez.
  const gecTebligNotu = useMemo(() => {
    if (dutyType !== 'off') return [];
    const son = off.endDate || date;
    const gunler = [];
    for (let d = date; d && d <= son; d = nextDay(d)) { gunler.push(d); if (d === son) break; }
    return Object.keys(selected).flatMap(pid => gecTebligUyarisi(gunler, rules,
      bosGunDilimi(offYeriKaydi(offLoc, pilotDilim[pid]), hbTz[pid] || null), { offTypes, subtype: off.subtype })
      .map(m => `${pilots.find(x => x.id === pid)?.code || ''} ${m}`.trim()));
  }, [dutyType, off, date, selected, rules, offLoc, pilotDilim, hbTz, offTypes, pilots]);
  const lim = rules.cumulative_limits || {};

  // ── TEK MOTOR ÖNİZLEMESİ (3 Eki 2026, adım ③a) ────────────────────────────────────────────────────────
  // Kapının karar verdiği sayılar (rapor, görev sonu, UGS, azami UGS, aşım, dinlenme bitişi) pilot başına SUNUCUNUN
  // motorundan: aday pilotun görev listesine yeni satır konur, `zincirHesabi` aynen koşar (`duzenlemeOnizlemesi`) —
  // kayıttan sonra sunucunun yazacağı değerin AYNISI. Ekip düzeni ekrandaki seçimden (tek pilot / CRZ). Nöbet ve intibak
  // açıklamaları ekranda aynı kalır. Dilimler gelmeden önizleme yoktur ve uçuş kaydedilmez (kapı eski sayıyla karar vermez).
  const assignPilotlari = useMemo(() => pilots.filter(ucusEkibindenMi).map(p => p.id), [pilots]);
  const assignKodlari = useMemo(() => {
    // Yer görevinde de (Md.16 ⑥, 4 Eki 2026): uzun menzil dinlenmesi önceki görevlerin dilimleriyle tanınır.
    if (dutyType !== 'flight' && dutyType !== 'ground' && dutyType !== 'dh') return '';   // DH: Md.16 ⑦
    const k = new Set();
    const ekle = (x) => { if (x && String(x).length === 4) k.add(String(x).toUpperCase()); };
    (duties || []).filter(d => assignPilotlari.includes(d.pilot_id) && d.status !== 'cancelled').forEach(d => {
      (d.sectors || []).forEach(x => { ekle(x.dep); ekle(x.dest); ekle(x.actual_dest); });
      ekle(d.acclimatised_to);
    });
    Object.values(homeBases || {}).forEach(ekle);
    legsAll.forEach(l => { ekle(l.dep); ekle(l.dest); });
    if (dutyType === 'dh') dhLegs.forEach(l => { ekle(l.dep); ekle(l.dest); });
    return [...k].sort().join(',');
  }, [dutyType, duties, assignPilotlari, homeBases, legsAll, dhLegs]);
  const [assignTz, setAssignTz] = useState(null);
  useEffect(() => {
    if (!assignKodlari) { setAssignTz({}); return; }
    let dead = false;
    (async () => { const m = await fetchTzMap(assignKodlari.split(',')); if (!dead) setAssignTz(m || {}); })();
    return () => { dead = true; };
  }, [assignKodlari]);
  // PAKET SIM SATIRLARI (14 Eki 2026) — önizleme, kapı ve kayıt AYNI satırları kullanır. Gün: başta SIM raporun gününde (saati
  // rapordan sonraysa önceki gün), sonda son varışın gününde (saati ondan önceyse ertesi gün). Bitiş: SIM ENDS + Md.10(1)(c)
  // (`yerGoreviBitisISO`, GND formunun aynısı). Saatleri ya da pilotu eksik SIM satır üretmez — kayıt kapısı adıyla durdurur.
  const paketSimSatirlari = useMemo(() => {
    if (dutyType !== 'flight' || !win || (!paketSim.once && !paketSim.sonra)) return [];
    if (legsAll.some(l => !timeOk(l.etd) || !timeOk(l.eta))) return [];
    const z = sektorZamanlari(date, legsAll.flatMap(l => [l.etd, l.eta]));
    const kural = effectiveRules(ruleset);
    const ekipIdleri = Object.keys(selected);
    const kur = (yer, sim) => {
      if (!sim || !timeOk(sim.start) || !timeOk(sim.end)) return [];
      const pilotlar = (sim.pilotlar || []).filter(pid => ekipIdleri.includes(pid));
      if (!pilotlar.length) return [];
      let tarih;
      if (yer === 'once') {
        const rapor = legsAll[0]?.deadhead ? z[0] : addMin(z[0], -win.preFlightMin);
        tarih = toMin(sim.start) > toMin(rapor.slice(11, 16)) ? shiftDate(rapor.slice(0, 10), -1) : rapor.slice(0, 10);
      } else {
        const son = z[z.length - 1];
        tarih = toMin(sim.start) < toMin(son.slice(11, 16)) ? nextDay(son.slice(0, 10)) : son.slice(0, 10);
      }
      const bas = utcISO(tarih, sim.start);
      const bit = yerGoreviBitisISO({ kind: 'sim', start: sim.start, end: sim.end }, tarih, kural.rules, kural.company);
      return pilotlar.map(pid => ({ id: `yeni-sim-${yer}:${pid}`, pilot_id: pid, customer_id: myProfile?.customer_id,
        assignment_id: 'yeni-atama', duty_type: 'ground', ground_kind: 'sim', status: 'planned', duty_date: tarih,
        report_time: bas, duty_end: bit, fdp_minutes: null,
        location: sim.loc?.location || null, location_tz: sim.loc?.location_tz || null,
        sim_device: sim.device || null, sim_checks: simKontrolleriYaz(sim.checks),
        ruleset_snapshot: { regulation: ruleset.regulation, company: ruleset.company } }));
    };
    return [...kur('once', paketSim.once), ...kur('sonra', paketSim.sonra)];
  }, [dutyType, win, paketSim, legsAll, date, ruleset, selected, myProfile]);
  const assignOnizleme = useMemo(() => {
    if (dutyType !== 'flight' || !win || !assignTz) return null;
    if (legsAll.some(l => !l.dep || !l.dest || !timeOk(l.etd) || !timeOk(l.eta))) return null;
    const sektorler = legsAll.map(l => ({ dep: String(l.dep).toUpperCase(), dest: String(l.dest).toUpperCase(),
      etd: l.etd, eta: l.eta,
      ...(l.deadhead ? { deadhead: true } : (l.operation_type ? { operation_type: l.operation_type } : {})) }));
    const satirlar = assignPilotlari.map(pid => ({ id: `yeni:${pid}`, pilot_id: pid, customer_id: myProfile?.customer_id,
      assignment_id: 'yeni-atama', duty_type: 'flight', status: 'planned', duty_date: date, accommodation,
      operation_type: win.operationType, inflight_rest_facility: winOptsTemel.inflightRest,
      ...(egitimliAssign ? { training_kind: egitimTurleri[pid] || null } : {}),
      ruleset_snapshot: { regulation: ruleset.regulation, company: ruleset.company }, sectors: sektorler }));
    // Paket SIM satırları aynı atamayla (`yeni-atama`) önizlemeye girer — motor onları uçuşun periyoduna bağlar (14 Eki 2026).
    const o = duzenlemeOnizlemesi({ satirlar: [...satirlar, ...paketSimSatirlari], tumGorevler: duties || [], tz: assignTz,
      anaUslar: homeBases || {}, baslangic: date,
      ekipDuzenlenen: { tekPilot: !!winOptsTemel.singlePilot, ucPilot: !!winOptsTemel.threePilot, dortPilot: !!winOptsTemel.fourPilot } });
    return { ...Object.fromEntries(assignPilotlari.map(pid => [pid, o[`yeni:${pid}`] || null])),
             __paketSim: Object.fromEntries(paketSimSatirlari.map(r => [r.id, o[r.id] || null])) };
  }, [dutyType, win, assignTz, legsAll, assignPilotlari, myProfile, date, accommodation, egitimTurleri, egitimliAssign,
      ruleset, duties, homeBases, winOptsTemel, paketSimSatirlari]);

  // GND formunda YAZILMAKTA OLAN nobetin etkisi (canli onizleme).
  const gndEffect = useMemo(() => {
    if (dutyType !== 'ground') return null;
    if (gnd.kind !== 'airport_standby' && gnd.kind !== 'other_standby') return null;
    if (!timeOk(gnd.start) || !timeOk(gnd.end)) return null;
    const startISO = utcISO(date, gnd.start);
    const endISO = utcISO(toMin(gnd.end) < toMin(gnd.start) ? nextDay(date) : date, gnd.end);
    if (!startISO || !endISO) return null;
    return standbyEffect(
      { duty_type:'ground', ground_kind: gnd.kind, report_time: startISO, duty_end: endISO }, rules);
  }, [dutyType, gnd, date, rules]);

  // ── SEÇİLİ EKİP: OML ve yaş (SHT-MED · SHT-FCL FCL.065) ───────────
  // Veri ATPL & MED modülünde girilir, buraya OKUNUR — tek kaynak.
  // 29 Eyl 2026: kapı `ekipKapilari`na taşındı — EDIT de AYNISINI çağırır.
  const ekipGerekceleri = useMemo(() => ekipKapilari({
    pilotlar: pilots.filter(p => selected[p.id]), lisansMed, duties,
    crzPilotlar: crzUyeleri(bacakRolleri), tzMap: acclTz,
  }), [pilots, selected, lisansMed, duties, acclTz, bacakRolleri]);

  // her pilot için uygunluk
  //
  // 🔴 4 Eyl 2026 — ÜÇÜNCÜ VE SON KAÇAK. Bu liste `dutyType !== 'flight'`
  //    dönüyordu; `save()` içindeki `engelli` de ondan besleniyor. Sonuç:
  //    YER GÖREVİ ATARKEN HİÇBİR ŞEY BAKILMIYORDU — ne boş gün, ne çakışma,
  //    ne dinlenme, ne kümülatif. Saha kanıtı (SCL, 3 Eyl): aynı güne OFF ve
  //    yer dersi, tek bir soru sorulmadan.
  //    Kardeşleri: atama ekranı (vardı) · düzenleme modalı (dün kapandı) · bu.
  //
  // Yer görevinde uçuşa özel olanlar (azami UGS, intibak, nöbet penceresi)
  // doğal olarak devre dışı kalır — `win` yoktur. Geriye motorun asıl işi
  // kalır: çakışma · dinlenme borcu · kümülatif · Md.5 boş gün.
  const fitList = useMemo(() => {
    if (dutyType === 'off') return [];
    // 🔑 Md.16 ⑦ (4 Eki 2026, Serkan A): tek başına DH de kapıdan geçer — UGS DEĞİLDİR (azami UGS, normal dinlenme, intibak,
    //    nöbet koşmaz) ama GÖREVDİR (Md.4(ğ), Md.14(1)(a)): çakışma, Md.13(1) görev süresi, Md.5, uzun menzil dinlenmesi.
    //    Önce: `win` yalnız uçuşta kurulduğu için DH'de liste boştu — hiçbir şey ölçülmeden kaydediliyordu.
    const dhGorevi = dutyType === 'dh';
    const dhAnlar = dhGorevi ? dhDamgala(dhLegs, date) : null;
    const yerGorevi = dutyType === 'ground' || dhGorevi;   // UGS olmayan görev
    if (dhGorevi ? !dhAnlar : yerGorevi ? !(timeOk(gnd.start) && timeOk(gnd.end)) : !win) return [];
    // DH bacakları: yer bilgisi (rotasyon / uzun menzil) için — saat VERİLMEZ, uçuş süresine girmez (Md.13(2), Md.14(1)(b)).
    const dhSektor = dhGorevi ? dhAnlar.map(l => ({ dep: String(l.dep).toUpperCase(), dest: String(l.dest).toUpperCase(),
                                                   deadhead: true })) : [];

    const reportISO = dhGorevi ? dhAnlar[0].start : yerGorevi ? utcISO(date, gnd.start) : utcISO(date, win.report);
    // Gece yarisini gecen yer gorevi ertesi gune biter — bitis baslangictan
    // kucukse gun ilerletilir (kodun baska yerindeki ayni desen).
    const gndEndISO = dhGorevi ? dhAnlar[dhAnlar.length - 1].end : yerGorevi
      ? yerGoreviBitisISO(gnd, date, rules, effectiveRules(ruleset).company) : null;   // kayıtla aynı an (SIM +Md.10(c))
    const gndDutyMin = yerGorevi && reportISO && gndEndISO
      ? Math.round((new Date(gndEndISO) - new Date(reportISO)) / 60000) : null;
    // 🔑 30 Eyl 2026 (B3): yeni görevin DİNLENME BİTİŞİ — sonraki mevcut görev
    //    onu deliyor mu (Md.16). Kayıttaki AYNI karar noktası: uçuşta `restForDuty`
    //    (uzun menzil `umAssign`), yer görevinde `yerGoreviDinlenmesi`.
    const ucusBitisISO = !yerGorevi && win.dutyMin && reportISO ? addMin(reportISO, win.dutyMin) : null;
    return pilots.filter(ucusEkibindenMi).map(p => {
      const myDuties = duties.filter(d => d.pilot_id === p.id);
      // ③a (3 Eki 2026): uçuşta kapının sayıları TEK MOTOR önizlemesinden (sunucunun yazacağı), pilot başına.
      const onH = !yerGorevi ? assignOnizleme?.[p.id] : null;
      const on = onH?.alanlar || null;
      const dinlenmeDk = dhGorevi
        ? (gndDutyMin != null ? dhDinlenmesi({ id: null, sectors: dhSektor, report_time: reportISO, duty_end: gndEndISO },
            gndDutyMin, rules, { oncekiler: myDuties, anaUs: homeBases?.[p.id] || null,
                                 tz: { ...(assignTz || {}), ...(tzAssign || {}) } }).rest : null)
        : yerGorevi
        ? (gndEndISO && gndDutyMin != null ? yerGoreviDinlenmesi(gnd.kind, gndDutyMin, gndEffect, rules) : null)
        : (() => {
            if (!ucusBitisISO || !umAssign || umAssign.olculemedi) return null;
            // Md.16(3)(b) rotasyon (4 Eki 2026) — sunucuyla aynı fonksiyon (önizleme gelene kadarki yedek).
            const atBaseA = endedAtBase(legs[legs.length - 1]?.dest, homeBases?.[p.id]);
            const rotA = atBaseA && umAssign.uzunMenzil !== true
              ? rotasyondaUzunMenzil({ id: null, sectors: legs }, myDuties, { anaUs: homeBases?.[p.id] || null,
                  tz: { ...(assignTz || {}), ...(tzAssign || {}) }, raporISO: reportISO }) : null;
            if (rotA && rotA.uzunMenzil == null) return null;
            return restForDuty({ dutyMin: win.dutyMin, atBase: atBaseA, longRange: umAssign.uzunMenzil === true,
                                 rotasyonUzunMenzil: rotA?.uzunMenzil === true, dutyEndISO: ucusBitisISO,
                                 arrivalTz: umAssign.varisTz, rules }).restMin;
          })();
      const bitisISO = yerGorevi ? gndEndISO : ucusBitisISO;
      const f = fitness({
        pilot: p, baseline: baselines[p.id] || null, duties: myDuties, ruleset,
        // Md.16 ⑥ (4 Eki 2026): uzun menzil dinlenmesi — önceki görevlerin meydan dilimleri + ana üs (sunucuyla aynı)
        tzMap: { ...(assignTz || {}), ...(tzAssign || {}) }, homeBase: homeBases?.[p.id] || null,
        // `dutyEndISO`: cakisma kontrolu icin gorevin BITISI de gerekir
        // (23 Agu). Yoksa yalniz rapor ani bakilir, kismi cakisma kacar.
        newDuty: yerGorevi
          ? { reportISO, sectors: dhSektor, dutyMin: gndDutyMin, dutyDate: date,
              // ground_kind (5 Eki 2026): nöbet çağrısı (Md.17) ve ev nöbetinin %25'i (Md.17(2)(g)) türden okunur.
              duty_type: dhGorevi ? 'dh' : 'ground', ground_kind: dhGorevi ? 'dh' : gnd.kind, dutyEndISO: gndEndISO,
              earliestNextReportISO: dinlenmeDk != null ? addMin(bitisISO, dinlenmeDk) : null }
          : on
            ? { reportISO: on.report_time, sectors: legs, dutyDate: date, dutyEndISO: on.duty_end,
                dutyMin: on.report_time && on.duty_end
                  ? Math.round((new Date(on.duty_end) - new Date(on.report_time)) / 60000) : win.dutyMin,
                earliestNextReportISO: on.earliest_next_report || null }
            : { reportISO, sectors: legs, dutyMin: win.dutyMin, dutyDate: date,
                dutyEndISO: ucusBitisISO,
                earliestNextReportISO: dinlenmeDk != null ? addMin(bitisISO, dinlenmeDk) : null },
        asOf: (on?.report_time || reportISO) ? new Date(on?.report_time || reportISO) : new Date(),
        // Md.5 — aylik bos gun olcusu artik MOTORDA (4 Eyl 2026). Eskiden
        // burada `daysOffSummary` ile ikinci kez hesaplaniyor, sonuc satira
        // ekleniyor ve HIC OKUNMUYORDU (`.off.` erisimi = 0): ay 0/7 iken
        // sistem tek kelime etmiyordu. Tek kaynak (Ilke 3).
        offTypes, tz: hbTz[p.id] || null,
      });
      const off = f.off;

      // ── NOBET (SHT-FTL/HG Md.17) — PILOT BAZLI ───────────────────────
      // Nobet her pilotun KENDI gecmisidir: ayni ucusa atanan iki pilottan biri
      // sabahtan beri nobette beklemis, digeri evinde olmus olabilir. Bu yuzden
      // azami UGS ORTAK DEGIL, pilot basina hesaplanir — ortak pencere yalnizca
      // "nobetsiz taban"dir. Kisaltilmis pencere ayni motordan gecer.
      const sbDuty = yerGorevi ? null : standbyBefore(myDuties, p.id, date, reportISO);
      const sbEffect = sbDuty
        // Md.17(e): 6→8 saat YALNIZ UGS gerçekten uzatıldıysa (otelsiz split uzatmaz).
        ? standbyEffect(sbDuty, rules, { fdpExtended: !!(win.split.extensionMin > 0 || win.augmented), cagriISO: reportISO })
        : null;

      // ── İNTİBAK (Md.22/1) — Tablo 1'in bandını bu belirler ─────────
      const depIcao = String(legs[0]?.dep || '').toUpperCase();
      const nowMs = reportISO ? new Date(reportISO).getTime() : Date.now();
      const offOf = (icao) => {
        const tz = acclTz[String(icao || '').toUpperCase()];
        return tz ? tzOffsetMin(tz, nowMs) : null;
      };
      const prevD = previousDuty(myDuties, p.id, reportISO);
      // Önceki görevin intibak referansı: kayıtlıysa o, değilse VARDIĞI meydan
      // (ekip oraya uçtu, dinlenmesi orada başladı).
      const prevLast = (prevD?.sectors || []).slice(-1)[0];
      const prevRefIcao = prevD
        ? (prevD.acclimatised_to || prevLast?.actual_dest || prevLast?.dest || null) : null;
      // İntibak Tablo 1'in bandını seçmek içindir; yer görevinde tablo hiç
      // okunmaz, o yüzden sorulmaz da. "Belirlenemedi" demek yanlış olurdu —
      // belirlenmesi GEREKMİYOR (İlke 1: olmayan soruyu kırmızı yakmayız).
      // ③a: intibak da TEK MOTORDAN — önceki görev girdilerinden yeniden hesaplanır (kayıttaki eski `acclimatised_to`
      //    okunmaz; OMDW vakasının ASSIGN'daki karşılığı). Önizleme yoksa (dilimler yükleniyor) kayıttan.
      const accl = yerGorevi ? null : (onH?.aciklama?.intibak || acclimatisation(
        prevD ? { refIcao: prevRefIcao, refOffsetMin: offOf(prevRefIcao), dutyEndISO: prevD.duty_end,
                  minRestMin: prevD.min_rest_minutes ?? null } : null,
        { depIcao, depOffsetMin: offOf(depIcao), reportISO, homeBaseIcao: homeBases?.[p.id] || null },
        rules));
      // BANT SAATİ (Md.22/2): `win.report` artık UTC (Serkan ilkesi). Tablo 1
      // ise YEREL saat ister — ekibin İNTİBAK ETTİĞİ meydanın yerel saati.
      // Kayma bu yüzden UTC→intibak meydanı (0 → accl.offsetMin); eskiden
      // kalkış meydanının yereliydi ve iki kez dilim uygulanırdı.
      // İNTİBAK ÇÖZÜLEMEZSE bant hesaplanmaz → pilot NOT LEGAL (aşağıda).
      const bandRep = (!yerGorevi && !accl.unavailable)
        ? bandReportHHMM(win.report, 0, accl.offsetMin) : null;

      const pOpts = { ...winOpts,
        ...(egitimliAssign && egitimTurleri[p.id] ? { trainingKind: egitimTurleri[p.id] } : {}),
        ...(bandRep ? { bandReport: bandRep } : {}),
        ...(accl?.icao ? { acclimatisedTo: accl.icao } : {}) };
      const pWin = yerGorevi ? null
        : (sbEffect?.fdpReductionMin || bandRep || (egitimliAssign && egitimTurleri[p.id]))
          ? dutyWindow(legs, accommodation, ruleset,
              { ...pOpts, ...(sbEffect?.fdpReductionMin ? { standbyReductionMin: sbEffect.fdpReductionMin } : {}) })
          : win;
      const sb = sbEffect ? standbyLimits(sbEffect, pWin.fdpMin) : null;

      // `reasons` düz metin · `kunyeli` aynı sırada { metin, ref } (29 Eyl 2026 ·
      // bkz. FTLEngine.fitness): kural ihlali kartının ⓘ'si künyeden okur.
      const reasons = [...f.reasons];
      const kunyeli = [...(f.kunyeli || [])];
      const neden = (metin, ref = null) => { reasons.push(metin); kunyeli.push({ metin, ref }); };
      if (sb) { reasons.push(...sb.reasons); kunyeli.push(...(sb.kunyeli || [])); }
      // UGS asimi NOBET yuzunden dogduysa PILOT BAZLIDIR -> uygunluk gerekcesi
      // olmali; aksi halde ortak pencere yesil gorunurken nobetli pilot sessizce
      // yasadisi atanir. (Nobetsiz asim zaten ortak pencerede kirmizi notta.)
      // Aşım ve sayılar: önizleme varsa ONDAN (sunucunun yazacağı), yoksa pencereden (yer görevi / dilim yok).
      const pAsim = on ? !!on.fdp_exceeded : !!pWin?.fdpExceeded;
      const pFdp = on ? on.fdp_minutes : pWin?.fdpMin;
      const pMax = on ? on.max_fdp_minutes : pWin?.maxFdpMin;
      const nobettenDogan = on
        ? ((on.standby_reduction_min || 0) > 0 && pFdp != null && pMax != null && pFdp <= pMax + on.standby_reduction_min)
        : !!(sb && !win.fdpExceeded);
      // Geçmiş tarihli (uçulmuş) görev bir KAYITtır — engellenmez; bitiş GEÇMİŞTEYSE satır eklenmez (4 Eyl kuralı).
      const bitisMs = on?.duty_end ? new Date(on.duty_end).getTime()
        : (reportISO && pWin?.dutyMin ? new Date(reportISO).getTime() + pWin.dutyMin * 60000 : null);
      const gecmisKayit = bitisMs != null && bitisMs < Date.now();
      if (sb && pAsim && nobettenDogan) {
        neden(`FDP ${fmtMin(pFdp)} > MAX ${fmtMin(pMax)} AFTER STANDBY REDUCTION ${fmtMin(sb.fdpReductionMin)} (${sb.reference})`,
              `SHT-FTL/HG ${sb.reference}`);
      } else if (pAsim && !gecmisKayit) {
        // 🔑 Serkan 3 Eki 2026 "A": nöbetsiz düz aşım da KURAL İHLALİDİR (eskiden yalnız kırmızı not, kayıt geçiyordu).
        // Bağlı yer görevi (ofis / ders / simülatör) UGS'yi başlattıysa sebep de söylenir — sunucunun cümlesi (5 Eki 2026).
        const bagliId = onH?.aciklama?.sim?.id;
        const bagli = bagliId ? ((duties || []).find(d => d.id === bagliId) || paketSimSatirlari.find(r => r.id === bagliId)) : null;
        // Paketteki SIM uçuştan sonraysa UGS onun sonuna kadar sayıldı — sebep söylenir (motorun cümlesi, 14 Eki 2026).
        const arkaSim = onH?.aciklama?.arkaYer ? paketSimSatirlari.find(r => r.id === onH.aciklama.arkaYer.id) : null;
        neden(planliAsimMetni(pFdp, pMax) + (bagli ? baglantiNotu(bagli) : '') + (arkaSim ? simSonraNotu(arkaSim) : ''),
              maxFdpKunyesi(hesapTuru(on?.operation_type || pWin?.operationType, rules)));
      }
      // PAKET SIM (14 Eki 2026): pilotun bu kayıttaki SIM satırları — motorun kendi gerekçeleri (Md.27(1)(a) oturum, uzun menzil
      // dinlenmesi …) ve kayıttaki görevlerle çakışma. SIM'li UGS aşımı yukarıda, uçuş satırında.
      if (!yerGorevi) {
        paketSimSatirlari.filter(r => r.pilot_id === p.id).forEach(r => {
          const h = assignOnizleme?.__paketSim?.[r.id];
          (h?.alanlar?.ftl_gerekce || []).filter(g => g.durum === 'NOT_LEGAL').forEach(g => neden(`SIMULATOR: ${g.metin}`, g.ref));
          const cak = myDuties.find(d => d.duty_type !== 'off' && d.status !== 'cancelled' && d.report_time && d.duty_end
            && new Date(d.report_time) < new Date(r.duty_end) && new Date(d.duty_end) > new Date(r.report_time));
          if (cak) {
            neden(`SIMULATOR ${String(r.report_time).slice(5, 16).replace('T', ' ')} OVERLAPS DUTY `
              + `${new Date(cak.report_time).toISOString().slice(5, 16).replace('T', ' ')}`);
          }
        });
      }
      // Md.27 (5 Eki 2026, Serkan A): eğitim uçuş süresi sınırı da KURAL İHLALİDİR — metin ve künye sunucunun gerekçesinden
      // (önizleme yoksa aynı pencereden aynı cümle). Eskiden yalnız kırmızı nottu, kayıt geçiyordu.
      // Tür seçilmemiş pilot (Md.27(1)) — sınır ölçülemez, atanamaz; satırındaki seçiciden seçilir.
      if (!yerGorevi && egitimliAssign && !egitimTurleri[p.id]) neden(EGITIM_TURU_SECILMEDI, 'SHT-FTL/HG Md.27(1)');
      if (!gecmisKayit) {
        const egitim = on ? (on.ftl_gerekce || []).filter(g => EGITIM_ENGEL_TURLERI.includes(g.tur))
          : (pWin?.flightLimitExceeded ? [{ metin: egitimUcusAsimMetni(pWin), ref: pWin.flightLimitRef }] : []);
        egitim.forEach(g => neden(g.metin, g.ref));
      }
      // İntibak ÇÖZÜLEMEDİYSE sessizce kalkış saatiyle devam etmeyiz: hangi
      // bandın okunduğu belirsizken azami UGS doğrulanmış sayılamaz (İlke 1).
      if (accl?.unavailable) {
        neden(`ACCLIMATISATION NOT DETERMINED (Md.22/1) — ${accl.reason}`, 'SHT-FTL/HG Md.22(1)');
      }
      // ── BOŞ GÜN (Md.5, 8 Ağu — Serkan: "regülatif bir OFF'a görev verilemez,
      //    uyarı vermeli; sistem ruleset'e göre arka planda takip yapar")
      // Ölçü GÜN değil ÇAKIŞMA: öğleden sonraki bir görev yerel gece
      // pencerelerine değmiyorsa boş gün DURUR ve engel yoktur. Kural motorda
      // (offDayRelease) — panel ile EDIT aynı kaynağı kullanır (İlke 2).
      // Gece yarısını geçen görevde `win.dutyEnd` yalnız HH:MM'dir, gün bilgisi
      // taşımaz — aynı güne yazılırsa bitiş başlangıçtan ÖNCE görünür ve çakışma
      // testi sessizce yanlış çalışır. Kodun başka yerindeki desen: bitiş
      // başlangıçtan küçükse ertesi gün.
      const relEndISO = yerGorevi ? gndEndISO : utcISO(
        toMin(win.dutyEnd) < toMin(win.report) ? nextDay(date) : date, win.dutyEnd);
      const rel = offDayRelease(myDuties, p.id, date,
                                { report_time: reportISO, duty_end: relEndISO || null },
                                rules, { offTypes, tz: hbTz[p.id] || null, baseline: baselines[p.id] || null });
      // Engel/uyarı artık `fitness`te (aynı gün + komşu günler, 1 Eki 2026) — burada ikinci kez yazılmaz.
      // ── OFF TO DUTY (4 Eyl 2026, Serkan) ─────────────────────────────
      // 🔑 *"OFF to duty yazması gerekir — kanunen görev verilebilirse, rest
      //    bölmüyorsa mesela, OFF TO DUTY olur, remark olarak."*
      // Engel DEĞİL, uyarı: gün OFF kayıtlı, görev yerel gecelere değmiyor,
      // boş gün Md.4/ü'ye göre AYAKTA. Planlayıcı görsün — sahada bu hâl
      // "mükerrer kayıt" sanılıyordu.
      // ── TİP YETKİSİ (21 Eki 2026, Serkan K2: *"tip yetkisi yoksa görev verilemez"*) ── sektörün tescili → AIRCRAFTS'taki tip
      //    → pilotun tip yetkisi (roller.ucusEngeli, ARCHIVED FLTS ile aynı kural ve metin). ASSIGN'da satır NOT LEGAL olur
      //    (seçilmez, tıklayınca kart), WHAT IF'te seçilir ve kırmızı görünür, kayıt anında yeniden denetlenir.
      if (dutyType === 'flight') tipYetkisiEngelleri(p, legs, aircraft, tipVasiflari).forEach(m => neden(m));
      const uyarilar = [...(f.warnings || [])];
      if (rel.isOffDay && rel.allowed && rel.keepsDayOff) {
        // 4 Eki 2026 (Serkan A): günün kendisine değen görev boş günü düşürür — bu dal yalnız OFF'un yerel gününe ve
        // gecelerine HİÇ değmeyen kayıt için kalır (ör. tarihi OFF günü yazılı ama saatleri başka güne düşen görev).
        uyarilar.push('OFF TO DUTY — day is recorded as OFF; the duty touches neither its local day nor its '
          + 'nights, so the day off stands (Md.4/ü)');
      }
      return { pilot: p, ...f, reasons, kunyeli, legal: reasons.length === 0, off, sb, sbDuty,
               accl, win: on && pWin ? { ...pWin, fdpMin: pFdp, maxFdpMin: pMax, fdpExceeded: pAsim } : pWin,
               offRelease: rel, warnings: uyarilar };
    });
  }, [pilots, duties, baselines, ruleset, legs, win, winOpts, accommodation, date, dutyType, rules, hbTz, offTypes, acclTz, homeBases, gnd,
      umAssign, gndEffect, assignOnizleme, assignTz, tzAssign, dhLegs, egitimTurleri, egitimliAssign, paketSimSatirlari,
      aircraft, tipVasiflari]);

  const setLeg = (i, k, v) => setLegs(ls => ls.map((l, j) => j === i ? { ...l, [k]: v } : l));
  // AIRCRAFT seçimi (21 Eki 2026, K2): yalnız AKTİF uçaklar (emekli uçak seçilemez).
  const aktifUcaklar = useMemo(() => (aircraft || []).filter(a => a.active !== false), [aircraft]);

  const toggle = (pid) => setSelected(s => {
    const cur = s[pid];
    const next = { ...s };
    const vals = Object.values(s);
    if (!cur) {
      if (!vals.includes('PF')) next[pid] = 'PF';
      else if (!vals.includes('PM')) next[pid] = 'PM';
      // 3. ve 4. pilot (CRZ CPT) yalnız + ADD COCKPIT CREW listesinden (5 Eki 2026) — tablo tıklaması PF/PM içindir.
      else return s;
    }
    else if (cur === 'PF') next[pid] = 'PM';
    else delete next[pid];
    return next;
  });

  const save = async ({ otomatik = false, mesajlar = null } = {}) => {
    // OTOMATİK SINAMA (WHAT IF şeridi, 15 Eki 2026): aynı kapılar ve satır kurulumu; mesajlar ekrana değil günün sonucuna gider
    // (çağıranın `mesajlar` dizisine), "kaydediyor" durumu değişmez. Dönüş: sonuç bildirildiyse true.
    const otoMesajlar = mesajlar || [];
    const toast = otomatik ? (m) => { otoMesajlar.push(String(m)); } : toastDisari;
    const setSaving = otomatik ? () => {} : setSavingDisari;
    const ids = Object.keys(selected);
    // WHAT IF (12 Eki 2026): YASALLIK kapıları denemede DURDURMAZ — gerekçe pilot pilot toplanır, deneme kırmızı görünür.
    // FORM eksikleri (pilot yok, saat yok, tip yok, dilim okunamadı…) gerçek ASSIGN'deki gibi durdurur: eksik girdiyle
    // hesap yapılamaz (İlke 1). Tek yol: kapılar ve satır kurulumu gerçek kayıtla AYNI kod.
    const denemeNedenleri = {};   // pilot id → [{ metin, ref }]
    const nedenEkle = (pid, liste) => { denemeNedenleri[pid] = [...(denemeNedenleri[pid] || []), ...liste]; };
    if (dutyType !== 'off' && !ids.length) { toast('Select at least one pilot.', 'error'); return; }
    if (dutyType === 'flight' && extraMode === 'crz' && !crzIds.length) {
      toast('CRZ CPT mode is on — pick the 3rd pilot from the CRZ CPT list, or REMOVE the box.', 'error'); return;
    }
    if (dutyType === 'flight' && extraMode === 'crz' && crzSlot) {
      toast('A 4th pilot is being added — pick the CRZ CPT from the list, or close the list (✕).', 'error'); return;
    }
    if (dutyType === 'flight' && extraMode === 'crz' && !dinlenme) {
      toast('Choose the IN-FLIGHT REST FACILITY: IN USE or NOT IN USE (SHT-FTL/HG Md.11(1)).', 'error'); return;
    }
    if (dutyType === 'flight' && extraMode === 'checkride' && !examiner.trim()) {
      toast('Enter TRE/TRI name for the check ride.', 'error'); return;
    }
    // UÇUŞ ÖNCESİ KONUMLANDIRMA YARIM KALAMAZ (5 Eki 2026, Serkan A). 🔴 Önce: yarım bacak `dhPrefix`te SESSİZCE atılıyor,
    //    görev konumlandırmasız kaydediliyordu — UGS gerçekte olduğundan geç başlar (Md.14(1)(b)), limit gevşek tarafa kayar.
    if (dutyType === 'flight' && dhBeforeFlight) {
      const eksik = dhBacakEksikleri(dhLegs);
      if (eksik.length) {
        toast(`POSITIONING BEFORE THIS FLIGHT incomplete — ${eksik.join(' · ')}. Complete it or remove it (✕).`, 'error'); return;
      }
    }
    // Uçuştan SONRAKİ konumlandırma da yarım kalamaz (14 Eki 2026) — yarım bacak sessizce atılsaydı görev erken biter, sonraki
    // dinlenme kısa ölçülürdü (Md.14(1)(a)(c)).
    if (dutyType === 'flight' && dhAfterFlight) {
      const eksik = dhBacakEksikleri(dhSonraLegs);
      if (eksik.length) {
        toast(`POSITIONING AFTER THIS FLIGHT incomplete — ${eksik.join(' · ')}. Complete it or remove it (✕).`, 'error'); return;
      }
    }
    // PAKET SIM yarım kalamaz, uçuşla çakışamaz (14 Eki 2026) — yarım satır sessizce atılsaydı SIM kaydedilmez, UGS kısa ölçülürdü.
    if (dutyType === 'flight') {
      for (const yer of ['once', 'sonra']) {
        const ad = yer === 'once' ? 'SIMULATOR BEFORE THIS FLIGHT' : 'SIMULATOR AFTER THIS FLIGHT';
        const eksik = paketSimEksikleri(paketSim[yer], Object.keys(selected));
        if (eksik.length) { toast(`${ad} incomplete — ${eksik.join(', ')} missing. Complete it or remove it (✕).`, 'error'); return; }
        const r = paketSimSatirlari.find(x => x.id.startsWith(`yeni-sim-${yer}:`));
        if (!r || !legsAll.every(l => timeOk(l.etd) && timeOk(l.eta))) continue;
        const z = sektorZamanlari(date, legsAll.flatMap(l => [l.etd, l.eta]));
        const rapor = legsAll[0]?.deadhead ? z[0] : addMin(z[0], -(win?.preFlightMin || 0));
        if (yer === 'once' && new Date(r.duty_end) > new Date(rapor)) {
          toast(`${ad} must end before the report ${rapor.slice(11, 16)} — its duty ends 60 min after the simulator (Md.10(1)(c)).`, 'error'); return;
        }
        if (yer === 'sonra' && new Date(r.report_time) < new Date(z[z.length - 1])) {
          toast(`${ad} must start after the last arrival ${z[z.length - 1].slice(11, 16)}.`, 'error'); return;
        }
      }
    }

    if (siraHatasi) { toast(`SECTOR TIMES OVERLAP — ${siraHatasi}`, 'error'); return; }
    // ── AÇIK MESAİ CEVABI ZORUNLU (29 Eyl 2026, Md.15) ─────────────────────
    if (dutyType === 'flight' && win?.split?.isSplit && win.split.cevapGerekli) {
      toast('SPLIT DUTY — choose where the break is taken (HOTEL or ON AIRCRAFT) before saving (SHT-FTL/HG Md.15).', 'error');
      return;
    }
    // ── BACAK ROLLERİ GEÇERLİ Mİ (29 Eyl 2026) ─────────────────────────────
    // Her uçuş bacağında tam bir PF, iki+ pilotta tam bir PM. Tablo tıklaması
    // geçersiz bir ara hâl bırakabilir (PF'i PM'e çevirince iki PM) — kayıt
    // bacak ADIYLA durur, rol sessizce uydurulmaz.
    if (dutyType === 'flight' && ids.length) {
      const hatalar = bacakRolleri.map((h, i) => {
        const e = bacakHatasi(h);
        return e ? `${legs[i]?.dep || '?'}-${legs[i]?.dest || '?'}: ${e}` : null;
      }).filter(Boolean);
      if (hatalar.length) { toast(`CREW ROLES — ${hatalar.join(' · ')}`, 'error'); return; }
    }

    // ── ASGARI UCUS EKIBI KAPISI (Serkan, 3 Eyl 2026) ──────────────────────
    // *"Bir ucus eklenip 2 pilot eklenmeli min. Eger long range ucus ise 3
    //   pilotta eklenebilir tabiki."*
    // Kapi ESITLIK degil ASGARI: atanan >= sayi, FAZLASI serbest (takviye ekip).
    //
    // 🔑 SAYI KODA GOMULMEZ (Ilke 6): ucak kaydindan okunur. Iki kaynak, sirayla:
    //   ① plan bulunduysa O UCAGIN degeri — en kesin olan
    //   ② plan yoksa FILODAKI EN KUCUK tanimli deger — "hangi ucak olursa olsun
    //      en az bu kadar gerekir" cikarimi; uydurma degil, veriden turetilmis
    // Hicbiri tanimli degilse KONTROL YAPILMAZ. Bos alan "1 yeter" DEMEZ,
    // "olculmedi" der (Ilke 1) — ve bunu asagida pilota SOYLERIZ.
    if (dutyType === 'flight') {
      const aktif = (aircraft || []).filter(a => a.active !== false);
      // 21 Eki 2026 (K2): uçak artık sektörde SEÇİLİ — kaynak seçilen uçak(lar); birden çoksa en büyük asgari (her sektörde
      // uçacak ekip aynı). Eskiden plan bulunursa planın uçağı, yoksa filonun en küçüğü kullanılıyordu.
      const secilenUcaklar = [...new Set(legs.map(l => String(l.reg || '').toUpperCase()).filter(Boolean))]
        .map(r => aktif.find(a => String(a.registration).toUpperCase() === r)).filter(Boolean);
      const tanimliSecilen = secilenUcaklar.filter(a => a.min_flight_crew != null);
      const enBuyuk = tanimliSecilen.sort((a, b) => b.min_flight_crew - a.min_flight_crew)[0] || null;
      const tanimli = aktif.map(a => a.min_flight_crew).filter(v => v != null);
      const asgari = enBuyuk?.min_flight_crew ?? (tanimli.length ? Math.min(...tanimli) : null);
      const kaynak = enBuyuk ? `${enBuyuk.registration} (${enBuyuk.ac_type})` : 'the fleet minimum';
      if (asgari != null && ids.length < asgari) {
        // Sayı regülasyondan değil UÇAK KAYDINDAN gelir — madde künyesi yok.
        const metin = `This flight needs at least ${asgari} pilots — ${kaynak} requires it. `
              + `${ids.length} selected. More than the minimum is allowed `
              + `(augmented crew on long range), fewer is not.`;
        toast(metin, 'error', ihlalDetayi([{ metin, neYapmaliKayit:
          `Select at least ${asgari} pilots. The number comes from the aircraft record (minimum flight `
          + 'crew), not from the FTL regulation — if it is wrong, correct it on the aircraft.' }]));
        return;
      }
    }
    // ── LIMIT KAPISI (26 Agu 2026) ────────────────────────────────────────
    // Uygunluk SECIM ANINDA bir kez bakiliyordu; NOT LEGAL satir zaten
    // secilemedigi icin "secili pilot yasaldir" varsayiliyordu. Ama secimden
    // SONRA saatler/sektorler degistirilebilir — o an yasal olan pilot artik
    // yasal olmayabilir ve kayit sessizce gecerdi. Bu yuzden kontrol KAYIT
    // ANINDA tekrarlanir; `fitList` girdilerin son haliyle hesaplanmistir.
    // ③a (3 Eki 2026): uçuşta kapı TEK MOTOR önizlemesiyle karar verir — hazır değilse kayıt beklenir.
    if (dutyType === 'flight' && !assignOnizleme) {
      toast('FTL CHECK IN PROGRESS — the values are still being computed; try again in a moment.', 'error');
      return;
    }
    const engelli = fitList.filter(f => selected[f.pilot.id] && !f.legal);
    if (whatIf) engelli.forEach(f => nedenEkle(f.pilot.id, kunyeliYaDuz(f)));   // kartla AYNI metin (tek kaynak)
    // 29 Eyl 2026 (adım b): ayrı pencere (BlockedModal) yerine ORTAK kural ihlali
    // kartı — pilot pilot, her gerekçe ayrı satır, ⓘ'de maddenin kendi metni.
    // Kart da pencere gibi kapatılana kadar durur (Bildirim: hata KALICI).
    if (engelli.length && !whatIf) {
      const b = pilotIhlalBildirimi(engelli.map(f => ({ kim: f.pilot.code || f.pilot.full_name, kaynak: f })));
      toast(b.mesaj, 'error', b.detay);
      return;
    }

    // ── EKİP DÜZEYİ KURALLAR (5 Eyl 2026) ─────────────────────────────
    // 🔑 Serkan: *"İki OML pilot aynı uçuşa assign olursa uyarı verecek mi?"*
    // 🔑 *"MED talimatındaki korelatif kuralları assign modülde
    //    çalıştırabilmemiz lazım."*
    //
    // ⚠️ BU KURAL PİLOT ÇİFTİ ÜZERİNDEDİR, satır başına DEĞİL. `fitList`
    //    her pilotu tek tek ölçer; OML'yi oraya koysaydık iki OML'li pilot
    //    AYRI AYRI "legal" görünür, birlikte seçilince kimse itiraz etmezdi.
    //    Bu yüzden ölçü SEÇİLİ EKİBİN TAMAMI ve kapı BURADA.
    if (whatIf && ekipGerekceleri.gerekceler.length) {
      ids.forEach(pid => nedenEkle(pid, ekipGerekceleri.kunyeli.map(k => ({ metin: k.metin, ref: k.ref || null }))));
    }
    if (ekipGerekceleri.gerekceler.length && !whatIf) {
      // Ekip düzeyi kural: gerekçe KİMİN olduğunu metninde taşır ("OML (SCL) — …").
      toast('This crew cannot fly together — the reasons are listed below.', 'error',
            ihlalDetayi(ekipGerekceleri.kunyeli.map(k => ({ metin: k.metin, ref: k.ref,
                                                           neYapmali: NE_YAPMALI.ekip }))));
      setSaving(false); return;
    }
    setSaving(true);
    try {
      const rows = [];
      // GECMISE GIRILEN GOREV 'planned' OLAMAZ (3 Agu, Serkan): genel havacilikta
      // planlama safhasi atlanabiliyor, ucus once yapilip kayda sonra giriliyor.
      // Gecmis bir gorev "planlanmis" degil OLMUS BITMIS ucustur.
      //   gecmis  -> actual  (gorev kapali; girilen saatler gercek kabul edilir,
      //                       rest ve earliest_next_report onlardan hesaplanir)
      //   bugun/ileri -> planned
      // NOT: bu, girilen saatlerin GERCEK off/on block oldugu varsayimina dayanir
      // (Serkan, 21 Agu: "girilenler actual olur" — ayrica off/on block sorulmaz).
      // Ucus uygulamada arsivlenmisse dogrusu arsivden gelir; archive-flight'in
      // duzeltme yolu bu gorevi bulup uzerine yazar (sektordeki plan_id ile).
      //
      // 🔴 20/21 AGU SAHA BULGUSU (Serkan): "21 Agustos aksami, 21 Agustos
      //    sabahina gorev girdim, beni uyarmadi halbuki saat gecti."
      //    Kok neden BURADAYDI — olcu TARIH METNIYDI:
      //        const isPast = date < new Date().toISOString().slice(0, 10);
      //    Ayni GUN icinde bitmis bir gorev "gecmis" sayilmiyordu; kayit
      //    `planned` aciliyor, kumulatiflere planli saat olarak giriyor ve
      //    sistem hicbir sey soylemiyordu (Ilke 1 ihlali).
      //    Yeni olcu GOREVIN BITISI: `duty_end` (= son ETA + postFlightDutyMin)
      //    su andan geride mi? Kural motorda: FTLEngine.isPastDuty (testli).
      //    Satirlar kurulduktan SONRA uygulanir — cunku duty_end ancak orada
      //    hesaplaniyor. `off` satirlarinin duty_end'i yoktur, dokunulmaz
      //    (onlarin durumu offPeriodStatuses'tan gelir).
      // AYNI ATAMADAN DOGAN TUM PILOT SATIRLARI AYNI assignment_id'yi TASIR.
      // Bu olmadan "ucusu iptal et" tek islem degil N ayri islem olur; biri
      // duserse PF'in gorevi iptal, PM'inki ayakta kalir ve kimse fark etmez.
      // (Goc eski satirlari doldurdu; yeni satirlari YAZAN BURASI.)
      const assignmentId = newUuid();
      // CHECK RIDE: dis TRE/TRI profiles'ta yoktur — FTL kumulatifi TUTULMAZ
      // (bizim AOC pilotu degil); adi+bayragi atamaya yazilir, roster/rapor
      // gosterir. (4 Agu, Serkan)
      const base = {
        assignment_id: assignmentId,
        ...(dutyType === 'flight' && extraMode === 'checkride'
          ? { check_ride: true, external_examiner: examiner.trim().toUpperCase() } : {}),
        // Md.11(1)(4) — artırılmış ekipte dinlenme olanağı beyanı; ekibin HER satırına (motor satırın kendisinden okur).
        ...(dutyType === 'flight' && extraMode === 'crz' ? { inflight_rest_facility: dinlenme } : {}),
        customer_id: myProfile.customer_id, created_by: myProfile.id,
        ruleset_id: ruleset.id, ruleset_snapshot: { regulation: ruleset.regulation, company: ruleset.company },
        // Saatler UTC yazilir. `report_tz` artik "saatin dilimi" DEGIL, kalkis
        // meydaninin dilimidir — bandi/intibaki geriye donuk cozebilmek icin
        // saklanir (rapor da bunu kullaniyor). Ucusta asagida depTz ile ezilir.
        duty_date: date, report_tz: 'UTC',
        status: 'planned',   // gecmisse asagidaki post-pass 'actual'a cevirir
      };
      if (dutyType === 'flight') {
        if (!win || legs.some(l => !l.dep || !l.dest || !l.etd || !l.eta)) { toast('Complete all sector fields.', 'error'); setSaving(false); return; }
        // TESCİL ZORUNLU (21 Eki 2026, Serkan K2) — tip yetkisi ve asgari ekip ondan; eksik girdiyle hesap yapılmaz (WHAT IF'te de).
        const tescilsiz = legs.map((l, i) => (l.reg ? null : `${i + 1} ${l.dep || '?'}→${l.dest || '?'}`)).filter(Boolean);
        if (tescilsiz.length) {
          toast(`AIRCRAFT missing — sector ${tescilsiz.join(', ')}. Choose the registration: the type rating and the minimum crew come from it.`, 'error');
          setSaving(false); return;
        }
        // FAALIYET TIPI HER BACAKTA OLMALI (Md.9): hangi hukmun uygulanacagi
        // ondan cikiyor. Bos birakip varsayilan uydurmak, yanlis limitle ucus
        // planlamak demektir — kayit ENGELLENIR.
        if (legs.some(l => !l.operation_type)) {
          toast('Every sector needs an operation type (SHT-FTL/HG Md.9) — the limit comes from it.', 'error');
          setSaving(false); return;
        }
        // SAATLER UTC (6 Agu, Serkan ilkesi): girilen ETD/ETA zaten UTC oldugu
        // icin mutlaklastirma DUZDUR — meydan dilimine ihtiyac YOK ve "tz yok →
        // admin dilimi" yamasi da gereksizlesti. Meydan tz'si artik yalniz
        // REGULASYONUN istedigi yerde kullaniliyor: Tablo 1 bandi (intibak) ve
        // uzun menzil tespiti.
        // Butun meydanlar cekilir: dilim ARALIGI (Md.4(ee)) ve varis meydaninin
        // yerel gecesi (Md.16(3)(b)) icin gerekli.
        // 🔑 30 Eyl 2026 (B2-3): uzun menzil TEK ölçüden (`umAssign`); ölçülemezse
        //    kayıt durur — "değil" sayılmaz. Dilimler ekranın okuduğu haritadan.
        if (!tzAssign || !umAssign || umAssign.olculemedi) {
          toast(dilimOkunamadiMetni(umAssign?.eksik || []), 'error'); setSaving(false); return;
        }
        const depTz = tzAssign[legs[0].dep.toUpperCase()] || null;
        const uzunMenzil = umAssign.uzunMenzil === true;
        const reportISO = utcISO(date, win.report);
        const lastEta = legs[legs.length - 1].eta;
        const crossesMidnight = toMin(lastEta) < toMin(win.report);
        // Uçuştan sonra DH varsa görev sonu motorun penceresinden (rapor + görev süresi = DH inişi; 14 Eki 2026). Kayıtta
        // türetilmiş alan sunucuda yeniden yazılır; bu değer önizleme / onay çizelgesi ve OFF→REST içindir.
        const endISO = dhSuffix.length && win.dutyMin != null
          ? addMin(reportISO, win.dutyMin)
          : addMin(utcISO(crossesMidnight ? nextDay(date) : date, lastEta), win.postFlightMin);   // Md.10, tek kaynak
        // 🔴 27 AGU: BU METIN YAPILMAYANI SOYLUYORDU — "arrival rest
        // max(duty,14:00)" diyordu ama kayda `max(gorev, 12:00)` gidiyordu.
        // Artik hem kural uygulaniyor hem metin uygulanani yaziyor.
        // 30 Eyl (B2-3): fark eskiden yalniz ilk kalkis–son varis arasindaydi (git-gelde 0).
        if (uzunMenzil) toast(uzunMenzilUyarisi(umAssign.farkSaat), 'error');
        // NOBET KAPISI (Md.17): secili bir pilotun nobet ihlali varsa kayit
        // ENGELLENIR. Liste NOT LEGAL satirin secilmesini zaten onluyor ama
        // secimden SONRA saat/sektor degistirilirse ihlal sonradan dogabilir —
        // o durumda sessizce yasadisi gorev yazilmasin.
        const sbBlocked = ids
          .map(pid => fitList.find(f => f.pilot.id === pid))
          .filter(f => f?.sb && !f.sb.ok);
        if (whatIf) sbBlocked.forEach(f => nedenEkle(f.pilot.id, kunyeliYaDuz(f.sb)));
        if (sbBlocked.length && !whatIf) {
          const b = pilotIhlalBildirimi(sbBlocked.map(f => ({ kim: f.pilot.code, kaynak: f.sb })),
                                        { basMetin: 'STANDBY LIMIT' });
          toast(b.mesaj, 'error', b.detay);
          setSaving(false); return;
        }
        ids.forEach(pid => {
          const home = homeBases[pid];
          // Görevin bittiği meydan — uçuştan sonra DH varsa DH'nin varışı (14 Eki 2026).
          const atBase = !home || legsAll[legsAll.length - 1].dest.toUpperCase() === home.toUpperCase();
          // PILOT BAZLI PENCERE (nobet kisaltmasi uygulanmis olabilir); nobeti
          // olmayan pilotta ortak pencerenin AYNISIDIR.
          const fp = fitList.find(f => f.pilot.id === pid);
          const pWin = fp?.win || win;
          const sb = fp?.sb || null;
          // Kural motorda TEK YERDE durur (27 Agu): kopyalar ayrisiyordu.
          // Uzun menzilde Md.16(3) devreye girer:
          //   us disi varis -> (a) max(onceki gorev, 14:00)
          //   usse donus    -> (b) 48 saat + 2 yerel gece
          const restK = restForDuty({ dutyMin: pWin.dutyMin || 0, atBase,
            longRange: uzunMenzil, dutyEndISO: endISO, arrivalTz: umAssign.varisTz, rules });
          const minRest = restK.restMin;
          rows.push({
            ...base, pilot_id: pid, duty_type: 'flight',
            // GOREVIN YONETICI TIPI = bacaklarin EN KISITLAYICISI (motor hesaplar).
            // Karisik gorevde bunu kaydin ICINE yazmak sart: denetci "13:30
            // nereden geldi" diye sorunca cevap kayitta olsun (Md.9).
            operation_type: win.operationType,
            operation_type_source: win.mixedOperation
              ? `mixed duty — most restrictive applies (${win.operationTypes.join(' + ')})`
              : (legs[0]?.opSrc && legs[0].opSrc !== 'manual'
                  ? legs[0].opSrc
                  : 'manual selection (per sector)'),
            ...(egitimliAssign ? { training_kind: egitimTurleri[pid] || null } : {}),
            report_tz: depTz || base.report_tz,
            report_time: reportISO, duty_end: endISO,
            // GECMIS TARIHTE ELLE GIRILEN SAAT = GERCEK SAAT (Serkan, 3 Agu):
            // "elle giris varsa sistemde bir hata/kirilma veya son dakika
            //  degisiklik olmustur; elle girilen deger saat-dk takibinde GERCEK
            //  degerdir, gecmise donuk plan degil olmus bitmis istir."
            // Bu yuzden gecmiste off_block/on_block da yazilir.
            // AMA `plan_id` YAZILMAZ — ayrimi o tasiyor: plan_id'si olan sektor
            // ARSIVDEN olculmustur, olmayan ELLE yazilmistir. archive-flight
            // elle yazilmis sektorun uzerine hala yazabilir; "gerceklesen ucus
            // atanmis gorevin ustune HER ZAMAN yazar" kurali boylece korunur.
            // SEKTOR LISTESI: once konumlandirma (deadhead: true), sonra ucus.
            // Motor DH'yi sektor saymaz ve ucus saatine yazmaz; ama UGS onunla
            // baslar (Md.14/1/b) ve gorev suresine girer (Md.14/1/a).
            sectors: legsAll.map((l, i) => ({
              seq: i + 1, dep: l.dep.toUpperCase(), dest: l.dest.toUpperCase(),
              etd: l.etd, eta: l.eta,
              ...(l.deadhead
                  ? { deadhead: true, flight_no: l.flight_no || null }
                  // ROL BACAK BAŞINA (29 Eyl 2026): `legsAll` = DH öneki + uçuş
                  // bacakları; `bacakRolleri` yalnız uçuş bacaklarını tutar.
                  : { role: bacakRolleri[i - dhPrefix.length]?.[pid] || selected[pid],
                      ...(l.reg ? { reg: String(l.reg).toUpperCase() } : {}),   // tescil (K2, 21 Eki 2026) — uçulunca gerçeği ezer
                      // HER SEKTOR KENDI TIPINI TASIR: denetimde hangi bacagin
                      // hangi hukme tabi oldugu okunabilsin (Md.9).
                      ...(l.operation_type ? { operation_type: l.operation_type,
                                               operation_type_source: l.opSrc || null } : {}) }),
            })),
            // Beyan YALNIZ gercekten kullanilan meydanlar icin yazilir: kisi
            // once yanlis yazip beyan etmis, sonra duzeltmis olabilir — olu
            // beyan kayitta kalirsa denetimde "buraya da ucruldu" sanilir.
            ad_hoc_airports: (() => {
              const kullanilan = new Set(legsAll.flatMap(l =>
                [l.dep, l.dest]).filter(Boolean).map(x => String(x).toUpperCase()));
              const g = Object.fromEntries(
                Object.entries(adHoc).filter(([k]) => kullanilan.has(k)));
              return Object.keys(g).length ? g : null;
            })(),
            // Açık mesai (Md.15): bekleme eşiği geçtiyse SPLIT, dinlenme yeri BEYAN.
            split_duty: !!(pWin.split.isSplit && !pWin.split.birlesmez), break_minutes: pWin.breakMin,
            accommodation: pWin.split.isSplit && !pWin.split.birlesmez ? accommodation : null,
            max_fdp_minutes: pWin.maxFdpMin, fdp_minutes: pWin.fdpMin, fdp_exceeded: !!pWin.fdpExceeded,
            // NOBET IZI (Md.17): hem KISALTMA MIKTARI, hem KAYNAK GOREV, hem de
            // insan-okur OZET yazilir. Ozet donar (ruleset_snapshot mantigi) ki
            // nobet satiri sonradan duzeltilse/silinse bile "bu UGS neden kisaydi"
            // sorusunun cevabi kaydin ICINDE kalsin.
            standby_reduction_min: sb?.fdpReductionMin || null,
            standby_duty_id: fp?.sbDuty?.id || null,
            standby_ref: sb ? standbyRef(fp.sbDuty, sb) : null,
            // İNTİBAK (Md.22/1): Tablo 1 hangi meydanın saatiyle okundu.
            // Zincirin sonraki halkası bu değeri referans alır.
            acclimatised_to: fp?.accl?.icao || null,
            min_rest_minutes: minRest, earliest_next_report: minRest != null ? addMin(endISO, minRest) : null,
            mandatory_report_due: pWin.fdpExceeded ? skpkRaporSonTarihi(endISO, effectiveRules(ruleset).company.mandatoryReportHours) : null,
          });
        });
        // PAKET SIM (14 Eki 2026) — uçuşla AYNI atama numarası: motor bu bağla SIM'i uçuşun görev periyoduna sayar (Md.23(1)).
        // Önizlemenin satırlarının aynısı; uçuş satırının alanları (check ride, dinlenme olanağı) SIM'e taşınmaz.
        paketSimSatirlari.forEach(r => {
          const dMin = Math.round((new Date(r.duty_end) - new Date(r.report_time)) / 60000);
          const minRest = yerGoreviDinlenmesi('sim', dMin, null, rules);
          rows.push({
            assignment_id: assignmentId, customer_id: myProfile.customer_id, created_by: myProfile.id,
            ruleset_id: ruleset.id, ruleset_snapshot: base.ruleset_snapshot, report_tz: 'UTC', status: 'planned',
            pilot_id: r.pilot_id, duty_type: 'ground', ground_kind: 'sim', duty_date: r.duty_date,
            report_time: r.report_time, duty_end: r.duty_end, fdp_minutes: null,
            location: r.location, location_tz: r.location_tz, sim_device: r.sim_device, sim_checks: r.sim_checks,
            min_rest_minutes: minRest, earliest_next_report: minRest != null ? addMin(r.duty_end, minRest) : null,
          });
        });
      } else if (dutyType === 'dh') {
        // ── DH / KONUMLANDIRMA (Md.14) ─────────────────────────────────
        // Gorev = ILK KALKIS ... SON INIS. Aradaki bekleme de gorevdir
        // (Md.14/1/a: "harcanan TUM ZAMAN"). Sektor SAYILMAZ (Md.14/1/b) —
        // `duty_type: 'ground'` oldugu icin Tablo-1'e zaten girmez.
        // GUN DEVRI: geriye giden her saat ertesi gundur — `dhDamgala` (kapı da aynısını kullanır).
        const damgali = dhDamgala(dhLegs, date);
        if (!damgali) {
          toast(`Deadhead: DEP, DEST and both times are required on every sector — ${dhBacakEksikleri(dhLegs).join(' · ')}.`, 'error');
          setSaving(false); return;
        }
        const startISO = damgali[0].start;
        const endISO   = damgali[damgali.length - 1].end;
        const dMin = Math.round((new Date(endISO) - new Date(startISO)) / 60000);
        // Motorun formülü (Md.16 ④, 4 Eki 2026: yedek 720 kalktı). Türetilmiş alan — yazmadan önce süzülür, sunucu yazar.
        const minRest = yerGoreviDinlenmesi('dh', dMin, null, rules);
        ids.forEach(pid => {
          rows.push({
            ...base, pilot_id: pid, duty_type: 'dh', ground_kind: 'dh',
            report_time: startISO, duty_end: endISO,
            // FDP URETMEZ (Serkan: "flt duty gibi flt time limitlerini
            // belirlemez"). Ucus saati kumulatifine de girmez — `fltMin`
            // yalniz `duty_type === 'flight'` sayar.
            fdp_minutes: null,
            // Sektorler KAYIT icin tutulur: hangi ucusla konumlandirildigi
            // denetimde sorulur. `duty_type` ground oldugu icin bunlar
            // sektor sayilmaz, uçuş saatine de girmez.
            sectors: damgali.map((l, i) => ({
              seq: i + 1, dep: l.dep.toUpperCase(), dest: l.dest.toUpperCase(),
              etd: l.start.slice(11, 16), eta: l.end.slice(11, 16),
              flight_no: (l.flt || '').toUpperCase() || null,
              deadhead: true,
            })),
            min_rest_minutes: minRest,
            earliest_next_report: minRest != null ? addMin(endISO, minRest) : null,
          });
        });
      } else if (dutyType === 'ground') {
        // 🔑 LOCATION KAPISI (Serkan, 1 Eyl 2026): *"Location girilmeden office
        // disinda gnd gorevi GIRILEMEZ."* Eksik ADIYLA soylenir (Ilke 7).
        // office -> sorulmaz (ana us) · dh -> kendi bacaklarinda ZATEN zorunlu.
        {
          const eksik = locationEksigi(gnd.kind, {
            location: gndLoc.location, locationTz: gndLoc.location_tz, icao: gndLoc.location });
          if (eksik) {
            toast(`${eksik} is required for a ${gnd.kind.toUpperCase().replace(/_/g, ' ')} duty — `
                  + 'rest and local-night calculations read the timezone from it.', 'error');
            setSaving(false); return;
          }
        }
        const startISO = utcISO(date, gnd.start);
        // ── SIM SONRASI BILDIRIM SURESI (SHT-FTL/HG Md.10/c, 23 Agu 2026) ──
        //
        // 🔑 Serkan: *"o zaman oncesine degil, mevzuata uygun olarak sonuna
        //    ekleyecegiz 60 dk — bu DEBRIEFING icin konmus bir duty suresi."*
        //
        // Md.10(c): *"(b) bendine istisna teskil etmek uzere, gorev suresi
        // kapsamindaki ucus sonrasi bildirim suresi, SIMULATOR GOREVLERI ve
        // egitim faaliyetleri icin asgari 60 ... dakikadir."* Yani ucusun 30
        // dakikasinin yerine sim'de 60 dakika gecer.
        //
        // ⚠️ SIM ONCESI icin mevzuatta HUKUM YOK: Md.10(a)'daki 60 dk acikca
        // "bir UCUS GOREVI icin hazirlik" der, simulator ucus gorevi degildir.
        // Bu yuzden sim'de rapor saati GIRILEN saattir, oncesine ek YAPILMAZ.
        //
        // ⚠️ KAPSAM BILEREK DAR: Md.10(c) "simulator gorevleri VE EGITIM
        // FAALIYETLERI" der ama kural YALNIZ `sim`'e uygulanir.
        // 🔑 Serkan (23 Agu): *"yer derslerine eklemeye gerek yok."* Debriefing
        // simulator oturumuna ozgu; teorik ders gunu boyle bir sure uretmiyor.
        // Sonradan okuyan "eksik" sanip `theoretical`/`training`e EKLEMESIN.
        const endISO = yerGoreviBitisISO(gnd, date, rules, effectiveRules(ruleset).company);   // kapıyla aynı an
        const dMin = (new Date(endISO) - new Date(startISO)) / 60000;
        // Md.17(2)(a) — HAVAALANI HARICI NOBET AZAMI 16 SAAT. Bu nobetin KENDI
        // ihlalidir (gorev atansa da atanmasa da gecersiz) -> kayit ENGELLENIR.
        // Havaalani nobetinin kendi azami suresi YOKTUR; onun siniri gorevle
        // BIRLESIK tavandir (Md.17/1/ç) ve ucus atanirken kontrol edilir.
        // 5 Eki 2026 (Md.17 ③): sayı motorun etkisinden — kural setinde yoksa kayıt adıyla durur (eskiden `?? 960`).
        const gEffect = standbyEffect(
          { duty_type:'ground', ground_kind: gnd.kind, report_time: startISO, duty_end: endISO }, rules);
        if (gEffect?.unavailable) {
          toast(`THIS DUTY'S RULESET DOES NOT DEFINE STANDBY RULES (SHT-FTL/HG Md.17)${gEffect.eksikAlan?.length
            ? ` — ${gEffect.eksikAlan.join(', ')} missing` : ''} — the standby cannot be checked.`, 'error');
          setSaving(false); return;
        }
        if (gnd.kind === 'other_standby' && gEffect?.maxExceeded && whatIf) {
          ids.forEach(pid => nedenEkle(pid, [{ metin: `OTHER STANDBY ${fmtMin(dMin)} EXCEEDS THE ${fmtMin(gEffect.maxStandbyMin)} MAXIMUM`,
                                               ref: 'SHT-FTL/HG Md.17/2/a' }]));
        } else if (gnd.kind === 'other_standby' && gEffect?.maxExceeded) {
          toast(`OTHER STANDBY ${fmtMin(dMin)} EXCEEDS THE ${fmtMin(gEffect.maxStandbyMin)} MAXIMUM (SHT-FTL/HG Md.17/2/a) — shorten it.`, 'error');
          setSaving(false); return;
        }
        ids.forEach(pid => {
          // DINLENME TABANI: genel kural "dinlenme >= onceki gorev suresi, asgari
          // ana usde 12h". HAVAALANI HARICI NOBETTE bu YANLIS olur: surenin yalniz
          // %25'i gorev sayilir (Md.17/2/g) ve gorev verilmezse ozel hukum asgari
          // 8 saat der (Md.17/2/b) — ozel hukum genel kurali ezer. 16 saat bekleyen
          // pilota 16 saat dinlenme dayatmak regulasyonun demedigi bir kisittir.
          const minRest = yerGoreviDinlenmesi(gnd.kind, dMin, gEffect, rules);
          rows.push({
            ...base, pilot_id: pid, duty_type: 'ground', ground_kind: gnd.kind,
            location: gndLoc.location || null, location_tz: gndLoc.location_tz || null,
            report_time: startISO, duty_end: endISO, fdp_minutes: null,
            min_rest_minutes: minRest, earliest_next_report: minRest != null ? addMin(endISO, minRest) : null,
            // 🔑 SIM oturumu: cihaz ve kalkis/inis sayilari (FCL.060).
            //    Sayilar YALNIZ FFS'te anlamlidir; FNPT'de bos gecilir ki
            //    sayilmayan bir cihaz sayiliyormus gibi durmasin (Ilke 1).
            ...(gnd.kind === 'sim' ? {
              sim_device: gnd.device || null,
              // 2 Eki 2026: sayı sorulmaz (FFS oturumu programın asgarisi sayılır) — yerine OPC / LPC.
              sim_checks: simKontrolleriYaz(gnd.checks),
            } : {}),
          });
        });
      } else { // off
        if (!ids.length) { toast('Select pilot(s) for OFF.', 'error'); setSaving(false); return; }
        if (offYeriEksigi(offLoc)) {
          toast(offYeriHataMetni(offLoc.location), 'error');
          setSaving(false); return;
        }
        const offYeri = (pid) => offYeriKaydi(offLoc, pilotDilim[pid]);
        const end = off.endDate || date;
        const offDates = [];
        for (let d = date; d <= end; d = nextDay(d)) { offDates.push(d); if (d === end) break; }
        // ── OFF GİRİŞ KAPISI (1 Eki 2026, Serkan: "OFF rest olması gereken yere girilemez … kural ihlal
        //    edilemez") — iki yerel gecesi görevle çakışan güne OFF YAZILMAZ; ölçü Md.4/ü, motordan (tek kaynak).
        // Kapı TEK çağrı (kaynak nöbetçisi OffGirisKapisi.test): sonuç pilot kimliğiyle tutulur — gerçek ASSIGN'de metin
        // kodla birleşir, WHAT IF'te o pilotun denemesine gerekçe olur (12 Eki 2026).
        const engel = ids.flatMap(pid => offGirisEngeli(offDates, duties.filter(x => x.pilot_id === pid), rules,
          bosGunDilimi(offYeri(pid), hbTz[pid] || null), { offTypes, subtype: off.subtype })
          .map(e => ({ pid, metin: offGirisEngeliMetni(e) })));
        if (whatIf) {
          engel.forEach(x => nedenEkle(x.pid, [{ metin: x.metin, ref: 'SHT-FTL/HG Md.4/ü' }]));
        } else if (engel.length) {
          toast(engel.map(x => `${pilots.find(p => p.id === x.pid)?.code || ''} ${x.metin}`.trim()).join(' · '), 'error');
          setSaving(false); return;
        }
        // 8 Agu (Serkan): periyodun TAMAMI actual yazilmaz. Regulasyonun istedigi
        // ilk blok actual; kalan gunler GERCEKLESTIGI GUN actual olur (gunluk
        // cron cevirir). Verilmis izin (AVAC vb.) taahhut edildigi icin bastan
        // actual. Hangi tipin izin oldugu ruleset'ten gelir — koda gomulmez.
        const grantedLeave = !!(offTypes || []).find(t => t.code === off.subtype)?.granted_leave;
        const statuses = offPeriodStatuses(offDates, {
          grantedLeave, today: new Date().toISOString().slice(0, 10),
        });
        offDates.forEach(d => {
          ids.forEach(pid => rows.push({ ...base, pilot_id: pid, duty_type: 'off',
                                         off_subtype: off.subtype, duty_date: d, ...offYeri(pid),
                                         status: statuses[d] || 'planned' }));
        });
      }
      // WHAT IF: hiçbir tabloya YAZILMAZ — satırlar denemeye gider (gerçek kayıtla AYNI kurulum, sahte kimlikle).
      if (whatIf) {
        // Kimlik SAYAÇTAN — saatten değil: aynı milisaniyede iki deneme aynı kimliği alıyor, çizelge ikisini tek görev
        // sanıyordu (12 Eki 2026, testte yakalandı).
        const damga = ++whatIfSayaci;
        // Sonuç kayıttaki biçimle (ftl_durum / ftl_gerekce) yazılır: çizelgenin durum notu ve gerekçe kartı (`durumKartiGoster`)
        // gerçek görevdeki gibi okur — ayrı bir gösterim yazılmaz (tek kaynak). OFF'ta durum yoktur (ekranDurumu null).
        const satirlar = rows.map((r, i) => {
          const n = denemeNedenleri[r.pilot_id] || [];
          return { ...r, id: `whatif-${damga}-${i}`, whatif: true,
                   ftl_durum: n.length ? 'NOT_LEGAL' : 'LEGAL', ftl_gerekce: n.map(x => ({ ...x, durum: 'NOT_LEGAL' })) };
        });
        const sonuc = [...new Set(satirlar.map(r => r.pilot_id))].map(pid => ({
          pid, kod: pilots.find(x => x.id === pid)?.code || '?',
          nedenler: denemeNedenleri[pid] || [], legal: !(denemeNedenleri[pid] || []).length,
        }));
        if (gunSonucu) gunSonucu({ durum: sonuc.some(x => !x.legal) ? 'notlegal' : 'legal', satirlar, sonuc, dutyType, date });
        setSaving(false); return true;
      }
      // ── ASSIGN ONAYI (12 Eki 2026, Serkan: *"assign ettiğimizde de bu tablo görüntüsü açılsa, sonra ikinci bir
      //    onaylama ile görevi assign etsek? … tek tip ekran yönetimi olsun"*). Kapılardan geçen satırlar ÖNCE çizelgede
      //    (gerçek roster + yeni görev, PREVIEW) gösterilir; veritabanına yazma CONFIRM ASSIGN'de (`atamayiYaz`).
      setAtamaOnayi({ rows }); setSaving(false); return;
    } catch (e) { toast(e.message, 'error'); }
    setSaving(false);
  };
  // ── OTOMATİK SINAMA (WHAT IF şeridi, 15 Eki 2026, Serkan: *"her girişten sonra what if çalışır"*) ─────────────────────────
  // Formdaki her değişiklikten (ve öteki günlerin denemeleri değişince) kısa bir bekleyişle `save` OTOMATİK kipte koşar: sonuç
  // LEGAL / NOT LEGAL olarak, form eksikse eksiğin cümlesiyle, hiç girilmemişse "boş" olarak güne bildirilir. İmza öteki
  // günlerin denemelerini KİMLİKSİZ ve DURUMSUZ alır — bir günün yeniden sınanması ötekini boş yere tetiklemez (döngü yok).
  const saveRef = useRef(save);
  saveRef.current = save;
  const otoImza = whatIf && gunSonucu ? JSON.stringify([dutyType, date, legs, accommodation, selected, gnd, gndLoc, dhLegs,
    dhBeforeFlight, dhAfterFlight, dhSonraLegs, paketSim, bacakDegisim, off, offLoc, extraMode, dinlenme, crzSlot, examiner,
    opType, egitimTurleri, adHoc, !!assignOnizleme, !!tzAssign, !!assignTz,
    (duties || []).filter(d => d.whatif).map(({ id, ftl_durum, ftl_gerekce, ...r }) => r)]) : null;
  useEffect(() => {
    if (!otoImza) return undefined;
    const t = setTimeout(async () => {
      const mesajlar = [];
      const r = await saveRef.current({ otomatik: true, mesajlar });
      if (r === true) return;
      const bos = dutyType !== 'off' && !Object.keys(selected).length
        && (dutyType !== 'flight' || legs.every(l => !l.dep && !l.dest && !l.etd && !l.eta));
      gunSonucu(bos ? { durum: 'bos' } : { durum: 'eksik', metin: mesajlar });
    }, 350);
    return () => clearTimeout(t);
  }, [otoImza]);   // eslint-disable-line react-hooks/exhaustive-deps

  // CONFIRM ASSIGN — bugünkü yazma akışı AYNEN (geçmiş uçuş → RECORD AS FLOWN, geçmiş yer görevi → onay penceresi).
  const atamayiYaz = async (rows) => {
    setSaving(true);
    try {
      // GECMIS MI? Olcu satirlarin `duty_end`'i (= son ETA + 30 dk), tarih metni
      // DEGIL. Gecmisse satirlar actual'a cevrilir ve ONAY ISTENIR — sessizce
      // yazilmaz.
      const { past, rows: finalRows } = backdateRows(rows, new Date().toISOString());
      if (past && rows.some(r => r.duty_type === 'flight')) {
        const kayit = await commitRows(rows, null, { gecmisUcus: true });
        const ucus = kayit.filter(r => r.duty_type === 'flight');
        if (ucus.length) setGecmisUcus({ key: ucus[0].assignment_id || `solo-${ucus[0].id}`, head: ucus[0], rows: ucus });
        setSaving(false); return;
      }
      if (past) { setBackdated({ rows: finalRows }); setSaving(false); return; }
      await commitRows(finalRows, null);
    } catch (e) { toast(e.message, 'error'); }
    setSaving(false);
  };

  // TEK YAZMA YOLU (Ilke 2): normal atama da, onaylanmis geriye donuk giris de
  // buradan gecer. Ayri iki yol olsaydi biri duzelirken oteki geride kalirdi.
  const commitRows = async (rows, backdatedReason, { gecmisUcus = false } = {}) => {
    // ③b TEK MOTOR TEK YOL (3 Eki 2026): veritabanına yalnız GİRDİ gider — türetilmiş alanlar görev tipine göre süzülür,
    // onları kayıttan sonra sunucu yazar (tetikleyici; panel "FTL RECALCULATING" ile bekler). Bellekteki `rows` aynı kalır
    // (aşağıdaki OFF→REST çevirici onları kullanır).
    const { data: created, error } = await supabase.from('crew_duties')
      .insert(rows.map(r => turetilmisleriAyikla(r, r.duty_type))).select('id,customer_id,pilot_id,assignment_id,duty_end');
    if (error) throw error;

    if (backdatedReason) {
      // IZ SONRA — bilerek ve yalniz BURADA. Diger yollarda "iz once" gecerlidir
      // cunku VAR OLAN satir degistirilir; burada satir INSERT ile DOGAR ve
      // ftl_duty_edits.duty_id ancak o zaman bilinir. Iz yazilamazsa kullanici
      // GORUR (10 Agu'daki `catch {}` ile yutulan hatanin tersi).
      // Görev YAZILDI, izi yazılamadı: başlık PARTLY SAVED (eski sabit başlık
      // "nothing was written" burada yalan söylüyordu). 29 Eyl 2026.
      const izDetayi = (hata) => ({
        baslik: 'PARTLY SAVED — the duty was saved, its audit row was not',
        aciklama: {
          neden: 'The duty was recorded, but the audit row saying who entered this past duty as ACTUAL, '
               + 'and why, could not be written'
               + (hata?.message ? `: ${dbHata(hata.message).metin}` : ' — the save returned no row to attach it to.'),
          neYapmali: 'Do NOT enter the duty again — it would be counted twice. Tell the EFB admin: the audit '
                   + 'trail of this duty is incomplete and has to be completed.',
          teknik: hata?.message || 'The insert returned no row (0 rows) and no error.',
        },
      });
      if (!created || !created.length) {
        toast('Duty saved but the audit row could not be written.', 'error', izDetayi(null));
      } else {
        const stamp = new Date().toISOString();
        const { error: eErr } = await supabase.from('ftl_duty_edits').insert(created.map(r => ({
          duty_id: r.id, customer_id: r.customer_id, pilot_id: r.pilot_id,
          assignment_id: r.assignment_id || null, edit_type: 'EDIT',
          field_name: 'backdated_entry', old_value: null,
          new_value: `recorded as ACTUAL - duty ended ${r.duty_end} - entered ${stamp}`,
          reason: backdatedReason, edited_by: myProfile?.id ?? null,
        })));
        if (eErr) toast('Duty saved but the audit row FAILED.', 'error', izDetayi(eErr));
      }
    }
    toast(gecmisUcus
      ? 'Flight saved as PLANNED — it is in the past: enter the four actual times to record it as flown.'
      : backdatedReason
        ? `${rows.length} duty row(s) recorded as ACTUAL (backdated entry, logged).`
        : `${rows.length} duty row(s) created.`, 'success');
    const kaydedilen = rows.map((r, i) => ({ ...r, id: created?.[i]?.id ?? r.id }));
    await offRestUygula({ duties, ruleset, offTypes, pilotDilim, myProfile, toast, gorevler: kaydedilen });
    setSelected({}); setExtraMode(null); setExaminer(''); setEgitimTurleri({}); setAccommodation(null);
    // Yeniden yükleme paneli LOADING'e çevirip bu ekranı KALDIRIR — geçmiş uçuşta RECORD AS FLOWN penceresi açılacak,
    // o yüzden yükleme pencere kapanınca yapılır (kaydedilince de vazgeçilince de).
    if (!gecmisUcus && onAtandi) onAtandi(kaydedilen);
    if (!gecmisUcus) reload();
    return kaydedilen;
  };

  // Görev tipi düğmeleri — sekmelerle AYNI kutu (tasarım B; 2 Eki 2026, Serkan: "duty type butonları unutulmuş").
  const seg = (t, label) => (
    <button key={t} type="button" data-testid={`gorev-tipi-${t}`} className={KUTU_SINIFI}
            style={sekmeStili(dutyType === t)} onClick={() => setDutyType(t)}>{label}</button>
  );

  return (
    <div>
      <div style={{ display:'flex', gap:16, flexWrap:'wrap', marginBottom:18, alignItems:'flex-end' }}>
        <div><span style={S.label}>Duty Type</span>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>{seg('flight', 'FLT')}{seg('ground', 'GND')}{seg('dh', 'DH')}{seg('off', 'OFF')}</div>
        </div>
        {dutyType === 'flight' && (<>
          {/* 22 Agu: tip artik SEKTOR SATIRINDA secilir. Burasi gorevin YONETICI tipini gosterir — karisik gorevde EN
              KISITLAYICI olan. 25 Eki 2026: EDIT ile ortak parca (`OperasyonBasligi`). */}
          <OperasyonBasligi tip={win?.operationType || opType} notlar={planNotlari} notTestid="assign-plan-notu" />
          {egitimliAssign && (<>
            <div style={{ fontSize:10, color:C.t2, fontFamily:'var(--mono)', maxWidth:260, lineHeight:1.5, paddingBottom:8 }}>
              TRAINING KIND — choose it for EACH PILOT in the crew table below (Md.27(1)): the instructor / examiner and
              the trainee have different daily flight time limits. Ground training on the same UTC day halves the
              limit and counts toward the 8:00 day total automatically (Md.27(1)(ç)).
            </div>
          </>)}
        </>)}
        <div style={{ width:170 }}><span style={S.label}>{dutyType === 'off' ? 'Start Date' : 'Date'}</span>
          {/* WHAT IF şeridinde gün şeritten seçilir (15 Eki 2026) — form kendi gününe kilitlidir. */}
          <input type="date" style={S.input} value={date} disabled={!!sabitTarih} data-testid="assign-tarih"
                 onChange={e => setDate(e.target.value)} />
        </div>
        {dutyType === 'off' && (<>
          <div style={{ width:170 }}><span style={S.label}>End Date (incl.)</span>
            <input type="date" style={S.input} value={off.endDate} onChange={e => setOff(o => ({ ...o, endDate: e.target.value }))} />
          </div>
          <div style={{ width:200 }}><span style={S.label}>Type</span>
            <select style={S.input} value={off.subtype} onChange={e => setOff(o => ({ ...o, subtype: e.target.value }))}>
              {offTypes.map(t => <option key={t.id} value={t.code}>{t.code} — {t.label}</option>)}
            </select>
          </div>
          <div style={{ width:300 }}>
            <OffYeriSecici value={offLoc} onChange={setOffLoc} testId="off-yeri"
                           evler={Object.keys(selected).map(pid => pilotDilim[pid]?.kaynak === 'own' ? pilotDilim[pid].icao : null)} />
          </div>
          {gecTebligNotu.length > 0 && (
            <div style={{ ...S.note, marginTop:8, borderLeftColor:C.accent, width:'100%' }} data-testid="off-gec-teblig-uyari">
              {gecTebligNotu.map(m => <div key={m} style={{ color:C.accent, fontSize:11 }}>{m}</div>)}
            </div>
          )}
        </>)}
        {dutyType === 'ground' && (<>
          <div style={{ width:200 }}><span style={S.label}>Kind</span>
            <select style={S.input} value={gnd.kind} onChange={e => setGnd(g => ({ ...g, kind: e.target.value }))}>
              <option value="office">OFFICE</option><option value="training">TRAINING</option>
              <option value="sim">SIM</option><option value="theoretical">THEORETICAL TRAINING (Md.27/c)</option>
                <option value="airport_standby">AIRPORT STANDBY (Md.17/1)</option>
                <option value="other_standby">OTHER STANDBY (Md.17/2)</option>
                {/* DH BURADAN CIKTI (3 Eyl 2026): artik kendi gorev tipi
                    (FLT · GND · DH · OFF). GND'nin bir "cesidi" gibi durmasi
                    orguyu bozuyordu — DH'nin sektoru ve saatleri var, Md.14
                    ona ayri hukum veriyor. */}
            </select>
          </div>
          {locationKurali(gnd.kind) !== 'none' && (
            <div style={{ width:280 }}><span style={S.label}>Location</span>
              <LocationPicker kural={locationKurali(gnd.kind)} value={gndLoc} zorunlu
                              locations={dutyLocations} onChange={setGndLoc} onAdd={addLocation} />
            </div>
          )}
          {gnd.kind !== 'dh' && (<>
            <div style={{ width:110 }}><span style={S.label}>Start (UTC)</span><input {...zAlan(S.input, true, timeOk(gnd.start))} data-testid="gnd-start" value={gnd.start} onChange={e => setGnd(g => ({ ...g, start: normTime(e.target.value) }))} /></div>
            <div style={{ width:110 }}>
              <span style={S.label}>{gnd.kind === 'sim' ? 'Sim ends (UTC)' : 'End (UTC)'}</span>
              <input {...zAlan(S.input, true, timeOk(gnd.end))} data-testid="gnd-end" value={gnd.end} onChange={e => setGnd(g => ({ ...g, end: normTime(e.target.value) }))} />
            </div>
            {/* Md.10(c): sim sonrasi bildirim suresi asgari 60 dk (debriefing).
                Girilen saat SIM'in bitisi; gorev 60 dk sonra biter. Ekranda
                yazmasi sart — yoksa gorev suresinin neden 60 dk uzun ciktigi
                gorunmez (Ilke 1). */}
            {/* ── SIM CIHAZI VE KALKIS/INIS SAYILARI (4 Eyl 2026, Serkan) ──
                🔑 *"GND-SIM secince sim icin bize bir hucre daha acsin —
                   FFS LEVEL D veya FNPT ayri ayri secilebilsin."*
                🔑 *"Ahmet kaptan gecenlerde SIM'e gitti — gece gunduz yetkisi
                   ordan cekilebiliyor mu?"*  Talimat EVET diyor ama YALNIZ
                   TAM UCUS SIMULATORU (FFS) icin; FNPT sayilmaz.
                ⚠️ Simulatorde GECE HESAPLANMAZ, GIRILIR: gercek ucusta gece
                   meydan koordinatindan cikar, burada oturumda ne uculduysa o. */}
            {gnd.kind === 'sim' && (
              <div style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end' }}>
                <div>
                  <span style={S.label}>Device</span>
                  <select style={{ ...S.input, width:150 }} value={gnd.device || ''}
                          onChange={e => setGnd(g => ({ ...g, device: e.target.value }))}>
                    <option value="">— SELECT —</option>
                    <option value="FFS_D">FFS LEVEL D</option>
                    <option value="FNPT">FNPT</option>
                  </select>
                </div>
                <SimKontrolKutulari secili={gnd.checks || []} testid="sim-kontrol"
                                    degistir={checks => setGnd(g => ({ ...g, checks }))} />
                <div style={{ ...S.note, borderLeftColor:C.accent, maxWidth:420 }}>{SIM_NOTU}</div>
                {gnd.device === 'FNPT' && (
                  <div style={{ ...S.note, borderLeftColor:C.amber, maxWidth:300 }}>
                    FNPT is not a full flight simulator — FCL.060 recency cannot be drawn from it.
                  </div>
                )}
              </div>
            )}
            {gnd.kind === 'sim' && (
              <div style={{ ...S.note, borderLeftColor:C.accent, alignSelf:'flex-end', maxWidth:340 }}>
                DUTY ENDS 60 MIN AFTER THE SIM — post-duty notification for simulator
                duties (SHT-FTL/HG Md.10/c). No extra time is added BEFORE the sim:
                Md.10(a)'s 60 min applies to a FLIGHT duty only.
              </div>
            )}
          </>)}
        </>)}
      </div>

      {/* ── DH SEKTORLERI (SHT-FTL/HG Md.14) ─────────────────────────────
          Gorev suresi ILK KALKIS ... SON INIS arasidir; aradaki bekleme de
          gorevdir (Md.14/1/a "harcanan tum zaman"). Ucus numarasi kayda girer:
          konumlandirmanin HANGI ucusla yapildigi denetimde sorulur. */}
      {/* UCUS MODUNDA DH ONEKI: bacaklar gorunur kalir, kaldirilabilir.
          Gorunmeseydi pilot UGS'nin neden 60 dk once degil de konumlandirma
          kalkisinda basladigini ekrandan okuyamazdi (Ilke 1). */}
      {/* PAKET SIM — görevin başı (14 Eki 2026). */}
      {dutyType === 'flight' && paketSim.once && (
        <PaketSimSatiri yer="once" sim={paketSim.once} degistir={paketSimDegistir('once')}
                        ekip={pilots.filter(p => selected[p.id])} locations={dutyLocations} onAddLocation={addLocation}
                        onSil={() => setPaketSim(p => ({ ...p, once: null }))} />
      )}
      {dutyType === 'flight' && dhBeforeFlight && (
        <div style={{ marginBottom:14 }}>
          <span style={S.label}>Positioning before this flight (SHT-FTL/HG Md.14)</span>
          <EkleSecici testid="dh-once-bacak-ekle-bas" secenekler={[
            { tur:'dh', etiket:'DH', onSec: () => setDhLegs(ls => arayaKoy(ls, -1, { dep:'', dest: ls[0]?.dep || '', start:'', end:'', flt:'' })) },
            ...(!paketSim.once ? [{ tur:'sim', etiket:'SIM', onSec: () => setPaketSim(p => ({ ...p, once: bosPaketSim() })) }] : []),
          ]} />
          {dhLegs.flatMap((l, i) => [
            <div key={i} style={{ display:'grid', gridTemplateColumns:'26px 1fr 1fr 1fr 1fr 1.2fr 38px',
                                  gap:8, marginBottom:6, alignItems:'center' }}>
              <div style={{ fontSize:9, color:C.accent, textAlign:'center', fontFamily:'var(--mono)', fontWeight:700 }}>DH</div>
              <MeydanGirisi {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), !!l.dep)} data-testid={`dh-once-leg-${i}-dep`} placeholder="DEP" value={l.dep}
                     onChange={v => setDhLeg(i, 'dep', v)}
                     beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
              <MeydanGirisi {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), !!l.dest)} data-testid={`dh-once-leg-${i}-dest`} placeholder="DEST" value={l.dest}
                     onChange={v => setDhLeg(i, 'dest', v)}
                     beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
              <input {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), dhSaatGecerli(l.start))} data-testid={`dh-once-leg-${i}-start`} placeholder="DEP UTC" value={l.start}
                     onChange={e => setDhLeg(i, 'start', normTime(e.target.value))} />
              <input {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), dhSaatGecerli(l.end))} data-testid={`dh-once-leg-${i}-end`} placeholder="ARR UTC" value={l.end}
                     onChange={e => setDhLeg(i, 'end', normTime(e.target.value))} />
              <HarfliGiris style={S.input} placeholder="FLIGHT NO" maxLength={10} value={l.flt}
                     onChange={v => setDhLeg(i, 'flt', v)} />
              <button style={{ ...S.btnS, padding:'8px 10px' }}
                      onClick={() => setDhLegs(ls => {
                        const kalan = ls.filter((_, j) => j !== i);
                        if (!kalan.length) { setDhBeforeFlight(false); return [{ dep:'', dest:'', start:'', end:'', flt:'' }]; }
                        return kalan;
                      })}>✕</button>
            </div>,
            <EkleSecici key={`ekle-${i}`} testid={`dh-once-bacak-ekle-${i}`} secenekler={[
              { tur:'dh', etiket:'DH', onSec: () => setDhLegs(ls => arayaKoy(ls, i, { dep: ls[i]?.dest || '', dest: ls[i + 1]?.dep || legs[0]?.dep || '', start:'', end:'', flt:'' })) },
              // Son DH'nin arkası uçuş bacaklarının önü — uçuş bacağı en üste girer.
              ...(i === dhLegs.length - 1 ? [{ tur:'sector', etiket:'SECTOR', onSec: () => setLegs(ls => arayaKoy(ls, -1, { dep: dhLegs[i]?.dest || '', dest:'', etd:'', eta:'', reg: ls[0]?.reg || '' })) }] : []),
            ]} />,
          ])}
          <div style={{ ...S.note, marginTop:8 }}>
            Md.14(1)(b): positioning BEFORE a flight operation counts as FDP — the duty window
            starts at the first positioning departure, with no pre-flight report period
            (Md.4/n: local transport is not positioning). It is NOT a sector, so the Table-1
            sector column is unchanged, and it is not flight time.
          </div>
        </div>
      )}

      {dutyType === 'dh' && (
        <div style={{ marginTop:4, marginBottom:14 }}>
          <span style={S.label}>Deadhead sectors — all times UTC</span>
          {dhLegs.flatMap((l, i) => [
            <div key={i} style={{ display:'grid', gridTemplateColumns:'26px 1fr 1fr 1fr 1fr 1.2fr 38px',
                                  gap:8, marginBottom:6, alignItems:'center' }}>
              <div style={{ fontSize:11, color:C.t3, textAlign:'center', fontFamily:'var(--mono)' }}>{i + 1}</div>
              <MeydanGirisi {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), !!l.dep)} data-testid={`dh-leg-${i}-dep`} placeholder="DEP" value={l.dep}
                     onChange={v => setDhLeg(i, 'dep', v)}
                     beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
              <MeydanGirisi {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), !!l.dest)} data-testid={`dh-leg-${i}-dest`} placeholder="DEST" value={l.dest}
                     onChange={v => setDhLeg(i, 'dest', v)}
                     beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
              <input {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), dhSaatGecerli(l.start))} data-testid={`dh-leg-${i}-start`} placeholder="DEP UTC" value={l.start}
                     onChange={e => setDhLeg(i, 'start', normTime(e.target.value))} />
              <input {...zAlan(S.input, dhSatirZorunlu(dhLegs, i), dhSaatGecerli(l.end))} data-testid={`dh-leg-${i}-end`} placeholder="ARR UTC" value={l.end}
                     onChange={e => setDhLeg(i, 'end', normTime(e.target.value))} />
              <HarfliGiris style={S.input} placeholder="FLIGHT NO" maxLength={10} value={l.flt}
                     onChange={v => setDhLeg(i, 'flt', v)} />
              <button style={{ ...S.btnS, padding:'8px 10px', opacity: dhLegs.length > 1 ? 1 : .35 }}
                      disabled={dhLegs.length <= 1}
                      onClick={() => setDhLegs(ls => ls.filter((_, j) => j !== i))}>✕</button>
            </div>,
            <EkleSecici key={`ekle-${i}`} testid={`dh-bacak-ekle-${i}`} secenekler={[
              { tur:'dh', etiket:'DH', onSec: () => setDhLegs(ls => arayaKoy(ls, i, { dep: ls[i]?.dest || '', dest: ls[i + 1]?.dep || '', start:'', end:'', flt:'' })) },
              // Md.14(1)(b): uçuş operasyonu ÖNCESİNDEKİ konumlandırma UGS'ye girer. Son DH'nin arkasına uçuş bacağı → görev UÇUŞ
              // görevine döner; DH bacakları sektör listesinin başında `deadhead` olarak kalır (eski "+ ADD FLT DUTY").
              ...(i === dhLegs.length - 1 ? [{ tur:'sector', etiket:'SECTOR', onSec: () => {
                setDhBeforeFlight(true); setDutyType('flight');
                setLegs(ls => (ls.length === 1 && !ls[0].dep && !ls[0].dest ? [{ ...ls[0], dep: dhLegs[i]?.dest || '' }] : ls));
              } }] : []),
            ]} />,
          ])}
          <div style={{ ...S.note, marginTop:8 }}>
            SHT-FTL/HG Md.14(1)(a): ALL time spent positioning is recorded as DUTY —
            the wait between connecting sectors counts too. Md.14(1)(b): positioning is
            NOT a sector, so it does not change the Table-1 sector column. It does not
            count as flight time; it does set the rest that follows.
          </div>
        </div>
      )}

      {/* ── KARISIK FAALIYET TIPI UYARISI (Serkan, 22 Agu) ───────────────
          *"mutlaka uyari olarak verilmeli: mix bir gorev olarak planlandi,
           kapsam dar olana gore belirlenecek desin PLANLAMA YAPILIRKEN."*
          Arsivde degil, ATAMA sirasinda — cunku limit o an belirleniyor. */}
      {dutyType === 'flight' && win?.mixedOperation && (
        <KarisikGorevNotu tipler={win.operationTypes} yoneten={win.operationType} maxFdpMin={win.maxFdpMin} />
      )}

      {/* ── NOBETIN SONUCU ONCEDEN GORUNSUN (Md.17) ──────────────────────
            Nobet kaydi tek basina zararsiz gorunur ama AYNI GUN atanacak ucusun
            azami UGS'sini kisaltir. Dispatcher bunu ucusa gelince degil, nobeti
            YAZARKEN gormeli — yoksa "neden bu pilot NOT LEGAL" sorusu sonra
            cikar ve kaynagi gorunmez olur. ── */}
      {dutyType === 'ground' && gndEffect && (
        <div style={{ ...S.note, borderLeftColor: gndEffect.maxExceeded ? C.red : C.accent,
                      color: gndEffect.maxExceeded ? C.red : C.t2, marginBottom:14 }}>
          {gndEffect.kind === 'airport_standby' ? (<>
            AIRPORT STANDBY {fmtMin(gndEffect.standbyMin)} ({gndEffect.reference}) — COUNTS AS DUTY IN FULL.
            {' '}A FLIGHT DUTY ASSIGNED THE SAME DAY HAS ITS MAX FDP REDUCED BY {fmtMin(gndEffect.fdpReductionMin)}
            {' '}(TIME BEYOND {fmtMin(gndEffect.reductionThresholdMin)}); STANDBY + FDP COMBINED MAY NOT EXCEED {fmtMin(gndEffect.combinedCapMin)}.
          </>) : (<>
            OTHER STANDBY {fmtMin(gndEffect.standbyMin)} ({gndEffect.reference}) — {fmtMin(gndEffect.dutyCreditMin)} COUNTS AS DUTY (25%).
            {' '}MAX FDP REDUCTION IF A FLIGHT FOLLOWS: {fmtMin(gndEffect.fdpReductionMin)} (TIME BEYOND {fmtMin(gndEffect.reductionThresholdMin)}).
            {' '}IF NO DUTY IS ASSIGNED, {fmtMin(gndEffect.restIfNoDutyMin)} REST FOLLOWS.
            {gndEffect.maxExceeded && <> {' '}⚠ EXCEEDS THE {fmtMin(gndEffect.maxStandbyMin)} MAXIMUM — CANNOT BE SAVED.</>}
          </>)}
        </div>
      )}

      {dutyType === 'flight' && (<>
        <span style={S.label}>Sectors</span>
        {/* 🔑 Remark KAYITTAN ONCE gorunur: planlayici "bu gorev tanimsiz meydan
            tasiyor" bilgisini kaydetmeden once alsin. Atama ekraninda beyan
            heniz yerel durumda (`adHoc`), o yuzden sahte bir gorev nesnesiyle
            AYNI bilesen cagrilir — ikinci bir rozet yazilmaz (Ilke 3). */}
        <AdHocRemark duty={{ ad_hoc_airports: Object.keys(adHoc).length ? adHoc : null }}
                     style={{ marginLeft:0, marginBottom:8, display:'inline-block' }} />
        {/* Görevin BAŞI (14 Eki 2026): uçuş bacağı en üste ya da uçuştan önce DH. DH öncesi varsa baş onun bloğundadır. */}
        {!dhBeforeFlight && (
          <EkleSecici testid="bacak-ekle-bas" secenekler={[
            { tur:'sector', etiket:'SECTOR', onSec: () => setLegs(ls => arayaKoy(ls, -1, { dep:'', dest: ls[0]?.dep || '', etd:'', eta:'', reg: ls[0]?.reg || '' })) },
            { tur:'dh', etiket:'DH', onSec: () => { setDhBeforeFlight(true);
                                                    setDhLegs([{ dep:'', dest: legs[0]?.dep || '', start:'', end:'', flt:'' }]); } },
            // SIM yalnız görevin başına / sonuna — iki uçuşun arasına konmaz (Serkan, 14 Eki 2026).
            ...(!paketSim.once ? [{ tur:'sim', etiket:'SIM', onSec: () => setPaketSim(p => ({ ...p, once: bosPaketSim() })) }] : []),
          ]} />
        )}
        {legs.flatMap((l, i) => [
          <div key={i} style={{ display:'grid', gridTemplateColumns:'30px 1fr 1fr 1fr 1fr 1.6fr 1.4fr 40px', gap:10, marginBottom:8, alignItems:'center' }}>
            <div style={{ fontSize:11, color:C.t3, textAlign:'center', fontFamily:'var(--mono)' }}>{i + 1}</div>
            {/* Kapı: "Complete all sector fields" (DEP, DEST, ETD, ETA) — zorunlu alan rengi aynı koşul. */}
            <MeydanGirisi {...zAlan(S.input, true, !!l.dep)} data-testid={`assign-leg-${i}-dep`} placeholder="DEP" value={l.dep}
              onChange={v => setLeg(i, 'dep', v)}
              beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
            <MeydanGirisi {...zAlan(S.input, true, !!l.dest)} data-testid={`assign-leg-${i}-dest`} placeholder="DEST" value={l.dest}
              onChange={v => setLeg(i, 'dest', v)}
              beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
            <input {...zAlan(S.input, true, saatGecerli(l.etd))} data-testid={`assign-leg-${i}-etd`} placeholder="ETD UTC (06:30)" value={l.etd} onChange={e => setLeg(i, 'etd', normTime(e.target.value))} />
            <input {...zAlan(S.input, true, saatGecerli(l.eta))} data-testid={`assign-leg-${i}-eta`} placeholder="ETA UTC (07:45)" value={l.eta} onChange={e => setLeg(i, 'eta', normTime(e.target.value))} />
            {/* BACAK BASINA FAALIYET TIPI (Md.9). Bos birakilamaz diye
                zorlanmaz — plandan gelmezse ve secilmezse gorev tipi
                belirlenemez ve kayit engellenir (asagida). */}
            <OperasyonSecici {...zAlan({ ...S.input, fontSize:11 }, true, !!l.operation_type)} data-testid={`assign-leg-${i}-op`}
                    value={l.operation_type || ''}
                    onChange={e => setLegs(ls => ls.map((x, j) => j === i
                      ? { ...x, operation_type: e.target.value, opSrc: 'manual' } : x))} />
            {/* TESCİL (21 Eki 2026, Serkan K2): zorunlu, sektör başına, AIRCRAFTS'tan seçilir (elle yazılmaz). Seçilince boş
                sonraki sektörler de aynı tescille dolar — normal günde tek seçim; uçak değişirse o sektörde değiştirilir. */}
            <select {...zAlan({ ...S.input, fontSize:11 }, true, !!l.reg)} data-testid={`assign-leg-${i}-reg`}
                    value={l.reg || ''}
                    onChange={e => { const v = e.target.value;
                      setLegs(ls => ls.map((x, j) => j === i ? { ...x, reg: v } : (j > i && !x.reg ? { ...x, reg: v } : x))); }}>
              <option value="">— AIRCRAFT —</option>
              {aktifUcaklar.map(a => <option key={a.registration} value={a.registration}>{a.registration} ({a.ac_type})</option>)}
            </select>
            <button style={{ ...S.btnSil, padding:'8px 10px' }} onClick={() => setLegs(ls => ls.length > 1 ? ls.filter((_, j) => j !== i) : ls)}>✕</button>
          </div>,
          <RaaqUyarisi key={`raaq-${i}`} icaolar={[l.dep, l.dest]} raaq={raaq} testid={`raaq-uyari-${i}`} />,
          <EkleSecici key={`ekle-${i}`} testid={`bacak-ekle-${i}`} secenekler={[
            { tur:'sector', etiket:'SECTOR', onSec: () => setLegs(ls => arayaKoy(ls, i, { dep: ls[i]?.dest || '', dest: ls[i + 1]?.dep || '', etd:'', eta:'', reg: ls[i]?.reg || '' })) },
            // DH yalnız son uçuş bacağının arkasına — iki uçuşun arasına konmaz (paket görev, 14 Eki 2026).
            ...(i === legs.length - 1 ? [{ tur:'dh', etiket:'DH', onSec: () => {
              if (dhAfterFlight) {
                setDhSonraLegs(ds => arayaKoy(ds, -1, { dep: legs[i]?.dest || '', dest: ds[0]?.dep || '', start:'', end:'', flt:'' }));
              } else {
                setDhAfterFlight(true);
                setDhSonraLegs([{ dep: legs[i]?.dest || '', dest:'', start:'', end:'', flt:'' }]);
              }
            } }] : []),
            ...(i === legs.length - 1 && !dhAfterFlight && !paketSim.sonra
              ? [{ tur:'sim', etiket:'SIM', onSec: () => setPaketSim(p => ({ ...p, sonra: bosPaketSim() })) }] : []),
          ]} />,
        ])}

        {/* PAKET GÖREV — UÇUŞTAN SONRA (14 Eki 2026, Serkan). DH aynı görevin sonuna girer. */}
        {dhAfterFlight ? (
          <div style={{ margin:'6px 0 14px' }} data-testid="dh-sonra-blok">
            <span style={S.label}>Positioning after this flight (SHT-FTL/HG Md.14)</span>
            {dhSonraLegs.flatMap((l, i) => [
              <div key={i} style={{ display:'grid', gridTemplateColumns:'26px 1fr 1fr 1fr 1fr 1.2fr 38px',
                                    gap:8, marginBottom:6, alignItems:'center' }}>
                <div style={{ fontSize:9, color:C.accent, textAlign:'center', fontFamily:'var(--mono)', fontWeight:700 }}>DH</div>
                <MeydanGirisi {...zAlan(S.input, dhSatirZorunlu(dhSonraLegs, i), !!l.dep)} data-testid={`dh-sonra-leg-${i}-dep`} placeholder="DEP" value={l.dep}
                       onChange={v => setDhSonraLeg(i, 'dep', v)}
                       beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
                <MeydanGirisi {...zAlan(S.input, dhSatirZorunlu(dhSonraLegs, i), !!l.dest)} data-testid={`dh-sonra-leg-${i}-dest`} placeholder="DEST" value={l.dest}
                       onChange={v => setDhSonraLeg(i, 'dest', v)}
                       beyan={adHoc} onBeyan={beyanEkle} declaredBy={myProfile?.id} />
                <input {...zAlan(S.input, dhSatirZorunlu(dhSonraLegs, i), dhSaatGecerli(l.start))} data-testid={`dh-sonra-leg-${i}-start`} placeholder="DEP UTC" value={l.start}
                       onChange={e => setDhSonraLeg(i, 'start', normTime(e.target.value))} />
                <input {...zAlan(S.input, dhSatirZorunlu(dhSonraLegs, i), dhSaatGecerli(l.end))} data-testid={`dh-sonra-leg-${i}-end`} placeholder="ARR UTC" value={l.end}
                       onChange={e => setDhSonraLeg(i, 'end', normTime(e.target.value))} />
                <HarfliGiris style={S.input} placeholder="FLIGHT NO" maxLength={10} value={l.flt}
                       onChange={v => setDhSonraLeg(i, 'flt', v)} />
                <button style={{ ...S.btnS, padding:'8px 10px' }} data-testid={`dh-sonra-sil-${i}`}
                        onClick={() => setDhSonraLegs(ls => {
                          const kalan = ls.filter((_, j) => j !== i);
                          if (!kalan.length) { setDhAfterFlight(false); return [{ dep:'', dest:'', start:'', end:'', flt:'' }]; }
                          return kalan;
                        })}>✕</button>
              </div>,
              <EkleSecici key={`ekle-${i}`} testid={`dh-sonra-bacak-ekle-${i}`} secenekler={[
                { tur:'dh', etiket:'DH', onSec: () => setDhSonraLegs(ls => arayaKoy(ls, i, { dep: ls[i]?.dest || '', dest: ls[i + 1]?.dep || '', start:'', end:'', flt:'' })) },
                ...(i === dhSonraLegs.length - 1 && !paketSim.sonra ? [{ tur:'sim', etiket:'SIM', onSec: () => setPaketSim(p => ({ ...p, sonra: bosPaketSim() })) }] : []),
              ]} />,
            ])}
            <div style={{ ...S.note, marginTop:8 }}>
              Md.4(z), Md.14(1)(b): the FDP ends at the on-block of the last FLIGHT sector — positioning AFTER a flight is not
              FDP and not a sector. Md.14(1)(a): all positioning time is DUTY — the duty ends at the positioning arrival.
              Md.14(1)(c): the rest that follows is counted from there.
            </div>
          </div>
        ) : null}

        {/* PAKET SIM — görevin sonu (14 Eki 2026). */}
        {paketSim.sonra && (
          <PaketSimSatiri yer="sonra" sim={paketSim.sonra} degistir={paketSimDegistir('sonra')}
                          ekip={pilots.filter(p => selected[p.id])} locations={dutyLocations} onAddLocation={addLocation}
                          onSil={() => setPaketSim(p => ({ ...p, sonra: null }))} />
        )}

        {win && (
          <div style={{ marginTop:16 }}>
            <AcikMesaiKutusu split={win.split} konaklama={accommodation}
                             setKonaklama={setAccommodation} testid="assign-split" />
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))', gap:1, background:C.border, border:`1px solid ${C.border}` }}>
              {[
                ['REPORT (AUTO)', win.report], ['MAX FDP', fmtMin(win.maxFdpMin)],
                ['PLANNED FDP', fmtMin(win.fdpMin)], ['LATEST FDP END', win.latestFdpEnd],
                ['DUTY END (PLN)', win.dutyEnd],
                // Md.27: egitimde gunluk UCUS SURESI ayri bir limittir
                ...(win.flightLimitMin != null
                  ? [['FLIGHT TIME', `${fmtMin(win.flightMin)} / ${fmtMin(win.flightLimitMin)}`]]
                  // Eğitimde sınır pilot başına (Md.27) — burada yalnız süre, sınır ekip tablosunda.
                  : win.hesapTuru === 'training' ? [['FLIGHT TIME', fmtMin(win.flightMin)]] : []),
              ].map(([k, v]) => (
                <div key={k} style={{ background:C.bg3, padding:'10px 13px' }}>
                  <div style={{ fontSize:9, letterSpacing:1.5, color:C.t3, textTransform:'uppercase', marginBottom:5, fontFamily:'var(--mono)' }}>{k}</div>
                  <div style={{ fontSize:16, fontWeight:700, color: k === 'PLANNED FDP' && win.fdpExceeded ? C.red : C.accent, fontFamily:'var(--mono)' }}>{v ?? '—'}</div>
                </div>
              ))}
            </div>
            {/* 🔴 27 AGU 2026 — OLCEMEDIGIMIZI SOYLERIZ (Ilke 1).
                Meydanin dilimi bilinmiyorsa uzun menzil (Md.4(ee)) tespiti
                YAPILAMAZ. Eskiden bu durumda sistem sessizce "uzun menzil
                degil" varsayiyordu — yani yapmadigi bir kontrolu yapmis gibi
                gorunuyordu. Artik hangi meydan oldugu ADIYLA yazar.
                Not: dilim adlari `airports` tablosunda IANA olarak durur
                (17.125 meydan, bugun eksigi yok); dilimi GO2 super admin
                AIRPORTS ekranindan duzeltir (`airports-tz` 1 Eki 2026'da
                kaldirildi — rol denetimsiz canli dilimleri eziyordu). Bu uyari,
                tabloda HIC OLMAYAN bir ICAO icindir. */}
            {tzAssignHata && (
              <div data-testid="assign-dilim-okunamadi" style={{ ...S.note, borderLeftColor:C.amber, color:C.amber, marginTop:8 }}>
                AERODROME TIME ZONES COULD NOT BE READ — this does not mean they are missing. Long range (SHT-FTL/HG
                Md.4(ee)) cannot be measured until they are read, so the duty cannot be saved yet.{' '}
                <button type="button" style={S.btnS} onClick={() => setTzAssignDeneme(n => n + 1)}>RETRY</button>
              </div>
            )}
            {tzBilinmeyen.length > 0 && (
              <div style={{ ...S.note, borderLeftColor:C.red, color:C.red, marginTop:8 }}>
                TIME ZONE UNKNOWN — {tzBilinmeyen.join(', ')}. LONG-RANGE CHECK NOT
                PERFORMED (SHT-FTL/HG Md.4(ee)): the FDP cap of Md.22(3) and the
                arrival rest of Md.16(3) cannot be applied to this duty. Add the
                aerodrome to AIRPORTS, then re-enter the sectors.
              </div>
            )}
            {win.longRangeCapped && <div style={{ ...S.note, borderLeftColor:C.amber || 'var(--amber)', marginTop:8 }}>LONG-RANGE DUTY (TZ CROSSING ≥4H) — MAX FDP CAPPED AT {fmtMin(win.maxFdpMin)} (SHT-FTL/HG Md.22(3)); arrival rest = max(duty, 14:00) and 48h/2 local nights on return (Md.16(3)).</div>}
            {win.fdpExceeded && <div style={{ ...S.note, borderLeftColor:C.red, color:C.red, marginTop:8 }}>PLANNED FDP EXCEEDS MAX FDP — this duty cannot be saved: a planned duty cannot exceed the maximum FDP (a commander's discretion, Md.12, is not a planning tool).</div>}
            {/* NOBET UYARISI: yukaridaki MAX FDP kutusu NOBETSIZ tabandir. Nobette
                beklemis pilotun tavani daha DUSUKTUR ve pilot basina degisir —
                kutu tek sayi gosterdigi icin bu ACIKCA soylenmeli, yoksa yanlis
                sayiya bakilir. Pilot bazli gercek tavan asagidaki tabloda. */}
            {fitList.some(f => f.sb?.fdpReductionMin > 0) && (
              <div style={{ ...S.note, borderLeftColor:C.accent, color:C.t2, marginTop:8 }}>
                MAX FDP ABOVE IS THE BASELINE WITHOUT STANDBY. {fitList.filter(f => f.sb?.fdpReductionMin > 0)
                  .map(f => `${f.pilot.code}: −${fmtMin(f.sb.fdpReductionMin)} → ${fmtMin(f.win.maxFdpMin)}`).join(' · ')}
                {' '}(SHT-FTL/HG Md.17). PER-PILOT VALUES ARE IN THE CREW TABLE AND ARE WHAT GETS SAVED.
              </div>
            )}
          </div>
        )}

        {siraHatasi && (
          <div data-testid="assign-sira-hatasi" style={{ ...S.note, borderLeftColor:C.red, color:C.red, marginTop:12 }}>
            SECTOR TIMES OVERLAP — {siraHatasi}
          </div>
        )}
        {/* ROTA KOPUKLUĞU (5 Eki 2026, Serkan) — uyarı, engel değil. */}
        {rotaKopukluklari(legsAll).map(m => (
          <div key={m} data-testid="assign-rota-kopuk" style={{ ...S.note, borderLeftColor:'var(--amber)', color:'var(--amber)', marginTop:12 }}>{m}</div>
        ))}
        <div style={{ marginTop:20 }}>
          <span style={S.label}>Crew — who can fly this duty?</span>
          <div style={{ overflowX:'auto' }}>
            <table style={S.table}>
              <thead><tr>{['', 'PILOT', ...(egitimliAssign ? ['TRAINING KIND (Md.27)'] : []), 'FITNESS', 'REASON', 'ACCLIM (Md.22/1)', 'STANDBY (Md.17)', `${limitAdi('flt28d')} / ${fmtMin(lim.flt_28d_min)}`, `${limitAdi('duty7d')} / ${fmtMin(lim.duty_7d_min)}`, 'DAYS OFF (MON)', 'ROLE'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {fitList.map(({ pilot, legal, reasons, kunyeli, warnings, cum, off, sb, accl, win: pWin }) => {
                  const sel = selected[pilot.id];
                  // 30 Eyl 2026 (adım ②): NOT LEGAL satıra tıklamak SESSİZDİ — "tıklamam
                  // mı işlemedi, yasak mı?" Artık kaydın gösterdiği AYNI kart açılır
                  // (`pilotIhlalBildirimi`); satır yine SEÇİLMEZ, kapı gevşemez (İlke 7).
                  // WHAT IF (12 Eki 2026, Serkan: NOT LEGAL de önizlemeye girer, gerekçesiyle): pencerede NOT LEGAL satır
                  // da SEÇİLİR — sonuç denemede kırmızı görünür. Gerçek ASSIGN'de kapı aynen (seçilmez, kart açılır).
                  const secilebilir = legal || whatIf;
                  const tikla = () => {
                    if (secilebilir && !sel && ['PF', 'PM'].every(r => Object.values(selected).includes(r))) {
                      toast('PF and PM are selected — a 3rd or 4th pilot is added as CRZ CPT with + ADD COCKPIT CREW below.', 'error');
                      return;
                    }
                    if (secilebilir) { toggle(pilot.id); return; }
                    const b = pilotIhlalBildirimi([{ kim: pilot.code || pilot.full_name, kaynak: { kunyeli, reasons } }]);
                    toast(b.mesaj, 'error', b.detay);
                  };
                  return (
                    // data-testid: ekip satiri testten SURULEBILSIN diye
                    // (NotificationBell'deki `data-durum` deseninin ayni sebebi
                    // — kural ekranda duruyorsa ekrandan dogrulanabilmeli).
                    <tr key={pilot.id} data-testid={`crew-${pilot.code}`}
                        onClick={tikla} style={{ cursor:'pointer', opacity: legal ? 1 : .65, background: sel ? `var(--accent-soft)` : 'transparent' }}>
                      <td style={S.td}><IsaretKutusu isaretli={sel} /></td>
                      <td style={{ ...S.td, color: legal ? C.accent : C.t3, fontWeight:700 }}>{pilot.code} — {pilot.full_name}</td>
                      {/* Md.27 (5 Eki 2026, Serkan A): tür PİLOT BAŞINA, seçmeden önce — satırın tıklaması tetiklenmez. */}
                      {egitimliAssign && (
                        <td style={S.td} onClick={e => e.stopPropagation()}>
                          <select {...zAlan({ ...S.input, width:210, opacity:1 }, true, !!egitimTurleri[pilot.id])}
                                  data-testid={`egitim-turu-${pilot.code}`}
                                  value={egitimTurleri[pilot.id] || ''}
                                  onChange={e => setEgitimTurleri(t => ({ ...t, [pilot.id]: e.target.value || undefined }))}>
                            <option value="">— SELECT —</option>
                            {/* SYNTHETIC yalnız SIM görevinin sınırıdır (Md.27(1)(a), 5 Eki 2026) — uçuşta seçilmez. */}
                            {ucusEgitimTurleri(effectiveRules(ruleset).rules)
                              .map(([k, v]) => <option key={k} value={k}>{v.label} — {fmtMin(v.flight_time_min)}</option>)}
                          </select>
                        </td>
                      )}
                      <td style={S.td}><span style={badge(legal ? 'green' : 'red')}>{legal ? 'LEGAL' : 'NOT LEGAL'}</span></td>
                      {/* KIRMIZI = engel (atamayi yapmayarak duzelir) ·
                          AMBER = uyari (duzelmez ama gorulmeli). 4 Eyl 2026. */}
                      <td style={{ ...S.td, fontSize:11, whiteSpace:'normal', maxWidth:280 }}>
                        <GerekceListesi kunyeli={kunyeliYaDuz({ kunyeli, reasons })} testid={`reason-${pilot.code}`}
                                        neYapmali={NE_YAPMALI.pilot} />
                        {(warnings || []).length > 0 && (
                          <div style={{ color:C.amber, marginTop: reasons.length ? 3 : 0 }}>
                            ⚠ {warnings.join(' · ')}
                          </div>
                        )}
                        {reasons.length === 0 && !(warnings || []).length && '—'}
                      </td>
                      {/* İNTİBAK: hangi meydanın saatiyle Tablo 1 okundu.
                          Kalkış meydanından FARKLIYSA amber — o zaman rapor
                          saati ile bandın okunduğu saat ayrışıyor demektir. */}
                      <td style={S.td} title={accl?.reason || ''}>
                        {!accl ? <span style={{ color:C.t3 }}>—</span>
                          : accl.unavailable
                            ? <span style={badge('red')}>UNKNOWN</span>
                            : (<span style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' }}>
                                <span style={badge(accl.icao === String(legs[0]?.dep || '').toUpperCase() ? 'dim' : 'amber')}>
                                  {accl.icao}
                                </span>
                                {pWin?.bandReport && pWin.bandReport !== pWin.report && (
                                  <span style={{ color:C.accent, fontSize:11 }}>BAND {pWin.bandReport}</span>
                                )}
                              </span>)}
                      </td>
                      {/* NOBET: hem SURESI hem SONUCU (kisaltilmis azami UGS) gorunur —
                          "kisaldi" demek yetmez, dispatcher YENI TAVANI gormeli. */}
                      <td style={S.td} title={sb ? `${sb.reference} · standby ${fmtMin(sb.standbyMin)} · duty credit ${fmtMin(sb.dutyCreditMin)}${sb.combinedMin != null ? ` · combined ${fmtMin(sb.combinedMin)}/${fmtMin(sb.combinedCapMin)}` : ''}` : ''}>
                        {!sb ? <span style={{ color:C.t3 }}>—</span> : (
                          <span style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' }}>
                            <span style={badge(sb.ok ? (sb.fdpReductionMin ? 'amber' : 'dim') : 'red')}>
                              {sb.kind === 'airport_standby' ? 'APT' : 'OTHER'} {fmtMin(sb.standbyMin)}
                            </span>
                            {sb.fdpReductionMin > 0 && (
                              <span style={{ color:C.accent, fontSize:11 }}>
                                −{fmtMin(sb.fdpReductionMin)} → MAX {fmtMin(pWin?.maxFdpMin)}
                              </span>
                            )}
                          </span>
                        )}
                      </td>
                      <td style={S.td}>{fmtMin(cum.flt28d)}</td>
                      <td style={S.td}>{fmtMin(cum.duty7d)}</td>
                      <td style={S.td} title={[
                        off?.reachable === false
                          ? `Md.5: this month can no longer reach ${off.required} — ${off.count} planned, `
                            + `${off.candidates} free day(s) left. A blank day is NOT a day off `
                            + '(Md.4/ü: notified in advance, 2 local nights, free of all duty).'
                          : off?.candidates != null
                            ? `${off.candidates} free day(s) still available this month.` : '',
                        off?.invalid?.length
                          ? `Not counted (2 local nights not free — Md.4/ü): ${off.invalid.join(', ')}` : '',
                      ].filter(Boolean).join('\n')}>
                        <span style={{ color: off?.reachable === false ? C.red
                                             : off?.ok === false ? (C.amber || 'var(--amber)') : C.t2,
                                       fontWeight:700 }}>
                          {off ? `${off.count}/${off.required ?? '—'}` : '—'}
                        </span>
                        {off?.invalid?.length ? <span style={{ ...badge('amber'), marginLeft:6 }}>{off.invalid.length} ✕</span> : null}
                      </td>
                      <td style={S.td}>{sel ? <span style={badge('blue')}>{sel}</span> : '—'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ ...S.note, marginTop:8 }}>Click row: 1st = PF, click again = PM, again = deselect. A 3rd or 4th pilot (CRZ CPT) is added with + ADD COCKPIT CREW below. {whatIf
            ? 'In WHAT IF a NOT LEGAL row can be selected too — the result is shown in red with its reasons; nothing is saved.'
            : 'NOT LEGAL rows cannot be selected — click one to see why.'} With more than one sector, the roles can be changed sector by sector below.</div>

          {/* ── ADD COCKPIT CREW (4 Agu, Serkan): 3 pilotlu ops / check ride.
                29 Eyl: kutu EDIT ile ORTAK bileşen (`UcuncuKisiKutusu`). ── */}
          {Object.values(selected).includes('PF') && Object.values(selected).includes('PM') && (() => {
            const ad = (pid) => { const pp = pilots.find(x => x.id === pid); return pp ? `${pp.code} — ${pp.full_name}` : pid; };
            // Serkan (5 Eki 2026): liste YALNIZ ekipte olmayan pilotlar; NOT LEGAL olan görünür ama seçilemez (tablodaki kural).
            const secilebilir = fitList.filter(f => !selected[f.pilot.id]);
            const seciciAcik = extraMode === 'crz' && (crzIds.length === 0 || crzSlot);
            return (
              <UcuncuKisiKutusu
                mod={extraMode} setMod={setExtraMode}
                crzler={crzIds.map(pid => ({ key: pid, ad: ad(pid), onKaldir: () => crzCikar(pid) }))}
                crzSecici={seciciAcik ? (
                  <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                    <select {...zAlan({ ...S.input, width:300 }, true, false)} data-testid="third-crew-pick" value=""
                            onChange={e => crzSec(e.target.value)}>
                      <option value="">{crzIds.length ? '— SELECT 2ND CRZ CPT —' : '— SELECT CRZ CPT —'}</option>
                      {secilebilir.map(f => (
                        <option key={f.pilot.id} value={f.pilot.id} disabled={!f.legal}>
                          {f.pilot.code} — {f.pilot.full_name}{f.legal ? '' : ' — NOT LEGAL'}
                        </option>
                      ))}
                    </select>
                    {crzIds.length > 0 && (
                      <button type="button" data-testid="third-crew-pick-kapat" style={{ ...S.btnS, color:C.t3 }}
                              onClick={() => setCrzSlot(false)}>✕</button>
                    )}
                    <span style={{ fontSize:10, color:C.t3 }}>
                      Only pilots not yet in this crew are listed. A NOT LEGAL pilot cannot be picked — click their row above to see why.
                    </span>
                  </div>
                ) : null}
                onCrzEkle={extraMode === 'crz' && crzIds.length >= 1 && crzIds.length < AZAMI_CRZ && !crzSlot
                  ? () => setCrzSlot(true) : null}
                onKutuKapat={crzIds.length === 0 ? () => setExtraMode(null) : null}
                augmentedNot={<AugmentedNot win={win} />}
                dinlenme={dinlenme} setDinlenme={setDinlenme}
                examiner={examiner} setExaminer={setExaminer}
                onCheckKaldir={() => { setExtraMode(null); setExaminer(''); }} />
            );
          })()}

          {/* ── BACAK BAŞINA ROLLER (29 Eyl 2026) — birden çok bacakta. ── */}
          {legs.length > 1 && Object.keys(selected).length > 0 && (
            <BacakRolleri
              sektorler={legs}
              uyeler={Object.keys(selected).map(pid => {
                const p = pilots.find(x => x.id === pid);
                return { key: pid, ad: p ? p.code : pid };
              })}
              haritalar={bacakRolleri}
              onDegis={bacakRolDegis} />
          )}
        </div>
      </>)}

      {dutyType !== 'flight' && (
        <div style={{ marginTop:6 }}>
          <span style={S.label}>Pilots</span>
          <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
            {pilots.filter(ucusEkibindenMi).map(p => {
              const sel = !!selected[p.id];
              return (
                <SecimKutusu key={p.id} isaretli={sel} testid={`pilot-pick-${p.code}`}
                  onClick={() => setSelected(s => { const n = { ...s }; if (n[p.id]) delete n[p.id]; else n[p.id] = 'CREW'; return n; })}>
                  {p.code} — {p.full_name}
                </SecimKutusu>
              );
            })}
          </div>

          {/* ── YER GÖREVİNDE GEREKÇELER (5 Eyl 2026) ────────────────────
              🔴 Test yazarken çıktı: yer görevinde EKİP TABLOSU çizilmiyor
                 (o yalnız uçuş görevine ait), dolayısıyla 4 Eyl'de açılan FTL
                 kapısı yer görevi için HESAP YAPIYOR ama gerekçelerini
                 göstermiyordu — yalnız SAVE'e basınca çıkıyordu. "Neden
                 seçemiyorum" sorusu ekrandan cevaplanmıyordu.
              Uçuşa özel kontroller (azami UGS, intibak, nöbet penceresi) yer
              görevinde zaten koşmaz; kalanlar burada görünür. */}
          {(dutyType === 'ground' || dutyType === 'dh') && (() => {
            const secililer = fitList.filter(f => selected[f.pilot.id]);
            const engelliler = secililer.filter(f => !f.legal);
            const uyarililar = secililer.filter(f => (f.warnings || []).length);
            if (!engelliler.length && !uyarililar.length) return null;
            return (
              <div style={{ ...S.note, marginTop:10,
                            borderLeftColor: engelliler.length ? C.red : C.amber }}
                   data-testid="gnd-fitness">
                {engelliler.map(f => (
                  <div key={`r-${f.pilot.id}`} style={{ color:C.red, fontSize:11 }}>
                    <b>{f.pilot.code}</b> — NOT LEGAL:
                    <div style={{ paddingLeft:12 }}>
                      <GerekceListesi kunyeli={kunyeliYaDuz(f)} testid={`gnd-${f.pilot.code}`}
                                      neYapmali={NE_YAPMALI.pilot} />
                    </div>
                  </div>
                ))}
                {uyarililar.map(f => (
                  <div key={`w-${f.pilot.id}`} style={{ color:C.amber, fontSize:11 }}>
                    ⚠ <b>{f.pilot.code}</b> {f.warnings.join(' · ')}
                  </div>
                ))}
                <div style={{ color:C.t3, fontSize:10, marginTop:4 }}>
                  Red blocks the assignment; amber is shown but does not. Flight-only checks
                  (max FDP, acclimatisation, the standby window) do not apply to a ground duty or a positioning (DH).
                </div>
              </div>
            );
          })()}
        </div>
      )}

      <div style={{ marginTop:22, display:'flex', gap:10 }}>
        {/* ── EKİP DÜZEYİ ENGELLER, KAYDETMEDEN ÖNCE ─────────────────────
            🔑 Serkan (5 Eyl 2026): *"İki OML pilot aynı uçuşa assign olursa
               uyarı verecek mi?"*  Toast'a bırakmak yetmez: dispatcher seçimi
               yaparken görmeli, düğmeye bastıktan sonra değil. */}
        {ekipGerekceleri.gerekceler.length > 0 && (
          <div style={{ ...S.note, borderLeftColor:C.red, marginBottom:10 }}
               data-testid="crew-level-block">
            {/* 29 Eyl 2026 (adım b): her gerekçenin yanında ⓘ — maddenin KENDİ
                metni (künyeden, `kunyeMetni`) ve ne yapılabileceği. Düğme kapalı
                olduğu için kullanıcının gerekçeyi gördüğü yer burasıdır. */}
            <GerekceListesi kunyeli={ekipGerekceleri.kunyeli} testid="crew-block" neYapmali={NE_YAPMALI.ekip} />
            <div style={{ color:C.t3, fontSize:10, marginTop:4 }}>
              Medical limitations and age limits are read from ATPL &amp; MED. These are crew-level
              rules — they depend on who else is on the flight, not on one pilot alone.
            </div>
          </div>
        )}

        {/* ── AMBER: ENGELLEMEZ, AMA GÖRÜNÜR ─────────────────────────────
            🔑 Serkan (6 Eyl 2026), SSL için (a) şıkkı: *"engellemez ama
               gerekçe dispatcher'ın önünde durur."*  Aynı yer, ölçülemeyen
               bağlamı da söyler (gece/tip/yolcu bilinmiyorsa VCL, OAL, OPL
               sessizce GEÇMEZ — İlke 1). */}
        {ekipGerekceleri.uyarilar.length > 0 && (
          <div style={{ ...S.note, borderLeftColor:C.amber, marginBottom:10 }}
               data-testid="crew-level-advisory">
            {ekipGerekceleri.uyarilar.map((u, i) => (
              <div key={i} style={{ color:C.amber, fontSize:11 }}>{u}</div>
            ))}
            <div style={{ color:C.t3, fontSize:10, marginTop:4 }}>
              These do not block the assignment. Assess them before dispatch.
            </div>
          </div>
        )}
        {whatIf ? null : (
          <button style={{ ...S.btnP, opacity: ekipGerekceleri.gerekceler.length ? .45 : 1 }}
                  disabled={saving || ekipGerekceleri.gerekceler.length > 0}
                  onClick={save}>{saving ? 'SAVING...' : 'ASSIGN DUTY'}</button>
        )}
      </div>

      {atamaOnayi && onaySatirlari && (
        <OnizlemeCizelgesi kip="assign" onizlemeSatirlari={onaySatirlari} gorevler={[...(duties || []), ...onaySatirlari]}
          pilots={pilots} baselines={baselines} ruleset={ruleset} offTypes={offTypes} pilotDilim={pilotDilim} toast={toast}
          busy={saving} onClose={() => setAtamaOnayi(null)}
          onConfirm={async () => { const r = atamaOnayi.rows; setAtamaOnayi(null); await atamayiYaz(r); }} />
      )}

      {backdated && (
        <ReasonModal
          title="BACKDATED DUTY — ARE YOU SURE?"
          warn={`This duty is already over (it ended ${backdated.rows.find(r => r.duty_end)?.duty_end || '—'}). A duty in the past is not planning — it will be recorded as an ACTUAL, completed duty and the times you entered are taken as the real off/on block times.`}
          confirmLabel="RECORD AS ACTUAL"
          onCancel={() => setBackdated(null)}
          onConfirm={async (reason) => {
            try {
              await commitRows(backdated.rows, reason);
              setBackdated(null);
            } catch (e) { toast(String(e.message || e), 'error'); }
          }}
        />
      )}
      {gecmisUcus && (
        <EditDutyModal
          group={gecmisUcus} gercekGiris pilots={pilots} duties={duties} ucuslar={{}}
          myProfile={myProfile} toast={toast} homeBases={homeBases} pilotDilim={pilotDilim}
          ruleset={ruleset} baselines={baselines} offTypes={offTypes} lisansMed={lisansMed} aircraft={aircraft} tipVasiflari={tipVasiflari}
          onClose={() => { const g = gecmisUcus; setGecmisUcus(null); if (onAtandi) onAtandi(g.rows); reload();
            toast('The flight stays PLANNED in the past — open it from DUTY HISTORY (PLN) to record it as flown.', 'error'); }}
          onSaved={() => { const g = gecmisUcus; setGecmisUcus(null); if (onAtandi) onAtandi(g.rows); reload(); }}
        />
      )}
    </div>
  );
}

// Ertesi gün — UTC (3 Eki 2026). Eskiden YEREL öğlen + 1 gün idi: UTC+13/+14'te yerel öğlen bir önceki UTC günüdür,
// gece yarısını geçen görevin bitiş tarihi ertesi gün yerine AYNI gün olurdu. Tek kaynak `shiftDate` (FTLEngine).
const nextDay = (dateStr) => shiftDate(dateStr, 1);

// ═══ 2a) PLANLANDI — GERCEKLESTI MI? ══════════════════════════════
// 15 Agu 2026, Serkan: "son iki ucusu iOS'ta kosturamadik, app'te ucus
// kosulmadi ama PLANLANAN UCUS GERCEKLESTI. PLN'ye tiklayalim, bize sorsun:
// bu plan gerceklesti mi? YES ise OFF BLOCK, T/O, LND ve ON BLOCK saatlerini
// sorsun, uculdu olarak sisteme girsin. NO dersek gerceklestirilmemis
// planlama olarak silinsin, o gun bos gune donsun — hatta BOS gun mu STBY mi
// OFF mu sorsun, niteligini biz girelim ki RULE SET duzgun calissin."
//
// VERI SOZLESMESI (archive-flight zaten boyle bekliyor): elle girilen sektore
// `plan_id` YAZILMAZ. Boylece ucus kaydi sonradan gelirse OLCULEN degerler
// elle girilenin ustune yazar ("gerceklesen ucus her zaman ustune yazar");
// hic gelmezse elle girilen kayit olarak kalir.
//
// SILME = IPTAL (status='cancelled'). Kalici silme YOK: gorev listeden duser,
// KAYITTAN DUSMEZ ve gerekce denetim izine yazilir.
function PlannedOutcomeModal({ duty, rows, myProfile, offTypes, toast, onClose, onSaved,
                              onGerceklesti = null, pilots = [], pilotDilim = {}, duties = [], ruleset = null }) {
  const isFlight = duty.duty_type === 'flight';
  // Yazılamayan görev ADIYLA söylenir (29 Eyl 2026 · FTL nöbetçisi A2).
  const nameOf = (pid) => { const x = pilots.find(p => p.id === pid); return x ? (x.code || x.full_name) : '—'; };
  const legs = duty.sectors || [];
  // ── UÇUŞ GÖREVİNİN GERÇEKLEŞMESİ EDIT'TE (29 Eyl 2026) ─────────────────
  // 🔑 Serkan: *"Burada görevi gerçekleşmiş yapabiliyorsam gerekli verileri de
  //    girebilmem lazım — tek kaynak."* · Seçenek 1: *"kesinlikle bu."*
  // 🔴 Bu pencerenin ayrı bir "ENTER THE ACTUAL TIMES" formu ve AYRI bir kayıt
  //    yolu (`saveFlown`) vardı: rol, 3. kişi, divert, tip sorulmuyordu ve
  //    RAPOR SAATİ GERÇEK OFF-BLOCK'TAN TÜRETİLMİYORDU — burada kapatılan
  //    görevin FDP'si planlanan rapor saatinden ölçülüyordu (21 Eyl kuralının
  //    üçüncü kapısı atlanmıştı). Artık YES → EDIT penceresi, "gerçekleşti"
  //    modunda (`onGerceklesti`); görevi gerçekleşmiş yapan TEK pencere, TEK
  //    kayıt yolu. Açık (OPEN) uçuş görevi de oradan kapanır (Duty History).
  //    Bu pencerede kalanlar: yer görevi "oldu" ve "OLMADI" yolları.
  const [step, setStep] = useState(duty.status === 'open' && !isFlight ? 'ground' : 'ask');
  // ── YER GOREVI "OLDU" YOLU (22 Agu 2026 saha) ──────────────────────
  // 🔴 Serkan: *"Ahmet kaptanin sim ve training planlamalari hala PLAN
  //    gorunuyor; o gorevler tanimlandi ve gerceklesti, geride kaldi."*
  //    Sebep: "YES — IT TOOK PLACE" butonu ucus OLMAYAN gorevde `notflown`
  //    adimina gidiyordu — yani IPTAL ekranina. Yer gorevinin "oldu" diyecek
  //    HICBIR yolu yoktu: ne otomatik donusum, ne elle. Bes gun PLN kaldi ve
  //    raporun toplamlarina girmedi ("PLN excluded from totals").
  // 🔑 Serkan'in karari: saatler SORULUR ama PLANLANDIGI GIBI dolu gelir —
  //    degismediyse onaylayip gecersin, degistiyse duzeltirsin.
  const isoToHHMM = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return isNaN(d) ? '' : `${String(d.getUTCHours()).padStart(2,'0')}:${String(d.getUTCMinutes()).padStart(2,'0')}`;
  };
  const [gStart, setGStart] = useState(() => isoToHHMM(duty.report_time));
  // SIM: kutu SIM ENDS — kayıttaki bitişten simülatör sonrası süre çıkarılır; kayıtta bir kez eklenir (`simSonrasiDk`).
  const [gEnd,   setGEnd]   = useState(() => (duty.ground_kind === 'sim'
    ? kutuBitisi(duty, 'sim', satirKurali(duty)) : isoToHHMM(duty.duty_end)));

  const [nature, setNature] = useState('empty');    // empty | stby | off
  // İptal edilecek ekip — atamanın planlı satırlarındaki pilotlar, tıklanan pilot ilk (5 Eki 2026, tek tık bütün ekip).
  const ekipPilotlari = [...new Set([duty.pilot_id, ...(rows || []).map(r => r.pilot_id)].filter(Boolean))];
  const [sbKind, setSbKind] = useState('airport_standby');
  const [sbStart, setSbStart] = useState('');
  const [sbEnd, setSbEnd] = useState('');
  const [offSubtype, setOffSubtype] = useState(() => (offTypes || [])[0]?.code || 'OFF');
  // OFF'un yeri — ASSIGN ile AYNI kutu ve kural (1 Eki 2026).
  const [offLoc, setOffLoc] = useState({ location:'', location_tz:null });
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  usePencereKapat(busy ? null : onClose);   // 12 Eki 2026: ESC + ✕ (pencereKapat.js); kaydederken kapanmaz

  const hhmmOK = (v) => /^\d{1,2}:\d{2}$/.test(v) && toMin(v) != null;

  // Denetim izi satiri — CANCEL yolundaki bicimin aynisi.
  const auditRow = (d, field, oldV, newV, type, why) => ({
    duty_id: d.id, customer_id: d.customer_id, pilot_id: d.pilot_id,
    assignment_id: d.assignment_id || null, edit_type: type,
    field_name: field, old_value: oldV == null ? null : String(oldV),
    new_value: newV == null ? null : String(newV),
    reason: why, edited_by: myProfile?.id ?? null,
  });

  // ── YES (YER GOREVI): OLDU ─────────────────────────────────────────
  // Ucus gorevinden farki: FDP YOKTUR. Yer gorevi GOREV suresi uretir,
  // ucus gorev suresi uretmez — bu yuzden `fdp_minutes` bos birakilir ve
  // `fdp_exceeded` hesaplanmaz. Dinlenme atama yolundaki formulun aynisiyla
  // yeniden kurulur (tek kaynak: ruleset_snapshot).
  const saveGround = async () => {
    if (!hhmmOK(gStart) || !hhmmOK(gEnd)) {
      toast('Start and end are required (HH:MM).', 'error'); return;
    }
    if (toMin(gStart) === toMin(gEnd)) {
      toast('Start and end cannot be the same.', 'error'); return;
    }
    setBusy(true);
    try {
      // Yer gorevi de TEK OLAYDIR: SIM ve egitim genelde iki pilotla yapilir
      // (8 Eyl 2026 — ucus yolundaki ayni kusur burada da vardi, tek satir
      // kapaniyordu). Saatler ortak; SIM sonrasi bildirim suresi ve dinlenme
      // tabani HER SATIRIN KENDI snapshot'indan okunur.
      const yerAlanlari = (row) => {
        // SIM SONRASI BILDIRIM SURESI (Md.10/c) — atama yolundaki kuralin AYNISI.
        // Girilen saat sim'in BITISIDIR; gorev debriefing icin 60 dk sonra biter.
        // Satırın KENDİ kopyası (bugünkü kural setine düşülmez); kopya yoksa debriefing eklenmez (canlı 4 Eki: kopyasız görev 0).
        const rPost = simSonrasiDk(row.ground_kind, satirKurali(row));
        // GUN DEVRI: bitis baslangictan kucukse ertesi gundur (atama yolundaki kural).
        const rEndGirilen = utcISO(toMin(gEnd) < toMin(gStart) ? nextDay(row.duty_date) : row.duty_date, gEnd);
        const rEndISO = rPost
          ? new Date(new Date(rEndGirilen).getTime() + rPost * 60000).toISOString()
          : rEndGirilen;
        const rStartISO = utcISO(row.duty_date, gStart);
        // ④ (3 Eki 2026): dinlenmeyi artık sunucu yazar — burada HAM mevzuattan (şirket ayarı ve diğer nöbet
        //    kuralı olmadan) hesaplanıyordu; motor `yerGoreviDinlenmesi` + şirket kural setiyle yazar.
        return {
          status: 'actual', duty_finished: true,
          report_time: rStartISO, duty_end: rEndISO,
        };
      };

      // İz görev penceresini görev penceresiyle karşılaştırır — SIM'de girilen SIM ENDS değil, yazılan bitiş (+Md.10(c)).
      const pencere = (row) => { const u = yerAlanlari(row); return `${gStart}–${isoToHHMM(u.duty_end)}`; };
      const why = `Ground duty confirmed as done: ${isoToHHMM(duty.report_time) || '—'}–`
                + `${isoToHHMM(duty.duty_end) || '—'} → ${pencere(duty)}`
                + (duty.ground_kind === 'sim' ? ` (SIM ENDS ${gEnd})` : '');

      let yerEkip = [];
      if (duty.assignment_id) {
        const { data: ed, error: kErr } = await supabase.from('crew_duties')
          .select('*').eq('assignment_id', duty.assignment_id)
          .neq('id', duty.id).neq('status', 'cancelled');
        if (kErr) { toast(`Crew could not be read: ${kErr.message}`, 'error'); setBusy(false); return; }
        yerEkip = ed || [];
      }

      const yerYazim = [{ id: duty.id, r: duty, upd: yerAlanlari(duty) }];
      const yerIz = [
        auditRow(duty, 'status', duty.status, 'actual', 'EDIT', why),
        auditRow(duty, 'duty_window', `${isoToHHMM(duty.report_time)}–${isoToHHMM(duty.duty_end)}`,
                 pencere(duty), 'EDIT', why),
      ];
      for (const r of yerEkip) {
        yerYazim.push({ id: r.id, r, upd: yerAlanlari(r) });
        yerIz.push(auditRow(r, 'status', r.status, 'actual', 'EDIT', why));
        yerIz.push(auditRow(r, 'duty_window', `${isoToHHMM(r.report_time)}–${isoToHHMM(r.duty_end)}`,
                            pencere(r), 'EDIT', why));
      }

      // Iz ONCE (silme/iptal/edit ile ayni ilke).
      const { error: eErr } = await supabase.from('ftl_duty_edits').insert(yerIz);
      if (eErr) { toast(`Audit write failed: ${eErr.message}`, 'error'); setBusy(false); return; }

      // Her yazma DÖNEN SATIRLA doğrulanır (29 Eyl 2026 · FTL nöbetçisi A2): RLS
      // reddi hata değil 0 satır döner (İlke 2). İlk düşende durulur; yazılmayan
      // ve hiç denenmeyen ekip ADIYLA söylenir, önce yazılmış izin yanına
      // DÜZELTME SATIRI düşer (iz kendini düzeltir, silinmez).
      const yazilan = [];
      for (const y of yerYazim) {
        const { data: donen, error } = await supabase.from('crew_duties')
          .update(turetilmisleriAyikla(y.upd, 'ground')).eq('id', y.id).select('id');
        if (!error && donen?.length === 1) { yazilan.push(y); continue; }
        const sebep = error?.message || 'no row returned (permission?)';
        const olmayan = yerYazim.slice(yerYazim.indexOf(y));
        const { error: dErr } = await supabase.from('ftl_duty_edits').insert(olmayan.map((o, k) =>
          auditRow(o.r, 'update', '(edit logged)', '(EDIT NOT WRITTEN)', 'EDIT',
                   k === 0 ? `Update refused: ${sebep}` : `Not attempted — an earlier write was refused: ${sebep}`)));
        toast(`NOT SAVED for ${olmayan.map(o => nameOf(o.r.pilot_id)).join(', ')}.`
              + (yazilan.length ? ` Saved for ${yazilan.map(o => nameOf(o.r.pilot_id)).join(', ')}.` : '')
              + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
                      : ' The edit log records that it was not written.'),
              'error', yazmaDetayi({ kismen: yazilan.length > 0, hata: error }));
        setBusy(false);
        if (yazilan.length) onSaved();   // bir kısmı yazıldı: ekran gerçeği göstersin
        return;
      }
      toast('Ground duty recorded as done.', 'success');
      await offRestUygula({ duties, ruleset, offTypes, pilotDilim, myProfile, toast,
                            gorevler: yazilan.map(y => ({ ...y.r, ...y.upd })) });
      onSaved();
    } catch (e) { toast(String(e.message || e), 'error'); }
    setBusy(false);
  };

  // ── NO: GERCEKLESMEDI ──────────────────────────────────────────────
  const saveNotFlown = async () => {
    if (!gerekceTamam(reason)) { toast(gerekceIpucuMetni(reason), 'error'); return; }
    if (nature === 'stby') {
      // SURESIZ NOBET OLMAZ (Serkan, 15 Agu) — saatler zorunlu.
      if (!hhmmOK(sbStart) || !hhmmOK(sbEnd)) {
        toast('Standby start and end are required (HH:MM). A standby without hours cannot be recorded.', 'error');
        return;
      }
      if (toMin(sbStart) === toMin(sbEnd)) { toast('Standby start and end cannot be the same.', 'error'); return; }
    }
    if (nature === 'off' && offYeriEksigi(offLoc)) {
      toast(offYeriHataMetni(offLoc.location), 'error');
      return;
    }
    // OFF GİRİŞ KAPISI (1 Eki 2026) — ASSIGN'la AYNI kapı; iptal edilen satır(lar) ölçüye girmez.
    // 5 Eki 2026: yerine konan gün BÜTÜN EKİBE (Serkan "hepsine uygula") — kapı her pilot için ayrı; biri geçemezse hiçbir
    // şey yazılmaz, pilot adıyla söylenir. Yer boşsa her pilotun KENDİ ana üssü (OFF kuralı).
    if (nature === 'off') {
      const iptal = new Set(rows.map(r => r.id));
      const engel = ekipPilotlari.flatMap(pid => offGirisEngeli([duty.duty_date],
        duties.filter(d => d.pilot_id === pid && !iptal.has(d.id)),
        effectiveRules(duty.ruleset_snapshot || ruleset).rules,
        bosGunDilimi(offYeriKaydi(offLoc, pilotDilim[pid]), pilotDilim[pid]?.tz || null),
        { offTypes, subtype: offSubtype }).map(e => `${nameOf(pid)} ${offGirisEngeliMetni(e)}`));
      if (engel.length) { toast(engel.join(' · '), 'error'); return; }
    }
    setBusy(true);
    try {
      const why = `Planned duty did not take place: ${reason.trim()}`;
      const ids = rows.map(r => r.id);

      // ── İPTAL + YERİNE KONAN GÜN: İZ ÖNCE, YAZMA DÖNEN SATIRLA (29 Eyl 2026) ──
      // 🔴 ÖNCESİ (FTL nöbetçisi ölçüm 1 · A2): ① iptal yalnız `error`e bakıyordu —
      //    RLS reddi 0 satır döner (İlke 2); görev planlı KALIRKEN yerine konan
      //    STBY/OFF yine yazılıyor, o gün iki kayıt oluyordu ve ekran "Duty
      //    cancelled" diyordu ② yerine konan satırın EDIT REPORT'ta HİÇ izi yoktu.
      // 🔑 Şimdi: yerine konan satırın kimliği ÖNCE üretilir, izi iptal iziyle
      //    BİRLİKTE önce yazılır; iptal eksik dönerse yerine satır YAZILMAZ.
      // GUNUN NITELIGI — rule set'in dogru calismasi icin gun bos birakilmaz.
      // Yerine konan gün HER PİLOTA (5 Eki 2026, Serkan "hepsine uygula") — pilotun kendi satırının kural seti kopyasıyla.
      const yeniler = nature === 'empty' ? [] : ekipPilotlari.map(pid => {
        const kendi = rows.find(r => r.pilot_id === pid) || duty;
        const base = {
          id: newUuid(),
          customer_id: duty.customer_id, pilot_id: pid,
          created_by: myProfile?.id ?? null,
          ruleset_id: kendi.ruleset_id ?? null,
          ruleset_snapshot: kendi.ruleset_snapshot ?? null,
          duty_date: duty.duty_date, status: 'actual',
        };
        if (nature === 'stby') {
          const startISO = utcISO(duty.duty_date, sbStart);
          const endISO = utcISO(toMin(sbEnd) < toMin(sbStart) ? nextDay(duty.duty_date) : duty.duty_date, sbEnd);
          return { ...base, duty_type: 'ground', ground_kind: sbKind, report_time: startISO, duty_end: endISO };
        }
        return { ...base, duty_type: 'off', off_subtype: offSubtype, ...offYeriKaydi(offLoc, pilotDilim[pid]) };
      });
      const gunAdi = nature === 'stby' ? 'STANDBY' : 'OFF';
      const gun = (r) => `${nameOf(r.pilot_id)} ${fmtD(r.duty_date)}`;

      // 1) İZ ÖNCE — iptal + yerine konan gün, TEK yazmada.
      const iz = rows.map(r => auditRow(r, 'status', r.status, 'cancelled', 'CANCEL', why));
      yeniler.forEach(y => iz.push(auditRow(y, 'day_nature', '(none)',
        nature === 'stby' ? `STANDBY ${sbKind} ${sbStart}–${sbEnd}` : `OFF ${offSubtype}`, 'EDIT', why)));
      const { error: eErr } = await supabase.from('ftl_duty_edits').insert(iz);
      if (eErr) { toast(`Audit write failed: ${eErr.message}`, 'error'); setBusy(false); return; }

      // 2) İPTAL — dönen satırlarla doğrulanır; eksikse yerine gün YAZILMAZ.
      const { data: iptalEdilen, error } = await supabase.from('crew_duties')
        .update({ status: 'cancelled' }).in('id', ids).select('id');
      const olan = new Set((iptalEdilen || []).map(r => r.id));
      const olmayan = error ? rows : rows.filter(r => !olan.has(r.id));
      if (olmayan.length) {
        const sebep = error?.message || 'no row returned (permission?)';
        const duzeltme = olmayan.map(r => auditRow(r, 'status', '(cancel logged)',
          '(CANCEL REFUSED — status unchanged)', 'EDIT', `Cancel refused by policy: ${sebep}`));
        yeniler.forEach(y => duzeltme.push(auditRow(y, 'day_nature', '(add logged)', '(ADD NOT WRITTEN — day not created)',
          'EDIT', `Not attempted — the cancel was refused: ${sebep}`)));
        const { error: dErr } = await supabase.from('ftl_duty_edits').insert(duzeltme);
        const yapilan = rows.filter(r => olan.has(r.id));
        toast(`Cancel refused for ${olmayan.map(gun).join(', ')}.`
              + (yapilan.length ? ` Cancelled: ${yapilan.map(gun).join(', ')}.` : '')
              + (yeniler.length ? ` The ${gunAdi} day was NOT recorded.` : '')
              + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
                      : ' The edit log records that it was refused.'),
              'error', yazmaDetayi({ kismen: yapilan.length > 0, hata: error }));
        setBusy(false);
        if (yapilan.length) onSaved();   // bir kısmı oldu: ekran gerçeği göstersin
        return;
      }

      // 3) YERİNE KONAN GÜN — eklemesi de dönen satırla doğrulanır.
      if (yeniler.length) {
        const { data: eklenen, error: iErr } = await supabase.from('crew_duties')
          .insert(yeniler.map(y => turetilmisleriAyikla(y, y.duty_type))).select('id');
        if (iErr || eklenen?.length !== yeniler.length) {
          const sebep = iErr?.message || 'no row returned (permission?)';
          const eklenenler = new Set((eklenen || []).map(r => r.id));
          const { error: dErr } = await supabase.from('ftl_duty_edits').insert(yeniler.filter(y => !eklenenler.has(y.id))
            .map(y => auditRow(y, 'day_nature', '(add logged)', '(ADD NOT WRITTEN — day not created)', 'EDIT',
                               `Add refused: ${sebep}`)));
          toast(`Duty cancelled, but the ${gunAdi} day was NOT recorded.`
                + (dErr ? ` The audit correction could not be written either: ${dErr.message}`
                        : ' The edit log records it.'),
                'error', yazmaDetayi({ kismen: true, hata: iErr,
                  neYapmali: `The duty is cancelled; only the ${gunAdi} day is missing. Record the day again from ASSIGN DUTY.` }));
          setBusy(false);
          onSaved();                       // iptal OLDU: ekran bunu göstersin
          return;
        }
      }
      const kimler = ekipPilotlari.map(nameOf).join(', ');
      toast(nature === 'empty' ? `Duty cancelled for ${kimler} — the day is now empty.`
            : `Duty cancelled for ${kimler} — the day is recorded as ${nature === 'stby' ? 'STANDBY' : 'OFF'} for each.`, 'success');
      onSaved();
    } catch (e) { toast(String(e.message || e), 'error'); }
    setBusy(false);
  };

  const box = { background:C.bg2, border:`1px solid ${C.border}`, borderRadius:10, width:640,
                maxWidth:vw(94), maxHeight:vh(92), overflowY:'auto' };
  const tIn = { ...S.input, width:88, textAlign:'center' };
  const chip = (on) => ({ padding:'9px 18px', fontSize:11, fontWeight:700, letterSpacing:1.5,
                          cursor:'pointer', fontFamily:'var(--mono)', borderRadius:6,
                          border:`1px solid ${on ? C.accent : C.border2}`,
                          background: on ? C.accent : 'transparent',
                          color: on ? 'var(--bg)' : C.t3 });

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', display:'flex',
                  alignItems:'center', justifyContent:'center', zIndex:70 }}>
      <div style={box}>
        <div style={S.panelH}>
          <span style={S.panelT}>
            {step === 'ask' ? 'DID THIS PLANNED DUTY TAKE PLACE?'
             : 'WHAT WAS THIS DAY?'}
          </span>
          <span style={{ display:'flex', alignItems:'center', gap:10 }}>
            <span style={{ fontSize:9, color:C.t3, letterSpacing:1, fontFamily:'var(--mono)' }}>
              {fmtD(duty.duty_date)} · {routeOf(duty)}
            </span>
            <KapatX onClose={onClose} disabled={busy} />
          </span>
        </div>

        <div style={{ padding:16 }}>
          {step === 'ask' && (
            <>
              <div style={S.note}>
                This duty is still marked PLANNED. If it was flown but never archived from the
                EFB (app failure, hard-copy flight), YES opens the duty to record what actually
                happened — times, crew roles per sector, a third pilot, a divert, the paper OFP.
                If it never happened, cancel it and say what the day actually was — the FTL
                rules need the day to be something.
              </div>
              {isFlight && !!legs.length && (
                <table style={{ ...S.table, marginTop:12 }}>
                  <thead><tr><th style={S.th}>Sector</th><th style={S.th}>Planned ETD</th><th style={S.th}>Planned ETA</th></tr></thead>
                  <tbody>{legs.map((l, i) => (
                    <tr key={i}><td style={S.td}>{l.dep}–{l.dest}</td>
                      <td style={S.td}>{l.etd || '—'}</td><td style={S.td}>{l.eta || '—'}</td></tr>
                  ))}</tbody>
                </table>
              )}
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
                <button style={S.btnS} onClick={onClose}>CLOSE</button>
                <button style={{ ...S.btnSil }}
                        onClick={() => setStep('notflown')}>NO — IT DID NOT HAPPEN</button>
                {/* 🔴 22 Agu: burasi `isFlight && legs.length ? 'flown' : 'notflown'`
                    idi — yani ucus olmayan gorevde EVET demek IPTAL ekranina
                    goturuyordu. Olumlu buton olumsuz sonuca cikiyordu. */}
                {/* 29 Eyl 2026: uçuş görevi → EDIT penceresi, "gerçekleşti" modunda
                    (tek pencere, tek kayıt yolu); yer görevi → aşağıdaki adım. */}
                <button style={S.btnP}
                        onClick={() => (isFlight && legs.length && onGerceklesti
                          ? onGerceklesti(duty) : setStep('ground'))}>
                  YES — IT TOOK PLACE
                </button>
              </div>
            </>
          )}

          {/* ── YER GOREVI OLDU (22 Agu 2026) ────────────────────────────
              Saatler PLANLANDIGI GIBI dolu gelir (Serkan: "AS IS olmasi
              gerekir, planlandigi gibi"); degismediyse onaylayip gecilir.
              Ucus gorevindeki gibi GERCEK saatler sorulur — SIM 09:00 yerine
              09:30'da basladiysa kayit onu gostersin. */}
          {step === 'ground' && (
            <>
              <div style={S.note}>
                All times UTC, HH:MM. The times below are the PLANNED ones — if the duty ran
                as planned, just save. Duty window and the next earliest report are calculated
                from what you confirm here.
              </div>
              <div style={{ display:'flex', gap:16, marginTop:12, alignItems:'flex-end' }}>
                <div>
                  <span style={S.label}>Start *</span>
                  <input {...zAlan(tIn, true, hhmmOK(gStart))} data-testid="pln-gnd-start" placeholder="HH:MM" maxLength={5} value={gStart}
                         onChange={e => setGStart(normTime(e.target.value))} />
                </div>
                <div>
                  <span style={S.label}>{duty.ground_kind === 'sim' ? 'Sim ends *' : 'End *'}</span>
                  <input {...zAlan(tIn, true, hhmmOK(gEnd))} placeholder="HH:MM" maxLength={5} value={gEnd} data-testid="pln-gnd-end"
                         onChange={e => setGEnd(normTime(e.target.value))} />
                </div>
                <div style={{ fontSize:10, color:C.t3, fontFamily:'var(--mono)', paddingBottom:9 }}>
                  PLN {isoToHHMM(duty.report_time) || '—'}–{isoToHHMM(duty.duty_end) || '—'}
                  {duty.ground_kind === 'sim' && (
                    <div style={{ color:C.accent }}>+60 MIN DEBRIEF AFTER THE SIM (Md.10/c)</div>
                  )}
                </div>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14 }}>
                <button style={S.btnS} onClick={() => setStep('ask')} disabled={busy}>BACK</button>
                <button style={{ ...S.btnP, opacity: busy ? .45 : 1 }} disabled={busy}
                        onClick={saveGround}>{busy ? 'SAVING...' : 'SAVE AS DONE'}</button>
              </div>
            </>
          )}

          {step === 'notflown' && (
            <>
              <div style={{ ...S.note, borderLeftColor:C.red, color:C.red }}>
                The planned duty will be CANCELLED for the whole crew
                {ekipPilotlari.length > 1 ? <> (<b data-testid="iptal-ekip">{ekipPilotlari.map(nameOf).join(', ')}</b>)</> : ''}.
                It stays in the record and in the audit trail — it is not deleted — but it drops out of the roster and
                out of the FTL totals.
              </div>
              <div style={{ marginTop:14 }}>
                <span style={S.label}>What was this day? *{ekipPilotlari.length > 1 ? ' — applies to every pilot of the crew' : ''}</span>
                <div style={{ display:'flex', gap:8, marginTop:6 }}>
                  {[['empty', 'EMPTY DAY'], ['stby', 'STANDBY'], ['off', 'OFF']].map(([v, lb]) => (
                    <div key={v} onClick={() => setNature(v)} style={chip(nature === v)}>{lb}</div>
                  ))}
                </div>
              </div>

              {nature === 'stby' && (
                <div style={{ marginTop:14 }}>
                  <span style={S.label}>Standby kind</span>
                  <div style={{ display:'flex', gap:8, margin:'6px 0 12px' }}>
                    {[['airport_standby', 'AIRPORT STANDBY · Md.17/1'],
                      ['other_standby', 'OTHER STANDBY · Md.17/2']].map(([v, lb]) => (
                      <div key={v} onClick={() => setSbKind(v)}
                           style={{ padding:'8px 14px', fontSize:10, fontWeight:700, letterSpacing:1,
                                    cursor:'pointer', fontFamily:'var(--mono)', borderRadius:6,
                                    border:`1px solid ${sbKind === v ? C.accent : C.border2}`,
                                    color: sbKind === v ? C.accent : C.t3 }}>{lb}</div>
                    ))}
                  </div>
                  <div style={{ display:'flex', gap:14 }}>
                    <div><span style={S.label}>Start (UTC) *</span>
                      <input {...zAlan(tIn, true, hhmmOK(sbStart))} data-testid="pln-sb-start" placeholder="HH:MM" maxLength={5} value={sbStart}
                             onChange={e => setSbStart(normTime(e.target.value))} /></div>
                    <div><span style={S.label}>End (UTC) *</span>
                      <input {...zAlan(tIn, true, hhmmOK(sbEnd))} data-testid="pln-sb-end" placeholder="HH:MM" maxLength={5} value={sbEnd}
                             onChange={e => setSbEnd(normTime(e.target.value))} /></div>
                  </div>
                  <div style={{ ...S.note, marginTop:10 }}>
                    Hours are mandatory — a standby with no hours cannot be recorded, and without
                    them the rules cannot reduce the maximum FDP (SHT-FTL/HG Md.17).
                  </div>
                </div>
              )}

              {nature === 'off' && (
                <div style={{ marginTop:14, width:260 }}>
                  <span style={S.label}>OFF type</span>
                  <select style={S.input} value={offSubtype} onChange={e => setOffSubtype(e.target.value)}>
                    {(offTypes || []).map(t => <option key={t.code} value={t.code}>{t.code}{t.label ? ` — ${t.label}` : ''}</option>)}
                    {!(offTypes || []).length && <option value="OFF">OFF</option>}
                  </select>
                  <div style={{ marginTop:10, width:300 }}>
                    <OffYeriSecici value={offLoc} onChange={setOffLoc} testId="iptal-off-yeri"
                                   evler={ekipPilotlari.map(pid => (pilotDilim[pid]?.kaynak === 'own' ? pilotDilim[pid].icao : null))} />
                  </div>
                  {ekipPilotlari.flatMap(pid => gecTebligUyarisi([duty.duty_date], effectiveRules(duty.ruleset_snapshot || ruleset).rules,
                      bosGunDilimi(offYeriKaydi(offLoc, pilotDilim[pid]), pilotDilim[pid]?.tz || null),
                      { offTypes, subtype: offSubtype }).map(m => (ekipPilotlari.length > 1 ? `${nameOf(pid)} ${m}` : m))).map(m => (
                    <div key={m} style={{ ...S.note, marginTop:8, borderLeftColor:C.accent, color:C.accent, fontSize:11 }}
                         data-testid="off-gec-teblig-uyari">{m}</div>
                  ))}
                </div>
              )}

              <div style={{ marginTop:14 }}>
                <span style={S.label}>Reason / report *</span>
                <HarfliGiris as="textarea" {...zAlan({ ...S.input, minHeight:64, resize:'vertical' }, true, gerekceTamam(reason))}
                          data-testid="pln-gerekce" value={reason}
                          onChange={setReason}
                          placeholder="Why did this duty not take place?" />
                <GerekceIpucu metin={reason} testid="pln-gerekce-ipucu" />
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14 }}>
                <button style={S.btnS} onClick={() => setStep('ask')} disabled={busy}>BACK</button>
                <button style={{ ...S.btnSil, borderWidth:2, opacity: busy || !gerekceTamam(reason) ? .45 : 1 }}
                        disabled={busy || !gerekceTamam(reason)} data-testid="pln-iptal-onay"
                        onClick={saveNotFlown}>{busy ? 'SAVING...' : 'CANCEL DUTY'}</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// DUTY HISTORY tablo satırının günü — sayfa GÜNLE bölünür (aynı günün görevleri aynı sayfada; 6 Eki 2026).
const dhSatirGunu = (item) => (item.kind === 'empty' ? item.date : (item.d?.duty_date || ''));

// ── TABLE EN FAZLA 24 AY (6 Eki 2026) ─────────────────────────────────────────────────────────────────────────────
// 🔑 Serkan: *"table görünüm içinde 24 ay bence yeterli, zaten yıl yıl seçip gösterebilirim"* (C). Sınır ARALIĞIN
//    UZUNLUĞU içindir, ne kadar geriye gidildiği için değil (*"30 ay - 10 ay geçmiş göster desek gösterecek"* — evet:
//    FTL açılışı bütün geçmişi okur). Ay çizelgesi tek ay gösterir, sınır ona değmez.
// 🔴 ÖNCESİ: tablo gün gün kurulurken 800 günde SESSİZCE kesiliyordu (ekran VE baskı) — uzun aralık "bu aralığın
//    raporu" gibi görünüp sonu eksik basılırdı. Şimdi uzun aralıkta tablo ve baskı YARIM çizilmez, uyarı çıkar.
export const DH_AZAMI_AY = 24;
/** From gününden başlayan 24 ayın son günü ('YYYY-MM-DD'): 2024-01-01 → 2025-12-31 · 2024-02-29 → 2026-02-28. */
export const dhAzamiBitis = (from) => {
  const t = new Date(`${from}T00:00:00Z`);
  if (Number.isNaN(t.getTime())) return null;
  return new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + DH_AZAMI_AY, t.getUTCDate()) - 864e5).toISOString().slice(0, 10);
};

// ═══ 2) DUTY HISTORY ══════════════════════════════════════════════
function DutyHistory({ pilots, duties, ucuslar = {}, baselines, offTypes, ruleset, homeBases,
                       pilotDilim, toast, myProfile, reload, readOnly, lisansMed = {}, dutyLocations, addLocation,
                       aircraft = [], tipVasiflari = {} }) {
  const flyable = pilots.filter(ucusEkibindenMi);
  const [pilotId, setPilotId] = useState('');
  // PLN ? · OPEN ? · RECORD AS FLOWN · MATCH REVIEW — ortak `useGorevSonucu` (21 Eki 2026: ROSTER'ın görev kartı da AYNI
  // pencereleri açar). Adlar bu ekranın eski adları — rozetler ve kutu aynı çağrılarla açar.
  const { plnSor: setResolving, acikKapat, incele: setReviewing, pencereler: sonucPencereleri } = useGorevSonucu({
    duties, pilots, ucuslar, myProfile, toast, homeBases, pilotDilim, ruleset, baselines, offTypes, lisansMed, aircraft,
    tipVasiflari, reload });
  useEffect(() => { if (!pilotId && flyable.length) setPilotId(flyable[0].id); }, [flyable, pilotId]);

  // Secili pilotun ana us dilimi — PANELDE tek yerde cozuldu (`pilotDilim`).
  // Eskiden burada kendi cozucusu vardi; ayni soruyu iki yerde sormak, ucuncu
  // ekranda hic sormamaya goz yumduruyordu (Ilke 3).
  const dilim = (pilotDilim || {})[pilotId] || { tz: null, icao: null, kaynak: null };
  const hbIcaoTz = dilim.tz;
  // PREVIOUS MONTH DUTY SHEET (1 Eki 2026) — seçili pilotun bir önceki takvim ayı; ölçüler motordan (DutySheet.js).
  const [cizelge, setCizelge] = useState(null);
  // ── AYLIK ÇİZELGE GÖRÜNÜMÜ (3 Eki 2026, FTL adım 4c-2) ───────────────────────────────────────────────────────────
  // 🔑 Serkan: *"duty history sayfası previous month duty gibi tile tile görünsün … bütün ayı görmek farkındalık
  //    veriyor"* · *"geçmiş ay için çizdik, current durum için de aynısı"* · yer **A**: sayfa doğrudan içinde bulunulan
  //    ayın çizelgesiyle açılır, ay ileri-geri; tablo TABLE ile. Kutucuk tıklaması bugünkü rozetlerin akışı (*"planlı
  //    görev ise tıklandığında bugünkü gibi uçuldu mu uçulmadı mı"*): planlı → PLN ?, OPEN → OPEN ?, durum notu → kart.
  const [gorunum, setGorunum] = useState('sheet');
  // Uçulmuş görev → roster'ın EDIT penceresi (aynı grup, aynı pencere).
  const [duzenleGrup, setDuzenleGrup] = useState(null);
  const duzenleAc = (d) => {
    // Roster ile AYNI satır grubu (4 Eki 2026): iptal edilmiş üyeler EDIT'in ekibine girmez.
    const rows = satirGrubu(duties, d);
    setDuzenleGrup({ key: satirGrubuAnahtari(d), rows, head: rows[0] || d });
  };
  const [gosterilenAy, setGosterilenAy] = useState(() => buAy());

  // Tarih aralığı — varsayılan: bugün −15 / +15 gün, UTC (`varsayilanAralik`, 30 Eyl 2026).
  const [from, setFrom] = useState(() => varsayilanAralik().from);
  const [to, setTo] = useState(() => varsayilanAralik().to);

  // ── İPTAL EDİLEN GÖREV DUTY HISTORY'YE GİRMEZ (4 Eyl 2026, Serkan) ──
  //
  // 🔑 Serkan: *"Assign duty'de iptal edilen OFF görünüyor cancel olarak — o
  //    OK, rosteringde değişimin görünmesi bir derece mantıklı. Ama duty
  //    history'de görünmemeli."*
  //
  // 🔴 ÖLÇÜLDÜ — ekran kendi kendisiyle çelişiyordu: tabloda 4 OFF satırı,
  //    hemen altında "3 valid / 3 recorded" ve "OFF DAYS 4". `daysOffSummary`
  //    iptali eliyordu, bu liste elemiyordu. Üstelik `srcBadge` `planned` ve
  //    `open` dışındaki her şeye ACT diyor — iptal edilmiş bir görev
  //    "gerçekleşti" rozetiyle duruyordu (İlke 1: olmamış şey olmuş gösterilmez).
  //
  // ⚠️ SİLME DEĞİL, GÖRÜNÜM: kayıt yerinde durur ve rosteringde iptal olarak
  //    görünür (İlke 4 — denetim izi silinmez). Burası "ne oldu" listesidir;
  //    iptal edilen görev olmamıştır.
  //
  // Süzgeç TEK YERE konur: `timeline`, `summary` ve PRINT/PDF hepsi `rows`tan
  // türer (İlke 3) — dördü birden düzelir.
  const rows = useMemo(() => duties
    .filter(d => d.pilot_id === pilotId)
    .filter(d => d.status !== 'cancelled')
    .filter(d => (!from || (d.duty_date || '') >= from) && (!to || (d.duty_date || '') <= to))
    .sort((a, b) => new Date(a.report_time || a.duty_date) - new Date(b.report_time || b.duty_date)),
  [duties, pilotId, from, to]);
  const baseline = baselines[pilotId];
  const pilot = pilots.find(p => p.id === pilotId);

  const rulesNow = useMemo(() => effectiveRules(ruleset).rules, [ruleset]);
  // ── PAPER OFP / NO DOCS (5 Eki 2026, Serkan B) ────────────────────────────────────────────────────────────────
  // 2 Eki kararı: evrak zorunlu değil; evraksız kâğıt uçuş ARCHIVED FLTS'te ve DUTY HISTORY'de NO DOCS ile görünür
  // (unutulmasın). B: PAPER OFP ekranda VE baskıda (kaydın kendisine dair bilgi), NO DOCS yalnız ekranda (ofisin işi).
  // Seçili pilotun uçuş görevlerinin anahtarları okunur; okunamazsa işaret çizilmez, sebebi yazar (bilinmiyor ≠ yok).
  const pilotUcusAnahtarlari = useMemo(() => [...new Set((duties || [])
    .filter(d => d.pilot_id === pilotId && d.duty_type === 'flight' && d.status !== 'cancelled')
    .map(kagitAnahtari).filter(Boolean))], [duties, pilotId]);
  const [kagitOkuma, setKagitOkuma] = useState({ anahtarlar: null, evrakli: null, hata: null });
  useEffect(() => {
    let dead = false;
    (async () => {
      try {
        const k = await canliKagitAnahtarlari(pilotUcusAnahtarlari);
        const e = k.anahtarlar?.size ? await evrakliKagitAnahtarlari([...k.anahtarlar]) : { anahtarlar: new Set() };
        if (!dead) setKagitOkuma({ anahtarlar: k.anahtarlar, evrakli: e.anahtarlar, hata: k.hata || e.hata || null });
      } catch (err) {
        if (!dead) setKagitOkuma({ anahtarlar: null, evrakli: null, hata: String(err?.message || err) });
      }
    })();
    return () => { dead = true; };
  }, [pilotUcusAnahtarlari]);
  const kagit = useMemo(() => ({ ...kagitOkuma, ucuslar }), [kagitOkuma, ucuslar]);
  const ayVeri = useMemo(() => (pilot ? gorevCizelgesi({ duties, pilotId, baseline: baseline || null, rules: rulesNow,
    tz: hbIcaoTz, offTypes, ...gosterilenAy, kagit }) : null),
    [pilot, duties, pilotId, baseline, rulesNow, hbIcaoTz, offTypes, gosterilenAy, kagit]);
  const ayHtml = useMemo(() => (ayVeri ? cizelgeHtml(ayVeri, { pilot, ussu: dilim.icao, baseline: baseline || null }) : ''),
    [ayVeri, pilot, dilim.icao, baseline]);
  // DURUM KARTI — kural ihlali kartının aynısı: her sebep ayrı satır, ⓘ madde metni + ne yapmalı (`durumNeYapmali`).
  const durumKartiAc = (d) => durumKartiGoster(d, { toast, kod: pilot?.code });
  // Tablodaki satırın açtığı pencere (Serkan 3 Eki: *"ilgili güne tıklayınca aynı fonksiyon açılmalı"*).
  const kagitTikla = ({ durum, review, gorev }) => {
    const d = (duties || []).find(x => x.id === (durum || review || gorev));
    if (!d) return;
    if (durum) { durumKartiAc(d); return; }
    if (readOnly) return;
    if (review) { setReviewing(d); return; }
    if (d.status === 'planned') setResolving(d);
    else if (d.status === 'open') acikKapat(d);
    else duzenleAc(d);
  };

  // ── DİNLENME REMARK'I (19 Eyl 2026, Serkan) ───────────────────────
  // *"Rest kısaltılmış veya görev uzatılmışsa rapor yazılması şartını koşup o
  //  görevin yanına remark koyalım... denetçi remark'ı görür, renk kodu zaten
  //  orange veya amber olur, 'nerede bunun raporu' diye sorar."*
  //
  // 🔴 Bugüne kadar SKPK'sız kısa dinlenme roster'da HİÇ görünmüyordu: kırmızı
  //    gerekçe yalnız düzenleme modalının içindeydi. Denetçinin göreceği yer
  //    ise satırın kendisi.
  // Türetilir, saklanmaz (İlke 3) — kayıt düzeltilince kendiliğinden düşer.
  const dinlenmeRemark = useMemo(() => {
    const m = new Map();
    rows.forEach(d => { const r = dinlenmeDurumu(d, duties); if (r) m.set(d.id, r); });
    return m;
  }, [rows, duties]);

  // ── OFF TO DUTY (4 Eyl 2026, Serkan) ──────────────────────────────
  // *"OFF to duty yazması gerekir — kanunen görev verilebilirse, rest
  //  bölmüyorsa mesela, OFF TO DUTY olur, remark olarak."*
  // Sahada aynı güne OFF + yer dersi "mükerrer kayıt" sanılıyordu; oysa Md.4/ü
  // boş günü yerel GECELERLE tanımlar, gün ortasındaki görev onu düşürmez.
  // Kayıt artık kendini anlatır. Türetilir, saklanmaz (bayatlamasın).
  const offToDutyGunleri = useMemo(() => {
    const m = new Map();
    new Set(rows.filter(d => d.duty_type === 'off').map(d => d.duty_date))
      .forEach(dt => {
        const r = offToDuty(duties, pilotId, dt, rulesNow, { offTypes, tz: hbIcaoTz });
        if (r) m.set(dt, r);
      });
    return m;
  }, [rows, duties, pilotId, rulesNow, offTypes, hbIcaoTz]);

  // ── KESINTISIZ TAKVIM (13 Agu 2026, Serkan) ────────────────────────
  // Eskiden yalniz GOREVLI gunler listeleniyordu; iki ucus arasindaki bos
  // gunler hic gorunmuyordu ve denetci "bu adam 4 gun ne yapti" sorusunu
  // listeden cevaplayamiyordu. Artik araliktaki HER GUN bir satir: gorev
  // varsa gorev, yoksa bos gun satiri.
  // NOT: bos gun "OFF" DEGILDIR — OFF ayrica kaydedilen bir gorev tipidir
  // (Md.5 sayimina girer). Kayitsiz gun yalnizca "kayit yok" demektir ve
  // oyle gosterilir; ikisini karistirmak izni kirletirdi (Ilke 1).
  const timeline = useMemo(() => {
    if (!from || !to || to < from) return rows.map(d => ({ kind:'duty', d }));
    const byDay = new Map();
    rows.forEach(d => {
      const k = d.duty_date || '';
      if (!byDay.has(k)) byDay.set(k, []);
      byDay.get(k).push(d);
    });

    // ── AYNI GÜNE İKİ SATIR YOK (4 Eyl 2026, Serkan: *"NET!"*) ────────
    // 🔑 *"Tek satır. OFF iken sonradan görev girildiyse ve yasal ise
    //    OFF TO DUTY yazacak, o kadar."*
    // 🔴 Saha: 3 Eyl'de hem OFF hem TRAINING satırı vardı; bakan kişi
    //    "mükerrer kayıt" görüyordu. Gün BİR satırdır: o gün ne yapıldıysa o.
    // ⚠️ SÜZGEÇ YALNIZ ÇİZİMDE. `rows` dokunulmaz — OFF kaydı Md.5 sayımını
    //    beslemeye devam eder (o gün hâlâ geçerli bir boş gündür). `rows`u
    //    süzseydik "3 valid / 3 recorded" sessizce 2'ye düşerdi.
    byDay.forEach((liste, gun) => {
      const gorev = liste.filter(d => d.duty_type !== 'off');
      if (gorev.length && gorev.length !== liste.length) byDay.set(gun, gorev);
    });
    // 4 Eki 2026 (A): önceki günden taşan görevin kapsadığı gün AYRI satır almaz — görev satırı "04 OCT — 05 OCT".
    const kapsanan = new Set();
    rows.forEach(d => {
      if (d.duty_type === 'off' || d.status === 'cancelled') return;
      for (let t = gunOf(new Date(Date.parse(`${d.duty_date}T00:00:00Z`) + 86400000).toISOString()); t <= gorevSonGunu(d);
           t = gunOf(new Date(Date.parse(`${t}T00:00:00Z`) + 86400000).toISOString())) kapsanan.add(t);
    });
    const out = [];
    const cur = new Date(from + 'T00:00:00Z');
    const end = new Date(to + 'T00:00:00Z');
    let guard = 0;
    // 800 gün: kaza döngüsüne karşı (yarım yazılan yıl) — tablo en fazla 24 ay (≤ 731 gün) gösterdiği için geçerli
    // bir aralık bu sınıra hiç varmaz; daha uzun aralıkta tablo çizilmez, uyarı çıkar (`aralikUzun`, 6 Eki 2026).
    while (cur <= end && guard++ < 800) {
      const key = cur.toISOString().slice(0, 10);
      const ds = byDay.get(key);
      if (ds && ds.length) ds.forEach(d => out.push({ kind:'duty', d }));
      else if (!kapsanan.has(key)) out.push({ kind:'empty', date: key });
      cur.setUTCDate(cur.getUTCDate() + 1);
    }
    return out;
  }, [rows, from, to]);

  // TABLE en fazla 24 ay (`dhAzamiBitis`) — aşan aralıkta tablo, özet ve PRINT yarım çizilmez, uyarı çıkar.
  const azamiBitis = from ? dhAzamiBitis(from) : null;
  const aralikUzun = !!(from && to && to >= from && azamiBitis && to > azamiBitis);
  const aralikUzunMetni = aralikUzun
    ? `RANGE TOO LONG — the table shows at most ${DH_AZAMI_AY} months. From ${utcGun(`${from}T00:00:00Z`)} the last day you can pick is ${utcGun(`${azamiBitis}T00:00:00Z`)}; narrow the range or pick it year by year.`
    : null;

  // ── TABLO SAYFASI (6 Eki 2026 · 24 ay şartı 3. adım, Serkan B) ───────────────────────────────────────────────────
  // 🔑 Veri zaten TAM (FTL açılışı bütün görevleri parça parça okur — kümülatif limitler bütün geçmişi ister); burada
  //    yalnız ekrandaki TABLO 100 GÜNLÜK sayfalara bölünür. Özet, ay çizelgesi ve PRINT / PDF aralığın TAMAMINDAN
  //    (`rows` / `timeline`). Aralık ya da pilot değişince sayfa 1 (FTL EDIT REPORT ile aynı).
  const [tabloSayfa, setTabloSayfa] = useState(1);
  useEffect(() => { setTabloSayfa(1); }, [pilotId, from, to]);
  const tabloGunleri = useMemo(() => [...new Set(timeline.map(dhSatirGunu))], [timeline]);
  const sayfaTimeline = useMemo(() => {
    const gunler = new Set(tabloGunleri.slice((tabloSayfa - 1) * SAYFA_BOYU, tabloSayfa * SAYFA_BOYU));
    return timeline.filter(item => gunler.has(dhSatirGunu(item)));
  }, [timeline, tabloGunleri, tabloSayfa]);

  // ── DİNLENME SATIRI + GÜNE SARKAN DİNLENME (29 Eyl 2026) ─────────────────
  // 🔑 Serkan: *"ertesi güne sarkması lazım, rest görünmeli … 23:00–11:00"* ·
  //    *"aylık çıktıda bütün günler görünmeli — boş, görevli veya restli"*.
  // Ekran ve aylık çıktı AYNI metni buradan alır (tek kaynak). Pencere motorda
  // türetilir (`dinlenmePenceresi` / `gunDinlenmesi`), saklanmaz.
  // Sarkma pilotun BÜTÜN görevlerinden bakılır: `rows` aralığa süzülmüştür ve
  // aralığın ilk gününe önceki günden sarkan dinlenme kaçmamalı.
  const pilotGorevleri = useMemo(() => (duties || [])
    .filter(d => d.pilot_id === pilotId && d.status !== 'cancelled'), [duties, pilotId]);
  const saatUTC = (iso) => fmtDT(iso).slice(-5);
  /** Görevin altındaki REST satırının metni; OFF/iptalde null. */
  const dinlenmeMetni = (d) => {
    const p = dinlenmePenceresi(d);
    if (!p) return null;
    if (p.olculemedi) {
      return { metin: 'REST NOT RECORDED — this duty has no rest end time', olculemedi: true, planli: p.planli };
    }
    const dk = p.dk ?? Math.round((Date.parse(p.bitisISO) - Date.parse(p.basISO)) / 60000);
    return { metin: `${fmtDT(p.basISO)} → ${fmtDT(p.bitisISO)} · ${fmtMin(dk)} · SHT-FTL/HG Md.16`
                    + (p.planli ? ' · PLN' : ''),
             olculemedi: false, planli: p.planli };
  };
  /** Kaydı OLMAYAN güne sarkan dinlenmenin metni; yoksa null. */
  const gunDinlenmeMetni = (gun) => {
    const p = gunDinlenmesi(pilotGorevleri, gun);
    if (!p) return null;
    const gunBas = Date.parse(`${gun}T00:00:00Z`), gunSon = gunBas + 86400000;
    const bas = Date.parse(p.basISO) >= gunBas ? saatUTC(p.basISO) : null;   // bu gün içinde başladıysa
    const bit = Date.parse(p.bitisISO) <= gunSon ? saatUTC(p.bitisISO) : null; // bu gün içinde bittiyse
    const metin = bas && bit ? `REST ${bas} → ${bit}`
      : bit ? `REST until ${bit}`
      : bas ? `REST from ${bas} (until ${fmtDT(p.bitisISO)})`
      : `REST all day (until ${fmtDT(p.bitisISO)})`;
    return { metin: metin + (p.planli ? ' · PLN' : ''), planli: p.planli };
  };
  /** Ekran: görevin hemen altındaki REST satırı (11 kolon). */
  const dinlenmeSatiri = (item) => {
    if (item.kind !== 'duty') return null;
    const r = dinlenmeMetni(item.d);
    if (!r) return null;
    return (
      <tr key={`rest_${item.d.id}`} data-testid={`rest-row-${item.d.id}`}
          style={{ borderBottom:`2px solid ${C.border2}` }}>
        <td style={S.td}></td>
        <td style={S.td}><span style={badge(r.olculemedi ? 'amber' : 'dim')}>REST</span></td>
        <td colSpan={9} style={{ ...S.td, fontWeight:600,
            color: r.olculemedi ? 'var(--amber)' : (r.planli ? C.t3 : C.green) }}>{r.metin}</td>
      </tr>
    );
  };


  // Kümülatif özet — PLN (planned) satırlar toplamlara girmez
  const summary = useMemo(() => {
    const s = { pfCount:0, pfMin:0, pmCount:0, pmMin:0, fltDays:0, gndDays:0, dhDays:0, offDays:0, dutyMin:0 };
    rows.forEach(d => {
      const actual = d.status !== 'planned';
      if (d.duty_type === 'off') { s.offDays++; return; }
      if (!actual) return;
      if (d.duty_type === 'flight') s.fltDays++;
      if (d.duty_type === 'ground') s.gndDays++;
      if (d.duty_type === 'dh') s.dhDays++;   // DH artik kendi tipi, GND sayacina karismaz
      if (d.report_time && d.duty_end) s.dutyMin += (new Date(d.duty_end) - new Date(d.report_time)) / 60000;
    });
    // Blok toplamları TEK HESAPTAN (`blokToplamlari`, 21 Eki 2026) — DH bacağı PF'ye girmez, DUTY SHEET ile aynı.
    const blok = blokToplamlari(rows.filter(d => d.status !== 'planned'));
    s.pfCount = blok.pf.n; s.pfMin = blok.pf.dk; s.pmCount = blok.pm.n; s.pmMin = blok.pm.dk;
    if (blok.crz.n) { s.crzCount = blok.crz.n; s.crzMin = blok.crz.dk; }
    // Md.5 — bos gunler: aralikta KAC TANESI gecerli (2 yerel gece sarti) ve
    // takvim yili toplami 96'ya gore nerede. Yerel gece ana us diliminde olculur.
    const myDuties = (duties || []).filter(d => d.pilot_id === pilotId);
    const tz = hbIcaoTz;
    const yearNum = Number(String(to).slice(0, 4));
    // 4 Eki 2026 (Md.5(1)(c)): baseline'ın yıl tabanı (OFF DAYS — CAL YEAR) eklenir.
    // 🔴 4 Eki 2026 (CI "+3 ay" koşusu, 4 Oca 2027): aralık yıl dönümünü geçince "IN RANGE" yalnız `to`nun yılından
    //    sayılıyordu — 30 Ara OFF'u "0 recorded" görünüyordu, toplam satırı "OFF DAYS 2" derken. Aralığın HER yılı sayılır;
    //    takvim yılı satırı aralığın son yılıdır. Baseline'dan tamamen önceki yıl (oncesi) aralığa bir şey katmaz.
    const yilBas = Number(String(from).slice(0, 4));
    const ozetler = [];
    for (let y = Math.min(yilBas, yearNum); y <= yearNum; y++) {
      ozetler.push(daysOffSummary(myDuties, rulesNow, { year: y, tz, offTypes, baseline: baseline || null }));
    }
    const yr = ozetler[ozetler.length - 1];
    const sayilan = ozetler.filter(o => !o.oncesi);
    // KAYIT ile OLCUM ayri: kac OFF GIRILDIGI dilimden bagimsiz bilinir,
    // kacinin Md.4(u)'ye gore GECERLI oldugu bilinmez (iki yerel gece gerekir).
    s.offMeasured = sayilan.every(o => o.measured);
    s.offYearMeasured = yr.measured;
    s.offValidInRange = s.offMeasured
      ? sayilan.flatMap(o => o.valid).filter(d => d >= from && d <= to).length : null;
    s.offRecordedInRange = ozetler.flatMap(o => o.offDates).filter(d => d >= from && d <= to).length;
    s.offYear = yr.count; s.offYearRequired = yr.required;
    s.offYearNeden = bosGunOlcumsuzNedeni(yr); s.offYearTaban = bosGunTabanMetni(yr);
    return s;
  }, [rows, duties, pilotId, hbIcaoTz, rulesNow, offTypes, from, to, baseline]);

  // PLN ROZETI TIKLANIR (15 Agu 2026, Serkan): planlanan gorevin gerceklesip
  // gerceklesmedigi buradan kapatilir. Salt-okunur gorunumde (pilot kendi
  // raporuna bakiyor) rozet duz kalir — kayit degistirmek admin isidir.
  const srcBadge = (d) => {
    if (d.status !== 'planned') {
      // ── OPEN ROZETI DE TIKLANIR (22 Agu 2026) ────────────────────────
      // 🔴 Sahada: 22 Agu gorevi `OPEN` kaldi. Ilk bacaktan sonra End Flt'te
      //    "DUTY FINISHED?" sorusuna dogru olarak NO denmisti (ikinci bacak
      //    gelecekti); son bacaktan sonra YES kaydi YOK. Sonuc: ucuslar bitti,
      //    gun bitti, gorev hala acik — ve KAPATMANIN HICBIR YOLU YOKTU.
      //    Rozet oluydu, yalniz PLN tiklanabiliyordu.
      // 🔑 Bugunun uc bulgusu ayni sinifta: sistem bir duruma sokuyor, o
      //    durumdan CIKIS yolu koymuyor (yer gorevi PLN, match_review, ve bu).
      //    Acik gorev artik gercek saatleriyle kapatilabilir.
      if (d.status === 'open') {
        return readOnly
          ? <span style={badge('amber')}>OPEN</span>
          : <span data-testid="open-badge"
                  onClick={() => acikKapat(d)}
                  title="Duty never closed — click to close it with the actual times"
                  style={{ ...badge('amber'), cursor:'pointer', borderStyle:'dashed' }}>OPEN ?</span>;
      }
      return <span style={badge('green')}>ACT</span>;
    }
    if (readOnly) return <span style={badge('dim')}>PLN</span>;
    return (
      <span onClick={() => setResolving(d)} title="Did this planned duty take place?"
            style={{ ...badge('dim'), cursor:'pointer', borderStyle:'dashed' }}>PLN ?</span>
    );
  };

  // Yazdırma: tüm sayfa yerine SADECE rapor içeriği — beyaz kâğıt formatında
  // ayrı pencerede kümülatif uçuş/görev süresi raporu üretir.
  const printReport = () => {
    if (!pilot) return;
    if (aralikUzun) { toast(aralikUzunMetni, 'error'); return; }   // yarım rapor basılmaz
    // Bir görevin çıktı satırları (bacaklar + remark satırları).
    const gorevHtml = (d) => {
      const actual = d.status !== 'planned';
      const st = d.status === 'planned' ? 'PLN' : d.status === 'open' ? 'OPEN' : 'ACT';
      const dutyT = d.report_time && d.duty_end ? fmtMin((new Date(d.duty_end) - new Date(d.report_time)) / 60000) : '—';
      if (d.duty_type === 'flight' && (d.sectors || []).length) {
        const ab = bacakArtiBir(d);
        const secRows = d.sectors.map((l, i) => {
          const blkS = l.off_block || l.etd, blkE = l.on_block || l.eta;
          const [abS, abE] = ab(i);
          return `<tr class="${actual ? '' : 'pln'}">
            <td>${i === 0 ? esc(gorevTarihi(d)) : ''}</td><td>${i === 0 ? 'FLT' : ''}</td>
            <td>${esc(l.dep)}–${esc(l.dest)}${l.actual_dest && l.actual_dest !== l.dest ? '&gt;' + esc(l.actual_dest) + ' DVT' : ''}${kagitGorevDurumu(d, kagit).bacak(l) ? ' <span style="border:1px solid #854f0b;color:#854f0b;font-size:9px;padding:0 3px;margin-left:4px">PAPER OFP</span>' : ''}</td><td>${esc(blkS)}${abS}–${esc(blkE)}${abE}</td>
            <td>${fmtMin(spanMin(blkS, blkE))}</td><td class="role">${esc(l.role || 'PF')}</td>
            <td>${i === 0 ? dutyT : ''}</td><td>${i === 0 ? st : ''}</td></tr>`;
        }).join('');
        // NOBET DAYANAGI RAPORDA (Md.17): azami UGS kisaltilmissa denetci
        // "neden kisa" sorusunu raporun kendisinden cevaplayabilmeli — baska
        // ekrana bakmak zorunda kalmamali. standby_ref kayitta DONMUS ozettir.
        const sbRow = d.standby_reduction_min > 0
          ? `<tr class="${actual ? '' : 'pln'}"><td></td><td></td><td colspan="6" class="sb">STANDBY (SHT-FTL/HG Md.17) — MAX FDP ${fmtMin(d.max_fdp_minutes)} AFTER −${fmtMin(d.standby_reduction_min)} · ${esc(d.standby_ref || '')}</td></tr>`
          : '';
        // SKPK RAPORDA (Md.12): komutan karariyla degistirilmis bir UGS/dinlenme
        // denetimin ilk bakacagi seydir — kaptan raporunun ozeti ve SHGM
        // yukumlulugunun durumu raporun kendisinde durur.
        // İNTİBAK RAPORDA (Md.22/1): azami UGS'nin HANGİ MEYDANIN saatiyle
        // okunduğu, kalkış meydanından farklıysa denetim için kritiktir.
        const acclRow = (d.acclimatised_to &&
          String(d.acclimatised_to).toUpperCase() !== String((d.sectors || [])[0]?.dep || '').toUpperCase())
          ? `<tr class="${actual ? '' : 'pln'}"><td></td><td></td><td colspan="6" class="sb">ACCLIMATISED TO ${esc(d.acclimatised_to)} (SHT-FTL/HG Md.22/1) — Table 1 band read in that aerodrome's local time, not ${esc((d.sectors || [])[0]?.dep || '?')}</td></tr>`
          : '';
        const skpkRow = ((d.skpk_fdp_extension_min || 0) > 0 || (d.skpk_rest_reduction_min || 0) > 0)
          ? `<tr class="${actual ? '' : 'pln'}"><td></td><td></td><td colspan="6" class="sb">COMMANDER'S DISCRETION (SHT-FTL/HG Md.12) — FDP +${fmtMin(d.skpk_fdp_extension_min || 0)} · REST −${fmtMin(d.skpk_rest_reduction_min || 0)} · MAX FDP ${fmtMin(d.max_fdp_minutes)} · NEXT REST ${fmtMin(d.min_rest_minutes)}`
            + (d.skpk_authority_due
                ? ` · DGCA DUE ${esc(fmtD(d.skpk_authority_due))} ${d.skpk_authority_reported_at ? `— SENT ${esc(fmtD(d.skpk_authority_reported_at))}` : '— <b>NOT SENT</b>'}`
                : ' · operator report only')
            + `${d.skpk_reason ? ` · ${esc(d.skpk_reason)}` : ''}</td></tr>`
          : '';
        // TANIMSIZ MEYDAN RAPORDA (21 Eyl 2026): gece/gunduz ve yerel saat bu
        // gorevde KOORDINATTAN degil BEYANDAN okundu. Denetci raporun kendisinden
        // gormeli — hangi meydan, kimin beyaniyla, hangi saatlerle. Baska ekrana
        // bakmak zorunda kalirsa remark isini yapmamis olur.
        const adHocRow = (() => {
          const b = d.ad_hoc_airports;
          const kodlar = b ? Object.keys(b) : [];
          if (!kodlar.length) return '';
          const ozet = kodlar.map(k => {
            const a = b[k] || {};
            const saat = a.sunrise_utc && a.sunset_utc
              ? `SR ${esc(a.sunrise_utc)}Z / SS ${esc(a.sunset_utc)}Z`
              : 'POLAR DAY/NIGHT — DAY/NIGHT NOT MEASURED';
            return `${esc(k)} ${esc(a.name || '?')} · UTC${esc(dakikaFark(a.utc_offset_min))} · ${saat}`;
          }).join(' | ');
          return `<tr class="${actual ? '' : 'pln'}"><td></td><td></td><td colspan="6" class="sb">`
            + `NOT IN AD DATABASE — declared for this duty only, not added to the aerodrome `
            + `database: ${ozet}</td></tr>`;
        })();
        return secRows + acclRow + sbRow + skpkRow + adHocRow;
      }
      const kind = d.duty_type === 'off' ? `OFF · ${esc(d.off_subtype || '—')}`
        : `GND · ${esc(d.ground_kind === 'sim' ? simEtiketi(d) : (d.ground_kind || '—').toUpperCase())}${d.ground_kind === 'airport_standby' ? ' (Md.17/1)' : d.ground_kind === 'other_standby' ? ' (Md.17/2)' : ''}`;
      return `<tr class="${actual ? '' : 'pln'}"><td>${esc(gorevTarihi(d))}</td><td>${dutyTypeLabel(d)}</td>
        <td colspan="4">${kind}</td><td>${d.duty_type === 'off' ? '—' : dutyT}</td><td>${st}</td></tr>`;
    };
    // Görevin altındaki REST satırı — ekrandakiyle AYNI metin (dinlenmeMetni).
    const dinlenmeHtml = (d) => {
      const r = dinlenmeMetni(d);
      if (!r) return '';
      return `<tr class="rest${r.planli ? ' pln' : ''}"><td></td><td>REST</td>`
        + `<td colspan="6">${r.olculemedi ? `<b>${esc(r.metin)}</b>` : esc(r.metin)}</td></tr>`;
    };
    // ── AYIN BÜTÜN GÜNLERİ (29 Eyl 2026) ─────────────────────────────────
    // 🔑 Serkan: *"aylık çıktıda görev atanmamış günler görünmüyor — 30 gün
    //    görünmeli, boş veya görevli veya restli fark etmez."* Çıktı artık
    //    ekranın zaman çizelgesinden üretilir: her gün bir satır, gün BİR
    //    satırdır (4 Eyl kuralı — OFF + görev aynı günse görev yazılır, ekranla
    //    aynı). Kaydı olmayan gün boş geçilmez: sarkan dinlenme varsa o yazılır.
    const dRows = timeline.map(item => {
      if (item.kind === 'empty') {
        const gd = gunDinlenmeMetni(item.date);
        return `<tr class="${gd ? 'rest' : 'bos'}${gd?.planli ? ' pln' : ''}"><td>${esc(fmtD(item.date))}</td>`
          + `<td>${gd ? 'REST' : '—'}</td><td colspan="6">${gd ? esc(gd.metin) : 'no record'}</td></tr>`;
      }
      return gorevHtml(item.d) + dinlenmeHtml(item.d);
    }).join('');
    const w = window.open('', '_blank', 'width=900,height=700');
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>FTL Report — ${esc(pilot.code)}</title><style>
      body{font-family:-apple-system,'Helvetica Neue',sans-serif;color:#0f172a;background:#fff;margin:28px;font-size:12px}
      h1{font-size:15px;letter-spacing:2px;margin:0 0 2px}
      .sub{font-size:10px;color:#64748b;margin-bottom:14px}
      .meta{display:flex;gap:28px;border:1px solid #e2e8f0;border-radius:6px;padding:10px 14px;margin-bottom:14px;background:#f8fafc}
      .meta div{font-size:11px}.meta b{display:block;font-size:9px;color:#64748b;letter-spacing:1px;margin-bottom:2px}
      table{width:100%;border-collapse:collapse;font-family:ui-monospace,Menlo,monospace;font-size:10.5px}
      th{background:#f1f5f9;border-bottom:1px solid #cbd5e1;padding:6px 8px;text-align:left;font-size:9px;letter-spacing:1px;color:#475569}
      td{padding:5px 8px;border-bottom:1px solid #eef2f7}
      tr.pln td{color:#94a3b8;font-style:italic}
      td.role{font-weight:700}
      td.sb{font-size:9.5px;color:#92400e;background:#fffbeb}
      tr.rest td{color:#166534;background:#f0fdf4}
      tr.rest.pln td{color:#94a3b8;background:#fff}
      tr.bos td{color:#94a3b8}
      .baseline{font-size:10px;color:#64748b;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:6px;padding:7px 10px;margin-bottom:10px}
      .sum{margin-top:16px;border:2px solid #0f172a;border-radius:8px;padding:12px 16px}
      .sum h2{font-size:11px;letter-spacing:2px;margin:0 0 8px}
      .sumgrid{display:flex;gap:32px;flex-wrap:wrap}
      .sumgrid div{font-size:11px}.sumgrid b{display:block;font-size:9px;color:#64748b;letter-spacing:1px;margin-bottom:2px}
      .big{font-size:16px;font-weight:800}
      .note{font-size:9px;color:#94a3b8;margin-top:8px}
      @media print{body{margin:10mm}}
    </style></head><body>
      <h1>CREW DUTY &amp; FLIGHT TIME REPORT</h1>
      <div class="sub">GO2 Aviation · Generated ${utcGunAySaat(new Date().toISOString(), { z: true })} · crew_duties</div>
      <div class="meta">
        <div><b>PILOT</b>${esc(pilot.full_name)} (${esc(pilot.code)})</div>
        <div><b>PERIOD</b>${esc(from)} → ${esc(to)}</div>
        <div><b>DUTIES</b>${rows.length}</div>
      </div>
      ${baseline ? `<div class="baseline">BASELINE (carried over, ${esc(fmtD(baseline.effective_date))}): FLT 28d ${fmtMin(baseline.flt_28d_min)} · FLT 12mo ${fmtMin(baseline.flt_12mo_min)} · DUTY 28d ${fmtMin(baseline.duty_28d_min)}</div>` : ''}
      <table><thead><tr><th>DATE</th><th>TYPE</th><th>SECTOR</th><th>BLOCKS</th><th>FLT TIME</th><th>ROLE</th><th>DUTY TIME</th><th>SRC</th></tr></thead>
      <tbody>${dRows || '<tr><td colspan="8">No duties in selected period.</td></tr>'}</tbody></table>
      <div class="sum"><h2>PERIOD TOTALS — ${esc(pilot.code)}</h2>
        <div class="sumgrid">
          <div><b>DAYS OFF IN RANGE (Md.5)</b>${summary.offMeasured
            ? `${summary.offValidInRange} valid / ${summary.offRecordedInRange} recorded`
            : `NOT MEASURED — ${summary.offRecordedInRange} recorded`}</div>
          <div><b>DAYS OFF — CAL YEAR</b>${summary.offYearMeasured && summary.offYear != null
            ? `${summary.offYear} / ${summary.offYearRequired ?? '—'}${summary.offYearTaban}`
            : `NOT MEASURED — ${summary.offYearNeden}`}</div>
          <div><b>SECTORS AS PF</b>${summary.pfCount} · ${fmtMin(summary.pfMin)}</div>
          <div><b>SECTORS AS PM</b>${summary.pmCount} · ${fmtMin(summary.pmMin)}</div>
          ${summary.crzCount ? `<div><b>SECTORS AS CRZ CPT</b>${summary.crzCount} · ${fmtMin(summary.crzMin)}</div>` : ''}
          <div><b>TOTAL FLIGHT TIME</b><span class="big">${fmtMin(summary.pfMin + summary.pmMin)}</span></div>
          <div><b>TOTAL DUTY TIME</b>${fmtMin(summary.dutyMin)}</div>
          <div><b>FLT / GND / DH / OFF DAYS</b>${summary.fltDays} / ${summary.gndDays} / ${summary.dhDays} / ${summary.offDays}</div>
        </div>
        <div class="note">Planned (PLN) duties are listed in italics and excluded from totals. All times UTC.</div>
      </div>
    <script>window.onload=function(){window.print();}</${'script'}></body></html>`);
    w.document.close();
  };

  return (
    <div>
      <div style={{ display:'flex', gap:14, alignItems:'flex-end', marginBottom:16, flexWrap:'wrap' }}>
        <div style={{ width:280 }}>
          <span style={S.label}>Pilot</span>
          <select style={S.input} value={pilotId} onChange={e => setPilotId(e.target.value)}>
            {flyable.map(p => <option key={p.id} value={p.id}>{p.code} — {p.full_name}</option>)}
          </select>
        </div>
        {gorunum === 'sheet' ? (<>
          <AyGezgini ay={gosterilenAy} setAy={setGosterilenAy} etiket={ayVeri?.ayAdi} onek="dh" />
          <div style={{ flex:1 }} />
          <button style={S.btnS} data-testid="dh-gorunum-tablo" onClick={() => setGorunum('table')}
                  title="The duty history as a table, with a date range">TABLE</button>
          <button style={S.btnS} data-testid="dh-cizelge-yazdir" disabled={!ayVeri}
                  onClick={() => cizelgeYazdir(ayHtml, { pilot, veri: ayVeri })}>🖨 PRINT / PDF</button>
        </>) : (<>
        <div style={{ width:160 }}>
          <span style={S.label}>From</span>
          <input type="date" style={S.input} value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div style={{ width:160 }}>
          <span style={S.label}>To</span>
          <input type="date" style={S.input} value={to} onChange={e => setTo(e.target.value)} />
        </div>
        <div style={{ flex:1 }} />
        <button style={S.btnS} data-testid="dh-gorunum-cizelge" onClick={() => setGorunum('sheet')}
                title="The month as a calendar sheet">MONTH SHEET</button>
        <button style={S.btnS} data-testid="duty-sheet-ac" disabled={!pilot}
                title="Calendar sheet of the previous month for the selected pilot — print or save as PDF"
                onClick={() => setCizelge(gorevCizelgesi({ duties, pilotId, baseline: baseline || null, rules: rulesNow,
                  tz: hbIcaoTz, offTypes, ...oncekiAy(), kagit }))}>
          PREVIOUS MONTH DUTY SHEET
        </button>
        <button style={S.btnS} onClick={printReport} disabled={aralikUzun} data-testid="dh-tablo-yazdir"
                title={aralikUzun ? aralikUzunMetni : 'Print the table of the selected period'}>🖨 PRINT / PDF</button>
        </>)}
      </div>
      {cizelge && (
        <DutySheet veri={cizelge} pilot={pilot} ussu={dilim.icao} baseline={baseline || null}
                   onClose={() => setCizelge(null)} />
      )}

      {/* ── ANA US NEREDEN GELDI — SESSIZ DUSUS YOK (21 Eyl 2026) ──────
          Md.4(u) bos gunu IKI YEREL GECE ile tanimlar, Md.4(ff) yerel geceyi
          "yerel saatle 22:00-08:00" der. Dilim nereden okundugu SOYLENMEZSE
          sayac, dayanagi bilinmeyen bir sayi olur (Ilke 1).
          🔑 Serkan: *"home base bos kalamaz"* — sirket vekili DOGRU bir
          olcumdur (pilot ucakla ayni ustedir) ama EKSIK BIR KAYITTIR;
          yazilmazsa kimse doldurmaz. */}
      {dilim.kaynak !== 'own' && (
        <div style={{ marginBottom:12, padding:'8px 12px', borderRadius:4,
                      border:'1px solid var(--orange)', background:'var(--orange-soft)',
                      color:'var(--orange)', fontSize:10, letterSpacing:0.6,
                      fontFamily:'var(--mono)', fontWeight:700 }}>
          {dilim.kaynak === 'company'
            ? `PILOT HOME BASE NOT SET — days off measured in the company base local time (${dilim.icao}). Set it in CREWS & OFFICERS.`
            : 'PILOT HOME BASE NOT SET — days off (Md.5) CANNOT BE MEASURED. A day off is one local day and two local nights (Md.4/ü); local night needs a home base. Set it in CREWS & OFFICERS.'}
        </div>
      )}

      {/* Kâğıt kayıt / evrak okunamadıysa PAPER OFP ve NO DOCS çizilmez — "yok" sanılmasın, sebebi yazar (5 Eki 2026). */}
      {kagitOkuma.hata && (
        <div data-testid="dh-kagit-okuma-hata" style={{ marginBottom:12, padding:'8px 12px', borderRadius:4,
                      border:`1px solid ${C.red}`, background:'var(--red-soft)', color:C.red, fontSize:10,
                      letterSpacing:0.6, fontFamily:'var(--mono)', fontWeight:700 }}>
          PAPER OFP RECORDS / DOCUMENTS COULD NOT BE READ — {kagitOkuma.hata}. PAPER OFP and NO DOCS marks are not shown.
        </div>
      )}

      {gorunum === 'sheet' && (
        <div data-testid="dh-cizelge">
          {ayHtml ? <CizelgeKagidi html={ayHtml} onTikla={kagitTikla} />
            : <div style={{ ...S.panel, padding:14, color:C.t3, fontFamily:'var(--mono)', fontSize:11 }}>SELECT A PILOT</div>}
          <div style={{ marginTop:8, fontSize:9.5, color:C.t3, fontFamily:'var(--mono)', letterSpacing:0.6 }}>
            {readOnly ? 'Click a duty\'s status for its reasons.'
              : 'Click a duty\'s status for its reasons · click a PLANNED duty to record what happened · click an OPEN duty to close it · '
                + 'click a flown duty to EDIT it · click MATCH REVIEW to resolve it.'}
          </div>
        </div>
      )}
      {gorunum === 'table' && aralikUzun && (
        <div data-testid="dh-aralik-uzun" style={{ margin:'0 0 12px', padding:'12px 14px', borderLeft:'3px solid var(--orange)',
             background:C.bg3, color:'var(--orange)', fontSize:11, fontWeight:700, fontFamily:'var(--mono)', lineHeight:1.6 }}>
          {aralikUzunMetni}</div>
      )}
      {gorunum === 'table' && !aralikUzun && (
      <div style={{ ...S.panel }}>
        <div style={S.panelH}>
          <span style={S.panelT}>Duty History — {pilot ? `${pilot.full_name} (${pilot.code})` : ''}</span>
          <span style={{ fontSize:9, color:C.t3, letterSpacing:1, fontFamily:'var(--mono)' }}>crew_duties · per pilot · no delete</span>
        </div>
        {/* Aralıktaki GÜN sayısı + sayfa — ekranda 100 gün; özet ve baskı aralığın tamamından. */}
        <div style={{ ...S.label, padding:'8px 14px 0' }} data-testid="dh-aralik-sayisi">
          {`${tabloGunleri.length} DAYS IN RANGE · PAGE ${tabloSayfa} / ${sayfaSayisi(tabloGunleri.length)}`}</div>
        <div style={{ overflowX:'auto' }}>
          <table style={{ ...S.table, minWidth:980 }}>
            <thead><tr>{['DATE', 'TYPE', 'SECTOR', 'BLOCKS', 'FLT TIME', 'DUTY', 'DUTY TIME', 'FDP / MAX', 'MIN REST', 'NEXT DUTY START', 'SRC'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
            <tbody>
              {baseline && tabloSayfa === 1 && (
                <tr style={{ borderBottom:`2px solid ${C.border2}` }}>
                  <td style={{ ...S.td, color:C.t3 }}>{fmtD(baseline.effective_date)}</td>
                  <td style={S.td}><span style={badge('dim')}>BASE</span></td>
                  <td style={{ ...S.td, color:C.t3 }} colSpan={8}>
                    BASELINE — carried over: FLT 28d {fmtMin(baseline.flt_28d_min)} · FLT 12mo {fmtMin(baseline.flt_12mo_min)} · DUTY 28d {fmtMin(baseline.duty_28d_min)} · last recurrent rest {fmtD(baseline.last_recurrent_rest_end)}
                  </td>
                  <td style={S.td}><span style={badge('green')}>ACT</span></td>
                </tr>
              )}
              {/* 29 Eyl 2026: her görevin altına türetilmiş REST satırı eklenir
                  (dinlenmeSatiri) — gün satırı aşağıdaki bloktan, REST ondan sonra. */}
              {sayfaTimeline.map((item, ti) => { const gunSatiri = (() => {
                if (item.kind === 'empty') {
                  // Kaydı olmayan güne önceki görevin dinlenmesi sarkıyorsa O yazılır.
                  const gd = gunDinlenmeMetni(item.date);
                  return (
                    <tr key={`e${item.date}`} style={{ borderBottom:`1px solid ${C.border}` }}>
                      <td style={{ ...S.td, color:C.t3 }}>{fmtD(item.date)}</td>
                      <td style={S.td}><span style={badge('dim')}>{gd ? 'REST' : '—'}</span></td>
                      <td data-testid={`gun-${item.date}`}
                          style={{ ...S.td, color: gd && !gd.planli ? C.green : C.t3, fontStyle: gd ? 'normal' : 'italic',
                                   fontWeight: gd ? 600 : undefined }}>{gd ? gd.metin : 'no record'}</td>
                      {/* 7 -> 8: FDP / MAX kolonu eklendi (26 Agu 2026). Bu sayi
                          atlanirsa bos gun satirlari bir kolon eksik kalir ve
                          tablo kayar — bastan asagi sessizce yanlis hizalanir. */}
                      {Array.from({ length:8 }).map((_, i) =>
                        <td key={i} style={{ ...S.td, color:C.t3 }}>—</td>)}
                    </tr>
                  );
                }
                const d = item.d;
                const legs = d.sectors || [];
                const isPln = d.status === 'planned';
                const dimC = { color: isPln ? C.t3 : 'var(--t1)' };
                if (d.duty_type === 'flight' && legs.length) {
                  const ab = bacakArtiBir(d);
                  const kd = kagitGorevDurumu(d, kagit);
                  return legs.map((l, i) => {
                    const last = i === legs.length - 1;
                    const blkS = l.off_block || l.etd, blkE = l.on_block || l.eta;
                    const [abS, abE] = ab(i);
                    return (
                      <tr key={`${d.id}_${i}`} style={last ? { borderBottom:`2px solid ${C.border2}` } : {}}>
                        <td style={{ ...S.td, ...dimC, borderBottom: last ? undefined : 'none' }}>{i === 0 ? gorevTarihi(d) : ''}</td>
                        <td style={{ ...S.td, borderBottom: last ? undefined : 'none' }}>{i === 0 ? <span style={badge('blue')}>FLT</span> : ''}</td>
                        <td style={{ ...S.td, ...dimC, borderBottom: last ? undefined : 'none' }}>
                          {l.dep}–{l.dest}{l.actual_dest && l.actual_dest !== l.dest ? `>${l.actual_dest} DVT` : ''}
                          {kd.bacak(l) && <span data-testid={`dh-paper-ofp-${d.id}-${i}`} title={PAPER_OFP_IPUCU}
                                                style={{ ...badge('amber'), marginLeft:6 }}>PAPER OFP</span>}
                          {i === 0 && <AdHocRemark duty={d} />}
                          {/* Serkan'in 8 Agu ornegi zaten UCUSTU: *"off tutan
                              pilota ogleden sonra ucus verilebilir."* Rozet ilk
                              bacakta durur — gunun tek satiri odur. */}
                          {i === 0 && <OffGorevRozeti bilgi={offToDutyGunleri.get(d.duty_date)} />}
                        </td>
                        <td style={{ ...S.td, ...dimC, borderBottom: last ? undefined : 'none' }}>{blkS}{abS}–{blkE}{abE}</td>
                        <td style={{ ...S.td, ...dimC, borderBottom: last ? undefined : 'none' }}>{fmtMin(spanMin(blkS, blkE))}</td>
                        <td style={{ ...S.td, ...dimC, borderBottom: last ? undefined : 'none' }}>{i === 0 ? `${fmtDT(d.report_time).slice(-5)}–${fmtDT(d.duty_end).slice(-5)}${artiBir(d.duty_end, d.duty_date)}` : ''}</td>
                        <td style={{ ...S.td, ...dimC, borderBottom: last ? undefined : 'none' }}>{last ? fmtMin(d.report_time && d.duty_end ? (new Date(d.duty_end) - new Date(d.report_time)) / 60000 : null) : ''}</td>
                        <td style={{ ...S.td, borderBottom: last ? undefined : 'none' }}>{last ? <FdpMaxCell d={d} /> : ''}</td>
                        <td style={{ ...S.td, color: isPln ? C.t3 : C.green, fontWeight:700, borderBottom: last ? undefined : 'none' }}>{last ? fmtMin(d.min_rest_minutes) : ''}</td>
                        <td style={{ ...S.td, color: isPln ? C.t3 : C.accent, fontWeight:700, borderBottom: last ? undefined : 'none' }}>{last ? fmtDT(d.earliest_next_report) : ''}</td>
                        <td style={{ ...S.td, borderBottom: last ? undefined : 'none' }}>{last ? <>{srcBadge(d)}{kd.evrakYok && <span data-testid={`dh-no-docs-${d.id}`} title={NO_DOCS_IPUCU}
                                     style={{ ...badge('red'), marginLeft:6, cursor: readOnly ? 'default' : 'pointer' }}
                                     onClick={() => { if (!readOnly) duzenleAc(d); }}>NO DOCS</span>}{d.match_review && <span data-testid="match-review-badge"
                                     style={{ ...badge('red'), marginLeft:6, cursor: readOnly ? 'default' : 'pointer' }}
                                     title={(d.match_review_note || 'Actual match ambiguous.')
                                            + (readOnly ? '' : ' — click to resolve')}
                                     onClick={() => { if (!readOnly) setReviewing(d); }}>MATCH REVIEW</span>}{d.match_review && <InfoDot note={d.match_review_note} />}{d.fdp_exceeded && <><span style={{ ...badge('red'), marginLeft:6 }}>FDP EXC</span>
                                     <InfoDot title="FDP EXCEEDED" note={
                                       `The flight duty period was ${fmtMin(d.fdp_minutes)} `
                                       + `against a maximum of ${fmtMin(d.max_fdp_minutes)}`
                                       + (d.operation_type ? ` for ${opLabel(d.operation_type)}` : '')
                                       + `. The limit comes from the ruleset snapshot stored on this duty, `
                                       + `not from today's ruleset — so the figure cannot change later.`}
                                       rule={`Maximum FDP is read from the ruleset SNAPSHOT stored on this duty, never `
                                       + `from today's ruleset — so a rule change later cannot alter a past flight. `
                                       + `For air taxi (Md.22(2) Table 1) the value comes from the band the report time `
                                       + `falls into, crossed with the sector group (1-4 / 5 / 6+) and the single/dual `
                                       + `pilot column. For general aviation (Md.25) it is a flat ceiling: 12:00 single `
                                       + `pilot, 14:00 dual. There is NO interpolation between bands and no sector `
                                       + `penalty — the figure is read straight from the table.`}
                                       action={`If the commander used discretion, record it as SKPK on this duty and file `
                                       + `the report to the authority — the extension then appears in the limit and the `
                                       + `overshoot clears. If discretion was NOT used, the recorded times are wrong: `
                                       + `open the duty, correct report/end times with a reason, and the limit is `
                                       + `recomputed with the same engine.`} /></>}{d.standby_reduction_min > 0 && <><span style={{ ...badge('amber'), marginLeft:6 }}>SB −{fmtMin(d.standby_reduction_min)}</span>
                                     <InfoDot title="STANDBY REDUCTION" note={
                                       `Standby before this duty reduced the maximum FDP by `
                                       + `${fmtMin(d.standby_reduction_min)}. Reference: ${d.standby_ref || 'SHT-FTL/HG Md.17'}.`}
                                       rule={`Time spent on standby before a duty counts against the FDP that follows it, `
                                       + `so the maximum is reduced. How much counts depends on the standby type: `
                                       + `airport standby (Md.17/1) counts in full, other standby (Md.17/2) counts at 25% `
                                       + `and is itself capped at 16 hours. The reduction is DERIVED from the standby `
                                       + `duty — it is never typed in.`}
                                       action={`Nothing to correct if the standby hours are right. If they are not, edit the `
                                       + `standby duty itself — this reduction is derived from it, not typed in, so it `
                                       + `follows the correction automatically.`} /></>}{((d.skpk_fdp_extension_min || 0) > 0 || (d.skpk_rest_reduction_min || 0) > 0) && <><span style={{ ...badge('amber'), marginLeft:6 }}>SKPK</span>
                                     <InfoDot title="COMMANDER'S DISCRETION" note={
                                       `This duty carries a commander's discretion change: `
                                       + ((d.skpk_fdp_extension_min || 0) > 0 ? `FDP extended by ${fmtMin(d.skpk_fdp_extension_min)}. ` : '')
                                       + ((d.skpk_rest_reduction_min || 0) > 0 ? `Rest reduced by ${fmtMin(d.skpk_rest_reduction_min)}. ` : '')
                                       + `Reference: ${d.skpk_ref || 'SHT-FTL/HG Md.12'}. `
                                       + `The operator must report it to the authority.`}
                                       rule={`Md.12 lets the commander extend an FDP or reduce a rest period when `
                                       + `unforeseen circumstances arise after report time. It is a discretion, not a `
                                       + `planning tool: it cannot be used to build a roster. Every use must be reported `
                                       + `to the authority, and the recorded maximum on this duty already INCLUDES the `
                                       + `extension — which is why the duty is not flagged as exceeded.`}
                                       action={(d.skpk_reason ? `Commander's report IS on file. ` : `⚠ NO COMMANDER'S REPORT ON FILE — Md.12/1/c/1 requires one for every discretion. `)
                                       + (d.skpk_authority_due
                                          ? (d.skpk_authority_reported_at
                                             ? `DGCA copy sent ${fmtD(d.skpk_authority_reported_at)}. `
                                             : `DGCA copy DUE ${fmtD(d.skpk_authority_due)} — NOT SENT YET. `)
                                          : `No DGCA deadline: the change is 01:00 or less, so the operator report is enough (Md.12/1/c/2). `)
                                       + `Do not remove the SKPK record to clear the badge — the change actually happened `
                                       + `and the trail must keep it.`}
                                       maddeRef={d.skpk_ref || 'SHT-FTL/HG Md.12'}
                                       madde={maddeMetni(d.skpk_ref || 'Md.12')} /></>}{(() => {
                                       /* 🔴 SKPK'SIZ KISA DİNLENME — DENETÇİNİN SORACAĞI SATIR (19 Eyl 2026).
                                          SKPK kaydı VARSA yukarıdaki amber rozet zaten anlatıyor; burada
                                          yalnız AÇIKLAMASI OLMAYAN eksik konuşur. İki ayrı renk, iki ayrı
                                          anlam: amber = mevzuatın tanıdığı istisna · orange = açıklanmamış.
                                          Ölçülemeyen hâl ÜÇÜNCÜ bir şeydir ve "kısa değil" demez (İlke 1). */
                                       const dr = dinlenmeRemark.get(d.id);
                                       if (!dr) return null;
                                       if (dr.olculemedi) return (<><span style={{ ...badge('amber'), marginLeft:6 }}>REST NOT MEASURED</span>
                                         <InfoDot title="REST COULD NOT BE MEASURED" testid={`rest-unmeasured-${d.id}`} note={
                                           `The rest before this duty could not be measured: the previous duty `
                                           + (dr.oncekiKusur.length
                                              ? `carries impossible values (${dr.oncekiKusur.join(', ')}).`
                                              : `has no recorded rest time.`)
                                           + ` This is NOT a statement that the rest was legal — it is a statement that `
                                           + `we do not know. Fix the previous duty and this remark clears itself.`}
                                           rule={`A rest figure is DERIVED from the duty that precedes it. When that duty's `
                                           + `own numbers are impossible, anything derived from them is meaningless — so the `
                                           + `system says "not measured" instead of "compliant".`}
                                           action={`Open the previous duty and correct its times. Nothing here needs to be `
                                           + `deleted; the values are wrong, not the record.`} /></>);
                                       // 3 Eki 2026: SKPK rozeti susturur ANCAK kısa dinlenmeyi karşılıyorsa (rapor + kısaltma
                                       // eksiğin tamamı kadar + Md.12 sınırları) — görev durumuyla aynı kaynak (`dinlenmeDurumu`).
                                       if (!dr.kisa || dr.skpkKarsilar) return null;
                                       return (<><span style={{ ...badge('orange'), marginLeft:6 }} data-testid={`rest-short-${d.id}`}>REST SHORT −{fmtMin(dr.eksikMin)}</span>
                                         <InfoDot title="MINIMUM REST NOT COMPLETED" testid={`rest-short-info-${d.id}`} note={
                                           `This duty reported ${fmtMin(dr.eksikMin)} BEFORE the minimum rest was complete. `
                                           + `The earliest lawful report was ${fmtDT(dr.gerekenISO)}. `
                                           + (dr.skpkVar
                                              ? `A commander's discretion (SKPK) is recorded but does not cover it: ${dr.skpkNeden}.`
                                              : `NO COMMANDER'S DISCRETION (SKPK) IS RECORDED against this duty, so there is `
                                                + `no commander's report explaining it.`)}
                                           rule={`Md.16 sets the minimum rest before an FDP: the longer of the previous duty `
                                           + `or 12 hours at home base (10 hours away). The ONLY lawful way to go below it `
                                           + `is Md.12 — a commander's decision taken AFTER report time because of `
                                           + `unforeseen circumstances, capped at 2 hours, never below 10 hours, and always `
                                           + `reported. It is not a planning tool.`}
                                           action={`If the commander did shorten the rest during operations, record it as SKPK `
                                           + `in EDIT DUTY and write the commander's report — the badge then turns amber and `
                                           + `carries the report. If it was a rostering error, it stays as it is: the flight `
                                           + `happened and the record must show it.`}
                                           maddeRef="SHT-FTL/HG Md.16 · Md.12"
                                           madde={maddeMetni('Md.16 Md.12')} /></>);
                                     })()}{d.acclimatised_to && String(d.acclimatised_to).toUpperCase() !== String(legs[0]?.dep || '').toUpperCase() && <><span style={{ ...badge('amber'), marginLeft:6 }}>ACCL {d.acclimatised_to}</span>
                                     <InfoDot title="ACCLIMATISATION" note={
                                       `The crew is acclimatised to ${d.acclimatised_to}, but this duty reports at `
                                       + `${String(legs[0]?.dep || '—').toUpperCase()}. The FDP band is read in the `
                                       + `acclimatised time zone, not local time. Reference: SHT-FTL/HG Md.22(1); `
                                       + `"acclimatised" is defined in Md.4(l) as the body clock being synchronised `
                                       + `to the time zone the crew member is in.`}
                                       rule={`Md.4(l) defines "acclimatised" as the crew member's body clock being `
                                       + `synchronised to the time zone they are in. Md.22(1) then reads the FDP band `
                                       + `from THAT time zone, not from local time at the departure airport. So a crew `
                                       + `still on home-base time flying out of a distant airport keeps the home-base `
                                       + `band, which can be tighter or looser than the local one.`}
                                       action={`Check where the crew actually was before this duty. If they were acclimatised `
                                       + `to the departure airport, correct it on the duty — leaving it wrong reads the FDP `
                                       + `band from the wrong time zone, so the maximum shown is not the one that applies.`} /></>}</> : ''}</td>
                      </tr>
                    );
                  });
                }
                return (
                  <tr key={d.id} style={{ borderBottom:`2px solid ${C.border2}` }}>
                    <td style={{ ...S.td, ...dimC }}>{gorevTarihi(d)}</td>
                    <td style={S.td}><span style={badge(d.duty_type === 'off' ? 'dim' : d.duty_type === 'dh' ? 'blue' : 'amber')}>{dutyTypeLabel(d)}</span>
                      {/* Geç girilen OFF'un üstüne görev girilmişse gün zaten REST — LATE NOTICE rozeti de çıkmaz (13 Eki 2026). */}
                      {d.duty_type === 'off' && !offToDutyGunleri.has(d.duty_date)
                        && <GecTebligRozeti t={gecTeblig(d, rulesNow, bosGunDilimi(d, hbIcaoTz))} />}</td>
                    <td style={{ ...S.td, color:C.t3 }}>
                      {/* DH'nin SEKTORU VAR ve gosterilmeliydi (Serkan, 3 Eyl):
                          *"sector yerine de DH ucula sektor girilmeli."* Bacaklar
                          zaten kayitli (`sectors`, deadhead:true) — yalnizca
                          cizilmiyordu, o yuzden hane bos gorunuyordu. */}
                      {d.duty_type === 'dh'
                        ? ((d.sectors || []).length
                            ? (d.sectors || []).map(x => `${(x.dep || '?').toUpperCase()}–${(x.dest || '?').toUpperCase()}`).join(' · ')
                            : 'DH')
                        : d.duty_type === 'off' ? (d.off_subtype || '—') : d.ground_kind === 'sim' ? simEtiketi(d) : (d.ground_kind || '—').toUpperCase()}
                      {/* 🔑 Serkan (4 Eyl): *"Bunu da SIM yaninda FFS LEVEL D veya
                          FNPT remark olarak gosterelim, duty history'de ve roster'da —
                          ayni OFF TO DUTY gibi."*  Cihaz currency'yi belirler:
                          FFS sayilir, FNPT sayilmaz. */}
                      {d.ground_kind === 'sim' && d.sim_device && (
                        <span data-testid="sim-device"
                              title={d.sim_device === 'FFS_D'
                                ? 'Full flight simulator — the session counts as the programme minimum (3 take-offs and landings) towards FCL.060 recency.'
                                : 'FNPT is not a full flight simulator — FCL.060 recency cannot be drawn from it.'}
                              style={{ ...badge(d.sim_device === 'FFS_D' ? 'blue' : 'dim'), marginLeft:6 }}>
                          {d.sim_device === 'FFS_D' ? 'FFS LEVEL D' : 'FNPT'}
                        </span>
                      )}
                      {/* 🔑 Serkan: *"OFF iken sonradan gorev girildiyse VE YASAL
                          ISE OFF TO DUTY yazacak, o kadar."*  Rozet artik GOREV
                          satirinda — o gunun tek satiri odur. Yasal degilse rozet
                          yok; o atamayi zaten kapi gecirmez. */}
                      {d.duty_type !== 'off' && <OffGorevRozeti bilgi={offToDutyGunleri.get(d.duty_date)} />}
                      {(d.ground_kind === 'airport_standby' || d.ground_kind === 'other_standby') && (
                        <span style={{ ...badge('amber'), marginLeft:6 }}>
                          {d.ground_kind === 'airport_standby' ? 'Md.17/1' : 'Md.17/2'}
                        </span>
                      )}
                    </td>
                    <td style={{ ...S.td, color:C.t3 }}>—</td><td style={{ ...S.td, color:C.t3 }}>—</td>
                    <td style={{ ...S.td, ...dimC }}>{d.report_time ? `${fmtDT(d.report_time).slice(-5)}–${fmtDT(d.duty_end).slice(-5)}${artiBir(d.duty_end, d.duty_date)}` : '—'}</td>
                    <td style={{ ...S.td, ...dimC }}>{d.report_time && d.duty_end ? fmtMin((new Date(d.duty_end) - new Date(d.report_time)) / 60000) : '—'}</td>
                    <td style={S.td}><FdpMaxCell d={d} /></td>
                    <td style={{ ...S.td, color:C.green, fontWeight:700 }}>{d.duty_type === 'off' ? '—' : fmtMin(d.min_rest_minutes)}</td>
                    <td style={{ ...S.td, color:C.accent, fontWeight:700 }}>{d.duty_type === 'off' ? '—' : fmtDT(d.earliest_next_report)}</td>
                    <td style={S.td}>{srcBadge(d)}</td>
                  </tr>
                );
              })(); return [gunSatiri, dinlenmeSatiri(item)]; })}
              {!rows.length && !baseline && (
                <tr><td style={{ ...S.td, color:C.t3 }} colSpan={11}>No duties recorded for this pilot yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <Sayfalama sayfa={tabloSayfa} toplam={tabloGunleri.length} onSayfa={setTabloSayfa} testid="dh-sayfa" />
        {/* Dönem özeti — PLN hariç kümülatif toplamlar */}
        <div style={{ display:'flex', gap:28, flexWrap:'wrap', padding:'11px 14px', borderTop:`2px solid ${C.border2}`, background:C.bg3, fontFamily:'var(--mono)' }}>
          {[
            ['SECTORS AS PF', `${summary.pfCount} · ${fmtMin(summary.pfMin)}`, false],
            ...(summary.crzCount ? [['SECTORS AS CRZ CPT', `${summary.crzCount} · ${fmtMin(summary.crzMin)}`, false]] : []),
            ['DAYS OFF IN RANGE (Md.5)', summary.offMeasured
              ? `${summary.offValidInRange} valid / ${summary.offRecordedInRange} recorded`
              : `NOT MEASURED — ${summary.offRecordedInRange} recorded`,
              false, summary.offMeasured ? null : 'var(--orange)'],
            ['DAYS OFF — CAL YEAR', summary.offYearMeasured && summary.offYear != null
              ? `${summary.offYear} / ${summary.offYearRequired ?? '—'}${summary.offYearTaban}`
              : `NOT MEASURED — ${summary.offYearNeden}`, false,
              summary.offYearMeasured && summary.offYear != null ? null : 'var(--orange)'],
            ['SECTORS AS PM', `${summary.pmCount} · ${fmtMin(summary.pmMin)}`, false],
            ['TOTAL FLT TIME', fmtMin(summary.pfMin + summary.pmMin), true],
            ['TOTAL DUTY TIME', fmtMin(summary.dutyMin), false],
            ['FLT / GND / DH / OFF DAYS', `${summary.fltDays} / ${summary.gndDays} / ${summary.dhDays} / ${summary.offDays}`, false],
          ].map(([l, v, big, renk]) => (
            <div key={l}>
              <div style={{ fontSize:8.5, color:C.t3, fontWeight:700, letterSpacing:1.2, marginBottom:2 }}>{l}</div>
              <div style={{ fontSize:big ? 15 : 12, fontWeight:700,
                            color: renk || (big ? C.accent : 'var(--t1)') }}>{v}</div>
            </div>
          ))}
          <div style={{ alignSelf:'flex-end', marginLeft:'auto', fontSize:8.5, color:C.t3 }}>PLN excluded from totals</div>
        </div>
        <div style={{ display:'flex', gap:20, flexWrap:'wrap', padding:'9px 14px', borderTop:`1px solid ${C.border}`, fontSize:9.5, color:C.t3, alignItems:'center', fontFamily:'var(--mono)' }}>
          <span><span style={badge('green')}>ACT</span> actual — auto-filled at archive</span>
          <span><span style={{ ...badge('dim'), ...(readOnly ? {} : { borderStyle:'dashed' }) }}>
            PLN{readOnly ? '' : ' ?'}</span> planned — not yet flown{readOnly ? '' : ' · click it to record what happened'}</span>
          <span><span style={badge('amber')}>OPEN</span> duty not finished at archive</span>
          <span><span style={badge('red')}>MATCH REVIEW</span> actual match ambiguous</span>
        </div>
      </div>
      )}

      {sonucPencereleri}

      {duzenleGrup && duzenleGrup.head.duty_type === 'flight' && (
        <EditDutyModal
          group={duzenleGrup} pilots={pilots} duties={duties} ucuslar={ucuslar} myProfile={myProfile}
          toast={toast} homeBases={homeBases} pilotDilim={pilotDilim}
          ruleset={ruleset} baselines={baselines} offTypes={offTypes} lisansMed={lisansMed} aircraft={aircraft} tipVasiflari={tipVasiflari}
          onClose={() => setDuzenleGrup(null)}
          onSaved={() => { setDuzenleGrup(null); reload && reload(); }}
        />
      )}
      {duzenleGrup && duzenleGrup.head.duty_type !== 'flight' && (
        <EditNonFlightModal
          group={duzenleGrup} pilots={pilots} offTypes={offTypes} myProfile={myProfile}
          toast={toast} dutyLocations={dutyLocations} addLocation={addLocation}
          duties={duties} baselines={baselines} ruleset={ruleset} pilotDilim={pilotDilim}
          onClose={() => setDuzenleGrup(null)}
          onSaved={() => { setDuzenleGrup(null); reload && reload(); }}
        />
      )}
    </div>
  );
}

// ═══ 3) RULESET SETTINGS ══════════════════════════════════════════
function RulesetSettings({ toast, myProfile, ruleset, offTypes, reload }) {
  const { rules, ignored } = useMemo(() => effectiveRules(ruleset), [ruleset]);
  const reg = ruleset.regulation || {};
  const comp = ruleset.company || {};
  const overrides = comp.overrides || {};
  const [edits, setEdits] = useState({});
  const [saving, setSaving] = useState(false);

  // 🔑 Serkan (3 Eyl 2026): *"Var olan bütün kurallar yazmalı rule sette"* —
  // liste ARTIK ELLE TUTULMUYOR. Elle tutulan listede yeni bir kural eklenince
  // ekrana yazmayı unutmak mümkündü: motor uygular, ekran göstermez.
  // `shtBloklari()` ruleset'in kendisini gezer, o kaçak kapanır.
  const bloklar = useMemo(() => shtBloklari(ruleset.regulation), [ruleset.regulation]);
  const kunye = useMemo(() => kaynakKunyesi(ruleset), [ruleset]);
  const sirket = useMemo(() => sirketKurallari(ruleset), [ruleset]);
  const [okunan, setOkunan] = useState(null);   // ⓘ açık olan satırın path'i
  // Katlanir bloklar — varsayilan KAPALI (Serkan: *"basinca acilsin"*).
  const [acikBloklar, setAcikBloklar] = useState({});
  const katla = (k) => setAcikBloklar(s => ({ ...s, [k]: !s[k] }));

  const getPath = (obj, path) => path.split('.').reduce((n, k) => n?.[k], obj);

  /** Blok anahtarını başlığa çevirir: `min_rest` → `MIN REST`. */
  const basligi = (k) => String(k).replace(/_/g, ' ').toUpperCase();

  /** Değeri türüne göre gösterir; dakika alanları HH:MM. */
  const gosterim = (path, v) => {
    if (v === null || v === undefined) return '—';
    if (Array.isArray(v)) return v.join(' · ');
    if (typeof v === 'boolean') return v ? 'YES' : 'NO';
    if (typeof v === 'number' && /_min$/.test(path)) return fmtMin(v);
    return String(v);
  };

  // ── KURAL DEĞİŞİKLİĞİ: İZ ÖNCE, YAZMA DÖNEN SATIRLA (29 Eyl 2026 · FTL nöbetçisi A2) ──
  // 🔴 ÖNCESİ: ① yazma yalnız `error`e bakıyordu — RLS reddi 0 satır döner
  //    (İlke 2): kural değişmiyor, iz yazılıyor, ekran "saved — audit logged"
  //    ② iz yazmadan SONRA yazılıyordu: iz düşerse kural izsiz değişmiş
  //    kalıyordu ③ off tipi düğmelerinin izinin hatası hiç okunmuyordu.
  // 🔑 Üç yol (kayıt + iki düğme) ortak `izliYaz`ı kural seti değişiklik iziyle çağırır
  //    (30 Eyl 2026: yardımcı modül düzeyine çıktı, match review de kullanıyor).
  const kuralIzliYaz = (tablo, id, patch, izler) => izliYaz({
    izTablosu: 'ftl_ruleset_changes', tablo, id, patch, izler,
    duzeltme: { old_value: '(change logged)', new_value: '(NOT WRITTEN)' },
    logAdi: 'The change log',
    izCumlesi: 'The ruleset change log records that the change was not applied.' });

  const save = async () => {
    setSaving(true);
    try {
      const newOverrides = { ...overrides };
      // 🔴 HESAP ESASI KURAL SETİNE YAZILMAZ (31 Eki 2026): panelin setinde şirketin seçimi birleşik durur (`sirketEsasiyla`);
      //    kural seti paylaşılır (REC-TR = REC + GO2Demo) — burada yazılsaydı bir şirketin seçimi ötekine geçerdi.
      const { hesap_esasi: _sirketSecimi, ...newCompany } = comp;
      const changes = [];
      Object.entries(edits).forEach(([key, valRaw]) => {
        if (valRaw === '' || valRaw == null) return;
        const val = key.includes(':company:') ? Number(valRaw) : (String(valRaw).includes(':') ? toMin(valRaw) : Number(valRaw));
        // 🔴 SAYI OLMAYAN DEĞER KAYDEDİLMEZ (29 Eyl 2026 · FTL nöbetçisi B12).
        //    "12a" → NaN; sınır kontrolü NaN'ı yakalamıyordu (NaN > x hep false)
        //    ve veritabanına `null` gidiyordu — değer sessizce boşalıyordu.
        if (!Number.isFinite(val)) {
          const ad = key.startsWith(':company:') ? `company.${key.slice(9)}` : key;
          throw new Error(`${ad}: "${valRaw}" is not a valid number`
            + `${key.startsWith(':company:') ? '' : ' or HH:MM'} — nothing was saved.`);
        }
        if (key.startsWith(':company:')) {
          const field = key.slice(9);
          changes.push({ field: `company.${field}`, old_value: newCompany[field] ?? null, new_value: val });
          newCompany[field] = val;
        } else {
          const regVal = getPath(reg, key);
          const dir = overrideDirection(key);
          if (dir === 'decrease_only' && val > regVal) { throw new Error(`${key}: above regulation — blocked.`); }
          if (dir === 'increase_only' && val < regVal) { throw new Error(`${key}: below regulation — blocked.`); }
          changes.push({ field: `overrides.${key}`, old_value: newOverrides[key] ?? null, new_value: val });
          if (val === regVal) delete newOverrides[key]; else newOverrides[key] = val;
        }
      });
      if (!changes.length) { toast('Nothing to save.', 'error'); setSaving(false); return; }
      newCompany.overrides = newOverrides;
      const hataMetni = await kuralIzliYaz('ftl_rulesets', ruleset.id, { company: newCompany },
        changes.map(c => ({ ruleset_id: ruleset.id, changed_by: myProfile.id, field: c.field,
                            old_value: c.old_value, new_value: c.new_value })));
      // girilen değerler ekranda KALIR; kartın detayı hatayla birlikte taşınır
      if (hataMetni) throw Object.assign(new Error(hataMetni.metin), { detay: hataMetni.detay });
      toast(`${changes.length} change(s) saved — audit logged.`, 'success');
      setEdits({}); reload();
    } catch (e) { toast(e.message, 'error', e.detay || null); }
    setSaving(false);
  };

  const toggleRest = async (t) => {
    const h = await kuralIzliYaz('ftl_off_types', t.id, { counts_as_recurrent_rest: !t.counts_as_recurrent_rest },
      [{ ruleset_id: ruleset.id, changed_by: myProfile.id, field: `off_type.${t.code}.counts_as_recurrent_rest`,
         old_value: t.counts_as_recurrent_rest, new_value: !t.counts_as_recurrent_rest }]);
    if (h) { toast(`${t.code}: ${h.metin}`, 'error', h.detay); return; }
    toast(`${t.code} updated.`, 'success'); reload();
  };

  const toggleGranted = async (t) => {
    const h = await kuralIzliYaz('ftl_off_types', t.id, { granted_leave: !t.granted_leave },
      [{ ruleset_id: ruleset.id, changed_by: myProfile.id, field: `off_type.${t.code}.granted_leave`,
         old_value: t.granted_leave, new_value: !t.granted_leave }]);
    if (h) { toast(`${t.code}: ${h.metin}`, 'error', h.detay); return; }
    toast(`${t.code} updated.`, 'success'); reload();
  };


  return (
    <div>
      <div style={{ ...S.note, borderLeftColor:C.accent, color:C.t2, marginBottom:16 }}>
        <b>{ruleset.name}</b> · engine: {ruleset.engine_type} · {kunye.reference || '—'}{kunye.revision ? ` · ${kunye.revision}` : ''} — regulation values are LOCKED. Company may only TIGHTEN
        (min rest/OFF ↑ only · max limits ↓ only). Every change → <b>ftl_ruleset_changes</b> (who · when · old → new, no delete). Applies FORWARD only.
      </div>
      {ignored.length > 0 && (
        <div style={{ ...S.note, borderLeftColor:C.red, color:C.red, marginBottom:16 }}>
          IGNORED OVERRIDES (outside regulation): {ignored.map(i => `${i.path}=${i.val} (${i.reason})`).join(' · ')}
        </div>
      )}

      {/* ── SHT — MEVZUAT ────────────────────────────────────────────────
          Serkan (3 Eyl 2026): *"Bizim FTL modulde ne rule varsa onlar rule
          sette yazmali"* ve *"var olan butun kurallar yazmali rule sette."*
          Bu yuzden liste ELLE SECILMEZ: `shtBloklari()` ruleset'in kendisini
          gezer. Etiketi olmayan satir GIZLENMEZ, path'i ile gorunur — aksi
          halde motorun uyguladigi bir kural ekranda yokmus gibi olur. */}
      <div style={{ ...S.panelT, fontSize:13, margin:'22px 0 8px' }}>
        SHT — REGULATION · {kunye.reference || '—'}{kunye.revision ? ` · ${kunye.revision}` : ''}
      </div>
      {bloklar.map(blok => (
        <Katlanir key={blok.key} baslik={basligi(blok.key)} kunye={blok.reference}
                  sayi={blok.rows.length} acikMi={!!acikBloklar[blok.key]}
                  onToggle={() => katla(blok.key)}>
          <div style={{ overflowX:'auto' }}>
            <table style={{ ...S.table, minWidth:820 }}>
              <thead><tr>{['PARAMETER', 'SHT VALUE', 'COMPANY VALUE', 'DIRECTION', 'STATUS', ''].map((h, i) => <th key={i} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {blok.rows.map(r => {
                  const effVal = getPath(rules, r.path);
                  const stricter = effVal !== r.value;
                  const acik = okunan === r.path;
                  return (
                    <React.Fragment key={r.path}>
                      <tr>
                        <td style={S.td}>
                          {r.label}
                          {r.etiketsiz && <span style={{ color:C.t3, fontSize:10 }}> · {r.path}</span>}
                        </td>
                        <td style={{ ...S.td, color:C.t3 }}>{gosterim(r.path, r.value)}</td>
                        <td style={S.td}>
                          {r.editable ? (
                            <HarfliGiris style={{ ...S.input, width:100, color: stricter ? C.green : 'var(--t1)' }}
                              placeholder={gosterim(r.path, effVal)}
                              value={edits[r.path] ?? ''}
                              onChange={v => setEdits(s => ({ ...s, [r.path]: v }))} />
                          ) : <span style={{ color:C.t3 }}>{gosterim(r.path, effVal)}</span>}
                        </td>
                        <td style={{ ...S.td, color:C.t3, fontSize:11 }}>
                          {r.direction === 'increase_only' ? 'increase only ▲'
                            : r.direction === 'decrease_only' ? 'decrease only ▼'
                            : r.structural ? 'structural' : 'locked 🔒'}
                        </td>
                        <td style={S.td}>
                          {!r.editable ? <span style={badge('dim')}>LOCKED</span>
                            : stricter ? <span style={badge('green')}>STRICTER</span>
                            : <span style={badge('dim')}>= SHT</span>}
                        </td>
                        <td style={{ ...S.td, textAlign:'right' }}>
                          {/* Serkan: *"her rule'a i koyalim, tiklayinca rule okunsun
                              — SHT talimatinda yazdigi gibi."* Metin `shtArticles.js`ten
                              gelir, TALIMATIN KENDI CUMLESIDIR; ozet degildir. */}
                          <button type="button" title="READ THE SHT ARTICLE"
                            aria-label={`READ THE SHT ARTICLE — ${r.label}`}
                            aria-expanded={acik}
                            onClick={() => setOkunan(acik ? null : r.path)}
                            style={{ ...S.btnS, padding:'1px 7px', fontSize:11, borderRadius:9,
                                     borderColor: acik ? C.accent : undefined,
                                     color: acik ? C.accent : C.t3 }}>ⓘ</button>
                        </td>
                      </tr>
                      {acik && (
                        <tr>
                          <td colSpan={6} style={{ ...S.td, background:'var(--bg2)' }}>
                            <div style={{ fontSize:10, color:C.t3, letterSpacing:0.4, marginBottom:6 }}>
                              {kunye.reference || 'SHT-FTL/HG'}{(r.reference || blok.reference) ? ` — ${r.reference || blok.reference}` : ''}
                            </div>
                            {maddeMetni(r.reference || blok.reference) ? (
                              <div style={{ maxHeight:260, overflowY:'auto', whiteSpace:'pre-wrap',
                                            fontSize:12, lineHeight:1.65, color:C.t2 }}>
                                {maddeMetni(r.reference || blok.reference)}
                              </div>
                            ) : (
                              /* Ilke 1: metni bulamadiysak UYDURMAYIZ, bulunamadigini yaziriz. */
                              <div style={{ color:C.amber, fontSize:12 }}>
                                THE ARTICLE TEXT IS NOT AVAILABLE FOR THIS REFERENCE — READ IT IN THE INSTRUCTION ITSELF.
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Katlanir>
      ))}

      {/* 🔴 SHT-FCL BÖLÜMÜ BURADAN TAŞINDI (5 Eyl 2026) → ATPL & MED modülü.
          Serkan onayı: *"Bir modül = bir mevzuat ailesi."*  Burası SHT-FTL/HG
          kural setidir (görev ve dinlenme); lisans ve sağlık mevzuatı kendi
          modülünde durur. Aynı ekranda tutmak "bu kural nereden geliyor"
          sorusunu bulandırıyordu — 4 Eyl'de yanlış yere konmuştu. */}

      {/* ── SIRKET KURALLARI ─────────────────────────────────────────────
          Mevzuatta karsiligi olmayanlar. Serkan: *"sht den gelenler
          regulasyona bagli, daraltilamasin"* — bunlar ise serbesttir. */}
      <div style={{ ...S.panelT, fontSize:13, margin:'26px 0 8px' }}>COMPANY RULES</div>
      <div style={{ overflowX:'auto', marginBottom:20 }}>
        <table style={{ ...S.table, minWidth:820 }}>
          <thead><tr>{['PARAMETER', 'SHT VALUE', 'COMPANY VALUE', 'DIRECTION', 'STATUS', ''].map((h, i) => <th key={i} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {sirket.map(c => (
              <tr key={c.key}>
                <td style={S.td}>{c.label}</td>
                <td style={{ ...S.td, color:C.t3, fontSize:10 }}>— no SHT counterpart</td>
                <td style={S.td}>
                  {Array.isArray(c.value)
                    ? <span style={{ color:C.t2 }}>{c.value.join(' · ')}</span>
                    : <HarfliGiris style={{ ...S.input, width:100 }} placeholder={String(c.value ?? '—')}
                        value={edits[`:company:${c.key}`] ?? ''}
                        onChange={v => setEdits(s => ({ ...s, [`:company:${c.key}`]: v }))} />}
                </td>
                <td style={{ ...S.td, color:C.t3, fontSize:11 }}>company-defined</td>
                <td style={S.td}><span style={badge('amber')}>COMPANY</span></td>
                <td style={{ ...S.td, textAlign:'right' }}>
                  {c.note && <InfoDot title="COMPANY RULE" note={c.note}
                    rule="Not derived from SHT-FTL/HG — set by the operator."
                    action="Change it here; every change is written to ftl_ruleset_changes." />}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ ...S.note, marginBottom:20 }}>
        Time values HH:MM (e.g. 11:00) or minutes; hour/count fields plain numbers. Leave blank = unchanged.
        Setting a value equal to regulation removes the override. <b>ⓘ</b> shows the SHT article, as written in the instruction.
      </div>
      <button style={S.btnP} disabled={saving} onClick={save}>{saving ? 'SAVING...' : 'SAVE CHANGES'}</button>

      <div style={{ ...S.panel, marginTop:26 }}>
        <div style={S.panelH}>
          <span style={S.panelT}>OFF / Absence Types</span>
          <span style={{ fontSize:9, color:C.t3, letterSpacing:1, fontFamily:'var(--mono)' }}>no delete — deactivate only · toggle = audit logged</span>
        </div>
        <table style={S.table}>
          <thead><tr>{['CODE', 'LABEL', 'ASSIGNABLE', 'COUNTS AS DAY OFF (Md.5)', 'GRANTED LEAVE'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {offTypes.map(t => (
              <tr key={t.id}>
                <td style={S.td}><span style={badge(t.counts_as_recurrent_rest ? 'dim' : 'red')}>{t.code}</span></td>
                <td style={S.td}>{t.label}</td>
                <td style={{ ...S.td, color:C.t3 }}>NO</td>
                <td style={{ ...S.td, cursor:'pointer', color: t.counts_as_recurrent_rest ? C.green : C.t3, fontWeight:700 }}
                  onClick={() => toggleRest(t)}>{t.counts_as_recurrent_rest ? 'YES' : 'NO'} ⇄</td>
                {/* VERILMIS IZIN (8 Agu): izin DINLENME DEGILDIR — taahhut
                    edildigi icin periyodun TAMAMI bastan actual yazilir.
                    Hangi tipin izin oldugu MUSTERININ otoritesine baglidir,
                    o yuzden koda gomulmez, buradan isaretlenir. */}
                <td style={{ ...S.td, cursor:'pointer', color: t.granted_leave ? C.accent : C.t3, fontWeight:700 }}
                  onClick={() => toggleGranted(t)}>{t.granted_leave ? 'YES' : 'NO'} ⇄</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export const __RulesetSettings = RulesetSettings;   // yalniz test icin disari acilir

export const __EditDutyModal = EditDutyModal;   // yalniz test icin disari acilir

export const __EditNonFlightModal = EditNonFlightModal;   // yalniz test icin disari acilir

export const __PlannedOutcomeModal = PlannedOutcomeModal;   // yalniz test icin disari acilir
export const __EditReport = EditReport;   // yalniz test icin disari acilir (6 Eki 2026, 3. adım)
